/* global jQuery, CodeMirror */
/* eslint-disable eqeqeq */
// ignore-security-checks-file - Legacy file with many .html() calls that have been reviewed

AoPS.Community.Views = (function (ComViews) {
	var Lang = AoPS.Community.Lang,
		Constants = AoPS.Community.Constants,
		Utils = AoPS.Community.Utils,
		Modal = AoPS.Ui.Modal,
		Flyout = AoPS.Ui.Flyout;

	ComViews.in_academy = AoPS.in_academy;

	ComViews.clicking = false;
	$(document)
		.on("mousedown.watcher", function () {
			ComViews.clicking = true;
		})
		.on("mouseup.watcher", function () {
			ComViews.clicking = false;
		});

	ComViews.isIOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
	// OMG hack for iOS
	if (ComViews.isIOS) {
		Constants.max_num_shown_topics = 170;
		Constants.num_topics_to_hide = 80;
		Constants.num_topics_to_reveal = 40;
	}

	jQuery.fn.extendedHighlightText = function (highlight_class, text) {
		var separate_strings,
			$this = $(this);

		// Note: currently stripping out backslashes.
		// / +(?= )/g looks for two or more consecutive spaces and selects all
		// but the last one. I'm not sure why .replace( /\s{2,}/, ' ') wasn't used.
		text = text.replace(/[^a-zA-Z0-9\' _-]/g, " ").replace(/ +(?= )/g, "");

		// Split text into individual strings/words
		separate_strings = text.split(" ");

		// Highlight each word that was passed into text.
		_.each(separate_strings, function (str) {
			$this.highlightText(highlight_class, str);
		});
	};

	jQuery.fn.cmtyLoadFromFile = function (obj) {
		var $el = $(this);
		Utils.cmty_ajax.add({
			a: "load_file",
			params: {
				filename: obj.filename,
			},
			main_handler: function (ok, msg) {
				if (ok) {
					$el.html(msg.response.file_contents);
				}
			},
			extra_handlers: obj,
		});
	};

	/**
	 * Based on work by Johann Burkard.  Thanks Johann!
	 **/
	jQuery.fn.highlightText = function (highlight_class, text) {
		// We need to decide how we are handling \ in highlighting/search.
		// Currently, I am removing \ from highlighing (in extendedHighlightSearch).
		// If we stuff it back in, then we need to put an "escape(text.toUpper...)" below.
		var regex = new RegExp(text.toUpperCase().replace(/\*/, ".*"));

		function highlight(node, target) {
			var step = 0,
				idx,
				insert_span,
				middle,
				middle_copy,
				i;
			if (node.nodeType === 3) {
				//				idx = node.data.toUpperCase().indexOf(target);
				idx = node.data.toUpperCase().match(regex);
				if (!_.isNull(idx)) {
					//idx >= 0) {
					insert_span = document.createElement("span");
					insert_span.className = highlight_class;
					middle = node.splitText(idx.index); // Made change here
					middle_copy = middle.cloneNode(true);
					insert_span.appendChild(middle_copy);
					middle.parentNode.replaceChild(insert_span, middle);
					step = 1;
				}
			} else if (
				node.nodeType === 1 &&
				node.childNodes &&
				!/(script|style)/i.test(node.tagName)
			) {
				for (i = 0; i < node.childNodes.length; ++i) {
					i += highlight(node.childNodes[i], target);
				}
			}

			return step;
		}

		return this.length && text && text.length
			? this.each(function () {
					highlight(this, text.toUpperCase());
				})
			: this;
	};

	jQuery.fn.stripSpansByClass = function (span_class) {
		return this.find("span." + span_class)
			.each(function () {
				this.parentNode.replaceChild(this.firstChild, this);
				this.parentNode.normalize();
			})
			.end();
	};

	/**
	 * Got this from Cursor, but couldn't find a better method online either, and it works.
	 * Replaced _.unescape() which didn't work for &#039; (apostrophe)
	 * I don't see anything insecure here, we'll be escaping it again before saving.
	 * See https://app.clickup.com/t/2295448/PROJ-25681
	 */
	ComViews.decodeHtmlEntities = function (str) {
		if (!str) {
			return "";
		}
		// ignore-security-checks
		return $("<textarea/>").html(str).text();
	};

	/**
	 * Make a consistent scrollbar for the community.
	 *
	 * Wacky stuff happens when the scrollbar gets very small.
	 *
	 * TODO: Think about how to deal with that.
	 */

	ComViews.buildCommunityScrollbar = function ($obj) {
		if ($obj) {
			var scrollbar_defaults = {
					fade_start_class: "aops-scroll-fade-top",
					fade_end_class: "aops-scroll-fade-bottom",
					slider_end_tolerance: 2,
					autosize: true,
					autosize_nudge: 8,
					stop_scroll_propagation: true,
				},
				scrollbar_args =
					arguments.length === 1
						? scrollbar_defaults
						: _.extend(scrollbar_defaults, arguments[1]),
				$scrollwrap = $obj.wrapWithScroll(scrollbar_args);

			$scrollwrap.addClass("cmty-scroll-outer");
			return $scrollwrap;
		}
	};

	ComViews.inCmtyRouter = function () {
		return (
			AoPS.hasOwnProperty("pushState_attr") &&
			AoPS.pushState_attr === "data-cmty"
		);
	};

	/**
	 * Basic error thrower upon an Ajax call.  Used for simple Ajax calls
	 *  that don't require customized errors.
	 **/
	ComViews.throwAjaxError = function (msg) {
		var error_msg;

		switch (msg.error_code) {
			case "E_NO_PERMISSION":
				error_msg = Lang["err-no-permission"];
				break;

			default:
				error_msg = Utils.formatString(Lang["err-unknown"], [msg.error_code]);
				break;
		}

		Modal.showAlert(error_msg, {
			onClose: function () {
				Modal.closeAllModals();
			},
		});
	};

	ComViews.onPMPage = function () {
		return Backbone.history.fragment.substring(0, 10) === "my-message";
	};

	ComViews.setTabTarget = function ($input_cell, $target) {
		$input_cell.on("keydown", function (e) {
			var key_pressed = e.which || e.keyCode;

			if ($input_cell.data("suppress_tab") === true) {
				return;
			}
			if (key_pressed === 9 && !e.shiftKey) {
				$target.focus();
				e.stopPropagation();
				e.preventDefault();
			}
		});

		$target.on("keydown", function (e) {
			var key_pressed = e.which || e.keyCode;
			if ($target.data("suppress_tab") === true) {
				return;
			}
			if (key_pressed === 9 && e.shiftKey) {
				$input_cell.focus();
				e.stopPropagation();
				e.preventDefault();
			}
		});
	};
	/**
	 * Several views are used in places in which the community is embedded in other
	 *  parts of the site.  This sets the appropriate paths and such.
	 **/
	ComViews.setRouteInfo = function (view, options) {
		var tryOptionsThenView = function (key, default_value) {
			if (typeof options[key] === "string") {
				return options[key];
			} else if (typeof view[key] === "string") {
				return view[key];
			}
			return default_value;
		};

		view.url_cmty_path = tryOptionsThenView("url_cmty_path", "");
		view.url_router_base = tryOptionsThenView("url_router_base", "/community");
		view.push_state_attribute = tryOptionsThenView(
			"push_state_attribute",
			"data-cmty"
		);
	};

	/**
	 * Launch a new private message to a user
	 *
	 * @return ComViews.NewPrivateConversation object
	 **/
	ComViews.launchNewPrivateMessage = function (obj) {
		if (typeof obj.is_admin === "boolean") {
			obj.is_admin = obj.is_admin ? 1 : 0;
		}
		var new_private = new ComViews.NewPrivateConversation({
			category_name: "", // PROBABLY put all of these in NewPrivateConversation as defaults.
			category_id: Constants.private_messages_id,
			model: AoPS.Community.MasterModel.get("my_privates"),
			preset_recipients: [
				{
					label: obj.username,
					user_id: obj.user_id,
					is_visible: true,
					is_admin: obj.is_admin,
				},
			],
			master: AoPS.Community.MasterModel,
		});

		return new_private;
	};
	/**
	 * Build a select with attached text.
	 *
	 * Structure:
	 *	<div class="cmty-select-row">
	 *		<div><select></div>
	 *      <div>text</div>
	 *	</div>
	 *
	 * @param object
	 *		options array of {value, label}
	 *		text string
	 * 		is_bold (optional) boolean : render the label bold (default false)
	 *		selected (optional) value of the option that is selected
	 *		action
	 **/
	ComViews.buildSelectRow = function (obj) {
		var $row = $('<div class="cmty-select-row"></div>'),
			$select = $("<select></select>"),
			is_bold = obj.hasOwnProperty("bold") && obj.bold,
			selected_value = obj.hasOwnProperty("selected") ? obj.selected : "";

		_.each(obj.options, function (option) {
			$select.append(
				'<option value="' +
					option.value +
					'" ' +
					(option.value === selected_value ? "selected" : "") +
					">" +
					option.label +
					"</option>"
			);
		});

		$select.change(function () {
			obj.action($select.val());
		});

		$row.append(
			$('<div class="cmty-select-row-select"></div>').append($select)
		);
		$row.append(
			$(
				'<div class="cmty-select-row-text">' +
					(is_bold ? "<b>" : "") +
					obj.text +
					(is_bold ? "</b>" : "") +
					"</div>"
			)
		);
		return $row;
	};

	/**
	 * Build a select with attached text.
	 *
	 * Structure:
	 *	<div class="cmty-select-row">
	 *		<div><select></div>
	 *      <div>text</div>
	 *	</div>
	 *
	 * @param object
	 *		options array of {value, label}
	 *		text string
	 * 		is_bold (optional) boolean : render the label bold (default false)
	 *		selected (optional) value of the option that is selected
	 *		action
	 **/
	ComViews.buildLinkLabelRow = function (obj) {
		var $row = $('<div class="cmty-link-label-row"></div>'),
			$link = $("<a>" + obj.link_text + "</a>"),
			is_bold = obj.hasOwnProperty("bold") && obj.bold;

		$link.on("click", function () {
			obj.action();
		});

		$row.append(
			$('<div class="cmty-link-label-row-link"></div>').append($link)
		);
		$row.append(
			$(
				'<div class="cmty-link-label-row-label">' +
					(is_bold ? "<b>" : "") +
					obj.link_label +
					(is_bold ? "</b>" : "") +
					"</div>"
			)
		);
		return $row;
	};

	/**
	 * Build an editable row with attached text.
	 *
	 * ONLY WORKS FOR INPUTS (NOT TEXTAREAS, NOT THINGS WITH LINE BREAKS).  ONLY PUSHES IN TEXT, DOES
	 *  NOT RENDER HTML IN THE EDITABLE ROW
	 *
	 * Structure:
	 *	<div class="cmty-editable-row">
	 *		<div class="cmty-editable-label">label</div>
	 *      <div contenteditable="true"><div class="cmty-editable-buttons"><span class="cmty-editable-save"></span><span class="cmty-editable-cancel"></span></div></div>
	 *	</div>
	 *
	 * @param object
	 *		label string
	 *		content optional string -- original content
	 *		placeholder optional string
	 *		allow_ctrl_biu optional boolean default false -- allow Ctrl-b, i, u
	 *		action -- what to do when saved
	 *		length_limit optional int default 0 means none
	 *		submit_on_enter optional default true
	 **/
	ComViews.buildEditableRow = function (obj) {
		var row,
			$buttons,
			submit_on_enter = obj.hasOwnProperty("submit_on_enter")
				? obj.submit_on_enter
				: true,
			$save,
			template = AoPS.View.compileTemplate("#cmty-editable-row-tpl"),
			$cancel,
			$pencil = $('<span class="cmty-editable-pencil aops-font">L</span>'),
			length_limit = obj.hasOwnProperty("length_limit") ? obj.length_limit : 0,
			original_content = obj.hasOwnProperty("content") ? obj.content : "";

		row = {
			is_active: false, //True when data has changed but is not yet saved

			allow_ctrl_biu: obj.hasOwnProperty("allow_ctrl_biu")
				? obj.allow_ctrl_biu
				: false,

			label: obj.label, // Label in the left column

			placeholder: obj.hasOwnProperty("placeholder") ? obj.placeholder : "",

			// Most recently burned content -- if the user changes the contents,
			//  we don't save it to row.contents until the user hits save
			contents: original_content,

			// Reset to contents, and put the pencil in place
			reset: function () {
				row.$input.text(row.contents);
				row.$input.append($pencil);
			},

			// What happens when the content is changed but not saved
			activate: function () {
				$buttons.show();
				row.$element.addClass("cmty-editable-active-row");
				row.is_active = true;
			},

			// What happens when we deactivate -- get rid of the buttons
			deactivate: function () {
				$buttons.hide();
				row.$element.removeClass("cmty-editable-active-row");
				row.is_active = false;
			},

			// Deactivate the editability of this cell
			renderUneditable: function () {
				row.$input.attr("contenteditable", false);
				$pencil.detach();
			},

			// What we do if we click on the X or the checkmark
			onButtonClick: function () {
				row.$input.blur();

				if (row.contents.length > 0) {
					row.$input.append($pencil);
				}
				row.deactivate();
			},

			// Save the entered data
			save: function () {
				if (row.burnNewContent() && obj.hasOwnProperty("action")) {
					obj.action(row.contents, row);
				}
				row.onButtonClick();
			},

			// Put the new content in the div without focus.
			// @return boolean is the content new?
			burnNewContent: function () {
				var lines = row.fetchInputLines(),
					new_content = lines.join("\n");
				row.$input.text(lines.join("<br>")); // DO NOT CHANGE TO HTML

				if (new_content !== row.contents) {
					row.contents = lines.join("\n");
					return true;
				}
				return false;
			},

			// Dig the contents out of the editable region, put in array.
			fetchInputLines: function () {
				var contents = [],
					last_was_br = false,
					last_was_text = false;

				row.$input.contents().each(function () {
					if (this.nodeName === "BR") {
						last_was_text = false;
						if (!last_was_br) {
							last_was_br = true;
							return;
						} else {
							if (!submit_on_enter) {
								contents.push("");
							}
							return;
						}
					}
					last_was_br = false;

					if (this.nodeType === 3) {
						// text
						if (last_was_text) {
							// For FF, grr
							contents[contents.length - 1] =
								contents[contents.length - 1] + this.textContent;
						} else {
							contents.push(this.textContent);
						}

						last_was_text = true;
					} else {
						// div
						last_was_text = false;
						if (this.innerHTML !== "<br>") {
							contents.push(this.innerHTML);
						} else {
							contents.push("");
						}
					}
				});
				return contents;
			},
		};

		// Construct the jQuery object for the row.
		row.$element = $(
			template({
				label: obj.label,
				placeholder: row.placeholder,
				content: original_content,
			})
		);

		// Name components.
		row.$input = row.$element.find('[contenteditable="true"]');
		$buttons = row.$element.find(".cmty-editable-buttons");
		$cancel = $buttons.find(".cmty-editable-cancel");
		$save = $buttons.find(".cmty-editable-save");

		if (row.contents.length > 0 || row.placeholder.length === 0) {
			row.$input.append($pencil);
		}

		// Build listeners
		$cancel.on("click", function () {
			row.$input.text(row.contents);
			row.onButtonClick();
		});

		$save.on("click", function () {
			row.save();
		});

		row.$input.on("focus", function () {
			//Need to let the focus event finish before detaching
			// the pencil, in case it was the pencil that was clicked.
			//  (If the pencil is clicked, then the cursor is placed
			//  relative to it, which is a problem if the pencil is gone!)
			setTimeout(function () {
				$pencil.detach();
			}, 1);
		});

		row.$input.on("paste", function (e) {
			var text = (e.originalEvent || e).clipboardData.getData("text/plain"),
				new_text;

			e.preventDefault();
			if (submit_on_enter) {
				text = text.replace(/\r?\n|\r/g, "");
			}
			document.execCommand("insertText", false, text);
			if (length_limit > 0) {
				new_text = row.$input.text();
				if (new_text.length > length_limit) {
					row.$input.text(new_text.substr(0, length_limit));
					AoPS.Ui.Flyout.display(
						Lang["editable-length-limit-exceeded-on-paste"]
					);
				}
			}
		});

		row.$input.on("blur", function () {
			if (!row.is_active && row.contents.length > 0) {
				row.$input.append($pencil);
			}
		});

		if (submit_on_enter) {
			row.$input.on("keydown", function (e) {
				var key_pressed = e.which || e.keyCode;
				if (key_pressed === 13) {
					row.save();
					e.preventDefault();
					e.stopPropagation();
				}
			});
		}
		if (length_limit > 0) {
			row.$input.on("keydown", function (e) {
				var key_pressed = e.which || e.keyCode,
					current_text = row.$input.text();
				if (key_pressed !== 8 && current_text.length > length_limit) {
					e.preventDefault();
				}
			});
		}

		// Block ctrl-b,i,u
		if (!row.allow_ctrl_biu) {
			row.$input.on("keydown", function (e) {
				var key_pressed = e.which || e.keyCode,
					disallowed_keys = [66, 73, 85];

				if (e.metaKey || e.ctrlKey) {
					if (_.indexOf(disallowed_keys, key_pressed) > -1) {
						e.stopPropagation();
						e.preventDefault();
					}
				}
			});
		}
		row.$input.on("keyup", function () {
			if (row.$input.text() !== row.contents) {
				row.activate();
			} else {
				row.deactivate();
			}
		});

		// Need to add the $pencil if content.length > 0 when there is not focus
		return row;
	};

	/**
	 * Put the screen in full-reply mode.  Because IE forgets scroll position
	 *  of display:none elements, this is much harder and dicier than it should be.
	 **/
	ComViews.setFullReplyStyle = function () {
		$("body").addClass("full-reply");
	};

	ComViews.removeFullReplyStyle = function () {
		$("body").removeClass("full-reply");
	};

	/**
	 * Turn an input box into a tag autocomplete.
	 *
	 *	-- Wraps the input box in a div with class cmty-tag-search
	 *	-- if show_no_results_msg == true, then show a message when there
	 *		are no hits.
	 *
	 * @param object
	 *		$input_box : input cell
	 *		model : category that we are building the autocomplete for.
	 *		show_no_results_msg : boolean default false
	 *		has_search_icon boolean default false
	 *		submitNewItem : What you want to do when the something is selected.
	 *
	 * This stands on top of a lot of the autocomplete infrastructure built inside
	 *  EditableItemList.  Perhaps at some point I'll reorg that to pull the autocomplete-
	 *	specific stuff out.
	 **/
	ComViews.buildTagAutocomplete = function (obj) {
		var $no_results;

		obj.$input_box.wrap($('<div class="cmty-tag-search"></div>'));
		obj = _.defaults(obj, {
			show_no_results_msg: false,
			no_results_msg_hash: "cat-cell-no-tag-match",
			has_search_icon: false,
		});

		obj.category = obj.model;
		/** We borrow just the arrow key bindings from EditableTagBox **/
		obj.processPostConstruction =
			ComViews.EditableTagBox.prototype.processTagBoxDropdownArrowing;

		if (obj.show_no_results_msg) {
			$no_results = $(
				'<div class="cmty-no-results-found">' +
					Lang[obj.no_results_msg_hash] +
					"</div>"
			);
			obj.$input_box.before($no_results);
			obj.$input_box.on("blur", function () {
				$no_results.hide();
			});
			obj.$input_box.on("remove", function () {
				$no_results.remove();
			});
			obj.onMatch = function () {
				$no_results.hide();
			};
			obj.onNoMatch = function () {
				$no_results.show();
			};
		}
		if (obj.hasOwnProperty("has_search_icon") && obj.has_search_icon) {
			obj.$input_box.before('<span class="aops-font">M</span>');
			obj.$input_box.parent().addClass("cmty-search-with-icon");
		}
		obj.constructAutocompleteArgs =
			ComViews.EditableTagBox.prototype.constructAutocompleteArgs; /*function () {
			return _.extend(ComViews.EditableTagBox.prototype.constructAutocompleteArgs.apply(this), {
				position : {
					my : 'left-1 top+1',
					at : 'left bottom',
					of : obj.$input_box
				}
			});
		}, */

		obj.getAutocompleteSource =
			ComViews.EditableTagBox.prototype.getAutocompleteSource;

		obj.constructAutocomplete =
			ComViews.EditableTagBox.prototype.constructItemAutocomplete;

		obj.constructAutocomplete();
	};

	/**
	 * Build a tag autocomplete in the tag-term manager.
	 *  God I hope I have time to clean up the tag autocompletes someday.
	 *
	 *	view : View we are working inside.
	 *	onFoundTag : function to execute when you hit the tag
	 *	create_new : create a new entry in cmty_tags if the submitted tag hits nothing on submit
	 *	tag_term_model : ComModels.TagTermManager
	 *	$input_box_target : where the input box gets added
	 **/
	ComViews.buildTagTermTagAutocomplete = function (obj) {
		function checkSubmittedTag(input_value) {
			if (input_value.length == 0) {
				return;
			}
			var tag = obj.tag_term_model.get("tags").findWhere({
				text_lc: input_value.toLowerCase(),
			});

			if (_.isUndefined(tag)) {
				ComViews.throwBlockingMessage(Lang["please-wait"]);
				obj.tag_term_model.fetchTagIdByText({
					tag_text: input_value,
					create_new: obj.hasOwnProperty("create_new") ? obj.create_new : false,
					suppress_clean: obj.hasOwnProperty("suppress_clean")
						? obj.suppress_clean
						: false,
					onFinish: function (msg) {
						obj.onFoundTag(msg.tag);
					},
					onError: function (msg) {
						var error_msg;
						switch (msg.error_code) {
							case "E_NO_SUCH_TAG":
								error_msg = Lang["cmty-tag-info-no-tag"];
								break;

							default:
								error_msg = Utils.formatString(Lang["err-unknown"], [
									msg.error_code,
								]);
								break;
						}

						Modal.showAlert(error_msg, {
							onClose: function () {
								Modal.closeAllModals();
							},
						});
					},
				});
			} else {
				obj.onFoundTag(tag);
			}
			ComViews.buildTagTermTagAutocomplete(obj);
		}

		if (obj.view.hasOwnProperty("$tag_input")) {
			obj.view.$tag_input.parent().remove();
		}
		obj.view.$tag_input = $(
			'<input name="tag" placeholder="Enter tag" maxlength="60">'
		);
		obj.view.$tag_input.on("keydown", function (e) {
			if (!ComViews.validateTagCharacter(e)) {
				e.stopPropagation();
				e.preventDefault();
			}
		});

		obj.view.$tag_input.on("paste", function (e) {
			ComViews.onTagPaste(e);
		});
		obj.$input_box_target.append(obj.view.$tag_input);

		ComViews.buildTagAutocomplete({
			model: obj.tag_term_model,
			$input_box: obj.view.$tag_input,
			show_no_results_msg: true,
			no_results_msg_hash: "cmty-tag-info-no-match",
			additional_autocomplete_params: {
				type: "tag",
			},
			submitNewItem: function (item) {
				var tag;
				//	self.model.addTagToFocusTerm(item);
				if (item.item_id == 0) {
					// what is typed doesn't match highlighted item because you type too fast
					checkSubmittedTag(item.label);
					return;
				}
				tag = obj.tag_term_model.findTagById(parseInt(item.item_id));
				if (_.isUndefined(tag)) {
					tag = new AoPS.Community.Models.Tag({
						tag_id: parseInt(item.item_id),
						tag_text: item.value,
					});
					obj.tag_term_model.get("tags").add(tag);
				}
				//				self.fetchTagInfo(item);
				obj.onFoundTag(tag);
				ComViews.buildTagTermTagAutocomplete(obj);
			},
		});
		obj.view.$tag_input.on("keyup", function (e) {
			var key = e.which || e.keyCode,
				input_value;
			if (key == 13) {
				input_value = $.trim(obj.view.$tag_input.val());
				checkSubmittedTag(input_value);
			}
		});
	};

	ComViews.validateTagCharacter = function (e) {
		var character = e.which || e.keyCode;
		// a-z
		if (character >= 65 && character <= 90) {
			return true;
		}

		//0-9
		if (character >= 48 && character <= 57) {
			// Parentheses
			if (character == 48 || character == 57) {
				return true;
			}

			// Numbers
			return !e.shiftKey;
		}
		// Right and left arrow
		if (character == 37 || character == 39) {
			return true;
		}

		// Period
		if (character == 190) {
			return true;
		}

		// dash & underscore
		if (character == 189) {
			return true;
		}

		// Apostrophe
		if (character == 222) {
			return true;
		}

		// Backspace and tab
		if (character == 8 || character == 9 || character == 46) {
			return true;
		}

		//space
		if (character == 32) {
			return true;
		}

		return false;
	};

	ComViews.onTagPaste = function (e) {
		var text = (e.originalEvent || e).clipboardData.getData("text/plain");
		text = text.replace(/[^a-zA-Z0-9 \._\(\)\-]/g, "");
		e.preventDefault();
		document.execCommand("insertText", false, text);
	};

	ComViews.constructUsernameAutocompleteExtraArgs = function () {
		return {
			ui_class: "cmty-username-autocomplete",
			_renderItem: function (ul, item) {
				var $list_item = $("<li></li>"),
					$link = $("<a>" + item.label + "</a>");

				$list_item.append($link);

				if (item.is_admin === "1") {
					$link.addClass("cmty-user-admin");
				}
				return $list_item.appendTo(ul);
			},
		};
	};

	ComViews.showError = function (output_string) {
		AoPS.Ui.Modal.showAlertQuick(output_string, {
			width: "400px",
			onClose: function () {
				Modal.closeAllModals();
			},
		});
	};

	ComViews.showErrorAtopAModal = function (output_string) {
		AoPS.Ui.Modal.showAlertQuick(output_string, {
			width: "400px",
		});
	};

	ComViews.constructUrlFromFocus = function (master, obj) {
		var category_id = master.get("focus_category").get("category_id"),
			url,
			settings = arguments.length === 2 ? obj : {},
			include_topic =
				!settings.hasOwnProperty("strip_topic") || !settings.strip_topic,
			topic = master.get("focus_topic"),
			focus_tag;

		// For the private message archive, we use the private archive url if the focus
		//  topic is not sought.
		if (
			category_id === Constants.private_messages_id &&
			master.get("focus_category").get("is_archive") &&
			(!include_topic || _.isNull(topic))
		) {
			url = Constants.private_archive_url;
		} else {
			url = "/c" + category_id;
		}

		focus_tag = master.get("focus_tag");
		if (!_.isNull(focus_tag)) {
			url += "t" + focus_tag.tag_id + "f" + focus_tag.tag_forum_id;
		}
		if (include_topic) {
			if (!_.isNull(topic)) {
				url += "h" + topic.get("topic_id");
			}
		}

		return url;
	};

	ComViews.leaveRouterOnClick = function (e, url) {
		if (e.metaKey || e.ctrlKey) {
			window.open("/community" + url, "_blank");
		} else {
			window.location.href = "/community" + url;
		}

		e.stopPropagation();
		e.preventDefault();
	};

	/**
	 * Go to a url on click event, either staying here or opening new browser window
	 *
	 * @param event
	 * @param string target string that would be appended to /community
	 * @param string optional string for different url base for going to difft router
	 * @param string optional string for path to the desired community route in that router
	 *
	 */
	ComViews.followUrlOnClick = function (e, url) {
		var router_base, cmty_path;

		if (arguments.length > 2) {
			router_base = arguments[2];
			cmty_path = arguments[3];
		} else {
			router_base = "/community";
			cmty_path = "";
		}

		if (e.metaKey || e.ctrlKey) {
			window.open(router_base + cmty_path + url, "_blank");
		} else {
			Backbone.history.navigate(cmty_path + url, {trigger: true});
		}

		e.stopPropagation();
		e.preventDefault();
	};

	/**
	 * Determine if a tag is one of the state tags.
	 *
	 * @param string
	 * @return boolean
	 **/
	ComViews.isStateTag = function (tag_text) {
		tag_text = tag_text.toLowerCase();
		return (
			tag_text === "/open" ||
			tag_text === "/closed" ||
			tag_text === "/not_monitored"
		);
	};

	/**
	 * Create a bookmark icon based on the bookmark state
	 *
	 * B = none
	 * C = bookmark, no feed, no email
	 * D = bookmark, no feed, yes email
	 * E = bookmark, yes feed, no email
	 * F = bookmark, yes feed, yes email
	 */
	ComViews.makeBookmark = function (state) {
		return String.fromCharCode(
			67 +
				(!state.is_bookmarked
					? -1
					: (state.in_feed ? 2 : 0) + (state.is_watched ? 1 : 0))
		);
	};

	/**
	 * Create a Url fragment for pretty URLs out of a string.
	 *  Used for Google; we'll have to mimic it in PHP.
	 **/
	ComViews.convertToUrlFragment = function (str) {
		if (!str) {
			return "";
		}
		var decodedStr = ComViews.decodeHtmlEntities(str);
		return decodedStr.replace(/ /g, "_").replace(/\W/g, "").toLowerCase();
	};

	/**
	 * Makes the href field for <a> tags by adding /community/
	 *
	 * @param string : route to navigate to.
	 * @param string optional : optional base+path if going somewhere other than /community
	 **/
	ComViews.makeLinkUrl = function (route) {
		var base = arguments.length == 2 ? arguments[1] : "/community";
		return base + route;
	};

	/**
	 * Add an onclick event to a jQuery object that
	 *  sends the clicker down a route.
	 *
	 * @param $object to be clicked
	 * @param string route to follow.
	 **/
	ComViews.makeBackboneClick = function ($obj, url) {
		$obj.on("click.backbone", function (e) {
			ComViews.followUrlOnClick(e, url);
		});
	};

	ComViews.throwBlockingMessage = function (message) {
		AoPS.Ui.Modal.showMessageQuick(message, {
			closeX: false,
			force_response: true,
			kill_phrase: "ajax-error-kill",
			width: "400px",
		});
	};

	/**
	 * Delay the clearing of all modals (used to prevent Ajax calls from going
	 *  so fast that you miss what happened).
	 *
	 * @param obj (optional)
	 *		onClose : extra stuff you want done when the modals blow up.
	 */
	ComViews.delayModalClearing = function (obj) {
		var settings = {};

		if (arguments.length > 0) {
			settings = obj;
		}

		setTimeout(function () {
			Modal.closeAllModals();
			if (settings.hasOwnProperty("onClose")) {
				settings.onClose();
			}
		}, Constants.message_readability_delay);
	};

	ComViews.replaceWithLoaderBlockingMessage = function (message) {
		var body =
			'<div class="cmty-quick-message">' +
			message +
			"</div>" +
			AoPS.Page.loader_html;

		AoPS.Ui.Modal.replaceTopModal({
			type: "message",
			body: body,
			closeX: false,
			force_response: true,
			kill_phrase: "ajax-error-kill",
			width: "450px",
			frame_class: "aops-modal-quick",
		});
	};

	ComViews.throwLoaderBlockingMessage = function (message) {
		var body =
			'<div class="cmty-quick-message">' +
			message +
			"</div>" +
			AoPS.Page.loader_html;
		AoPS.Ui.Modal.showMessageQuick(body, {
			closeX: false,
			force_response: true,
			kill_phrase: "ajax-error-kill",
			width: "350px",
		});
	};

	ComViews.applyItemColor = function ($item, colors) {
		$item
			.css({
				"background-color": colors.main_color,
			})
			.on("mouseenter", function (e) {
				$item.css({
					"background-color": colors.secondary_color,
					color: colors.main_color,
				});
			})
			.on("mouseleave", function (e) {
				$item.css({
					"background-color": colors.main_color,
					color: "",
				});
			});
	};

	/**
	 * The $bookmarkModals object holds the modals for bookmarks of each type.
	 *  We only make these as needed, and only make them for the bookmark
	 *  types for which they are requested.  See ComViews.constructBookmarkModal()
	 */
	ComViews.$bookmarkModals = {};

	/**
	 * Construct the instructions/options modal for bookmarking an item.
	 *
	 * @param string type of item being bookmarked (tag, topic, forum)
	 */
	ComViews.constructBookmarkModal = function (type, description) {
		var info_text = "";
		if (!ComViews.in_academy) {
			info_text = Lang["bookmark-modal-info-text"];
		} else {
			info_text = Lang["bookmark-modal-info-text-academy"];
		}
		var $msg = $(
			AoPS.View.prototype.getTemplate("#cmty-bookmark-modal-tpl", {
				username: AoPS.session.username,
				description: description,
				info_text: info_text,
				feed_text: Lang["bookmark-modal-feed"],
				email_text: Lang["bookmark-modal-email-" + type],
			})
		);
		//	ComViews.$bookmarkModals[type] = msg;

		$msg.find(".cmty-cancel-button").on("click", function () {});
		return $msg;
	};

	/**
	 * Show the options for bookmarking an item by firing a modal with the
	 *  options.
	 *
	 * @param type string : type of item we are bookmarking
	 * @param function : function to fire after selection is made
	 *
	 * TODO : User defaults
	 */
	ComViews.fireBookmarkModal = function (type, description, onFinish) {
		var $modal;
		//	if (!ComViews.$bookmarkModals.hasOwnProperty(type)) {
		$modal = ComViews.constructBookmarkModal(type, description);
		//	}

		//	modal = ComViews.$bookmarkModals[type];
		$modal.showModal({
			type: "confirm",
			title: Lang["bookmark-modal-title-" + type],
			force_response: true,
			closeX: false,
			confirm_button_cancel: Lang["bookmark-modal-cancel"],
			confirm_button_ok: Lang["bookmark-modal-ok"],
			width: "450px",
			onButtonClick: function (result) {
				if (result) {
					onFinish({
						is_bookmarked: true,
						is_watched: $modal
							.find('input[name="bkmk-watch-me"]')
							.is(":checked"),
						in_feed: $modal.find('input[name="bkmk-add-feed"]').is(":checked"),
					});
				}

				AoPS.Ui.Modal.closeAllModals();
			},
		});
		/*
		$modal.find('.cmty-submit-button').on('click', function () {
			var setting = 0;


			AoPS.Ui.Modal.closeAllModals();
			submit.off('click');
			return false;
		});*/
	};

	/**
	 * Determine the constructor for the TopicsList based on a category type.
	 */
	ComViews.fetchTopicsListConstructor = function (category_type) {
		switch (category_type) {
			case "my_privates":
				return ComViews.TopicsListPrivates;

			case "user_search_posts":
			case "search":
				return ComViews.TopicsListSearchPosts;

			default:
				return ComViews.TopicsList;
		}
	};

	/***
	 * fetch the View to use to construct a Category Cell given
	 *  the Category type.
	 *
	 * @param string : type of category
	 */
	ComViews.fetchCategoryCellConstructor = function (category_type) {
		switch (category_type) {
			case "forum": // Views probably go here.
			case "forum_class": // Views probably go here.
				return ComViews.CategoryCell;

			case "my_privates":
				return ComViews.CategoryCellMyPrivates;

			case "folder":
			case "folder_forums":
			case "folder_collections":
			case "my_forums":
			case "my_blogs":
			case "blogroll":
			case "my_collections":
				//		return ComViews.CategoryCellCollection;
				return ComViews.CategoryCellFolder;

			case "my_books":
				return ComViews.CategoryCellMyBooks;

			case "blog":
				return ComViews.CategoryCellBlog;

			case "my_classes":
				return ComViews.CategoryCellMyClasses;

			case "my_bookmarks":
				return ComViews.CategoryCellMyBookmarks;

			case "view_topics":
				return ComViews.CategoryCellTopicView;

			case "bookmark_topics":
			case "feed_topics":
				return ComViews.CategoryCellTopicBookmarks;

			case "bookmark_users":
				return ComViews.CategoryCellBookmarkUsers;

			case "view_forums":
				return ComViews.CategoryCellForumView;

			case "bookmark_forums":
				return ComViews.CategoryCellForumBookmarks;

			case "view_tags":
				return ComViews.CategoryCellTagView;

			case "view_posts":
				return ComViews.CategoryCellPostView;

			case "bookmark_tags":
				return ComViews.CategoryCellTagBookmarks;

			case "user":
				return ComViews.CategoryUserCell;
		}
		return ComViews.CategoryCell;
	};

	/**
	 * Check if a user has general access to community
	 */
	ComViews.hasCommunityGeneralAccess = function (
		loginMessage,
		freeResourceMessage,
		hasUndoGlobalBanPerm
	) {
		let hasCommunityGeneralAccess = true;

		// Make sure the user is logged in
		if (!AoPS.session.logged_in) {
			AoPS.Ui.buildLoginConfirm(Lang[loginMessage]);
			hasCommunityGeneralAccess = false;
		}
		// Make sure the session is initialized
		else if (!AoPS.session.initialized) {
			AoPS.Initialize.display({escapable: true});
			hasCommunityGeneralAccess = false;
		}
		// make sure the user is not COPPA blocked
		else if (AoPS.isUserCoppaBlocked()) {
			AoPS.displayCoppaBlockedModal({escapable: true});
			hasCommunityGeneralAccess = false;
		}
		// Make sure the user is allowed to access community free resources
		else if (
			!hasUndoGlobalBanPerm &&
			!ComViews.in_academy &&
			!AoPS.hasFreeResourceAccess()
		) {
			const message = Lang[freeResourceMessage];

			AoPS.Ui.Modal.showMessage(message, {
				width: "450px",
			});

			hasCommunityGeneralAccess = false;
		}

		return hasCommunityGeneralAccess;
	};

	/***
	 * fetch the View to use to construct a Category Cell Top given
	 *  the Category type.
	 *
	 * @param string : type of category
	 */
	ComViews.fetchCategoryCellCategoryTopConstructor = function (category_type) {
		switch (category_type) {
			case "my_privates":
				return ComViews.CategoryCellCategoryTopMyPrivates;

			case "bookmark_forums":
			case "view_forums":
				return ComViews.CategoryCellCategoryTopViewForums;

			case "bookmark_topics":
			case "feed_topics":
			case "view_topics":
				return ComViews.CategoryCellCategoryTopViewTopics;

			case "bookmark_tags":
			case "view_tags":
				return ComViews.CategoryCellCategoryTopViewTags;

			case "user_search_posts":
				return ComViews.CategoryCellCategoryTopUserSearchPosts;

			case "search":
				return ComViews.CategoryCellCategoryTopSearch;

			default:
				return ComViews.CategoryCellCategoryTop;
		}
	};

	/**
	 * ComViews.Post shows an entire post.
	 *
	 * Properties it expects passed in
	 * main_color : main color of the category (forum) that the post is in
	 * secondary_color : light version of the color.
	 * topic : topic view holding this post
	 */
	ComViews.Post = AoPS.View.extend({
		template_id: "#cmty-post-tpl",

		className: "cmty-post",

		show_link_in_post_number_modal: false,

		initialize: function (options) {
			this.topic = options.topic;
			this.is_read = true;
			this.watching_edit_time = false;
			// Check if this post has a poll.
			//  Polls can only be in the first post for now.
			//  If we change that, then we have made a mistake, I think :)

			this.has_poll =
				this.topic.model.get("poll_id") > 0 &&
				this.model.get("post_number") == 1;
			this.render();
			// We reset this post's visibility on changes to how we're viewing the topic.
			this.listenTo(
				this.model,
				"change:show_from_start change:show_from_end",
				_.bind(function () {
					this.topic.setPostVisibility(this);
				}, this)
			);
			this.listenTo(this.model, "change:deleted", this.onChangeDeleted);
			this.listenTo(
				this.model,
				"change:thanks_received change:nothanks_received",
				this.renderThankCount
			);
			this.listenTo(this.model, "hard_delete", this.removePostFromTopic);
			this.listenTo(
				this.model,
				"change:attachment change:attachments",
				this.parseAttachments
			);
			this.listenTo(this.model, "change:post_rendered", this.render);

			this.listenTo(
				this.model,
				"change:date_rendered",
				_.bind(function () {
					this.$el
						.find(".cmty-post-date")
						.html(this.model.get("date_rendered"));
				}, this)
			);
			this.listenTo(
				this.model,
				"change:last_edit_time_rendered",
				this.parseEditData
			);
		},

		render: function () {
			var report_data = this.constructReportTemplateData(),
				search_text,
				user_tooltip_text,
				is_site_admin = this.model.get("admin"),
				can_topic_edit = this.topic.model.getPermission("c_can_edit"),
				self = this,
				thanking_active =
					(this.topic.model.isClassForum() || AoPS.hasFreeResourceAccess()) &&
					this.topic.model.get("has_thanks") &&
					this.topic.model.getPermission("c_can_thank") &&
					AoPS.session.user_id != this.model.get("poster_id"),
				nothanking_active =
					(this.topic.model.isClassForum() || AoPS.hasFreeResourceAccess()) &&
					this.topic.model.get("has_nothanks") &&
					this.topic.model.getPermission("c_can_nothank") &&
					AoPS.session.user_id != this.model.get("poster_id"),
				can_delete_mod_level =
					this.topic.model.getPermission("c_can_delete") &&
					this.model.get("post_number") > 1,
				can_delete_user_level = this.model.isDeletableByUser(),
				template_parameters;

			var can_pm =
				AoPS.session.logged_in_and_initialized && AoPS.hasFreeResourceAccess();

			if (can_delete_user_level && !can_delete_mod_level) {
				this.listenTo(this.topic.model, "change:last_post_id", function () {
					self
						.$(".cmty-post-delete")
						.toggle(
							self.topic.model.get("last_post_id") == self.model.get("post_id")
						);
				});
			}

			if (is_site_admin) {
				user_tooltip_text = Lang["post-user-tooltip-admin"];
			} else if (this.model.get("is_forum_admin")) {
				user_tooltip_text = Lang["post-user-tooltip-forum-admin"];
			} else if (this.model.get("is_forum_mod")) {
				user_tooltip_text = Lang["post-user-tooltip-mod"];
			} else {
				user_tooltip_text = Lang["post-user-tooltip-regular"];
			}
			// Note: Data on real_poster_id, real_poster_username will only be passed
			//   forward if current user can see them.
			template_parameters = {
				user_id: this.model.get("poster_id"),
				has_poll: this.has_poll,
				username: this.model.get("username"),
				date_rendered: this.model.get("date_rendered"),
				post_number: this.model.get("post_number"),
				post_number_title: Lang["post-number-title"],
				has_real:
					this.model.get("real_poster_id") > 0 &&
					this.model.get("real_poster_id") != this.model.get("poster_id"),
				real_poster_id: this.model.get("real_poster_id"),
				real_username: this.model.get("real_poster_username"),
				is_reported: report_data.is_reported,
				highlight_report_button: report_data.highlight_report_button,
				post_rendered: this.model.get("post_rendered"),
				avatar: this.model.get("avatar"),
				user_tooltip_text: user_tooltip_text,
				one_post: this.model.get("num_posts") == 1,
				can_pm: can_pm,
				is_admin: is_site_admin,
				is_forum_admin: !is_site_admin && this.model.get("is_forum_admin"),
				is_forum_mod: !is_site_admin && this.model.get("is_forum_mod"),
				num_posts: this.model.get("num_posts"),
				rating: this.model.get("rating"),
				report_title: report_data.title,
				lang_post_unread: Lang["post-unread-tootip"],
				can_quote:
					!this.topic.model.get("locked") &&
					!this.topic.model.get("forum_locked"),
				can_report: report_data.can_report, // assumes that anyone who can settle reports can also make them.
				thankers: this.model.get("thankers"),
				lang_thankers: Lang["post-thanked-by"],
				can_edit:
					this.topic.model.getPermission("c_can_edit_own_posts") &&
					((this.topic.model.getPermission("c_can_lock_category") &&
						can_topic_edit) ||
						(!this.topic.model.get("locked") &&
							!this.topic.model.get("forum_locked") &&
							(can_topic_edit || this.model.get("editable")))),
				can_delete: can_delete_mod_level || can_delete_user_level,
				can_undelete: this.topic.model.getPermission("c_can_undelete"),
				thanking_active: thanking_active,
				nothanking_active: nothanking_active,
			};

			this.$el.html(this.getTemplate(this.template_id, template_parameters));

			if (thanking_active) {
				this.$thanks = this.$(".cmty-post-thank");
				this.setThanks();
				this.listenTo(this.model, "change:is_thanked", this.setThanks);
			}

			if (nothanking_active) {
				this.$nothanks = this.$(".cmty-post-nothank");
				this.setNothanks();
				this.listenTo(this.model, "change:is_nothanked", this.setNothanks);
			}

			// We push this in afterwards to get the pywindow to render pretty
			this.$post_html = this.$(".cmty-post-html");
			//this.$post_html.html(this.model.get('post_rendered'));
			this.setTargetBox();
			/*			if (this.model.checkShowTargetLink()) { //this.model.get('has_target')) {
				sought_url = new RegExp(document.domain + '/' + AoPS.router_root);
				full_target_url = document.domain + this.topic.model.get('target_url');
				this.$el.find('.cmty-post-body').prepend(this.getTemplate('#cmty-post-to-target-link-tpl', {
					target_note : Utils.formatString(Lang['topic-full-post-with-target-url'],
						[this.topic.model.get('target_url'), this.topic.model.get('topic_id'),
							sought_url.test(full_target_url) ? AoPS.pushState_attr : '',
						(this.topic.model.get('target_text').length > 0 ?
						this.topic.model.get('target_text') : Lang['topic-full-target-text-default'])])
				}));
			}
	*/

			if (this.model.get("can_target")) {
				this.listenTo(
					this.topic.model,
					"change:target_url change:target_text",
					this.setTargetBox
				);
			}
			this.$attachments = this.$(".cmty-post-attachments");
			this.parseAttachments();

			this.parseEditData();

			this.renderThankCount();
			this.listenTo(this.model, "change:thankers", this.setThankersBox);
			this.setVisibility();
			if (this.has_poll) {
				this.initializePoll();
			}

			if (report_data.can_settle_report) {
				this.listenTo(this.model, "change:reported", this.onReportedChange);
			}

			if (this.topic.model.get("is_search_result")) {
				search_text = this.topic.model.fetchSearchText("post_text");
				if (search_text.length > 0) {
					this.$post_html.extendedHighlightText("cmty-highlight", search_text);

					if (
						this.model.get("post_id") ===
						this.topic.model.get("focus_post").get("post_id")
					) {
						// pre-open hidden text in focus text
						this.$(".cmty-hide-heading").trigger("click");
					}
				}
			}
		},

		setThankersBox: function () {
			this.$(".cmty-post-thankers").html(
				'<span class="cmty-thank-title">' +
					Lang["post-thanked-by"] +
					'</span> <span class="cmty-thankers">' +
					this.model.get("thankers") +
					"</span>"
			);
			if (this.model.get("thanks_received") <= 0) {
				this.$el.removeClass("cmty-post-show-thanks");
			}
		},

		setThanks: function () {
			var title, content;

			if (this.model.get("is_thanked")) {
				title = Lang["post-unthank-this"];
				content = "{";
			} else {
				title = Lang["post-thank-this"];
				content = "Y";
			}

			this.$thanks[0].title = title;
			this.$thanks.text(content);
			// define this.$thanks and this.$nothanks, edit those directly.
			//  need this.has_thanks and this.has_nothanks, too, sigh.  This is so dumb
			// Remove the handlebars switches
		},

		setNothanks: function () {
			var title, content;

			if (this.model.get("is_nothanked")) {
				title = Lang["post-unnothank-this"];
				content = "}";
			} else {
				title = Lang["post-nothank-this"];
				content = "_";
			}

			this.$nothanks[0].title = title;
			this.$nothanks.text(content);
		},

		setTargetBox: function () {
			var sought_url, target_note, full_target_url;

			this.$(".cmty-post-target-note").remove();

			if (this.model.checkShowTargetLink()) {
				sought_url = new RegExp(document.domain + "/" + AoPS.router_root);
				full_target_url = document.domain + this.topic.model.get("target_url");

				// now check if we should show active or inactive link
				if (this.determineShowLink()) {
					target_note = Utils.formatString(
						// "topic-full-post-with-external-target-url"
						// "topic-full-post-with-internal-target-url"
						Lang[
							`topic-full-post-with-${
								this.linkIsExternal() ? "external" : "internal"
							}-target-url`
						],
						[
							this.topic.model.get("target_url"),
							this.topic.model.get("topic_id"),
							sought_url.test(full_target_url) ? AoPS.pushState_attr : "",
							this.topic.model.get("target_text").length > 0
								? this.topic.model.get("target_text")
								: Lang["topic-full-target-text-default"],
						]
					);
				} else {
					target_note = Utils.formatString(
						Lang["topic-full-post-without-target-url"],
						[
							this.topic.model.get("target_text").length > 0
								? this.topic.model.get("target_text")
								: Lang["topic-full-target-text-default"],
						]
					);
				}

				if (this.topic.model.get("is_restricted_soln")) {
					target_note = Utils.formatString(
						target_note + "<br>" + Lang["topic-full-post-solution-thread"]
					);
				}
				if (
					AoPS.session.user_id === this.model.get("poster_id") ||
					AoPS.session.user_id === this.model.get("real_poster_id")
				) {
					target_note +=
						'<div class="cmty-remove-target"><a class="faux-link">' +
						Lang["topic-full-remove-target"] +
						"</a></div>";
				}
				this.$el.find(".cmty-post-body").prepend(
					this.getTemplate("#cmty-post-to-target-link-tpl", {
						target_note: target_note,
					})
				);
			}
		},

		/**
		 * Determine if we should show the link in the target text
		 * This is based on hidden tags that we recieve from shared forums
		 *
		 **/
		determineShowLink: function () {
			// check hidden tags for special hidden link behavior
			var hide_target_links_to_diff_classes = false;
			_.each(this.topic.model.get("tags"), function (tag) {
				if (tag.tag_text == "hide_target_links_to_diff_classes") {
					hide_target_links_to_diff_classes = true;
				}
			});

			var show_link = true;

			var is_mod =
				AoPS.session.admin || this.topic.model.getPermission("c_can_edit");

			if (is_mod) {
				show_link = true;
			} else if (hide_target_links_to_diff_classes) {
				// parse class ID from target url of topic's target link and current url
				var class_id_curr_url =
					this.topic.model.get("target_url").match(`class\/([0-9]+)-`) || false;
				if (class_id_curr_url.length > 0) {
					class_id_curr_url = class_id_curr_url[1];
				}

				// get class ID of current url
				var current_url_class_id =
					document.URL.match(`class\/([0-9]+)-`) || false;
				if (current_url_class_id.length > 0) {
					current_url_class_id = current_url_class_id[1];
				}

				// if these classes are the same, or we didn't find a class id, show the link.
				var same_class = current_url_class_id === class_id_curr_url;
				show_link = !class_id_curr_url || !current_url_class_id || same_class;
			}

			return show_link;
		},

		linkIsExternal: function () {
			return !_.isNull(this.topic.model.get("target_url_application"));
		},

		/**
		 * Initialize the poll display window for this post.
		 *  Only happens for the first post of a topic that is a poll.
		 *  Builds the window for the poll and sets up listeners on the
		 * 	topic's poll_data property to build the poll on any change.
		 *
		 * Mixed into ComViews.TopicCellBlog
		 **/
		initializePoll: function () {
			this.$poll = this.$(".cmty-post-poll");
			this.listenTo(this.topic.model, "change:poll_data", this.constructPoll);
			this.$poll_loader = $(
				'<div class="cmty-poll-display-top cmty-poll-display">' +
					Lang["poll-loading"] +
					"</div>"
			);

			if (
				this.topic.model.has("poll_data") &&
				!_.isEmpty(this.topic.model.get("poll_data"))
			) {
				this.constructPoll();
			} else {
				this.$poll.append(this.$poll_loader);
			}
		},

		/**
		 * Construct the poll for this topic.
		 *  Called whenever the topic's poll_data is reset.
		 *
		 * Mixed into ComViews.TopicCellBlog
		 **/
		constructPoll: function () {
			var poll_data,
				lang_select_options,
				can_revote,
				self = this,
				lang_votes;
			this.$poll_loader.detach();
			this.topic.model.computeDerivedPollData();

			poll_data = this.topic.model.get("poll_data");
			lang_select_options = Utils.formatString(
				Lang[
					poll_data.num_selections == 1 ? "poll-select-one" : "poll-select-many"
				],
				[poll_data.num_selections]
			);
			lang_votes =
				poll_data.num_votes +
				Lang[poll_data.num_votes === 1 ? "poll-Vote" : "poll-Votes"];

			can_revote = poll_data.has_voted && poll_data.can_vote;

			var lang_helper = Lang["poll-revote-directions"];
			if (!AoPS.session.logged_in) {
				lang_helper = Lang["poll-not-logged-in"];
			} else if (!AoPS.session.initialized) {
				lang_helper = Lang["poll-not-initialized"];
			} else if (AoPS.isUserCoppaBlocked()) {
				lang_helper = Lang["poll-needs-coppa-approval"];
			} else if (!AoPS.hasFreeResourceAccess()) {
				lang_helper = Lang["poll-is-free-resource"];
			}
			this.$poll.html(
				this.getTemplate("#cmty-poll-display-tpl", {
					lang_heading: Lang["poll-display-heading"],
					question: poll_data.question,
					options: poll_data.options,
					lang_select_options: lang_select_options,
					lang_votes: lang_votes,
					input_type: poll_data.num_selections == 1 ? "radio" : "checkbox",
					can_vote: poll_data.can_vote,
					has_toggle: !poll_data.poll_closed && !poll_data.has_voted,
					lang_poll_vote: poll_data.has_voted
						? Lang["poll-revote-btn"]
						: Lang["poll-vote-btn"],
					lang_hide_results: Lang["poll-hide-results"],
					lang_show_results: Lang["poll-show-results"],
					has_helper_text:
						!AoPS.session.logged_in_and_initialized ||
						AoPS.isUserCoppaBlocked ||
						can_revote,
					lang_helper,
				})
			);

			this.$poll.toggleClass(
				"cmty-poll-show-results",
				poll_data.poll_closed || poll_data.has_voted
			);

			this.poll_selections = [];
			/** We track the user's selections so the user can't spazz out and click "vote" over and over. **/
			if (poll_data.can_vote) {
				_.each(poll_data.options, function (opt) {
					if (opt.selected) {
						self.poll_selections.push(opt.id);
					}
				});
			}
		},

		/** Mixed in to blogs; look at that if you change much here **/
		parseAttachments: function () {
			var images = [],
				files = [],
				self = this,
				images_contents,
				files_contents = "";

			this.$el.toggleClass("post-has-attachment", this.model.get("attachment"));
			this.$attachments.html("");
			if (!this.model.get("attachment")) {
				return;
			}
			_.each(this.model.get("attachments"), function (attachment) {
				if (self.isAttachmentImage(attachment.mimetype)) {
					images.push(attachment);
				} else {
					files.push(attachment);
				}
			});
			this.$attachments.append(
				'<div class="cmty-post-attached-title">' +
					Lang["post-attachments"] +
					"</div>"
			);
			if (images.length > 0) {
				images_contents =
					'<div class="cmty-post-attached-images"><div class="cmty-post-attached-image-content">';
				_.each(images, function (img) {
					images_contents +=
						'<a target="_blank" href="' +
						img.href +
						'"><img title="' +
						img.name +
						'" src="' +
						Constants.attachment_path +
						img.url +
						'"></a>';
				});

				images_contents += "</div></div>";
				this.$attachments.append(images_contents);
			}

			if (files.length > 0) {
				_.each(files, function (f) {
					files_contents +=
						'<div class="cmty-post-attached-file"><a target="_blank" href="' +
						f.href +
						'">' +
						f.name +
						" (" +
						f.size +
						"kb)</a></div>";
				});
				this.$attachments.append(files_contents);
			}
		},

		isAttachmentImage: function (mimetype) {
			return mimetype.substr(0, 5) === "image";
		},

		/**
		 * Called from TopicFull for the topic that holds this post.
		 **/
		markUnread: function () {
			this.$el.addClass("cmty-post-unread");
			this.is_read = false;
		},

		/**
		 * Called from TopicFull for the topic that holds this post.
		 **/
		markRead: function () {
			this.$el.removeClass("cmty-post-unread");
			this.is_read = true;
		},

		constructReportTemplateData: function () {
			var settings = {
				can_report:
					// Free-resources access is only required in the public community.
					// Class communities (class message boards) are never gated on it.
					(this.topic.model.isClassForum() || AoPS.hasFreeResourceAccess()) &&
					this.topic.model.getPermission("c_can_report"),
				can_settle_report: this.topic.model.getPermission(
					"c_can_settle_report"
				),
				is_reported: this.model.get("reported"),
				title: "",
			};

			if (settings.can_report) {
				if (settings.is_reported) {
					if (settings.can_settle_report) {
						settings.title = Lang["topic-full-settle-report-title"];
					} else {
						settings.title = Lang["topic-full-already-reported-title"];
					}
				} else {
					settings.title = Lang["topic-full-report-post-title"];
				}
			}

			settings.highlight_report_button =
				settings.can_settle_report && settings.is_reported;

			return settings;
		},

		/**
		 * If the reported status of the post changes, we need to style the report button accordingly.
		 **/
		onReportedChange: function () {
			if (this.topic.model.getPermission("c_can_settle_report")) {
				this.$el
					.find(".cmty-post-report")
					.toggleClass("cmty-post-settle-report", this.model.get("reported"));
			}
		},

		parseEditData: function () {
			var num_edits = this.model.get("num_edits"),
				edit_html;
			this.$el.toggleClass("cmty-post-edited", num_edits > 0);
			if (num_edits > 0) {
				if (this.model.get("edit_time_on_timer") && !this.watching_edit_time) {
					// TODO : set the listener in initialize
					this.watching_edit_time = true;
				}

				edit_html =
					Lang["topic-full-edited-1"] +
					num_edits +
					(num_edits > 1
						? Lang["topic-full-edited-3"]
						: Lang["topic-full-edited-2"]) +
					Lang["topic-full-edited-4"] +
					this.model.get("last_editor_username") +
					", " +
					this.model.get("last_edit_time_rendered");

				if (this.model.get("last_edit_reason").length > 0) {
					edit_html +=
						"<br>" + Lang["Reason"] + ": " + this.model.get("last_edit_reason");
				}
				this.$el.find(".cmty-post-edit-info").html(edit_html);
			}
		},

		events: {
			"click .cmty-post-report": "onClickReport",
			"click .cmty-post-settle-report": "onClickSettleReport",
			"click .cmty-post-quote": "onClickQuote",
			"click .cmty-post-delete": "onClickDelete",
			"click .cmty-post-deleted-info": "onClickDeletedInfo",
			"click .cmty-undelete-post": "onClickUndelete",
			"click .cmty-post-thank": "onClickThanks",
			"click .cmty-post-nothank": "onClickNothanks",
			"click .cmty-post-edit": "onClickEdit",
			"click .cmty-post-number": "onClickDirectLink",
			"click .cmty-poll-results-toggle span": "onClickTogglePollResults",
			"click .cmty-poll-vote-row .btn": "onClickPollVote",
			"mousedown .cmty-post-middle": "onClickPostBody",
			"click .cmty-remove-target": "onClickRemoveTarget",
			"click .cmty-post-thank-count": "onClickThankCount",
			"click .cmty-pm-from-post": "onClickMessage",
		},

		/**
		 * Start a new private message with this user.
		 **/
		onClickMessage: function (e) {
			var poster_id;
			var username;
			if (this.model.get("real_poster_id") > 0) {
				poster_id = this.model.get("real_poster_id");
				username = this.model.get("real_poster_username");
			} else {
				poster_id = this.model.get("poster_id");
				username = this.model.get("username");
			}

			var private_message = ComViews.launchNewPrivateMessage({
				user_id: poster_id,
				username: username,
				is_admin: this.model.get("admin"),
			});

			/**
			 * If topic is a private message, we don't include link to the post;
			 *  the recipient may not be able to access it.
			 *
			 * This essentially provides a forwarding mechanism.
			 **/
			var contentKey = "private-from-post";
			if (this.model.get("deleted")) {
				contentKey += "-deleted";
			}

			var url_data = this.constructPostUrl();

			var message = this.topic.model.isPrivateMessage()
				? ""
				: Utils.formatString(Lang[contentKey], [url_data.url]);
			message = message.replace(/&#x2F;/g, "/");

			message +=
				'[quote="' +
				this.model.get("username") +
				'"]' +
				this.model.get("post_canonical") +
				"[/quote]";
			private_message.addContent(message);

			if (!_.isUndefined(e)) {
				e.stopPropagation();
				e.preventDefault();
				return false;
			}
		},

		onClickThankCount: function () {
			this.$el.toggleClass("cmty-post-show-thanks");
		},

		onClickRemoveTarget: function () {
			var self = this,
				message,
				topic = this.model.get("topic");

			message =
				topic.get("target_text").length > 0
					? Utils.formatString(Lang["mod-topic-remove-target-with-text"], [
							topic.get("target_text"),
						])
					: Lang["mod-topic-remove-target-confirm"];

			Modal.showConfirm(
				message,
				function (ok) {
					if (ok) {
						ComViews.replaceWithLoaderBlockingMessage(
							Lang["mod-topic-remove-target-blocker"]
						);
						self.model.get("topic").removeTarget({
							onFinish: function () {
								setTimeout(function () {
									Modal.closeAllModals();
								}, 500);
							},
							onError: ComViews.throwAjaxError,
						});
					} else {
						Modal.closeAllModals();
					}
				},
				{
					width: "450px",
					close_on_button_click: false,
				}
			);
		},

		/** Mixed into ComViews.TopicCellBlog **/
		onClickTogglePollResults: function () {
			this.$poll.toggleClass("cmty-poll-show-results");
		},

		/**
		 * Here we stop the propagation of click events when user clicks in the post,
		 *  so that users can highlight text in the feed (the feed is draggable).
		 **/
		onClickPostBody: function (e) {
			e.stopPropagation();
		},

		/**
		 * What we do when we click to vote on polls
		 * Mixed into ComViews.TopicCellBlog
		 **/
		onClickPollVote: function () {
			var num_selections = this.topic.model.get("poll_data").num_selections,
				selection,
				self = this;
			if (num_selections === 1) {
				selection = this.$poll
					.find('input:radio[name="poll-options"]:checked')
					.val();
				if (_.isUndefined(selection)) {
					AoPS.Ui.Modal.showAlertQuick(Lang["poll-nothing-selected"]);
					return;
				}
				selection = [selection];
			} else {
				selection = [];
				_.each(
					this.$poll.find('input:checkbox[name="poll-options"]:checked'),
					function (checkbox) {
						selection.push(checkbox.value);
					}
				);
				if (selection.length == 0) {
					AoPS.Ui.Modal.showAlertQuick(Lang["poll-nothing-selected"]);
					return;
				} else if (selection.length > num_selections) {
					AoPS.Ui.Modal.showAlertQuick(
						Utils.formatString(Lang["poll-too-many-selected"], [num_selections])
					);
					return;
				}
			}

			/** Check if the user's vote has actually changed. **/
			if (selection.join() === this.poll_selections.join()) {
				return;
			}

			AoPS.Community.Views.throwBlockingMessage(Lang["poll-vote-processing"]);
			this.topic.model.castVote({
				votes: selection,
				onFinish: function () {
					setTimeout(function () {
						AoPS.Ui.Modal.closeAllModals();
					}, Constants.message_readability_delay_short);
				},
				onError: function (msg) {
					var code = msg.error_code,
						output_string;
					if (code === "E_NOT_LOGGED_IN") {
						output_string = Lang["poll-err-not-logged-in"];
					} else if (code === "E_POLL_CLOSED") {
						self.topic.model.get("poll_data").poll_closed = true;
						self.topic.model.trigger("change:poll_data");
						output_string = Lang["poll-err-closed"];
					} else {
						output_string = Lang["unexpected-error-code"] + code;
					}

					AoPS.Community.Views.showError(output_string);
				},
			});
		},

		constructPostUrl: function () {
			var url_path =
					"/community/c" +
					this.topic.model.get("category_id") +
					"h" +
					this.model.get("topic_id") +
					"p" +
					this.model.get("post_id"),
				url = Constants.base_url + url_path;

			return {
				url_path: url_path,
				url: url,
			};
		},

		/**
		 * When we click on the post number, we get a modal with the direct
		 *  link already selected.
		 **/
		onClickDirectLink: function (e) {
			var url_data = this.constructPostUrl(),
				$modal,
				view_IP = AoPS.Community.MasterModel.fetchStaffPermission("ip-lookup"),
				self = this,
				$button,
				$loading,
				$input;

			$modal = $(
				'<div class="cmty-post-direct-modal">' +
					Utils.formatString(Lang["post-direct-link"], [url_data.url_path]) +
					'<br><br>\
					<input value="' +
					url_data.url +
					'" /></div>'
			);

			/**
			 * Eventually we will probably fold this into permissions.
			 **/

			if (view_IP) {
				$button = $(
					'<button class="btn btn-primary">' +
						Lang["post-direct-click-ip"] +
						"</button>"
				);
				$loading = $("<div>" + Lang["post-direct-loading-ip"] + "</div>");
				$modal.append("<br><br>").append($button);
				$button.on("click", function () {
					$button.hide();
					$modal.append($loading);
					self.model.fetchIP({
						onFinish: function (response) {
							$loading.text(response.ip);
						},
						onError: function (response) {
							$loading.text(response.error_code);
						},
					});
				});
			}

			$modal.showModal({
				width: "400px",
			});
			$input = $modal.find("input");
			$input[0].setSelectionRange(0, $input.val().length);
			e.stopPropagation();
			e.preventDefault();
		},

		/**
		 * What happens when we click edit.
		 * NOTE: I do not update the views on topic lock to remove the quotes or the
		 *   edits because that might be hundreds or thousands of posts.
		 */
		onClickEdit: function (e) {
			var edit_post,
				edit_post_constructor =
					this.model.get("post_number") === 1 ? "EditFirstPost" : "EditPost";
			e.stopPropagation();
			e.preventDefault();

			// Only people with the ability to lock/unlock the forum can edit posts here
			if (this.topic.model.get("forum_locked")) {
				if (!this.topic.model.getPermission("c_can_lock_category")) {
					Modal.showMessage(Lang["topic-edit-forum-locked"]);
					return;
				}
			}

			// We allow mods to edit posts in locked topics but not locked forums
			if (!this.topic.model.getPermission("c_can_edit")) {
				if (this.topic.model.get("locked")) {
					Modal.showMessage(Lang["topic-edit-locked"]);
					return;
				}
			}

			edit_post = new AoPS.Community.Views[edit_post_constructor]({
				post_model: this.model,
				topic_id: this.model.get("topic_id"),
				category_id: this.topic.model.get("category_id"),
				topic: this.topic.model,
				master: this.topic.model.get("master"),
				input_text: this.model.get("post_canonical"),
			});

			edit_post.$el.showModal({
				frame_class: "cmty-posting-modal",
				mask_fade_in_speed: 200,
				scrollable: false,
				max_width: "1000px",
				onClickMask: function () {
					// edit_post.onClickCancel();
					return false;
				},
				onClickX: function () {
					edit_post.onClickCancel();

					return false;
				},
			});
			edit_post.setHeight();
		},

		/**
		 * What happens when we click Thank.
		 */
		onClickThanks: function (e) {
			// This function silently fails for users that are not logged in or not initialized.
			// The thanks will appear to work, but not actually be saved.
			var status = this.model.get("is_thanked") ? 0 : 1;
			this.model.setThankStatus({new_status: status});
			/*if (new_thank_status == 1) {
				this.$el.toggleClass('cmty-post-show-thanks');
			}// Rethink : won't have the name until back from server -- trigger there? */

			//	Y to thank
			//{ to unthank
			// &#125; is }
			//		this.$el.find('.cmty-post-thank').hide();
			/*this.$el.find('.cmty-
			this.model.thank();			*/
		},

		onClickNothanks: function (e) {
			var status = this.model.get("is_nothanked") ? 0 : -1;
			this.model.setThankStatus({new_status: status});
		},

		/**
		 * What happens when we hit the quote button.
		 *
		 * NOTE: I do not update the views on topic lock to remove the quotes or the
		 *   edits because that might be hundreds or thousands of posts.
		 */
		onClickQuote: function () {
			// Check for general access
			if (
				!ComViews.hasCommunityGeneralAccess(
					"topic-full-unregistered-reply",
					"new-reply-no-permission-free-resource",
					this.topic.model.getPermission("c_undo_global_ban")
				)
			) {
				return false;
			} else {
				if (this.topic.model.get("locked")) {
					Modal.showMessage(Lang["topic-full-reply-to-locked"]);
				} else if (this.topic.model.get("forum_locked")) {
					Modal.showMessage(Lang["topic-full-reply-to-forum-locked"]);
				} else {
					this.topic.appendToReply(
						"[quote=" +
							this.model.get("username") +
							"]" +
							$.trim(this.model.get("post_canonical")) +
							"[/quote]\n\n"
					);
				}
			}
		},

		/**
		 * What happens when we hit the report post button. (Launch ComViews.ReportPost window)
		 */
		onClickReport: function (e) {
			var report_window;
			e.stopPropagation();
			e.preventDefault();

			if (!AoPS.session.logged_in) {
				AoPS.Ui.buildLoginConfirm(Lang["topic-full-report-not-logged-in"]);
				return;
			} else if (!AoPS.session.initialized) {
				AoPS.Initialize.display({escapable: true});
				return;
			}

			if (this.model.get("reported")) {
				if (!this.topic.model.getPermission("c_can_settle_report")) {
					AoPS.Ui.Modal.showMessage(Lang["topic-full-already-reported"]);
					return;
				} else {
					return;
				}
			}

			report_window = new ComViews.ReportPost({
				model: this.model,
			});
			report_window.$el.showPlainModal();
		},

		onClickSettleReport: function (e) {
			if (ComViews.inCmtyRouter()) {
				ComViews.followUrlOnClick(
					e,
					"/reported-posts/p" + this.model.get("post_id")
				);
			} else {
				window.location.href =
					"/community/reported-posts/p" + this.model.get("post_id");
			}
			//			Backbone.history.navigate('/reported-posts/p' + this.model.get('post_id'), {trigger : true});
			e.stopPropagation();
			e.preventDefault();
		},

		/**
		 * What happens when we hit the delete post button. (Launch ComViews.DeletePost window)
		 */
		onClickDelete: function (e) {
			var delete_window;

			delete_window = new ComViews.DeletePost({
				model: this.model,
				topic: this.model.get("topic"),
			});

			if (AoPS.session.national_staff && (e.shiftKey || e.metaKey)) {
				delete_window.onFormSubmit(e, {force_soft: true});
			} else {
				delete_window.$el.showPlainModal();
				delete_window.$el.find('[value="OK"]').focus();
			}
			e.stopPropagation();
			e.preventDefault();
		},

		/**
		 * What happens when we click the bar that sits atop deleted posts.
		 */
		onClickDeletedInfo: function () {
			this.$el.toggleClass("cmty-post-deleted-open");
		},

		/**
		 * What happens when we click undelete -- throw confirm dialog.
		 */
		onClickUndelete: function (e) {
			AoPS.Ui.Modal.showMessage(Lang["topic-full-undelete-message"], {
				type: "confirm",
				title: Lang["topic-full-undelete-title"],
				confirm_button_ok: Lang["yes"],
				confirm_button_cancel: Lang["no"],
				onButtonClick: _.bind(function (value) {
					if (value) {
						this.model.undelete({
							onError: function (data) {
								if (data.error_code === "E_HARD_DELETE") {
									Flyout.display(Lang["topic-full-undelete-hard"]);
								}
							},
						});
					}
					AoPS.Ui.Modal.closeAllModals();
				}, this),
			});
			e.stopPropagation();
			e.preventDefault();
			return false;
		},

		/**
		 * When the deleted status of this post changes, we need to decide
		 *  whether to hide, reveal, or destroy this post.
		 */
		onChangeDeleted: function () {
			if (
				this.model.get("deleted") &&
				!this.topic.model.getPermission("c_can_read_deleted")
			) {
				this.removePostFromTopic();
			} else {
				this.setVisibility();
			}
		},

		/**
		 * Remove this post from its topic.
		 *  Overwritten in some children (PostReportPostWindow)
		 **/
		removePostFromTopic: function () {
			if (typeof this.topic.removePost === "function") {
				this.topic.removePost(this);
			}
		},

		/**
		 * Render the number of thanks.
		 *
		 * Number of thanks never goes down, so we don't have to worry about
		 *  erasing something on thanks_received == 0.
		 */
		renderThankCount: function () {
			if (
				this.model.get("thanks_received") > 0 &&
				this.topic.model.get("has_thanks")
			) {
				this.$el
					.find(".cmty-post-thank-count")
					.html(
						$.parseHTML(
							" &bull; " +
								this.model.get("thanks_received") +
								' <span class="aops-font">Y</span>'
						)
					);
			} else {
				this.$el.find(".cmty-post-thank-count").html("");
			}

			if (
				this.model.get("nothanks_received") > 0 &&
				this.topic.model.get("has_nothanks")
			) {
				this.$el
					.find(".cmty-post-nothank-count")
					.html(
						$.parseHTML(
							" &bull; " +
								this.model.get("nothanks_received") +
								' <span class="aops-font">_</span>'
						)
					);
			} else {
				this.$el.find(".cmty-post-nothank-count").html("");
			}
		},

		/**
		 * Set the visibility of the post based on whether or not it is deleted.
		 *  CSS controls what is shown.
		 */
		setVisibility: function () {
			this.$el.toggleClass("cmty-post-is-deleted", this.model.get("deleted"));
		},
	});

	ComViews.ModerateTopic = AoPS.View.extend({
		template_id: "#cmty-moderate-topic-tpl",

		initialize: function (options) {
			var lock_state = this.model.get("locked"),
				self = this,
				has_target,
				hidden_tags = [],
				is_private = this.model.get("topic_type") === "private",
				announce_type = this.model.get("announce_type");

			ComViews.setRouteInfo(this, options);
			this.topic_category_at_initialization =
				options.topic_category_at_initialization;

			this.$el.html(
				$(
					this.getTemplate(this.template_id, {
						title: this.model.get("topic_title"),
						username: this.model.get("first_poster_name"),
					})
				)
			);

			this.$buttons_cell = this.$el.find(".cmty-moderate-topic-buttons");

			//this.topic_view = options.topic_view;

			// remember to destroy view up in TopicFull on close

			if (!is_private) {
				this.buildButton({
					permission: "c_can_move_topic_out",
					symbol: "N",
					text: Lang["mod-topic-move"],
					onClick: "onClickMoveTopic",
				});

				this.buildButton({
					permission: "c_can_lock_topic",
					symbol: lock_state ? "l" : "k",
					text: lock_state ? Lang["mod-topic-unlock"] : Lang["mod-topic-lock"],
					onClick: "onLockTopic",
				});
			}

			if (this.model.get("category_id") != Constants.recycle_bin_id) {
				this.buildButton({
					permission: "c_can_delete",
					symbol: "J",
					text: Lang["mod-topic-delete"],
					onClick: "onSoftDeleteTopic",
				});
			}

			this.buildButton({
				permission: "c_can_hard_delete",
				symbol: "J",
				text: Lang["mod-topic-hard-delete"],
				onClick: "onHardDeleteTopic",
			});

			if (!is_private) {
				if (announce_type === "none") {
					this.buildButton({
						permission: "c_can_announce",
						symbol: "i",
						text: Lang["mod-topic-announce"],
						onClick: "onMakeLocalAnnouncement",
					});
					this.buildButton({
						permission: "c_can_global_announce",
						symbol: "a",
						text: Lang["mod-topic-global"],
						onClick: "onMakeGlobal",
					});
				} else if (announce_type === "local") {
					this.buildButton({
						permission: "c_can_announce",
						symbol: "i",
						text: Lang["mod-topic-normal"],
						onClick: "onMakeNormal",
					});
					this.buildButton({
						permission: "c_can_global_announce",
						symbol: "a",
						text: Lang["mod-topic-global"],
						onClick: "onMakeGlobal",
					});
				} else if (announce_type === "global") {
					this.buildButton({
						permission: "c_can_global_announce",
						symbol: "a", // TODO What icon?
						text: Lang["mod-topic-normal"],
						onClick: "onMakeNormal",
					});
				}
			}

			if (this.model.get("cat_can_target")) {
				has_target = this.model.get("target_url").length > 0;
				this.buildButton({
					permission: "c_can_add_target",
					symbol: "j",
					text: has_target
						? Lang["mod-topic-replace-target"]
						: Lang["mod-topic-add-target"],
					onClick: "onAddTarget",
				});

				if (has_target) {
					this.buildButton({
						permission: "c_can_remove_target",
						symbol: "Jj",
						text: Lang["mod-topic-remove-target"],
						onClick: "onRemoveTarget",
					});
				}

				/**
				 * For now, assuming that only categories that can have targets
				 *  can have hidden tags.  This may change, of course.
				 *
				 * I'm letting hidden tag permissions go right alongside
				 *  add/remove target.
				 **/

				this.buildButton({
					permission: "c_can_add_target",
					symbol: "+",
					text: Lang["mod-topic-add-hidden"],
					onClick: "onAddHiddenTag",
				});
				if (this.model.getPermission("c_can_remove_target")) {
					if (this.model.get("tags").length > 0) {
						hidden_tags = this.findRemovableHiddenTags();
						if (hidden_tags.length > 0) {
							this.$el.append(
								'<div class="cmty-mod-topic-hidden-title"><u>' +
									Lang["mod-topic-hidden-tags"] +
									"</u></div>"
							);
							_.each(hidden_tags, function (tag) {
								var $hidden_tag = $(
									'<div class="cmty-mod-topic-hidden-tag"><span class="aops-font">J</span>' +
										tag.tag_text +
										"</div>"
								);
								self.$el.append($hidden_tag);
								$hidden_tag.find(".aops-font").on("click", function () {
									self.model.removeTag(tag.tag_id, tag.tag_text);
									$hidden_tag.remove();
									if (self.findRemovableHiddenTags().length == 0) {
										self.$(".cmty-mod-topic-hidden-title").remove();
									}
								});
							});
						}
					}
				}
			}
			if (this.model.get("master").fetchPermission("can_access_log")) {
				this.buildButton({
					symbol: "h",
					text: Lang["mod-topic-log"],
					onClick: "onVisitLog",
				});
			}

			this.$el.showModal({
				title: Lang["mod-topic-title"],
				onClose: function () {
					self.destroy();
				},
			});
		},

		onVisitLog: function (e) {
			ComViews.leaveRouterOnClick(
				e,
				"/log/topic/" + this.model.get("topic_id")
			);
			//			window.location.href = '/community/log/topic/' + this.model.get('topic_id');
		},

		/**
		 * What happens when we click 'Add Target Url' or 'Replace Target Url'
		 **/
		onAddTarget: function () {
			var $win,
				current_target = this.model.get("target_url"),
				current_target_tag,
				self = this,
				is_current_restricted = false;

			if (current_target.length > 0) {
				current_target_tag = _.findWhere(this.model.get("tags"), {
					tag_text: current_target,
				});
				is_current_restricted =
					!_.isUndefined(current_target_tag) && !current_target_tag.is_public;
			}

			$win = $(
				this.getTemplate("#cmty-mod-topic-add-target-tpl", {
					current_target: current_target,
					is_restricted: is_current_restricted,
					lang_edit_instructions: Lang["mod-topic-edit-target-instructions"],
					lang_tag_text: Lang["mod-topic-edit-target-url"],
					lang_target_text: Lang["mod-topic-edit-target-text"],
					current_target_text: this.model.get("target_text"),
					lang_restricted: Lang["mod-topic-edit-target-is-restricted"],
				})
			);

			$win.find('input[type="text"]').focus();

			Modal.showConfirm(
				$win,
				function (ok) {
					var new_target, new_target_text, is_restricted;
					if (ok) {
						new_target = $.trim($win.find("input.cmty-mod-topic-target").val());
						new_target_text = $.trim(
							$win.find("input.cmty-mod-topic-target-text").val()
						);
						if (new_target.length == 0) {
							self.destroy();
							return;
						}

						if (ComViews.isStateTag(new_target)) {
							ComViews.showErrorAtopAModal(Lang["mod-topic-no-state-tags"]);
							return;
						}
						is_restricted = $win.find('input[type="checkbox"]').is(":checked");

						if (
							new_target.toLowerCase() === current_target.toLowerCase() &&
							is_restricted == is_current_restricted &&
							new_target_text === self.model.get("target_text")
						) {
							self.destroy();
							return;
						}
						ComViews.replaceWithLoaderBlockingMessage(
							Lang["mod-topic-remove-target-blocker"]
						);

						self.model.changeTargetUrl({
							new_target: new_target,
							new_target_text: new_target_text,
							is_restricted: is_restricted,
							onFinish: function () {
								setTimeout(function () {
									self.destroy();
								}, 500);
							},
							onError: ComViews.throwAjaxError,
						});
					} else {
						self.destroy();
					}
				},
				{
					width: "450px",
					close_on_button_click: false,
				}
			);
		},

		/**
		 * Stuff we do when we click Add Hidden Tag.
		 **/
		onAddHiddenTag: function () {
			var $win,
				self = this;

			$win = $(
				this.getTemplate("#cmty-mod-topic-add-target-tpl", {
					lang_edit_instructions: Lang["mod-topic-hidden-tag-instructions"],
					lang_tag_text: Lang["mod-topic-hidden-tag-text"],
					lang_restricted: Lang["mod-topic-hidden-tag-is-restricted"],
					current_target: "",
					is_restricted: false,
				})
			);
			$win.find('input[type="text"]').focus();
			Modal.showConfirm(
				$win,
				function (ok) {
					var new_text, is_restricted;
					if (ok) {
						new_text = $.trim($win.find('input[type="text"]').val());
						if (new_text.length == 0) {
							self.destroy();
							return;
						}
						if (ComViews.isStateTag(new_text)) {
							ComViews.showErrorAtopAModal(Lang["mod-topic-no-state-tags"]);
							return;
						}
						is_restricted = $win.find('input[type="checkbox"]').is(":checked");

						ComViews.replaceWithLoaderBlockingMessage(
							Lang["mod-topic-hidden-tag-blocker"]
						);

						self.model.addHiddenTag({
							new_text: new_text,
							is_restricted: is_restricted,
							onFinish: function () {
								setTimeout(function () {
									self.destroy();
								}, 500);
							},
							onError: ComViews.throwAjaxError,
						});
					} else {
						self.destroy();
					}
				},
				{
					width: "450px",
					close_on_button_click: false,
				}
			);
		},

		/**
		 * Find the hidden tags that can be removed.
		 *
		 * @return array of the hidden tags that are not the target url, and
		 *	are not state tags.
		 **/
		findRemovableHiddenTags: function () {
			var hidden_tags = [],
				self = this;
			_.each(this.model.get("tags"), function (tag) {
				if (
					!tag.is_visible &&
					tag.tag_text !== self.model.get("target_url") &&
					!ComViews.isStateTag(tag.tag_text)
				) {
					hidden_tags.push(tag);
				}
			});
			return hidden_tags;
		},

		/**
		 * Note that we don't bother checking for login status.  The
		 *  user should get a separate warning if they happen to get logged out
		 *  while they have the mod panel up.  If they barrel ahead and lock/unlock,
		 *  it will only happen on their client.  That's fine by me.
		 *  No need for a fancy structure here for something that almost never happens
		 *	and does not damage when it does.
		 */
		onLockTopic: function () {
			if (this.model.get("locked")) {
				this.model.unlock();
				this.destroy();
			} else {
				if (this.model.get("first_poster_id") !== AoPS.session.user_id) {
					var self = this;
					var $confirm = $("<div />")
						.append($.parseHTML(Lang["mod-topic-lock-warning"]))
						.append($("<h3 />").text("Reason:"))
						.append(Utils.getModerationInputsForType("topic"));

					AoPS.Ui.Modal.showConfirm(
						$confirm,
						function (value) {
							if (value) {
								var reason =
									$confirm.find("input[name='reason']:checked").val() || "";

								AoPS.Community.Views.throwBlockingMessage(
									Lang["mod-topic-lock-pending"]
								);

								self.model.lock({reason: reason});
								self.destroy();
							} else {
								AoPS.Ui.Modal.closeTopModal();
							}
						},
						{
							title: Lang["mod-topic-lock-title"],
							close_on_button_click: false,
						}
					);
				} else {
					this.model.lock();
					this.destroy();
				}
			}
		},

		onRemoveTarget: function () {
			var self = this;

			Modal.showConfirm(
				Lang["mod-topic-remove-target-confirm"] +
					Lang["mod-topic-remove-target-extra"],
				function (ok) {
					if (ok) {
						ComViews.replaceWithLoaderBlockingMessage(
							Lang["mod-topic-remove-target-blocker"]
						);
						self.model.removeTarget({
							onFinish: function () {
								setTimeout(function () {
									self.destroy();
								}, 500);
							},
							onError: ComViews.throwAjaxError,
						});
					} else {
						self.destroy();
					}
				},
				{
					width: "450px",
					close_on_button_click: false,
				}
			);
		},

		hasTopicMoved: function () {
			if (
				this.topic_category_at_initialization != this.model.get("category_id")
			) {
				AoPS.Ui.Modal.showMessage(Lang["mod-topic-move-err-E_ALREADY_MOVED"]);
				return true;
			} else {
				return false;
			}
		},

		onClickMoveTopic: function () {
			var self = this;
			this.checkTopicLength({
				onOK: function () {
					self.onMoveTopic();
				},
			});
		},

		onMoveTopic: function () {
			if (this.hasTopicMoved()) {
				return;
			}

			var quick_links = Constants.move_topic_quick_links,
				has_quick_links =
					AoPS.session.logged_in_and_initialized &&
					quick_links.hasOwnProperty(this.model.get("category_id").toString()),
				current_category = this.model
					.get("master")
					.fetchCategory(this.model.get("category_id")),
				$current_category,
				$move_window = $(
					this.getTemplate("#cmty-mod-topic-move-tpl", {
						has_current_category: !_.isUndefined(current_category),
						topic_title: this.model.get("topic_title"),
						quick_link_title: Lang["mod-topic-move-quick"],
						first_poster_name: this.model.get("first_poster_name"),
						input_heading: Lang["mod-topic-move-input-heading"],
						has_quick_links: has_quick_links,
					})
				),
				$quick_link_window,
				topic_id = this.model.get("topic_id"),
				self = this;

			function buildOnError() {
				return function (data) {
					var err = data.error_code,
						msg;
					if (Lang.hasOwnProperty("mod-topic-move-err-" + err)) {
						msg = Lang["mod-topic-move-err-" + err];
					} else {
						msg = Lang["unexpected-error-code"] + err;
					}
					AoPS.Ui.Modal.showAlert(msg, {
						onClose: function () {
							self.destroy();
						},
						width: "450px",
					});
				};
			}

			function buildOnFinish(new_category_id, new_topic_id) {
				return function () {
					var url = "/c" + new_category_id + "h" + new_topic_id;

					// If in the community,
					//  then stay in router.  Otherwise, we need to rebuild
					if (self.url_router_base === "/community") {
						Backbone.trigger("close_feed_topic");
						Backbone.history.navigate(url, {trigger: true});
						self.close();
					} else {
						window.location.href = "/community" + url;
					}
				};
			}

			if (!_.isUndefined(current_category)) {
				$current_category = $move_window.find(".cmty-item-forum").first();
				$current_category.html(current_category.get("category_name")).css({
					color: current_category.get("main_color"),
				});
			}

			if (has_quick_links) {
				$quick_link_window = $move_window.find(".cmty-mod-topic-move-quick");
				_.each(
					quick_links[this.model.get("category_id").toString()],
					function (quick_link) {
						var category = self.model.get("master").fetchCategory(quick_link),
							$category;
						if (!_.isUndefined(category)) {
							$category = $("<div/>", {
								class: "cmty-item-forum",
								html: category.get("category_name"),
							}).on("click", function () {
								var new_category_id = category.get("category_id");

								AoPS.Community.Views.throwBlockingMessage(
									Lang["mod-topic-move-in-progress"]
								);

								self.model.move({
									new_category_id: new_category_id,
									onFinish: buildOnFinish(new_category_id, topic_id),
									onError: buildOnError(),
								});
							});

							$category
								.css({
									color: category.get("main_color"),
								})
								.on("mouseenter", function (e) {
									$category.css({
										color: category.get("secondary_color"),
										"background-color": category.get("main_color"),
									});
								})
								.on("mouseleave click", function (e) {
									$category.css({
										color: category.get("main_color"),
										"background-color": "#fff",
									});
								});

							$quick_link_window.append($category);
						}
					}
				);

				//TODO : Don't show move topic if we are in a view?  Yeah, we can, since the moderator
				// is set on the topic's category
			}

			Utils.buildCategoryAutocomplete($move_window.find("input").first(), {
				ajax_call: "fetch_forum_autocomplete",
				autocomplete_settings: {
					onSelect: function (e, ui) {
						var category_id = parseInt(ui.item.category_id);
						AoPS.Community.Views.throwBlockingMessage(
							Lang["mod-topic-move-in-progress"]
						);

						self.model.move({
							new_category_id: category_id,
							onFinish: buildOnFinish(category_id, topic_id),
							onError: buildOnError(),
						});
					},
					onOpen: function () {
						//		$('.cmty-move-topic-modal .aops-modal-body').height(400);
						//		$('.cmty-move-topic-modal').height(400);
					},
				},
			});

			$move_window.showModal({
				title: Lang["mod-topic-move-title"],
				frame_class: "cmty-move-topic-modal aops-modal-standard",
				scrollable: false,
				max_width: "400px",
				onClose: function () {
					$move_window.remove();
				},
			});
		},

		onSoftDeleteTopic: function () {
			var self = this;
			this.checkTopicLength({
				onOK: function () {
					self.onDeleteTopic("soft");
				},
			});
		},

		onHardDeleteTopic: function () {
			var self = this;
			this.checkTopicLength({
				onOK: function () {
					self.onDeleteTopic("hard");
				},
			});
		},

		/**
		 * Only admins and mods can move or delete long topics.
		 *  Admins should only move or delete when the site is not that active.
		 **/
		checkTopicLength: function (obj) {
			if (this.model.get("num_posts") > Constants.topic_move_length_limit) {
				if (
					AoPS.Community.MasterModel.fetchStaffPermission(
						"can-delete-long-topic"
					)
				) {
					AoPS.Ui.Modal.showConfirm(
						Lang["mod-long-topic-admin-warning"],
						function (ok) {
							AoPS.Ui.Modal.closeTopModal();
							if (ok) {
								obj.onOK();
							} else {
							}
						},
						{
							confirm_button_ok: Lang["mod-long-topic-admin-OK"],
							confirm_button_cancel: Lang["mod-long-topic-admin-no"],
							width: "450px",
							close_on_button_click: false,
						}
					);
					$(":focus").blur(); // Must force them to click on yes.
				} else {
					AoPS.Ui.Modal.showAlert(
						Lang["mod-topic-delete-err-E_TOPIC_TOO_LONG"],
						{
							onClose: function () {
								self.destroy();
							},
							width: "400px",
						}
					);
				}
			} else {
				obj.onOK();
			}
		},

		setAnnouncementType: function (type, announce_through) {
			var self = this;
			this.model.setAnnounceType({
				type: type,
				announce_through: announce_through,
				onFinish: function () {
					var url;

					url =
						self.url_cmty_path +
						"/c" +
						self.model.get("category_id") +
						"h" +
						self.model.get("topic_id");
					Backbone.history.fragment = null;
					Backbone.history.navigate(url, {trigger: true});
					self.destroy();
				},
				onError: function (data) {
					var err = data.error_code;
					var msg;

					if (Lang.hasOwnProperty("mod-topic-announce-err-" + err)) {
						msg = Lang["mod-topic-announce-err-" + err];
					} else {
						msg = Lang["unexpected-error-code"] + err;
					}
					AoPS.Ui.Modal.showAlert(msg, {
						onClose: function () {
							self.destroy();
						},
					});
				},
			});
		},

		onMakeNormal: function () {
			this.setAnnouncementType("none", "");
		},

		onMakeLocalAnnouncement: function () {
			this.fetchAnnouncementDate("local");
		},

		onMakeGlobal: function () {
			this.fetchAnnouncementDate("global");
		},

		fetchAnnouncementDate: function (announce_type) {
			var $announce_through = $(
					"<div>" +
						Lang["mod-topic-set-announce-through"] +
						'<br><input type="text" class="cmty-posting-announce-through" placeholder="yyyy-mm-dd"></div>'
				),
				$announce_input = $announce_through.find("input"),
				self = this;
			ComViews.makeAnnounceDateInput($announce_input);

			Modal.showConfirm(
				$announce_through,
				function (ok) {
					if (ok) {
						ComViews.replaceWithLoaderBlockingMessage(
							Lang["mod-topic-announce-blocker"]
						);
						setTimeout(function () {
							self.setAnnouncementType(announce_type, $announce_input.val());
						}, 500);
					}
				},
				{
					close_on_button_click: false,
				}
			);
		},

		/**
		 * The actions for the two types of deletes are nearly identical.
		 *  This creates both.
		 *
		 * @param string : 'soft' or 'hard'
		 **/
		onDeleteTopic: function (delete_type) {
			var self = this,
				topic_type = this.model.get("topic_type");
			var $confirm = $("<div />").append(
				$.parseHTML(Lang["mod-topic-" + delete_type + "-delete-warning"])
			);

			if (self.model.get("first_poster_id") !== AoPS.session.user_id) {
				$confirm
					.append($("<h3 />").text("Reason:"))
					.append(Utils.getModerationInputsForType("topic"));
			}

			AoPS.Ui.Modal.showConfirm(
				$confirm,
				function (value) {
					if (value) {
						var reason =
							$confirm.find("input[name='reason']:checked").val() || "";
						AoPS.Community.Views.throwBlockingMessage(
							Lang["mod-topic-delete-pending"]
						);
						self.model.delete({
							delete_type: delete_type,
							reason: reason,
							onFinish: function () {
								Backbone.trigger("close_feed_topic");
								self.destroy();
								if (topic_type === "blog_post") {
								}
							},
							onError: function (err) {
								var msg, error_code;
								error_code = err.error_code;
								if (Lang.hasOwnProperty("mod-topic-delete-err-" + error_code)) {
									msg = Lang["mod-topic-delete-err-" + error_code];
								} else {
									msg = Lang["unexpected-error-code"] + error_code;
								}
								AoPS.Ui.Modal.showAlert(msg, {
									onClose: function () {
										self.destroy();
									},
									width: "400px",
								});
							},
						});
					} else {
						AoPS.Ui.Modal.closeTopModal();
					}
				},
				{
					title: Lang["mod-topic-" + delete_type + "-delete-title"],
					close_on_button_click: false,
				}
			);
		},

		destroy: function () {
			AoPS.Ui.Modal.closeAllModals();
			this.close();
		},

		buildButton: function (data) {
			var self = this;
			if (
				!data.hasOwnProperty("permission") ||
				this.model.getPermission(data.permission)
			) {
				this.$buttons_cell
					.append(
						$("<button/>", {
							class: "btn btn-primary",
							html:
								'<span class="aops-font">' +
								data.symbol +
								"</span> " +
								data.text,
						}).on("click", function (e) {
							self[data.onClick](e);
						})
					)
					.append("<br>");
			}
		},
	});

	ComViews.makeAnnounceDateInput = function ($announce_input) {
		$announce_input.on("blur", function (e) {
			var date_val = $announce_input.val(),
				moment_date;

			if (date_val.length === 0) {
				return;
			}

			moment_date = moment(date_val, "YYYY-MM-DD");

			if (!moment_date.isValid()) {
				ComViews.showErrorAtopAModal(
					Lang["post-environ-invalid-announce-date"]
				);
				$announce_input.val("");
			} else if (moment().diff(moment(date_val, "YYYY-MM-DD"), "days") > 0) {
				ComViews.showErrorAtopAModal(
					Lang["post-environ-announce-date-too-early"]
				);
				$announce_input.val("");
			} else if (moment().diff(moment(date_val, "YYYY-MM-DD"), "years") <= -2) {
				ComViews.showErrorAtopAModal(
					Lang["post-environ-announce-date-too-late"]
				);
				$announce_input.val("");
			}
		});
	};
	/**
	 * ComViews.Itembox is a box with a set of 'items' inside.
	 *
	 *  model : category whose items will be displayed in the tagbox.
	 *
	 *  Properties that can be passed in:
	 *  category_id (optional) : If not set, then the model's category will be used.
	 *
	 * Other properties:
	 * secondary_color : light version of primary color for a category
	 * category_type : the type of category whose Tagbox we're building
	 * item_cells : array of jQuery objects for the items in the tagbox.
	 *
	 * Each item has some or all of the following:
	 *	item_id
	 *	item_text
	 *	item_type
	 *	item_subtitle
	 *	item_forum_id
	 *	item_can_remove
	 *	item_main_color
	 *	item_secondary_color
	 */
	ComViews.Itembox = AoPS.View.extend({
		className: "cmty-itembox",

		push_state_attribute: "data-cmty",

		// Some of these items may be remove-able (if item_can_remove == true)
		check_can_remove: false,

		// All of these items are removable.
		can_remove_all: false,

		scrollbarCreator: ComViews.buildCommunityScrollbar,

		initialize: function (options) {
			var self = this;

			this.url_cmty_path = "";
			this.url_router_base = "/community";

			_.defaults(this, options);
			if (!this.hasOwnProperty("scrollbar_arguments")) {
				this.scrollbar_arguments = {};
			}

			/** Didn't have the guts to change 'defaults' to 'extend' just above. **/
			if (options.hasOwnProperty("check_can_remove")) {
				this.check_can_remove = options.check_can_remove;
			}
			if (options.hasOwnProperty("can_remove_all")) {
				this.can_remove_all = options.can_remove_all;
			}
			ComViews.setRouteInfo(this, options);

			this.render_tooltips_on_items =
				this.model.get("category_type") != "forum" &&
				!this.model.get("is_private");
			this.render();
			this.$loader = $(
				'<div class="cmty-itembox-loader">' +
					Lang["cmty-itembox-loader"] +
					"</div>"
			);

			this.listenTo(this.model, "item_removed", this.render);

			this.listenTo(this.model, "item_added", this.addItem);
			this.$el.find(".aops-scroll-bar").on("slider_at_end", function () {
				if (!self.model.get("no_more_items")) {
					// Stop the scrollbar from being able to continue being dragged;
					//  needed to keep a bunch of load more events from firing.
					$(document).trigger("mouseup");

					self.$itembox.append(self.$loader);
					self.$scrollable.scrollTop(self.$scrollable[0].scrollHeight);

					self.model.fetchMoreItems({
						onFinish: function (response) {
							self.$loader.detach();

							if (!self.model.get("no_more_items")) {
								var $scrollable = self.$itembox.parent();
								if (
									self.$itembox.height -
										($scrollable.scrollTop() + $scrollable.height()) <
									10
								) {
									self.$el.find(".aops-scroll-bar").trigger("slider_at_end");
								}
							}
						},
						onError: function () {
							self.$loader.detach();
						},
					});
				}
			});
		},

		render: function () {
			var i,
				item,
				$item_cell,
				items_length = this.model.get("items").length;
			this.$itembox = $("<div/>", {
				class: "cmty-itembox-inner-box",
			});

			this.category_id = this.hasOwnProperty("category_id")
				? this.category_id
				: this.model.get("category_id");

			this.category_type = this.model.get("category_type");
			this.item_cells = [];
			if (items_length > 0) {
				// We don't use addItem here for optimization reasons...
				for (i = 0; i < items_length; i++) {
					item = this.model.get("items")[i];
					$item_cell = this.constructItem(item);
					this.item_cells.push($item_cell);
				}
				this.$itembox.append(this.item_cells);
			} else {
				if (this.hasOwnProperty("placeholder_text")) {
					this.$placeholder = $("<div/>", {
						class: "cmty-itembox-placeholder",
					}).append(this.placeholder_text);
					this.$itembox.append(this.$placeholder);
				}
			}
			this.$el.html(
				this.scrollbarCreator(this.$itembox, this.scrollbar_arguments)
			);
			this.$scrollable = this.$el.find(".aops-scroll-inner");
		},

		constructItem: function (item) {
			var url,
				$item_cell,
				self = this,
				$item_div,
				$subtitle,
				colors,
				stay_on_click = true,
				url_base,
				input_text,
				last_visited,
				add_delete_x,
				tag_string,
				remove_text;

			// If the item is a tag, then we want to stay inside the
			//  the category we are now viewing.  Otherwise, the item
			//  serves as a link into a new category (we leave the one we
			//  are now viewing).
			//
			// So, for example, if we are in a view and click a forum,
			//  we leave that view.  But if we click a tag, then
			//  we stay inside that view (and only get topics with that
			//  tag in that view).
			/**
			 * Coloring time!
			 **/
			colors = {
				main_color: item.item_main_color,
				secondary_color: item.item_secondary_color,
			};

			if (item.item_type === "tag") {
				if (this.model.get("special_url").length > 0) {
					url_base = this.model.get("special_url");
				} else {
					url_base = this.url_cmty_path + "/c" + this.category_id;
				}
				url =
					url_base +
					"t" +
					item.item_id +
					"f" +
					item.item_forum_id +
					"_" +
					ComViews.convertToUrlFragment(item.item_text);
			} else if (
				item.item_type === "blog" ||
				item.item_type === "blogroll" ||
				item.item_type === "folder_collections" ||
				item.item_type === "folder_forums" ||
				item.item_type === "folder" ||
				item.item_type === "forum_class" ||
				item.item_type === "forum" ||
				item.item_type.substr(0, 4) === "view" ||
				item.item_type.substr(0, 8) === "bookmark"
			) {
				url =
					this.url_cmty_path +
					"/c" +
					item.item_id +
					"_" +
					ComViews.convertToUrlFragment(item.item_text);
			} else if (item.item_type === "user") {
				url = this.url_cmty_path + "/user/" + item.item_id;
			}

			if (item.item_type === "blog") {
				stay_on_click = false;
			}

			// Build the item's tag
			//			$item_cell = $($.parseHTML('<a ' + this.push_state_attribute + ' href="' + ComViews.makeLinkUrl(url) + '"></a>'));
			input_text =
				"<a " +
				(stay_on_click ? this.push_state_attribute : "") +
				' href="' +
				ComViews.makeLinkUrl(url, this.url_router_base) +
				'">';
			add_delete_x =
				this.check_can_remove &&
				(this.can_remove_all ||
					(item.hasOwnProperty("item_can_remove") && item.item_can_remove));
			remove_text = add_delete_x
				? '<span class="cmty-delete-item aops-font">J</span>'
				: "";

			switch (item.item_type) {
				case "forum":
				case "forum_class":
				case "folder":
				case "folder_forums":
				case "folder_collections":
				case "blogroll":
				case "blog":
				case "view_tags":
				case "view_topics":
				case "view_posts":
					//$item_cell.append('<div class="cmty-item-' + item.item_type + '"><div class="cmty-item-text">' +
					//	item.item_text + '<br><span class="cmty-item-subtitle">' + item.item_subtitle + '</span></div></div>');
					input_text +=
						'<div class="cmty-item-' +
						item.item_type +
						'" style="color:' +
						colors.main_color +
						'"><div class="cmty-item-text">' +
						item.item_text +
						'<br><span class="cmty-item-subtitle">' +
						item.item_subtitle +
						"</span></div>" +
						remove_text +
						"</div>";
					break;

				case "user":
					//$item_cell.append('<div class="cmty-item-' + item.item_type + '"><div class="cmty-item-text">' +
					//	item.item_text + '<br><span class="cmty-item-subtitle">' + item.item_subtitle + '</span></div></div>');
					last_visited = Utils.getLastVisitedText(item);
					input_text +=
						'<div class="cmty-item-' +
						item.item_type +
						'"><img src="' +
						item.avatar +
						'"><div class="cmty-item-text">' +
						item.item_text +
						'<br><span class="cmty-item-subtitle">' +
						last_visited +
						"</span></div>" +
						remove_text +
						"</div>";
					break;

				case "bookmark_tags":
				case "bookmark_topics":
				case "feed_topics":
				case "bookmark_forums":
					//	$item_cell.append('<div class="cmty-item-' + item.item_type + '"><div class="cmty-item-text-w-extra">' +
					//		item.item_text + '</div></div>');//<span class="cmty-item-bookmark-extra">C</span>
					input_text +=
						'<div class="cmty-item-' +
						item.item_type +
						'" style="color:' +
						colors.main_color +
						'"><div class="cmty-item-text-w-extra">' +
						item.item_text +
						"</div>" +
						remove_text +
						"</div>";
					break;

				default:
					// tags
					tag_string = "<div";
					//			$item_cell.append('<div class="cmty-tag-wrap"><div class="cmty-item-' + item.item_type + '">' + item.item_text + '</div><div class="cmty-tag-extra"></div></div>');
					if (
						this.render_tooltips_on_items &&
						item.hasOwnProperty("item_category_name")
					) {
						tag_string +=
							' title="' +
							Lang["tag-tooltip-forum"] +
							" " +
							item.item_category_name +
							'"';
					}
					tag_string += ' style="background-color:' + colors.main_color + '" ';
					tag_string +=
						' class="cmty-item-' +
						item.item_type +
						'">' +
						item.item_text +
						remove_text +
						"</div>";
					//					$item_cell.append(tag_string);
					input_text += tag_string;
					break;
			}

			/*

			if (this.check_can_remove) {
				if (this.can_remove_all ||
				(item.hasOwnProperty('item_can_remove') && item.item_can_remove)) {
					$remove_cell = $('<span class="cmty-delete-item aops-font">J</span>').on('click',
						function (e) {
							self.onClickDelete(item, $item_cell);
							e.stopPropagation();
							e.preventDefault();
						}
					);
					$item_cell.find('.cmty-item-' + item.item_type).append($remove_cell);
				}
			}

			*/

			input_text += "</a>";
			$item_cell = $(input_text);

			if (add_delete_x) {
				$item_cell.find(".cmty-delete-item").on("click", function (e) {
					self.onClickDelete(item, $item_cell);
					e.stopPropagation();
					e.preventDefault();
				});
			}

			$item_div = $item_cell.find(".cmty-item-" + item.item_type);

			if (item.item_type === "tag") {
				$item_div
					.on("mouseenter", function (e) {
						$item_div.css({
							"background-color": colors.secondary_color,
							color: colors.main_color,
						});
					})
					.on("mouseleave", function (e) {
						$item_div.css({
							"background-color": colors.main_color,
							color: "",
						});
					})
					.on("click", function (e) {
						$item_div.css({
							"background-color": colors.main_color,
							color: "",
						});
					});
			} else {
				$subtitle = $item_div.find(".cmty-item-subtitle");
				$item_div
					.on("mouseenter", function (e) {
						$item_div.css({
							color: colors.secondary_color,
							"background-color": colors.main_color,
						});
						$subtitle.addClass("cmty-item-subtitle-on-hover");
					})
					.on("mouseleave", function (e) {
						$item_div.css({
							color: colors.main_color,
							"background-color": "",
						});
						$subtitle.removeClass("cmty-item-subtitle-on-hover");
					})
					.on("click", function (e) {
						$item_div.css({
							color: colors.main_color,
							"background-color": "",
						});
						$subtitle.removeClass("cmty-item-subtitle-on-hover");
					});
			}

			return $item_cell;
		},

		onClickDelete: function (item, $item) {
			if (this.hasOwnProperty("onDeleteItem")) {
				this.onDeleteItem(item);
			}
		},

		addItem: function (item) {
			var $item_cell;
			if (this.hasOwnProperty("$placeholder")) {
				this.$placeholder.detach();
			}
			$item_cell = this.constructItem(item);
			this.item_cells.push($item_cell);
			this.$itembox.append($item_cell);
		},

		events: {
			// mouseleave and click color resetting actions set based on category_type in initializiation.
		},

		// Included in a child, in case something gets added here.
		onClose: function () {},
	});

	/**
	 * For a category whose items are posts (category_type == 'view_posts'), the
	 *  items in the Itembox have a very different look.  Here, we extend
	 *  Itembox with the only difference being how we construct the
	 *  individual items.  The individual items are themselves Views, so
	 *	we need to deal with them on close, too.
	 **/
	ComViews.ItemboxPosts = ComViews.Itembox.extend({
		post_views: [],

		/**
		 * Construct one item that will be placed in the box.
		 *
		 * @param obj an item (see Itembox above for details)
		 * @return jQuery object that will be added to the itembox.
		 **/
		constructItem: function (item) {
			var post_row_view;

			if (!this.hasOwnProperty("has_label_column")) {
				this.has_label_column =
					ComViews.ViewPosts.prototype.hasLabel.apply(this);
			}
			post_row_view = new ComViews.ViewPostsItem({
				model: this.model,
				item: item,
				has_label_column: this.has_label_column,
			});

			this.post_views.push(post_row_view);
			return post_row_view.$el;
		},

		onClose: function () {
			ComViews.Itembox.prototype.onClose.apply(this);
			_.each(this.post_views, function (post_view) {
				post_view.close();
			});
		},
	});

	/**
	 * Properties
	 * full_topics_popup boolean: tells template not to make this a link, since a
	 *  	popup will hold the topic if this is clicked. (True in feed)
	 * has_subtitle boolean: True if this has the time, etc, subtitle line
	 * watch_focus boolean: True if this topic should watch if the master's focus
	 *		or feed's focus is changed (watch behavior set in setFocusWatchBehavior)
	 *
	 */
	ComViews.TopicCell = AoPS.View.extend({
		template_id: "#cmty-topic-cell-tpl",

		className: "cmty-topic-cell",

		marked_for_deletion: false, // Tells whether this cell should be removed when the TopicsList is removed from page.

		is_hidden_until_page_add: false, // Tells us if this cell is 'lurking', to be revealed when the list is added to the page

		full_topics_popup: false, // Tells whether or not we have a new page or a popup for the full topic

		has_subtitle: true,

		is_focus: false,

		watch_focus: true,

		show_focus_post: false,

		show_forum: false,

		in_feed: false,

		initialize: function (options) {
			this.master = options.master;
			this.route_category_id = options.route_category_id;

			this.topic_list = options.topic_list;
			ComViews.setRouteInfo(this, options);
			this.focus_tag = options.hasOwnProperty("focus_tag")
				? options.focus_tag
				: null;
			this.buildRoutes();
			// Blog posts that appear in the community that are not in the recycle bin
			//  Need to leave the router.  I think.
			if (
				this.url_router_base === "/community" &&
				this.model.get("topic_type") === "blog_post" &&
				this.model.get("category_id") !== Constants.blog_recycle_bin_id
			) {
				this.push_state_attribute = "";
			}

			this.setAnnouncementStatus();

			this.buildTopic();
			this.setColor();

			this.setReadStatus();

			this.skip_onClickTopic = false; /* IE10; see onClickTopic() */

			this.listenTo(this.model, "change:is_read", this.setReadStatus);
			this.listenTo(this.model, "change:num_posts", this.onChangeNumPosts);
			this.listenTo(this.model, "change:last_post_id", this.onChangeLastPost);
			if (this.watch_focus) {
				this.setFocusWatchBehavior();
			}
			this.listenTo(
				this.model,
				"change:watchers_usernames change:num_watchers change:num_views",
				this.constructWatchersLine
			);
			this.listenTo(
				this.model,
				"change:last_post_rendered_time",
				this.onChangeLastPostTime
			);
			this.listenTo(
				this.model,
				"change:first_post_rendered_time",
				this.onChangeFirstPostTime
			);
			this.listenTo(
				this.model,
				"change:locked change:forum_locked",
				this.setTitleLine
			);
			this.listenTo(this.model, "change:deleted", this.onDelete);
			this.listenTo(this.model, "change:preview", this.onChangePreview);
			this.listenTo(this.model, "change:topic_title", this.setTitleLine);

			if (this.model.getPermission("c_can_monitor")) {
				this.listenTo(this.model, "change:state", this.setColor);
			}

			if (
				this.master.get("monitoring_office_hours") &&
				this.model.get("state") != "none"
			) {
				this.listenTo(
					this.master,
					"reset_office_hours_topics",
					this.onResetOfficeHours
				);
				this.listenTo(
					this.model,
					"office_hours_person_here",
					this.onOfficeHoursPersonHere
				);
			}
			// Note: We don't listen to the announce status because we don't want the cell
			//  to change on change in announce status.  A change in announce status will
			//  trigger a delete/add, so a new cell will be built.
		},

		onResetOfficeHours: function () {
			this.$el.removeClass("cmty-office-hours-person-here");
		},

		onOfficeHoursPersonHere: function (obj) {
			if (AoPS.session.user_id != obj.user_id) {
				this.$el.addClass("cmty-office-hours-person-here");
			}
		},

		onChangePreview: function () {
			this.$post_preview.html(this.model.get("preview"));
		},

		events: {
			"click a.cmty-topics-list-jump-bottom-link": "onClickJumpToBottom",
			"click .cmty-topic-cell-close-topic": "onClickClose",
			"click .cmty-post-settle-report": "onClickSettleReport",
			"click .cmty-topic-cell-forum-view-last-poster": "onClickJumpToBottom",
			"click a.cmty-topics-list-goto-unread-link": "onClickGotoUnread",
		},

		/**
		 * Set the behavior for watching the focus topic.  Children (particularly the
		 *  feed's extension) overwrite this.
		 */
		setFocusWatchBehavior: function () {
			this.listenTo(this.model, "change:is_master_focus", this.checkFocusTopic);
			this.checkFocusTopic();
		},

		onClickJumpToBottom: function (e) {
			/* No longer needed because we don't support old IE */
		},

		onClickGotoUnread: function (e) {
			/* No longer needed because we don't support old IE */
		},

		/**
		 * Color the topic components appropriately
		 **/
		setColor: function () {
			var color,
				self = this,
				can_monitor = this.model.getPermission("c_can_monitor"),
				main_color = this.model.get("category_main_color"),
				hover_color = "",
				secondary_rgb,
				secondary_color = this.model.get("category_secondary_color");

			color = !this.is_focus ? main_color : secondary_color;
			this.$el.find(".cmty-color-main").css({
				color: color,
			});
			this.$el.find(".cmty-topic-cell-top").css({
				"background-color": main_color,
			});
			if (can_monitor) {
				this.colorMonitoredTopic(secondary_color, main_color);
			}

			secondary_rgb = Utils.hexToRgb(secondary_color);

			if (!_.isNull(secondary_rgb)) {
				hover_color =
					"rgba(" +
					parseInt((255 + secondary_rgb.r) / 2) +
					"," +
					parseInt((255 + secondary_rgb.g) / 2) +
					"," +
					parseInt((255 + secondary_rgb.b) / 2) +
					", 1.0)";
			}

			this.$el
				.on("mouseenter", function (e) {
					if (!self.is_focus) {
						self.$el.add(self.$topic_watchers).css({
							"background-color": hover_color,
						});
					}
				})
				.on("mouseleave click", function (e) {
					if (can_monitor) {
						self.colorMonitoredTopic(secondary_color, main_color);
					} else {
						self.$el.add(self.$topic_watchers).css({
							"background-color": "",
						});
					}
				});
		},

		colorMonitoredTopic: function (secondary_color, main_color) {
			var is_open = this.model.get("state") === "open",
				bg_color = is_open && !this.is_focus ? secondary_color : "";
			this.$el.css({
				"background-color": bg_color,
				"border-left": is_open ? "3px " + main_color + " solid" : "auto",
			});

			this.$topic_watchers.css({
				"background-color": bg_color,
			});
		},

		setAnnouncementStatus: function () {
			if (!this.topic_list.collection.category.get("show_announcements")) {
				this.announce_type = "none"; // Don't render as announcement
			} else {
				this.announce_type = this.model.get("announce_type");
			}
		},

		/**
		 * Build the topic.  Separate from initialize in case we need to build
		 *  differently in children.
		 */
		buildTopic: function () {
			var search_text,
				extra_url_path = this.url_router_base + this.url_cmty_path;

			this.$el.html(
				this.getTemplate(this.template_id, {
					route: AoPS.Community.Views.makeLinkUrl(this.route, extra_url_path),
					route_bottom: AoPS.Community.Views.makeLinkUrl(
						this.route_bottom,
						extra_url_path
					),
					route_back: AoPS.Community.Views.makeLinkUrl(
						this.route_back,
						extra_url_path
					),
					route_unread: AoPS.Community.Views.makeLinkUrl(
						this.route_unread,
						extra_url_path
					),
					push_state_attribute: this.push_state_attribute,
					category_id: this.model.get("category_id"),
					topic_id: this.model.get("topic_id"),
					lang_visit_in_forum: Lang["topic-cell-visit-in-forum"],
					full_topics_popup: this.full_topics_popup,
					first_poster_username: this.model.get("first_poster_name"),
					has_subtitle: this.has_subtitle,
					has_replies: this.model.get("num_posts") > 1,
					last_poster_username: this.model.get("last_poster_name"),
					last_post_time: this.model.get("last_post_rendered_time"),
					topic_title: this.model.get("topic_title"),
					post_text: this.show_focus_post
						? this.model.get("focus_post").get("post_rendered")
						: this.model.get("preview"), // this.model.get('posts').first().get('post_rendered'),//this.model.get('preview'), //first_post.get('post_rendered')
					first_poster_avatar: this.model.get("first_poster_avatar"),
					first_post_time: this.model.get("first_post_rendered_time"),
					is_logged_in: AoPS.session.logged_in,
					is_initialized: AoPS.session.is_initialized,
					is_logged_in_and_initialized: AoPS.session.logged_in_and_initialized,
					title_jump_end: Lang["topic-cell-title-jump-end"],
					title_settle: Lang["topic-cell-title-settle"],
					title_close: Lang["topic-cell-title-close"],
					title_unread: Lang["topic-cell-title-unread"],
					can_have_source: this.model.get("can_have_source"),
					has_source: this.model.get("source").length > 0,
					source: this.model.get("source"),
					lang_source_title: Lang["topic-cell-source"],
					show_forum: this.show_forum,
					lang_Posted_at: this.show_focus_post
						? Utils.formatString(Lang["topic-cell-Posted-at"], [
								this.model.get("focus_post").get("username"),
								this.model.get("focus_post").get("poster_id"),
								Lang["topic-cell-view-user-profile"],
							])
						: "",
					show_focus_post_date: this.show_focus_post,
					focus_post_number: this.show_focus_post
						? this.model.get("focus_post").get("post_number")
						: 0,
					focus_post_date: this.show_focus_post
						? Utils.makePrettyTimeStatic(
								this.model.get("focus_post").get("post_time")
							)
						: 0,
					category_name: this.model.get("category_name"),
				})
			);
			if (this.has_subtitle) {
				this.$subtitle = this.$el.find(".cmty-topic-cell-subtitle");
			}

			// Remove these if we decide to keep the bottom row watchers
			this.$watchers_line = this.$el.find(".cmty-topic-cell-watchers");
			this.$watchers_line_forum_view = this.$el.find(
				".cmty-topic-cell-data-watchers"
			);
			this.$subject_line = this.$el.find(".cmty-topic-cell-subject");
			this.$topic_cell_time = this.$el.find(".cmty-topic-cell-time");

			this.$topic_watchers = this.$(".cmty-topic-watchers");
			this.$post_preview = this.$el.find(".cmty-topic-cell-post");

			this.$forum_view_last_poster = this.$el.find(
				".cmty-topic-cell-forum-view-last-poster"
			);
			this.$replies_line = this.$el.find(".cmty-topic-cell-replies");
			this.$data_posts = this.$el.find(".cmty-topic-cell-data-posts");
			this.setTitleLine();
			this.onChangeNumPosts();
			this.onChangeLastPost();
			this.constructWatchersLine();
			if (this.announce_type === "local") {
				this.$el.addClass("cmty-topics-list-local-announcement");
			} else if (this.announce_type === "global") {
				this.$el.addClass("cmty-topics-list-global-announcement");
			}
			if (this.model.getPermission("c_can_settle_report")) {
				this.onChangeNumReports();
				this.listenTo(
					this.model,
					"change:num_reports",
					this.onChangeNumReports
				);
			}
			if (this.model.get("can_have_source")) {
				this.listenTo(this.model, "change:source", this.onChangeSource);
			}

			// Highlight the hits if this is a search result.
			if (this.model.get("is_search_result")) {
				if (this.model.get("focus_post").get("deleted")) {
					this.$el.addClass("cmty-search-target-deleted");
				}
				search_text = this.model.fetchSearchText("post_text");
				if (search_text.length > 0) {
					this.$post_preview.extendedHighlightText(
						"cmty-highlight",
						search_text
					);
				}
				search_text = this.model.fetchSearchText("title");
				if (search_text.length > 0) {
					this.$subject_line.extendedHighlightText(
						"cmty-highlight",
						search_text
					);
				}
				if (this.model.get("source").length > 0) {
					search_text = this.model.fetchSearchText("source");
					if (search_text.length > 0) {
						this.$(".cmty-topic-cell-source").extendedHighlightText(
							"cmty-highlight",
							search_text
						);
					}
				}
			}
		},

		constructSubtitle: function () {
			if (this.has_subtitle) {
				this.$subtitle.html(
					this.getTemplate("#cmty-topic-cell-subtitle-tpl", {
						has_replies: this.model.get("num_posts") > 1,
						last_poster_username: this.model.get("last_poster_name"),
						last_post_time: this.model.get("last_post_rendered_time"),
					})
				);
			}
		},

		/**
		 * Build the line that shows the number of watchers and puts the list of watchers
		 *  in the title line.
		 **/
		constructWatchersLine: function () {
			var num_watchers = this.model.get("num_watchers"),
				num_named,
				has_avatars = false,
				avatars,
				num_avatars_shown = 0,
				avatar_string = "",
				num_views = this.model.get("num_views"),
				title = ComViews.decodeHtmlEntities(this.model.get("topic_title"));

			if (this.in_feed && this.model.get("topic_type") !== "private") {
				title +=
					"\n" + ComViews.decodeHtmlEntities(this.model.get("category_name"));
			}

			if (num_watchers === 0) {
				this.$topic_watchers.hide();
				/*	this.$watchers_line.html('');
				this.$watchers_line_forum_view.html('');*/
			} else {
				num_named = this.model.get("num_named_watchers");
				title += "\n";

				if (num_named === 0) {
					title += Utils.formatString(
						Lang[
							"topic-cell-" + (num_watchers === 1 ? "" : "not-") + "1-reader"
						],
						[num_watchers]
					);
				} else {
					title +=
						Lang["topic-cell-reading-now"] +
						this.model.get("watchers_usernames") +
						(num_watchers > num_named ? " +" + (num_watchers - num_named) : "");
				}
				avatars = this.model.get("watchers_avatars");
				if (
					!this.model.get("master").get("current_user").get("hide_avatars") &&
					!_.isUndefined(avatars) &&
					avatars.length > 0
				) {
					avatars = avatars.split(" ");
					has_avatars = true;

					if (avatars.length > 0) {
						if (avatars.length > 6) {
							avatars = _.first(avatars, 6);
						}
						_.each(avatars, function (av) {
							av = $.trim(av);
							if (!_.isUndefined(av) && av.length > 0) {
								avatar_string +=
									'<img class="cmty-avatar" src="' +
									av +
									'" width="15" height="15">';
								num_avatars_shown += 1;
							}
						});
					}
				}
				if (has_avatars) {
					if (avatars.length < num_watchers) {
						avatar_string +=
							" <span>+" +
							(num_watchers - num_avatars_shown) +
							'</span> <span class="aops-font">w</span>';
					}
				} else {
					avatar_string = num_watchers + " " + Lang["viewing"];
				}

				this.$topic_watchers.html(avatar_string);
				this.$topic_watchers.show();
				/*	this.$watchers_line.html('' + num_watchers + ' <span class="aops-font">w</span>');
				this.$watchers_line_forum_view.html('<span class="aops-font">w</span> ' + num_watchers + ' viewing');*/
			}

			title +=
				"\n" +
				this.model.get("num_views") +
				" " +
				(num_views === 1 ? Lang["view"] : Lang["views"]);

			if (this.model.get("announce_type") !== "none") {
				if (this.model.get("announce_through").length > 0) {
					title +=
						"\nAnnouncement ends " +
						moment(this.model.get("announce_through"), "YYYY-MM-DD").format(
							"MMM Do, YYYY"
						) +
						".";
				}
			}

			this.el.title = title;
			return title;
		},

		setTitleLine: function () {
			var new_title = "";

			new_title +=
				this.model.get("locked") || this.model.get("forum_locked")
					? '<span class="aops-font">k</span>&nbsp;'
					: "";
			new_title +=
				this.model.get("announce_type") === "local"
					? '<span class="aops-font">i</span>&nbsp;'
					: "";
			new_title +=
				this.model.get("poll_id") > 0
					? '<span class="aops-font">9</span>&nbsp;'
					: "";
			new_title +=
				this.model.get("announce_type") === "global"
					? '<span class="aops-font">a</span>&nbsp;'
					: "";
			new_title += this.model.get("topic_title");
			this.$subject_line.html(new_title);
		},

		/**
		 * If the number of reports this topic has changes, then we
		 *  may need to change the visibility of the icon that identifies this topic
		 *  as having reported posts.
		 **/
		onChangeNumReports: function () {
			var $reported;

			if (this.model.getPermission("c_can_settle_report")) {
				$reported = this.$el.find(".cmty-topic-cell-topic-reported");
				if ($reported.length === 0 && this.model.get("num_reports") > 0) {
					$reported = this.getTemplate("#cmty-topic-cell-reported-topic-tpl", {
						topic_id: this.model.get("topic_id"),
					});
					this.$el.find(".cmty-topic-cell-left").append($reported);
				} else {
					$reported.toggle(this.model.get("num_reports") > 0);
				}
			}
		},

		/**
		 * When the number of posts changes, we change the number of replies, and
		 *  edit the topic title if we have to add or remove "Re:"
		 */
		onChangeNumPosts: function () {
			this.$replies_line.html(this.model.get("num_posts") - 1);
			this.$data_posts.html(
				this.model.get("num_posts") -
					1 +
					' <span class="cmty-no-tablet">' +
					(this.model.get("num_posts") == 2
						? Lang["topic-cell-reply"]
						: Lang["topic-cell-replies"]) +
					"</span>"
			);
			// We live with the small hole in which there is a reply and a delete in the same topic fetch
			// cycle, rather than calling constructSubtitle twice for each.
			//   As an alternative, we could track last_post_id or last_post_number.
			this.constructSubtitle();
		},

		buildForumViewLastPoster: function () {
			var extra_url_path = this.url_router_base + this.url_cmty_path;

			this.$forum_view_last_poster.html(
				this.getTemplate("#cmty-topic-cell-forum-view-last-poster-tpl", {
					has_replies: this.model.get("num_posts") > 1,
					last_poster_username: this.model.get("last_poster_name"),
					route_bottom: AoPS.Community.Views.makeLinkUrl(
						this.route_bottom,
						extra_url_path
					),
					last_poster_avatar: this.model.get("last_poster_avatar"),
					last_post_time: this.model.get("last_post_rendered_time"),
					no_replies_message: Lang["topic-cell-no-replies"],
					push_state_attribute: this.push_state_attribute,
				})
			);
		},

		onChangeLastPost: function () {
			this.constructSubtitle();
			this.buildForumViewLastPoster();
		},

		onChangeLastPostTime: function () {
			this.$el
				.find(".cmty-reply-time")
				.html(this.model.get("last_post_rendered_time"));
			this.buildForumViewLastPoster(); // Will sometimes be calling this twice.  Can we get around that?
		},

		onChangeFirstPostTime: function () {
			this.$topic_cell_time.html(this.model.get("first_post_rendered_time"));
		},

		onChangeSource: function () {
			var source;
			if (this.model.get("can_have_source")) {
				source = this.model.get("source");
				if (source.length > 0) {
					this.$(".cmty-topic-cell-source").html(
						'<span class="cmty-source-title">' +
							Lang["topic-cell-source"] +
							"</span>: " +
							source
					);
				} else {
					this.$(".cmty-topic-cell-source").html("");
				}
			}
		},

		onDelete: function () {
			this.close();
		},

		/**
		 * This topic has moved and won't be in this list upon next visit.  Here's where we tell the user.
		 * When a topic gets moved, we need to rebuild the routes and then set the links to
		 * point to the right place.  This function is triggered by a call to markMoved
		 * from within TopicsList when a topic gets moved.  (If the moved topic fails
		 * the filter for that list, then we mark it as moved but keep the cell around
		 * so as not to confuse the user.
		 **/
		markMoved: function () {
			// Rebuild the links so that clicking on the topic will take them to the right place
			//  We have to reset the route's category_id to make the links correctly.
			this.route_category_id = this.model.get("category_id");

			this.$post_preview.html(
				this.route_category_id === Constants.recycle_bin_id
					? Lang["topic-cell-recycled-topic"]
					: Lang["topic-cell-moved-topic"]
			);
			this.buildRoutes();

			this.$el
				.find("a.cmty-full-cell-link")
				.attr("href", "/community" + this.route)
				.removeAttr(this.push_state_attribute)
				.attr("data-cmty", true);
			this.$el
				.find("a.cmty-topics-list-jump-bottom-link")
				.attr("href", "/community" + this.route_bottom)
				.removeAttr(this.push_state_attribute)
				.attr("data-cmty", true);
			this.$el
				.find("a.cmty-topics-list-goto-unread-link")
				.attr("href", "/community" + this.route_unread)
				.removeAttr(this.push_state_attribute)
				.attr("data-cmty", true);
		},

		/**
		 * Build the routes for this topic so that clicking on the topic takes us to the right
		 *  place.
		 **/
		buildRoutes: function () {
			var title = ComViews.convertToUrlFragment(this.model.get("topic_title")),
				route_base,
				route_topic_base;
			if (this.topic_list.collection.category.get("category_type") === "priv") {
				route_base = "/x" + this.topic_list.collection.category.get("user_id");
			} else {
				route_base = "/c" + this.route_category_id;
			}
			if (!_.isNull(this.focus_tag)) {
				route_base +=
					"t" + this.focus_tag.item_id + "f" + this.focus_tag.item_forum_id;
			}

			route_topic_base = route_base + "h" + this.model.get("topic_id");
			this.route = route_topic_base + "_" + title;
			this.route_bottom = route_topic_base + "s1_" + title;
			this.route_back = route_base;
			this.route_unread = route_topic_base + "s2_" + title;

			if (
				this.model.get("topic_type") === "private" &&
				this.model.get("status") === "archived"
			) {
				this.route_back = "/my-messages-archive";
				if (this.focus_tag != null) {
					this.route_back +=
						"/t" + this.focus_tag.item_id + "f" + this.focus_tag.item_forum_id;
				}
			}
		},

		/**
		 * checkFocusTopic checks if this is the focus topic, and
		 *  dresses up this view accordingly.
		 */
		checkFocusTopic: function () {
			this.is_focus = this.model.get("is_master_focus");
			this.processFocusTopicStatusChange();
		},

		processFocusTopicStatusChange: function () {
			this.$el.toggleClass("focus-topic", this.is_focus);
			this.setColor();
		},

		setReadStatus: function () {
			this.$el.toggleClass("topic-unread", !this.model.get("is_read"));
		},
	});

	/**
	 * View for the popout cell that appears when user scrolls the focused topic offscreen
	 *  in the topic list.
	 **/
	ComViews.TopicCellPopout = ComViews.TopicCell.extend({
		parent: ComViews.TopicCell,

		buildTopic: function () {
			this.parent.prototype.buildTopic.apply(this);
			this.createStuntDouble();
		},

		/**
		 * Create a cell that imitates this topic cell for click events.  This stunt_double
		 *  sits inside the scrollable topic list behind the popout cell.
		 *  We do this because we need the hover and scroll events to still work when the
		 *  mouse is over the popout cell (when user has scrolled the focus topic cell off
		 *  screen).  To get that to happen, we block the pointer events on the popout
		 *  cell (it is not in the scrollable div, so scrolling doesn't work), and
		 *  stick the stunt_double behind it.  The stunt_double's location is recomputed
		 *  on every scroll event, since it is inside the scrollable div (so scrolling will work).
		 *  This causes a wicked flicker, which is why we need the popout cell on top of it for display.
		 *
		 **/
		createStuntDouble: function () {
			var path = this.url_router_base + this.url_cmty_path;

			this.$stunt_double = $(
				this.getTemplate("#cmty-topic-cell-stunt-double-tpl", {
					wrapper_class: "cmty-topic-cell-double focus-topic " + this.className,
					push_state_attribute: this.push_state_attribute,
					full_topics_popup: this.full_topics_popup,
					route: AoPS.Community.Views.makeLinkUrl(this.route, path),
					route_bottom: AoPS.Community.Views.makeLinkUrl(
						this.route_bottom,
						path
					),
					route_back: AoPS.Community.Views.makeLinkUrl(this.route_back, path),
					title_settle: Lang["topic-cell-title-settle"],

					has_settleable_reports:
						this.model.get("num_reports") > 0 &&
						this.model.getPermission("c_can_settle_report"),
				})
			);

			if (
				this.model.get("announce_type") === "global" ||
				this.model.get("announce_type") === "local"
			) {
				this.$stunt_double.addClass("cmty-stunt-double-announcement");
			}
			this.constructWatchersLine();
			return this.$stunt_double;
		},

		/**
		 * In addition to creating the title for the cell, add the title to the stunt_double.
		 **/
		constructWatchersLine: function () {
			var title = this.parent.prototype.constructWatchersLine.apply(this);
			if (this.hasOwnProperty("$stunt_double")) {
				this.$stunt_double[0].title = title;
			}
		},

		onClose: function () {
			this.$stunt_double.remove();
		},
	});

	/**
	 * Topic cells for searches (user's posts or general search) are a bit different
	 *	from regular topic cells.  The arguments below are used for the
	 *  TopicCell and TopicCellPopout views for these searches.
	 **/
	ComViews.search_post_topic_cell_arguments = {
		className:
			ComViews.TopicCell.prototype.className + " cmty-topic-cell-search-post",

		show_focus_post: true,

		show_forum: true,

		buildRoutes: function () {
			var focus_post = this.model.get("focus_post"),
				//user_id = focus_post.get('poster_id'),
				post_id = focus_post.get("post_id"),
				cat_type_string,
				category = this.topic_list.collection.category,
				cat_identifier_id,
				route_back,
				route_base;

			if (category.get("category_type") === "user_search_posts") {
				cat_type_string = "u";
				cat_identifier_id = category.get("user_id");
			} else if (category.get("category_type") === "search") {
				cat_type_string = "q";
				cat_identifier_id = category.get("search_id");
			} else {
				console.log(
					"Uh-oh, building a Search Posts type topic cell without \
					user_search_posts or search type category"
				);
			}
			route_back = "/" + cat_type_string + cat_identifier_id;
			route_base =
				route_back + "h" + this.model.get("topic_id") + "p" + post_id;

			this.route = route_base;
			this.route_bottom = route_base + "s1";
			this.route_back =
				route_back +
				(category.has("encoded_search_text")
					? "_" + category.get("encoded_search_text")
					: "");
			this.route_unread = route_base + "s2";
		},
	};

	/**
	 * A TopicCell for the result of a search
	 **/
	ComViews.TopicCellSearchPost = ComViews.TopicCell.extend(
		ComViews.search_post_topic_cell_arguments
	);

	/**
	 * The popout for a TopicCell for the result of a search
	 **/
	ComViews.TopicCellSearchPopout = ComViews.TopicCellPopout.extend(
		ComViews.search_post_topic_cell_arguments
	);

	ComViews.CategoryCellTopicCell = ComViews.TopicCell.extend({
		has_subtitle: false,

		watch_focus: true,
	});

	/***
	 * List of topic cells.  Used in many places -- feed, forums, collections that
	 *  have associated topics, category cells for forums, collections of tags, topics, etc.
	 *
	 * Lots of stuff you can pass in :
	 * collection : Models.FilteredTopicList (usually)
	 * main_color : color string
	 * secondary_color : color string
	 * focus_tag : tag to which these topics are filtered if any
	 * master : Master model,
	 * category_id : Category id associated with this list,
	 * can_toggle_scroll_style : boolean default false, set true for lists that
	 * 		are fixed height for full width, but switch to variable height in phone/tablet portrait
	 *		mode (like forum view)
	 *
	 * Some notes on the initial topic fetch:
	 *   Some whole classes of TopicsList should try to fetch topics
	 *   when the list is built, while others shouldn't.  We control
	 *	 this toggle through two mechanisms:
	 * 		(1) fetch_topics_on_build, which is a prototype property.
	 *  		Extensions of TopicsList can flip this to false to turn
	 *  		off the initial fetch.
	 *		(2) We can pass in suppress_initial_fetch when we
	 *			want to turn off the initial fetch for a list
	 *			that is in a class of lists that has fetch_topics_on_build
	 *			set to true.
	 *
	 * I suspect these machinations have become moot, but am not
	 *	sure.  In earlier versions of the community, the topics
	 *	lists were not built as part of a category fetch in
	 *	the router.  So, the router would grab a category (forum),
	 *	and then the TopicsList view would make the call for the
	 *	initial topics.  However, we changed the category fetch
	 *	to get the topics, too, when we found out that this
	 *	could be done cheaply.
	 *
	 *	Leaving the fetch_topics_on_build does allow us to go
	 *	get more if that initial fetch doesn't grab enough.
	 *
	 * 	One special case: private messages.  For private messages
	 *	we always turn off the extra fetch.  Otherwise, when
	 *	a user navigates to the PMs, there are 4 topics already
	 *	(from the feed), the fetchMoreT
	 **/
	ComViews.TopicsList = AoPS.View.extend({
		template_id: "#cmty-category-cell-topics-tpl",

		list_location: "master",

		no_more_items_message: Lang["topics-list-no-more-items"],

		no_items_at_all_message: Lang["topics-list-no-items-at-all"],

		className: "cmty-topics-list",

		focus_tag: null, // Needed for setting links correctly.

		popout_focus_cell: null,

		focus_topic_cell: null,

		fetch_topics_on_build: true,

		on_page: false,

		use_topic_category: false, // For each topic cell, use the topic's category for the link rather than the list's category (used in bookmark forums category cell)

		topicView: ComViews.TopicCell,

		popoutView: ComViews.TopicCellPopout,

		initialize: function (options) {
			var self = this;
			this.view_start_id = 0;
			this.view_end_id = -1;
			this.suppress_scroll = false;

			// Office hours tab should have special text.
			if (AoPS.bd && AoPS.bd.mode && AoPS.bd.mode === "office_hours") {
				this.no_more_items_message =
					Lang["topics-list-no-more-items-office-hours-default"];
				this.no_items_at_all_message =
					Lang["topics-list-no-items-at-all-office-hours"];
			}

			ComViews.setRouteInfo(this, options);
			this.$loader = AoPS.Page.buildLoader();
			this.$no_more_topics = $(
				'<div class="cmty-no-more-topics">' +
					this.no_more_items_message +
					"</div>"
			);

			this.listenTo(
				this.collection,
				"bulk_topics_added",
				this.addBulkLoadedTopics
			);

			this.suppress_initial_fetch = options.hasOwnProperty(
				"suppress_initial_fetch"
			)
				? options.suppress_initial_fetch
				: false;

			this.can_toggle_scroll_style =
				typeof options.can_toggle_scroll_style === "boolean" &&
				options.can_toggle_scroll_style;

			this.on_initial_topic_fetch = false;
			this.scroll_inner_listener_set = false;
			if (options.hasOwnProperty("use_topic_category")) {
				this.use_topic_category = options.use_topic_category;
			}

			if (this.collection.length === 0 && !this.suppress_initial_fetch) {
				this.onEmptyCollection(options);
			} else {
				this.constructTopicsList(options);
			}

			if (this.collection.length === 0 && this.suppress_initial_fetch) {
				this.appendNoMoreTopicsMessage();
			}

			// When replies come in for topics that are on-screen, we store those up so that
			//  the topics don't jump around on the screen.  We'll add them when
			//  we leave and come back to this list.
			this.topics_hidden_until_next_add = [];
			this.updated_topics = [];

			this.topics_marked_for_deletion = false; // Set to true if there are topic_boxes marked to be deleted

			this.listenTo(this.collection, "reset", this.onCollectionReset);
			this.listenTo(
				this.collection.category,
				"check_for_more_topics",
				function () {
					if (self.collection.length < 10) {
						self.suppress_scroll = true;
						self.fetchMoreTopics();
					}
				}
			);
		},

		/**
		 * Determine if this topic list is currently in fixed-height mode, scrollable, and on-screen.
		 **/
		isFixedHeight: function () {
			// Feed is always fixed height
			if (this.list_location === "feed") {
				return true;
			}

			return (
				(!this.can_toggle_scroll_style ||
					$(window).width() > Constants.phone_mode_max_width) &&
				this.$scrollbar.is(":visible")
			);
		},

		/**
		 * When the collection underlying this TopicsList is reset,
		 *  we will wipe out all the topic boxes in the list. But that
		 *  will be bad if we are currently looking at this topic list, so
		 *  we have to go get more topics!!!
		 **/
		onCollectionReset: function () {
			_.each(this.topic_boxes, function (topic_box) {
				topic_box.close();
			});
			this.topic_boxes = [];
			this.view_start_id = 0;
			this.view_end_id = -1;

			this.topics_hidden_until_next_add = [];
			this.topics_marked_for_deletion = false;
			this.updated_topics = [];
			this.$no_more_topics.detach();

			if (this.on_page) {
				this.onSliderAtBottom();
			}
		},

		onEmptyCollection: function (options) {
			// Do something reasonable here.  For now, we'll just do the default....
			// RR removed the $loader add here.
			//this.$el.append(this.$loader);
			this.constructTopicsList(options);
		},

		/**
		 * When the page loads, shift the box to the focus topic.
		 *  First, we reset the scroll area to where it was on last visit
		 * NOTE: This is where the bug is that makes the topiclist scroll to top on each click
		 *  -- Page.js isn't hitting this.
		 *
		 * This should be moved out of common, maybe?
		 */
		onAddToPage: function () {
			var self = this;
			this.$scroll_area.scrollTop(this.scroll_loc);

			if (!_.isNull(this.getFocusTopic()) && this.$el.is(":visible")) {
				this.shiftToTopic(this.getFocusTopic());
			}

			this.on_page = true;

			this.checkQueuedUpTopicBoxes();
			this.parseFocusTopic();
			this.setFocusListener();
			$("#cmty-topic-view-top .cmty-cat-cell-jump-top").on(
				"click.cat-jump-to-top-" + this.cid,
				function () {
					self.onClickJumpToTop();
				}
			);

			$(window).on(
				"scroll.topics_list-" + this.cid + " touchmove.topics_list-" + this.cid,
				_.bind(function () {
					var document_scrollTop = $(document).scrollTop();
					if (_.isUndefined(this.$scrollbar)) {
						return;
					}

					if (this.$el.is(":visible") && !this.$scrollbar.is(":visible")) {
						if (
							document.documentElement.clientHeight + document_scrollTop >=
							document.body.offsetHeight -
								Constants.phone_more_topics_sensitivity
						) {
							//	this.fetchMoreTopics();
							this.onSliderAtBottom();
						}
						if (
							document_scrollTop <
							$("#header-wrapper").outerHeight() +
								parseInt($("#main-content").css("padding-top")) +
								$("#cmty-topic-view-top").height()
						) {
							// COMPUTE THIS FACTOR AT INITIALIZATION?
							this.onSliderAtTop();
						}
					}
				}, this)
			);

			this.checkIfEnoughCells();
		},

		onClose: function () {
			var i,
				num_boxes = this.topic_boxes.length;

			for (i = 0; i < num_boxes; i++) {
				if (
					!this.topic_boxes[i].hasOwnProperty("is_placeholder") ||
					!this.topic_boxes[i].is_placeholder
				) {
					this.topic_boxes[i].close();
				}
			}

			if (
				this.hasOwnProperty("popout_focus_cell") &&
				!_.isNull(this.popout_focus_cell)
			) {
				this.popout_focus_cell.close();
			}
		},

		/**
		 * When the master focus_topic_list changes, we compare it to this collection.
		 *  It should basically never be a match.  Then we manage the
		 *  TopicListTopic visibility issues that cropped up as topics were
		 *  added or removed, so that the topics are back to being in order by time.
		 * (We don't move topics around while the user is looking at a given topic list.
		 **/
		parseFocusTopicList: function () {
			if (this.master.get("focus_topic_list") != this.collection) {
				this.processUpdatedTopicVisibility();
				this.stopListening(this.master, "change:focus_topic_list");
			}
		},

		/**
		 * Clean up/reorder the topics list to get everything in order.  We fire this when we close the
		 *  topics list, so it will all be ordered propertly next time we visit.
		 **/
		processUpdatedTopicVisibility: function () {
			var i,
				n_boxes,
				self = this,
				new_topic_boxes = [],
				last_announcement = null;

			if (this.hasOwnProperty("topic_boxes")) {
				/*if (this.topics_marked_for_deletion) {
					/**
					 * http://stackoverflow.com/questions/5722254/underscore-js-is-there-a-function-that-produces-an-array-thats-the-difference
					 *
					this.topic_boxes = _.without.apply(_, [this.topic_boxes].concat(this.topics_marked_for_deletion));
				}
				_.each(this.topics_marked_for_deletion, function (topic_box) {
					topic_box.close();
				});
				this.topics_marked_for_deletion = false;*/

				if (this.topics_marked_for_deletion) {
					n_boxes = this.topic_boxes.length;
					for (i = n_boxes - 1; i >= 0; i--) {
						if (this.topic_boxes[i].marked_for_deletion) {
							this.updateViewLimitIdOnDelete(i);
							this.topic_boxes[i].close();
						} else {
							new_topic_boxes.unshift(this.topic_boxes[i]);
						}
					}
					this.topic_boxes = new_topic_boxes;
					this.updated_topics = [];
					this.topics_marked_for_deletion = false;
				}
				_.each(this.topics_hidden_until_next_add, function (topic) {
					/*	topic_box.$el.show();
					topic_box.is_hidden_until_page_add = false;*/
					self.addTopic(topic, {});
				});
				this.topics_hidden_until_next_add = [];
			}

			/** Deal with applying correct class to last announcement **/
			n_boxes = this.topic_boxes.length;

			for (i = 0; i < n_boxes; i++) {
				if (this.topic_boxes[i].announce_type !== "none") {
					this.topic_boxes[i].$el.removeClass("cmty-last-announcement");
					last_announcement = this.topic_boxes[i];
				} else {
					i = n_boxes;
				}
			}
			if (!_.isNull(last_announcement)) {
				last_announcement.$el.addClass("cmty-last-announcement");
			}
		},

		/**
		 * When we remove this from the page, we don't have to watch the focus topic for re-painting
		 *  trickery.
		 **/
		onRemoveFromPage: function () {
			this.on_page = false;
			this.stopListening(this.master, "change:focus_topic");
			this.stopListening(this.master, "change:fullscreen_mode");

			$("#cmty-topic-view-top .cmty-cat-cell-jump-top").off(
				"click.cat-jump-to-top-" + this.cid
			);

			$(window).off(
				"scroll.topics_list-" + this.cid + " touchmove.topics_list-" + this.cid
			);
		},

		/**
		 * shiftToTopic positions the box to make sure the submitted topic is visible.
		 *  If the topic is already fully visible, do nothing.  Otherwise,
		 *  the topic is set to the top of the view box if there are enough topics below it
		 *  to extend beyond the end of the box.  Otherwise, the bottom of the stack of
		 *  topics is set to the bottom of the view box (so the topic is somewhere in the middle).
		 *
		 * @param topic : the topic we need to see.
		 */
		shiftToTopic: function (topic) {
			var topic_box = _.find(this.topic_boxes, function (box) {
					return box.model === topic && !box.is_hidden_until_page_add;
				}),
				window_height = this.$topics_window.height(),
				topics_box_height = this.$topics_box.height(),
				topic_location,
				window_scrollTop,
				topic_top;

			// Check if the topics list is smaller than the window it's in,
			//  so all the topics are already visible.
			if (window_height > topics_box_height) {
				return;
			}

			if (topic_box) {
				if (this.isFixedHeight()) {
					topic_top = topic_box.$el.position().top;
					topic_location = topic_top - this.$scroll_area.scrollTop(); // topics_box position removed -- always 0 now

					// Don't slide the box around if the topic is already completely in the box.
					// That is, if the topic is already visible, then do nothing.

					if (
						topic_location < 0 ||
						topic_location + topic_box.$el.height() > window_height
					) {
						this.$scroll_area.scrollTop(
							-Math.max(-topic_top, window_height - topics_box_height)
						);
					}
				} else {
					topic_top = topic_box.$el.offset().top;
					window_scrollTop = $(window).scrollTop();
					if (
						window_scrollTop > topic_top ||
						window_scrollTop + $(window).height() >
							topic_top + topic_box.$el.height()
					) {
						window.scrollTo(0, topic_top);
					}
				}
			}
		},

		checkIfEnoughCells: function () {
			var topics_box_height, topics_window_height;

			if (
				this.$topics_box.is(":visible") &&
				this.$topics_window.is(":visible")
			) {
				topics_box_height = this.$topics_box.height();

				/**
					If in phone view, go get more only if topics_box_height is less than
					window height
				**/
				if (
					$(window).width() <= Constants.phone_mode_max_width &&
					topics_box_height > $(window).height()
				) {
					return;
				}

				topics_window_height = this.$topics_window.height();

				if (topics_box_height > 0 && topics_window_height > 0) {
					if (topics_box_height <= topics_window_height) {
						this.fetchMoreTopics();
					}
				}
			}
		},

		/**
		 * @param object optional.  Currently only "never_cancel boolean"
		 *   supported as a property
		 **/
		constructFetchMoreTopicsOptions: function () {
			var self = this,
				never_cancel =
					arguments.length === 1 &&
					typeof arguments[0].never_cancel === "boolean"
						? arguments[0].never_cancel
						: false;
			return {
				source: this.list_location,
				never_cancel: never_cancel,
				onFinish: function () {
					self.parseFocusTopic();
					self.$loader.detach();
					if (self.collection.all_topics_fetched) {
						self.appendNoMoreTopicsMessage();
					}
					self.on_initial_topic_fetch = false;
					self.suppress_scroll = false;
					self.checkIfEnoughCells();
					if (ComViews.isIOS) {
						self.$scroll_area.css({
							"-webkit-overflow-scrolling": "touch",
						});
					}
				},
				onError: function (data) {
					var msg;
					self.$loader.detach();

					if (data.error_code === "E_AJAX_CANCEL") {
						return;
					}

					if (typeof Lang["topic-fetch-err-" + data.error_code] === "string") {
						msg = Lang["topic-fetch-err-" + data.error_code];
					} else {
						msg = Lang["unexpected-error-code"] + data.error_code;
					}
					// Error; don't want to try fetching any more.
					if (data.error_code != "E_AJAX_TIMEOUT") {
						self.collection.all_topics_fetched = true;
					}
					ComViews.showError(msg);
					if (ComViews.isIOS) {
						self.$scroll_area.css({
							"-webkit-overflow-scrolling": "touch",
						});
					}
				},
			};
		},

		/**
		 * Go get more topics for this list from the database.
		 *
		 * @param optional object that is passed to constructFetchMoreTopicsOptions.
		 *		Used to set never_cancel as desired.
		 */
		fetchMoreTopics: function () {
			var obj = arguments.length === 1 ? arguments[0] : {};
			if (!this.collection.topics_loading) {
				// We want to treat the initial fetch of topics
				//  slightly differently.
				if (this.collection.length === 0) {
					this.on_initial_topic_fetch = true;
					this.suppress_scroll = true;
				}
				if (!this.collection.all_topics_fetched) {
					this.$topics_box.append(this.$loader);
					if (ComViews.isIOS) {
						this.$scroll_area.css({
							"-webkit-overflow-scrolling": "auto",
						});
						this.$scroll_area.scrollTop(this.$scroll_area[0].scrollHeight);
					}
					this.collection.fetchMoreTopics(
						this.constructFetchMoreTopicsOptions(obj)
					);
				} else {
					this.suppress_scroll = false;
					this.appendNoMoreTopicsMessage();
				}
			}
		},

		/**
		 * Construct the initial list.
		 *
		 * @param obj : options passed to initialize.
		 */
		constructTopicsList: function (options) {
			var num_topics = this.collection.length,
				last_topic_idx,
				i,
				$topics_to_add = [];

			_.extend(
				this,
				_.pick(options, "master", "focus_tag", "main_color", "secondary_color")
			);
			this.category_id = options.category_id;

			// Probably error on no master?

			this.$topics_box = $("<div/>", {
				class: "cmty-topics-list-inner-box",
			});
			this.$title_bar = $(
				this.getTemplate("#cmty-topic-list-heading-tpl", {
					topic: "Topic",
					first: "First Poster",
					last: "Last Poster",
				})
			);
			this.$topics_box.append(this.$title_bar);
			this.topic_boxes = [];
			if (num_topics > 0) {
				last_topic_idx =
					Math.min(Constants.max_num_shown_topics, num_topics) - 1;

				for (i = 0; i <= last_topic_idx; i++) {
					this.addTopic(this.collection.models[i], {
						add_in_bulk: true,
					});
				}
				for (i = 0; i <= last_topic_idx; i++) {
					$topics_to_add.push(this.topic_boxes[i].$el);
				}

				if (last_topic_idx < num_topics - 1) {
					for (i = last_topic_idx; i < num_topics; i++) {
						this.topic_boxes.push({
							model: this.collection.models[i],
							is_placeholder: true,
						});
					}
				}

				this.$title_bar.after($topics_to_add);
				this.view_end_id = last_topic_idx;
			}
			this.min_add_bulk_idx = Constants.BIG;

			// Build scrollbar, fetch more topics on end.
			this.$scrollwrapped_list = AoPS.Community.Views.buildCommunityScrollbar(
				this.$topics_box,
				{
					onScroll: _.bind(function () {
						this.onScroll();
					}, this),
				}
			);
			this.$el.append(this.$scrollwrapped_list);
			this.$topics_window = this.$topics_box.parent();

			this.$scroll_inner_window = this.$el.find(".aops-scroll-inner");
			this.$scrollbar = this.$el.find(".aops-scroll-bar");
			this.$scrollbar.before(
				'<div title="' +
					Lang["topic-list-jump-top"] +
					'" class="cmty-topic-list-jump-top clickable">G</div>'
			);
			this.$scroll_slider = this.$scrollbar.find(".aops-scroll-slider");
			this.$scrollbar.on(
				"slider_at_end",
				_.bind(function () {
					this.onSliderAtBottom();
				}, this)
			);
			this.$scrollbar.on(
				"slider_at_start",
				_.bind(function () {
					this.onSliderAtTop();
				}, this)
			);
			// Watchers for add and remove topics
			this.listenTo(this.collection, "add", this.addTopicAfterLoad);
			this.listenTo(this.collection, "remove", this.removeTopic);
			// location of the scroll bar; need to remember it when we travel around,
			//  so we get back to the right place when we come back
			this.scroll_loc = 0;
			this.$scroll_area = this.$topics_box.parent();
			this.$scroll_area.on(
				"scroll",
				_.bind(function () {
					this.scroll_loc = this.$scroll_area.scrollTop();
				}, this)
			);

			if (!this.collection.all_topics_fetched) {
				if (this.fetch_topics_on_build && !this.suppress_initial_fetch) {
					this.checkMoreTopicsNeeded();
				}
			} else {
				this.appendNoMoreTopicsMessage();
			}

			// RR Removed 1/20/15
			//  Main result: no listeners for topic lists that are embedded in category cells.  That seems right?
			//this.setFocusListener();
			this.$scroll_area.scrollTop(0);

			if (this.master.get("current_user").get("forum_view") === "condensed") {
				this.$el.addClass("cmty-condensed-topic-list");
			}
		},

		events: {
			"click .cmty-topic-list-jump-top": "onClickJumpToTop",
		},

		/**
		 * Set the listener for the focus topic.  Overwritten in the Feed's extension.
		 */
		setFocusListener: function () {
			this.listenTo(this.master, "change:focus_topic", this.onChangeFocusTopic);
			this.listenTo(
				this.master,
				"change:focus_topic_list",
				this.parseFocusTopicList
			);
			this.listenTo(
				this.master,
				"change:fullscreen_mode",
				this.onChangeFullscreen
			);
		},

		/**
		 * When fullscreen mode changes, we need to check if the popout is visible.
		 **/
		onChangeFullscreen: function () {
			var self = this;
			setTimeout(function () {
				self.setPopoutVisibility();
			}, 10);
		},

		/**
		 * Get the focus topic that's relevant to this list.  Overwritten in the Feed's extension.
		 */
		getFocusTopic: function () {
			return this.master.get("focus_topic");
		},

		/**
		 * When we scroll, we check out the popout visibility.
		 */
		onScroll: function () {
			if (_.isNull(this.getFocusTopic())) {
				return;
			}

			this.setPopoutVisibility();
		},

		/**
		 * Show the topic cell in the submitted location.
		 *
		 * @param string : 'top' puts the cell on top.  Everything else is the bottom.
		 */
		revealFocusCell: function (location) {
			var show_on_top = location === "top",
				focus_topic = this.getFocusTopic(),
				self = this;
			if (
				!this.hasOwnProperty("popout_focus_cell") ||
				_.isNull(this.popout_focus_cell)
			) {
				return;
			}
			this.popout_focus_cell.$el.show();
			this.$stunt_double.show();
			this.focus_cell_location = location;
			if (!this.scroll_inner_listener_set) {
				this.$scroll_inner_window.on("scroll.stunt", function () {
					self.locateStuntDouble(location);
				});

				this.scroll_inner_listener_set = true;
			}

			this.$el.toggleClass("top-focus-popup", show_on_top);
			this.$el.toggleClass("bottom-focus-popup", !show_on_top);
			this.$el.toggleClass(
				"announcement-popup",
				!(focus_topic.get("announce_type") === "none")
			);
			this.stunt_double_height = this.$stunt_double.outerHeight();
			/**
			 * The location of the stunt double needs to happen after all
			 *  the new topic cells are added.
			 **/
			//	setTimeout(function () {
			self.locateStuntDouble(location);
			//	}, 10);
		},

		/**
		 * Set the location of the stunt double
		 *
		 * @param string top or bottom
		 **/
		locateStuntDouble: function (location) {
			var new_loc = this.$scroll_inner_window.scrollTop();

			if (location === "top") {
				this.$stunt_double.css("top", new_loc + "px");
			} else {
				this.$stunt_double.css(
					"top",
					new_loc +
						this.$scroll_inner_window.height() -
						this.stunt_double_height +
						"px"
				);
			}
		},

		/**
		 * Decide whether or not the popout for the focus topic is visible.
		 **/
		setPopoutVisibility: function () {
			var focus_topic = this.getFocusTopic(),
				focus_index = -1,
				num_boxes = this.topic_boxes.length,
				focus_cell = null;

			if (!this.on_page) {
				return;
			}

			for (var i = 0; i < num_boxes; i++) {
				if (this.topic_boxes[i].model === focus_topic) {
					focus_index = i;
					focus_cell = this.topic_boxes[i];
					break;
				}
			}

			if (_.isNull(focus_cell)) {
				if (!_.isNull(focus_topic)) {
					/**
					 * We need to check if the focus_topic is still part of this collection.
					 *  If not, then we don't make a focus cell at all.
					 * (This extra check was added for ViewTopics, specifically bookmarked topics,
					 *  because we can unbookmark a topic in the Bookmarked Topics feed,
					 *  and we don't want a FocusCell popping up for that now that the topic is
					 *  not in the bookmarked topics feed.)
					 **/
					if (this.collection.filter(focus_topic)) {
						/** Topic's topic_box is not in the list yet; this is an old topic that hasn't been loaded
						 except to look at it now.  Peg this puppy to the bottom. **/
						this.revealFocusCell("bottom");
					} else {
						this.destroyPopoutCell();
					}

					return;
				} else {
					// no focus, no focus cell.  Nothing to do here.
					return;
				}
			}

			if (focus_index < this.view_start_id) {
				this.revealFocusCell("top");
				return;
			}

			if (focus_index > this.view_end_id) {
				this.revealFocusCell("bottom");
				return;
			}

			var focus_top =
				-this.$scroll_inner_window.scrollTop() + focus_cell.$el.position().top;

			/** The 0.5 gives a little leeway for rounding issues when the page is first loaded. **/
			if (focus_top < 0.5) {
				this.revealFocusCell("top");
			} else if (focus_top > this.$el.height() - focus_cell.$el.outerHeight()) {
				this.revealFocusCell("bottom");
			} else {
				this.$el.removeClass("top-focus-popup bottom-focus-popup");
				if (
					this.hasOwnProperty("popout_focus_cell") &&
					!_.isNull(this.popout_focus_cell)
				) {
					this.popout_focus_cell.$el.hide();
				}
				if (this.$stunt_double) {
					this.$stunt_double.hide();
				}
				this.$scroll_inner_window.off("scroll.stunt");
			}
		},

		/**
		 * Get rid of the popout cell.
		 */
		destroyPopoutCell: function () {
			if (!_.isNull(this.popout_focus_cell)) {
				this.stopListening(
					this.popout_focus_cell.model,
					"change:announce_type"
				);
				this.popout_focus_cell.close();
				this.$stunt_double.remove();
				this.$scroll_inner_window.off("scroll.stunt");
				this.scroll_inner_listener_set = false;
				this.popout_focus_cell = null;
				this.$el.removeClass("top-focus-popup bottom-focus-popup");
			}
			return;
		},

		onChangeFocusTopic: function () {
			var self = this;
			if ($(window).width() <= Constants.phone_mode_max_width) {
				if (_.isNull(this.master.get("focus_topic"))) {
					if (!_.isUndefined(this.stored_window_top)) {
						setTimeout(function () {
							window.scrollTo(0, self.stored_window_top);
						}, 10);
					}
				} else {
					this.stored_window_top = $(window).scrollTop();
				}
			}
			this.parseFocusTopic();
		},

		/**
		 * Based on where the focus topic is in our queue, we may pop out a TopicCell
		 *  cell to sit atop the list.  Here, we look for where the topic is in the
		 *  list to decide whether to pop it out.
		 *
		 * TODO : What happens if the topic is not in the list?  (This will happen for old topics
		 *  that are directly linked.)  Once I fix the router for that, we'll be fine.  Peg the popout cell
		 *  to the bottom.
		 **/
		parseFocusTopic: function () {
			var new_topic;
			/* If this list isn't on-screen, close the popout if it is open and skip the list */
			//	if (this.collection !== this.master.get('focus_topic_list')) { //TODO: CHECK FEED

			if (!this.on_page) {
				this.destroyPopoutCell();
				return;
			}

			new_topic = this.getFocusTopic();
			/* Kill the popout cell if there's no focus topic */
			if (!new_topic) {
				this.destroyPopoutCell();
				return;
			}

			/** If the focus hasn't changed, then do nothing besides check visibility **/
			if (
				this.popout_focus_cell &&
				this.popout_focus_cell.model === new_topic
			) {
				this.setPopoutVisibility();
				return;
			}
			if (this.popout_focus_cell) {
				this.popout_focus_cell.close();
			}
			/* Build the popout focus cell */
			this.popout_focus_cell = new this.popoutView({
				model: new_topic,
				topic_list: this,
				master: this.master,
				focus_tag: this.focus_tag,
				push_state_attribute: this.push_state_attribute,
				url_cmty_path: this.url_cmty_path,
				url_router_base: this.url_router_base,
				route_category_id: this.category_id,
			});
			this.listenTo(new_topic, "change:announce_type", this.destroyPopoutCell);
			this.popout_focus_cell.$el.addClass("cmty-topic-list-popout");
			this.$stunt_double = this.popout_focus_cell.$stunt_double;
			// See ComViews.TopicCellPopout.createStuntDouble documentation for what the
			//  $stunt_double is all about.
			this.$scroll_inner_window.append(this.$stunt_double);
			// TODO: Figure out what I should really do here.
			//   The popout cell is set to null by setPopoutVisibility if the
			//   topic is no longer in this filteredTopicList -- what do
			//	 we want to do in that case in the list of topic cells?
			if (this.popout_focus_cell) {
				this.$el.find(".aops-scroll-outer").append(this.popout_focus_cell.$el);
			}
			this.setPopoutVisibility();
		},

		/**
		 * checkMoreTopicsNeeded determines if more
		 * topics are needed based on the number currently loaded.
		 */
		checkMoreTopicsNeeded: function () {
			// Add a check to see if the data are loading
			if (this.collection.all_topics_fetched) {
				/**
				 * This takes care of a rare edge case: we have preloaded a small number
				 *  of topics that happens to be the entire list.
				 *  In this case, the view_start_id and view_end_id will be 0,
				 *  and all sorts of stuff will go wrong, and they won't
				 *  get reset by the onSliderAtBottom() call that would happen
				 *  for a list that hasn't been fully loaded.
				 **/
				if (this.topic_boxes.length <= Constants.num_topics_to_reveal) {
					this.view_start_id = 0;
					this.view_end_id = this.topic_boxes.length - 1;
				}
				this.appendNoMoreTopicsMessage();
			} else if (this.topic_boxes.length < 10) {
				this.suppress_scroll = true;
				this.onSliderAtBottom({
					never_cancel: true,
				});
			}
		},

		buildTopicCell: function (topic) {
			return new this.topicView({
				model: topic,
				url_cmty_path: this.url_cmty_path,
				url_router_base: this.url_router_base,
				push_state_attribute: this.push_state_attribute,
				topic_list: this,
				master: this.master,
				focus_tag: this.focus_tag,
				route_category_id: this.use_topic_category
					? topic.get("category_id")
					: this.category_id,
			});
		},

		includeTopicWhenLocatingNew: function (topic_box) {
			// If we aren't marked for deletion, then we have to consider this box
			if (!topic_box.marked_for_deletion) {
				return true;
			}

			// If we're not a forum, then we don't have any more checks
			if (!this.collection.category.get("is_forum")) {
				return false;
			}

			// Announcements need to be pegged to the top in forums; we need to force
			//  all new topics below them, even if the box is "marked for deletion"
			//  because there has been a reply.  This takes care of the case "While on the
			//  page, there is a reply to the announcement and then a new topic."
			return topic_box.model.get("announce_type") !== "none";
		},
		/**
		 * addTopic adds a topic to this topics list
		 *
		 * @param topic: CommunityModels.Topic
		 * @param object: optional options that may be passed with a topic add
		 *    --If 'added_by' is set to 'topic_update',
		 *    	then we hide the new view that we make for this topic and
		 *    	mark it to be added upon page load. See addTopicAfterLoad below for more details.
		 *	  --If 'add_in_bulk' is set to true, then added in bulk when the list triggers the completion
		 *		of adding all the topics.
		 */
		addTopic: function (topic, options) {
			var new_topic = this.buildTopicCell(topic),
				i,
				insert_index,
				this_topic_time = -this.collection.comparator(topic),
				current_box,
				/**
					5/16/15: RR added the check of announcement_type.
					This is needed to get announcement cells added to the
					category cells in the folder once the user drills into a
					forum.  If those cells aren't there, then if a user visits
					a forum and replies to early topics there, the old topic cell will get
					removed from the topic list in the folder but its new topic cell
					will not get added because the code below will place it after
					the announcement cell, which never got added.  (This is
					a weird initial condition bug.)
				**/
				add_in_bulk =
					options.hasOwnProperty("add_in_bulk") &&
					options.add_in_bulk &&
					topic.get("announce_type") === "none",
				topic_box_added = false,
				n_boxes = this.topic_boxes.length;

			new_topic.is_hidden_until_page_add = false;
			for (i = n_boxes - 1; i >= 0; i--) {
				current_box = this.topic_boxes[i];

				if (
					this.includeTopicWhenLocatingNew(current_box) &&
					-this.collection.comparator(current_box.model) > this_topic_time
				) {
					if (add_in_bulk) {
						if (this.min_add_bulk_idx > i + 1) {
							this.min_add_bulk_idx = i + 1;
						}
					} else {
						current_box.$el.after(new_topic.$el);
					}

					this.topic_boxes.splice(i + 1, 0, new_topic);
					insert_index = i + 1;
					i = -1;
					topic_box_added = true;
				}
			}
			if (!topic_box_added) {
				if (add_in_bulk) {
					this.min_add_bulk_idx = 0;
				} else {
					// Put this topic at the start.
					this.$title_bar.after(new_topic.$el);
				}
				this.topic_boxes.splice(0, 0, new_topic);

				insert_index = 0;
			}

			// Hopefully this is all fast enough to avoid a flicker
			//  upon add and remove...
			if (!this.updateViewLimitIdOnAdd(insert_index)) {
				new_topic.$el.detach();
			} /* && options.hasOwnProperty('added_by') &&
				(options.added_by === 'topic_update' || options.added_by === 'topic_move')) {
				// This is here in case we have a topic that is in two lists that are on-screen (feed and cmty),
				//  but the topic is only present in one of those lists.  It will be marked for
				//  deletion in that list.  That list will pass the next test.  The other list won't,
				//  and the new cell will appear.
				if( !_.isUndefined(_.findWhere(this.topics_marked_for_deletion, {
					model : new_topic.model
				}))) {
					new_topic.$el.hide();
					new_topic.is_hidden_until_page_add = true;
					this.topics_hidden_until_next_add.push(new_topic);
				} else {
					this.num_visible_topics++;
				}
			} else {
				this.num_visible_topics++;
			}*/
			/**
			 * See if this is the last announcement in the topic list; if so,
			 *  class it as such.
			 **/
			// Instead of is_visible here, I might rather have a focus_list on master to compare to.
			//  Tough call.  Dangerous if same list is used in multiple places
			// If this TopicsList is on-screen right now, and this topic was added by
			//  a topic update, then don't add this TopicCell right now.
			//  Mark it for addition later.  It will get added next time we load this
			//  list to the page.
			// TODO: Think about nuking the visible list check, and only doing the marked_for_deletion test.
			/*	if (this.on_page /*this.$el.is(':visible')*/ if (
				new_topic.announce_type !== "none"
			) {
				/** First check if it's the last cell in the list, then check if it is before an announcement. **/
				if (
					insert_index === n_boxes ||
					this.topic_boxes[insert_index + 1].model.get("announce_type") ===
						"none"
				) {
					for (i = 0; i < insert_index; i++) {
						this.topic_boxes[i].$el.removeClass("cmty-last-announcement");
					}
					new_topic.$el.addClass("cmty-last-announcement");
				}
			}

			this.$no_more_topics.text(this.no_more_items_message);

			return new_topic;
		},

		/**
		 * Whenever there's a new topic added to this list after the initial load,
		 *  we may need to adjust the scroll of the topics container accordingly.
		 *  We have a lot of policy decisions to make here.
		 *
		 *  @param ComModels.Topic
		 *  @param Collection of ComModels.Topic that was added to in order to trigger this add
		 *  @param Optional options that may be passed with a model add.
		 *
		 * We use the options when adding a model to indicate if the model was added by
		 *  a topic_update event.  (See ComModels.Topic.processTopicUpdate for where this
		 *  add happens.)  We pass these options on to addTopic so that we
		 *  can tell when to treat this added topic differently because it is added by a
		 *  topic update event.  (When a topic is updated, we remove and then add it
		 *  to the master topics list.  This triggers all sorts of events and re-sorts
		 *  that get the topic placed in the correct location.)
		 *
		 * We perform this sort of magic because we don't want a topic to change its position in a topic list
		 *  if that topic list is on page.  So, we keep the old cells around when the topics are updated,
		 *  and we don't show the new topic cells that we form upon topic updates.  The updates
		 *  are still registered in the topic cells that we keep on-screen.  The new cells
		 *  stay hidden until we add the topic list to the page again, whereupon we clean out
		 *  the old cells and reveal the new ones.
		 */
		addTopicAfterLoad: function (topic, collection, options) {
			var new_topic_cell,
				is_updating_cell_here = false,
				current_scroll_top,
				topic_postponed = false;

			/**
			 * This is a little sleight of hand added 5/16/15.
			 *	When we update a topic that has a cell in this list (and the list is visible),
			 *	we mark the old cell for deletion when the list is removed from
			 *  the page, and keep the topic's new cell hidden until next time
			 *  the list is added.  We accomplish this by marking the topic
			 *  add to the collection as "added_by = 'topic_update'".  However,
			 *  there's a wrinkle -- the topic may belong in many topic lists.
			 *  The topic is marked as being updated in all of them.  So,
			 *  when a topic is updated, we need to check each list for whether
			 *  that topic already had a cell built in this list.
			 *
			 *	Example: Suppose you load a bunch of topics in Middle School Math
			 *		and you have the global feed open but haven't loaded many topics
			 *		there.  If someone replies to a topic that is among those
			 *		you have loaded in MSM but not in the global feed, then
			 *		we need to add the new cell to the global feed right away,
			 *		but we do not add it to MSM right away.
			 **/
			if (this.on_page && options.added_by === "topic_update") {
				is_updating_cell_here =
					this.topics_marked_for_deletion &&
					_.indexOf(this.updated_topics, topic) > -1;
			}

			if (
				this.on_page &&
				(is_updating_cell_here || options.added_by === "topic_move") &&
				this.collection.category !== topic.get("force_add_to_category")
			) {
				if (_.indexOf(this.topics_hidden_until_next_add, topic) === -1) {
					this.topics_hidden_until_next_add.push(topic);
				}
				topic_postponed = true;
			} else {
				new_topic_cell = this.addTopic(topic, options);
			}
			if (options.add_in_bulk) {
				return;
			}

			this.$loader.detach();

			// TODO  : Think a lot about what's going on here.  Not sure exactly what we want to do.
			//  This is really tricky...  On initial load, we want the scroll top to reset.
			//   After that, we don't.  That's difficult.  If we have <= below, then the
			//   topic lists will set to the end of the first load list.  That's bad.
			//   So, I added the "on_initial_topic_fetch" to block that.  When we
			//   grab the initial set of topics, we don't touch the scrollbar.
			if (!this.on_initial_topic_fetch && !topic_postponed) {
				if (this.isFixedHeight()) {
					current_scroll_top = this.$scroll_area.scrollTop();
					if (new_topic_cell.$el.position().top <= current_scroll_top) {
						this.$scroll_area.scrollTop(
							current_scroll_top + new_topic_cell.$el.outerHeight()
						);

						// Just in case the window shifts in a way that changes the popout visibility.
						//  This could happen in short topic lists, where a new topic will force the topics down because we can't have any scroll
						//  action when the window is not large enough to scroll.
						this.setPopoutVisibility();
					}
				} else {
					if (this.on_page) {
						current_scroll_top = $(window).scrollTop();
						if (new_topic_cell.$el.position().top <= current_scroll_top) {
							window.scrollTo(
								0,
								current_scroll_top + new_topic_cell.$el.outerHeight()
							);
						}
					}
				}
			}
		},

		/**
		 * Remove a topic.
		 *
		 *  @param ComModels.Topic
		 *  @param Collection of ComModels.Topic that was added to in order to trigger this remove
		 *  @param Optional options that may be passed with a model remove.
		 *
		 * See addTopicAfterLoad for details about how we are dealing with options.
		 */
		removeTopic: function (removed_topic, collection, options) {
			var removed_topic_box = null,
				i,
				self = this,
				removed_topic_index,
				new_topics_hidden = [],
				num_topic_boxes = this.topic_boxes.length;

			// Remove this topic from the topics_hidden_until_next_add, so it
			//  doesn't get inadvertently revived.  We need this in the case
			//  of a remove event being called after a topic is queued up
			//  for being added to the list.
			_.each(this.topics_hidden_until_next_add, function (hidden_topic) {
				if (hidden_topic !== removed_topic) {
					new_topics_hidden.push(hidden_topic);
				}
			});
			this.topics_hidden_until_next_add = new_topics_hidden;

			for (i = 0; i < num_topic_boxes; i++) {
				if (this.topic_boxes[i].model === removed_topic) {
					removed_topic_index = i;
					removed_topic_box = this.topic_boxes[i];
					break;
				}
			}
			if (!_.isNull(removed_topic_box) && !_.isUndefined(removed_topic_box)) {
				// If this TopicsList is on-screen right now, and this topic was removed by
				//  a topic update, then don't nuke this TopicCell right now.
				//  Mark it for deletion later.  It will get nuked next time we load this
				//  list to the page.
				// RR changed .is(':visible') to this.on_page on 7/22/14
				if (this.on_page && options.hasOwnProperty("removed_by")) {
					if (options.removed_by === "topic_update") {
						removed_topic_box.marked_for_deletion = true;
						this.updated_topics.push(removed_topic);
						this.topics_marked_for_deletion = true; //.push(removed_topic_box);
					} else if (options.removed_by === "topic_move") {
						// What we do when the topic changes forums.
						// We remove whether or not it is supposed to stay in this category,
						//   since the re-added version of this topic will turn visible when
						//   the user leaves this list.  So, for example, if we are in
						//   an egosearch list of topics and a topic is moved, then
						//   we need the topic to stay in this list.  This instance will get
						//   removed, and the new instance will get added.
						removed_topic_box.marked_for_deletion = true;
						this.topics_marked_for_deletion = true; //.push(removed_topic_box);
						if (!this.collection.filter(removed_topic)) {
							// If the topic will not be re-added to this list, then we
							//   call this topic_box's markMoved method to indicate to user
							//   that this has found a new home.
							removed_topic_box.markMoved();
						} else {
							// Otherwise, we just make sure it's colored properly
							// 2/12/15 RR removed line below.
							//  The line below deals with topic moves (and soft deletes for admins).  If
							//  the new topic would still be in this list,
							//  then the new cell for the topic will pop up in the list, too.
							//  So, we'd have a double-cell for that topic.  So, I don't think
							//  we want to just set color; we need to nuke this topic_box.
							//  The only weird thing will be when a topic is in, say, the global feed,
							//  gets a reply, and then gets moved.  Then it will jump to the location
							//  of the reply time (rather than stay in place, as it will with a move).
							//  I can live with that.
							//removed_topic_box.setColor();
							this.removeTopicBox(
								removed_topic_box,
								removed_topic_index,
								removed_topic
							);
							if (this.on_page && this.getFocusTopic() === removed_topic) {
								// Maybe we don't have to do anything?
								setTimeout(function () {
									self.parseFocusTopic();
								}, 10);
							}
						}
					} else {
						// This should not happen, right?  (Topic deletes are handled as
						//  topic.destroy removing topic model from collection, which calls this
						//  function without removed_by set
					}

					Backbone.trigger("topic_cell_marked_for_deletion", {
						topics_list: this,
					});
				} else {
					this.removeTopicBox(
						removed_topic_box,
						removed_topic_index,
						removed_topic
					);
				}
			}

			// TODO : think if there's a better way to filter than the 'is visible' item.
			//  Changed the is(':visible') to on_page on 7/22/14
			if (!_.isNull(this.master.get("focus_topic")) && this.on_page) {
				this.shiftToTopic(this.master.get("focus_topic"));
			}

			if (this.collection.length === 0) {
				this.$no_more_topics.text(this.no_items_at_all_message);
			}
		},

		/**
		 * Remove a topicCell from this list.
		 *
		 * @param TopicCell to remove
		 * @param int index of that cell in the topic_boxes array
		 * @param Models.Topic of the topic.
		 **/
		removeTopicBox: function (
			removed_topic_box,
			removed_topic_index,
			removed_topic
		) {
			if (
				!_.isNull(this.popout_focus_cell) &&
				this.popout_focus_cell.model === removed_topic
			) {
				this.popout_focus_cell.close();
				this.popout_focus_cell = null;
				this.$el.removeClass("top-focus-popup bottom-focus-popup");
			}
			removed_topic_box.close();

			this.topic_boxes = _.without(this.topic_boxes, removed_topic_box);
			this.updateViewLimitIdOnDelete(removed_topic_index);
		},

		/**
		 * Add the topics that were bulk-loaded to this list.
		 *
		 * Assumes that bulk-adding will only happen at the bottom
		 *  of the list.
		 **/
		addBulkLoadedTopics: function () {
			var i,
				$cells = [],
				self = this,
				max;
			/**
			 * We only put something on the page if we have set the
			 *  minimum index of the bulk addition, and if the viewing window
			 *  is currently set to add topics at the end (the view_end_id is
			 *  the end of the currently loaded topics).
			 **/
			if (
				this.min_add_bulk_idx < Constants.BIG &&
				(this.view_end_id === this.topic_boxes.length - 1 ||
					this.view_end_id <= 0)
			) {
				max = this.topic_boxes.length - 1;

				for (i = this.min_add_bulk_idx; i <= max; i++) {
					$cells.push(this.topic_boxes[i].$el);
				}

				this.$topics_box.append($cells);
				this.checkRevealedTopics();

				if (
					!this.on_initial_topic_fetch &&
					this.on_page &&
					!this.suppress_scroll
				) {
					if (this.isFixedHeight()) {
						if (self.$scroll_area.scrollTop() != 0) {
							self.$scroll_area.scrollTop(
								self.topic_boxes[self.min_add_bulk_idx].$el.position().top -
									self.$topics_window.height()
							);
						}
					} else {
						window.scrollTo(
							0,
							this.topic_boxes[this.min_add_bulk_idx].$el.offset().top -
								$(window).height() +
								20
						);
					}
				}
			}
			this.min_add_bulk_idx = Constants.BIG;
			/**
			 * Sometimes on the initial fetch of a batch of topics,
			 *  the scrollbar doesn't get triggered to appear.  This is
			 *  because there's a tiny bit of delay between the creation of
			 *  a scrollbar and the initialization of the scrollbar listeners.
			 *  (See checkInitSettings in Ui.buildAopsScrollbar to see
			 *  the initialization delay.)  So, for any bulk add,
			 *  we go ahead and call the adjustSlider manually just to be
			 *  sure it gets fired.
			 **/
			if (this.$scrollwrapped_list.hasOwnProperty("aopsScroll")) {
				this.$scrollwrapped_list.aopsScroll.adjustSlider();
			}
		},

		/**
		 * Update the endpoints of what topics are viewable when a topic is inserted in
		 *	the topic_boxes array.
		 *
		 * @param int index of added topic
		 * @return boolean Should the topic be shown or hidden?
		 **/
		updateViewLimitIdOnAdd: function (added_id) {
			if (added_id < this.view_start_id) {
				this.view_start_id++;
				this.view_end_id++;
				return false;
			}
			/** REMOVE 9/15/14
			 * There's a very subtle edge case at the start of a list.
			 *  The topics are coming in out of order, and get added willy nilly.
			 *  The first topic that comes in gets added, incrementing the view_end_id
			 *  to show that we have one.  But then things go bad if the any subsequent
			 *  topic should be listed before that first one.
			 *  That's because the first check after this one will
			 *  add that topic, and increment view_end_id.  But the next topic
			 *  may be off the end of the list by one, and not get added to the screen
			 *  and not have view_end_id incremented.  Then, the onSliderAtBottom
			 *  check to see what topics should be shown will go whack because
			 *  the view_end_id won't be where it thinks it should be.
			 *  Initial conditions are hard.
			 */
			//	if (this.view_start_id == 0 && this.view_end_id == 0 && !this.on_page) {
			//		return false;
			//	}

			// RR removed + 1 after view_end_id, and put >= on the final
			//  if statement, trying to solve the "same list in two views, load more topics in one,
			//  make the other superbig
			if (added_id >= this.view_start_id && added_id <= this.view_end_id) {
				this.view_end_id++;
				return true;
			}

			if (added_id == this.view_end_id + 1 && this.on_page == true) {
				this.view_end_id++;
				return true;
			}

			/** Gotta mark that we have one! REMOVE 9/15/14
		//	if (added_id === 0 && this.view_end_id === -1) {
		//		this.view_end_id = 0;
		//		return true;
		//	}*/

			if (added_id >= this.view_end_id + 1) {
				return false;
			}
		},

		/**
		 * If we delete a topic that's prior to the end of the visible range,
		 *  then we will need to update the visible range limits.
		 **/
		updateViewLimitIdOnDelete: function (deleted_id) {
			if (deleted_id < this.view_start_id) {
				this.view_start_id--;
			}

			// RR changed view_end_id > 0 to view_end_id >= 0 on 11/29
			//  to deal with last cell getting removed.  Don't know if
			//  this will cause problems elsewhere
			if (deleted_id <= this.view_end_id && this.view_end_id >= 0) {
				this.view_end_id--;
			}
		},

		/**
		 * When we click the jump to top button just above the scrollbar, we go to the
		 *  beginning of the whole list, and adjust which topic cells are visible accordingly.
		 **/
		onClickJumpToTop: function () {
			var num_boxes = this.topic_boxes.length,
				i,
				add_through_id,
				$add_boxes = [];
			this.view_end_id = Math.min(
				this.view_end_id,
				Constants.max_num_shown_topics - 1
			);

			add_through_id = Math.min(this.view_start_id - 1, this.view_end_id);
			this.view_start_id = 0;

			for (i = this.view_start_id; i <= add_through_id; i++) {
				$add_boxes.push(this.topic_boxes[i].$el);
			}

			for (i = this.view_end_id + 1; i < num_boxes; i++) {
				this.topic_boxes[i].$el.detach();
			}
			this.$title_bar.after($add_boxes);
			if (this.isFixedHeight()) {
				this.$scroll_area.scrollTop(0);
			} else {
				window.scrollTo(0, 0);
			}
			this.markIfAtTop();
		},

		/**
		 * Check which of the loaded topics should be revealed.
		 **/
		checkRevealedTopics: function () {
			var slider_top, i, hide_lower_limit, hide_upper_limit, scrollbar_height;

			if (
				this.view_end_id - this.view_start_id <=
				Constants.max_num_shown_topics
			) {
				this.markIfAtTop();
				return;
			}

			if (!this.on_page) {
				return;
			}

			slider_top = this.$scroll_slider.position().top;
			scrollbar_height = this.$scrollbar.height();

			if (slider_top / scrollbar_height < 0.2) {
				// Nuke stuff from the end.
				hide_lower_limit = this.view_end_id - Constants.num_topics_to_hide + 1;
				hide_upper_limit = this.view_end_id;
				this.view_end_id = hide_lower_limit - 1;
			} else if (slider_top / scrollbar_height > 0.7) {
				// Nuke stuff from the start.
				hide_upper_limit =
					this.view_start_id + Constants.num_topics_to_hide - 1;
				hide_lower_limit = this.view_start_id;
				this.view_start_id = hide_upper_limit + 1;
			}
			for (i = hide_lower_limit; i <= hide_upper_limit; i++) {
				this.topic_boxes[i].$el.detach();
			}
			this.markIfAtTop();
		},

		markIfAtTop: function () {
			var is_at_top = this.view_start_id == 0;
			this.$el.toggleClass("cmty-not-at-top", !is_at_top);
			$("body").toggleClass("cmty-hide-header", !is_at_top);
		},

		/**
		 * Check queued topic boxes -- those that have been added while
		 *   we aren't on-screen.
		 **/
		checkQueuedUpTopicBoxes: function () {
			var num_boxes,
				$cells_to_add = [];
			if (this.view_end_id === -1) {
				num_boxes = Math.min(
					this.topic_boxes.length,
					Constants.max_num_shown_topics
				);
				for (var i = 0; i < num_boxes; i++) {
					$cells_to_add.push(this.topic_boxes[i].$el);
				}
				this.$title_bar.after($cells_to_add);
				this.view_end_id = num_boxes - 1;
				this.view_start_id = 0;
			} else if (this.view_end_id !== this.topic_boxes.length - 1) {
				this.addQueuedTopics({
					fetch_more_if_at_end: false,
				});
			}
		},

		/**
		 * Add topic cells that have been built but not added to list because the
		 *  list was not on screen when the cells were built.
		 *
		 * @param object
		 * 		fetch_more_if_at_end boolean Fetch more topics
		 *   				if we hit the end of the list when adding.
		 *					False when called from onAddToPage, true when called by
		 *					slider hitting bottom.
		 **/
		addQueuedTopics: function (obj) {
			var old_end,
				new_end,
				$cells_to_add = [];

			new_end = Math.min(
				this.topic_boxes.length - 1,
				this.view_end_id + Constants.num_topics_to_reveal
			);
			if (ComViews.isIOS) {
				this.$scroll_area.css({
					"-webkit-overflow-scrolling": "auto",
				});
			}
			// Pile up the cells we want to add.
			for (var i = this.view_end_id + 1; i <= new_end; i++) {
				if (
					this.topic_boxes[i].hasOwnProperty("is_placeholder") &&
					this.topic_boxes[i].is_placeholder
				) {
					this.topic_boxes[i] = this.buildTopicCell(this.topic_boxes[i].model);
				}

				$cells_to_add.push(this.topic_boxes[i].$el);
			}
			// I'm only about 80% sure this is right.
			//  I hypothesize that all the cells past the end
			//  have been detached, so that a simple append is the right
			// thing to do here.

			this.topic_boxes[this.view_end_id].$el.after($cells_to_add);
			old_end = this.view_end_id;
			// reset the end id after adding
			this.view_end_id = new_end;

			// See if we need to hide some topics
			this.checkRevealedTopics();
			if (!this.suppress_scroll) {
				if (this.isFixedHeight()) {
					this.$scroll_area.scrollTop(
						this.topic_boxes[old_end + 1].$el.position().top -
							this.$topics_window.height()
					);
				} else {
					// The +50 is a nudge needed to draw the next topic into view.
					window.scrollTo(
						0,
						this.topic_boxes[old_end + 1].$el.offset().top -
							$(window).height() +
							50
					);
				}
			}

			// Nudge back by 1 in case we didn't actually get any more topics.  This should basically never happen.
			if (old_end === new_end) {
				old_end--;
			} else {
				this.$scrollbar.trigger("reset_end_watchers");
			}
			if (ComViews.isIOS) {
				this.$scroll_area.css({
					"-webkit-overflow-scrolling": "touch",
				});
			}

			// O noes!  I built right up to the end.  Gonna have to go to the database for more, yo.
			//  This is needed because the pre-built topics might not be enough to fill the whole space.
			if (obj.fetch_more_if_at_end && new_end == this.topic_boxes.length - 1) {
				this.fetchMoreTopics();
			} else {
				this.suppress_scroll = false;
			}
		},

		/**
		 * When the slider hits the bottom, we check if we have any hidden topics
		 *  that were already loaded.  If so, we show those.  If not, then we call
		 *  fetchMoreTopics.
		 *
		 * @param optional object that will be passed to fetchMoreTopics
		 ***/
		onSliderAtBottom: function () {
			var obj = arguments.length === 1 ? arguments[0] : {};

			// Stop the scrollbar from being able to continue being dragged;
			//  needed to keep a bunch of load more events from firing.
			$(document).trigger("mouseup");

			if (this.view_end_id === this.topic_boxes.length - 1) {
				this.fetchMoreTopics(obj);
			} else {
				this.addQueuedTopics({
					fetch_more_if_at_end: true,
				});
			}
		},

		/**
		 * When the slider hits the top, we check if there are any topics to un-hide (the topics that
		 *  were disappeared when we scrolled down).
		 **/
		onSliderAtTop: function () {
			var new_start,
				new_top,
				old_start,
				$cells_to_add = [];

			if (this.view_start_id === 0) {
				return;
			}

			this.$scrollbar.trigger("reset_end_watchers");
			if (ComViews.isIOS) {
				this.$scroll_area.css({
					"-webkit-overflow-scrolling": "auto",
				});
			}
			new_start = Math.max(
				0,
				this.view_start_id - Constants.num_topics_to_reveal
			);
			for (var i = new_start; i < this.view_start_id; i++) {
				$cells_to_add.push(this.topic_boxes[i].$el);
			}
			this.topic_boxes[this.view_start_id].$el.before($cells_to_add);

			old_start = this.view_start_id;
			this.view_start_id = new_start;
			this.checkRevealedTopics();

			if (!this.suppress_scroll) {
				if (this.isFixedHeight()) {
					new_top = this.topic_boxes[old_start].$el.position().top;
					this.$scroll_area.scrollTop(new_top);
				} else {
					new_top = this.topic_boxes[old_start].$el.offset().top;
					window.scrollTo(0, new_top - 40);
				}
			}
			if (ComViews.isIOS) {
				this.$scroll_area.css({
					"-webkit-overflow-scrolling": "touch",
				});
			}
		},

		/**
		 * Add the "No more topics" message to this topics list.
		 **/
		appendNoMoreTopicsMessage: function () {
			this.$loader.detach();
			if (this.collection.length == 0) {
				this.$no_more_topics.text(this.no_items_at_all_message);
			}
			this.$topics_box.append(this.$no_more_topics);
		},
	});

	ComViews.CategoryCellTopics = ComViews.TopicsList.extend({
		template_id: "#cmty-category-cell-topics-tpl",

		className: "cmty-itembox",

		topicView: ComViews.CategoryCellTopicCell,
	});

	ComViews.CategoryCellPrivatesTopics = ComViews.CategoryCellTopics.extend({
		no_more_items_message: Lang["topics-list-no-more-privates"],

		no_items_at_all_message: Lang["topics-list-no-privates"],

		/*appendNoMoreTopicsMessage : function () {
			this.$loader.detach();
			this.$topics_box.append($.parseHTML('<div class="cmty-no-more-topics">No more private messages :(</div>'));
		}*/
	});

	ComViews.TopicsListPrivates = ComViews.TopicsList.extend({
		no_more_items_message: Lang["topics-list-no-more-privates"],

		no_items_at_all_message: Lang["topics-list-no-privates"],

		//		appendNoMoreTopicsMessage : ComViews.CategoryCellPrivatesTopics.prototype.appendNoMoreTopicsMessage
	});

	ComViews.TopicsListSearchPosts = ComViews.TopicsList.extend({
		topicView: ComViews.TopicCellSearchPost,

		popoutView: ComViews.TopicCellSearchPopout,
	});

	/**
	 * ComViews.TopicTagbox extends ComViews.Itembox to create a tagbox for a single topic.
	 *
	 * model : ComModels.Topic
	 *
	 * Properties that can be passed in:
	 * category : Must pass the category in; used for the colors (may change to passing colors in).
	 * route_category_id (optional) : category_id of the route we are viewing
	 *
	 * Other properties:
	 * color : primary color of the topic's category
	 * secondary_color : light version of primary color for a category
	 * category_type : the type of category whose Itembox we're building
	 * tag_cells : array of jQuery objects for the tags in the tagbox.
	 */
	ComViews.TopicTagbox = ComViews.Itembox.extend({
		always_show_edit: true,

		initialize: function (options) {
			var $edit_tags_cell,
				render_titles =
					options.hasOwnProperty("render_titles") && options.render_titles,
				self = this,
				url_category_base;
			/*this.category = options.category;*/
			ComViews.setRouteInfo(this, options);
			this.category_id = this.model.get("category_id");
			this.secondary_color = this.model.get("category_secondary_color");
			this.main_color = this.model.get("category_main_color");

			// Link from a tag in a topic always goes to that topic's forum.
			_.each(this.model.get("tags"), function (tag) {
				var url, $tag_cell;
				var category_name;

				if (tag.hasOwnProperty("is_visible") && !tag.is_visible) {
					return;
				}

				if (
					self.category_id === Constants.private_messages_id &&
					self.model.get("status") === "archived"
				) {
					url_category_base = "/my-messages-archive/";
					category_name = self.model
						.get("master")
						.get("my_privates_archive")
						.get("category_name");
				} else {
					url_category_base = "/c" + self.category_id;
					category_name = self.model.get("category_name");
				}
				url =
					url_category_base +
					"t" +
					tag.tag_id +
					"f" +
					self.category_id +
					"_" +
					ComViews.convertToUrlFragment(tag.tag_text);
				$tag_cell = $(
					$.parseHTML(
						"<a " +
							self.push_state_attribute +
							' href="' +
							ComViews.makeLinkUrl(
								url,
								self.url_router_base + self.url_cmty_path
							) +
							'"><div ' +
							(render_titles
								? 'title="' +
									Lang["tag-tooltip-forum"] +
									ComViews.decodeHtmlEntities(category_name) +
									'"'
								: "") +
							' class="cmty-item-tag">' +
							tag.tag_text +
							"</div></a>"
					)
				);

				self.$el.append($tag_cell);
			});

			if (
				this.always_show_edit ||
				this.model.getPermission("c_can_edit_tags")
			) {
				$edit_tags_cell = $(
					$.parseHTML(
						'<div title="' +
							Lang["tag-edit-title"] +
							'" class="cmty-item-tag cmty-edit-tag aops-font">L</div>'
					)
				);
				this.$el.append($edit_tags_cell);
			}

			// TODO : Why can't I just ride off the other one?
			this.$el.find(".cmty-item-tag").css({
				//				'border' : '1px solid ' + this.color,
				"background-color": this.main_color,
			});
		},

		events: {
			"mouseenter .cmty-item-tag": "onHoverTag",
			"mouseleave .cmty-item-tag": "onLeaveTag",
			"click .cmty-item-tag": "onClickTag",
		},

		onClickTag: function (e) {
			var message_field;

			if (!$(e.target).hasClass("cmty-edit-tag")) {
				// Need to fix the colors on the way out.
				this.onLeaveTag(e);
				//e.stopPropagation();
				return true;
			} else {
				if (!AoPS.session.logged_in) {
					AoPS.Ui.buildLoginConfirm(Lang["tagbox-not-logged-in"]);
					e.stopPropagation();
					e.preventDefault();
					return false;
				} else if (!AoPS.session.initialized) {
					AoPS.Initialize.display({escapable: true});
					e.stopPropagation();
					e.preventDefault();
					return false;
				} else if (AoPS.isUserCoppaBlocked()) {
					AoPS.displayCoppaBlockedModal({escapable: true});
					e.stopPropagation();
					e.preventDefault();
					return false;
				} else if (!this.model.getPermission("c_can_edit_tags")) {
					message_field = this.model
						.get("master")
						.get("current_user")
						.get("is_new_user")
						? "tagbox-new-user"
						: "tagbox-no-permission";
					AoPS.Ui.Modal.showMessage(Lang[message_field], {
						width: "450px",
					});
					e.stopPropagation();
					e.preventDefault();
					return false;
				}
			}
		},

		// Taking care of this in CSS now.  Can omit if we stick with colored tags going white on hover.
		onHoverTag: function (e) {
			e.target.style.backgroundColor = this.secondary_color;
			e.target.style.color = this.main_color;
		},

		onLeaveTag: function (e) {
			e.target.style.color = "#fff";
			e.target.style.backgroundColor = this.main_color;
		},
	});

	/**
	 * This view is used to add a user to a private message.
	 *
	 * model : Community.Models.Topic
	 */
	ComViews.ModalToAddParticipant = AoPS.View.extend({
		template_id: "#cmty-private-add-participant-tpl",

		initialize: function () {
			this.$el.html(
				this.getTemplate("#cmty-private-add-participant-tpl", {
					instructions_start: Lang["add-participant-instructions-start"],
					instructions_end: Lang["add-participant-instructions-end"],
					add_user: Lang["add-participant-add-user"],
					placeholder: Lang["add-participant-placeholder"],
					max_number: Constants.max_conversation_participants,
				})
			);

			this.$input = this.$el.find("input");
			Utils.buildUsernameAutocomplete(this.$input, {
				ajax_call: "fetch_username_matches",
				autocomplete_settings: {
					onSelect: _.bind(function (event, ui) {
						var message_property,
							participant = _.findWhere(this.model.get("participants"), {
								user_id: parseInt(ui.item.user_id),
							});
						if (!_.isUndefined(participant)) {
							if (!participant.removed) {
								message_property = "private-already-added-active";
							} else {
								message_property = "private-already-added-self-removed";
							}
							AoPS.Ui.Modal.showMessage(
								Utils.formatString(Lang[message_property], [ui.item.label]),
								{
									width: "450px",
								}
							);
							this.$input.val("");
						} else {
							this.chooseUser(ui.item);
						}
						event.stopPropagation();
						event.preventDefault();
						return false;
					}, this),
				},
			});

			this.$new_participant = this.$el.find(".cmty-chosen-new-participant");
			//this.$input.aopsAutocomplete(autocompleteArgs);
			this.$el.showModal({
				type: "buttons",
				buttons: [
					{
						text: Lang["private-add-user-confirm-OK"],
						value: 1,
					},
					{
						text: Lang["Cancel"],
						value: 0,
					},
				],
				close_on_button_click: false,
				max_width: "450px",
				onButtonClick: _.bind(function (value) {
					if (value == 1) {
						if (!this.hasOwnProperty("user") && this.$input.val().length == 0) {
							AoPS.Ui.Modal.showMessage(Lang["private-no-username"]);
							return;
						} else {
							var addedUsers = this.model.get("participants");
							var wasIncluded = false;
							for (var i = 0; i < addedUsers.length; i++) {
								if (
									addedUsers[i].username.toLowerCase() ==
									this.$input.val().toLowerCase()
								) {
									wasIncluded = true;
									break;
								}
							}
							if (!wasIncluded) {
								this.addUserToParticipants();
							} else {
								AoPS.Ui.Modal.showMessage(
									Utils.formatString(Lang["private-already-added-active"], [
										this.$input.val(),
									]),
									{
										width: "450px",
									}
								);
							}
						}
					} else {
						this.close();
					}
				}, this),
			});
			this.$el.find("input").focus();
		},

		/**
		 * Fired when the user asks us to add the user to the private message.
		 */
		addUserToParticipants: function () {
			var self = this;
			var submit_properties = {
				onFinish: _.bind(function (msg) {
					this.onFinishAdding(msg);
				}, this),
				onError: _.bind(function (msg) {
					var output_string,
						code = msg.error_code;

					if (code === "E_NO_USER") {
						AoPS.Ui.Modal.closeTopModal();

						AoPS.Ui.Modal.showAlert(
							Utils.formatString(Lang["invalid-user"], [msg.response.username]),
							{
								onClose: _.bind(function () {
									this.$input.focus();
								}, this),
							}
						);
						this.$new_participant.html("");
						this.$input.show();
						this.$input.val("");
					} else {
						if (code === "E_NOT_LOGGED_IN") {
							output_string = Lang["add-participant-logged-out"];
						} else if (code === "E_NO_PERMISSION") {
							output_string = Lang["add-participant-no-permission"];
						} else if (code === "E_PAST_TIME_LIMIT") {
							output_string = Lang["add-participant-too-late"];
						} else if (code === "E_NO_MORE_PARTICIPANTS") {
							output_string = Lang["add-participant-no-more"];
						} else if (code === "E_NO_ADDING_TO_SHERIFF") {
							output_string = Lang["add-participant-to-sheriff"];
						} else if (code === "E_NO_ADDING_TO_EXTENSIONS") {
							output_string = Lang["add-participant-to-extensions"];
						} else if (code === "E_USER_REMOVED_SELF") {
							output_string = Lang["add-participant-removed-user"];
						} else if (code === "E_USER_EXCLUDED_FROM_PM") {
							output_string = Utils.formatString(
								Lang["add-participant-recipient-exclude-system"],
								[msg.response.username]
							);
						} else if (code === "E_PM_SHERIFF") {
							output_string = Utils.formatString(
								Lang["add-participant-recipient-sheriff"],
								[msg.response.username]
							);
						} else if (code === "E_PM_EXTENSIONS") {
							output_string = Utils.formatString(
								Lang["add-participant-recipient-extensions"],
								[msg.response.username]
							);
						} else if (code === "E_USER_DOESNT_RECEIVE_PM") {
							output_string = Utils.formatString(
								Lang["add-participant-recipient-exclude-self"],
								[msg.response.username]
							);
						} else if (code === "E_NO_ADDING_SELF") {
							output_string = Lang["add-participant-no-self"];
						} else {
							output_string = Lang["unexpected-error-code"] + code;
						}

						AoPS.Community.Views.showError(output_string);
					}
				}, this),
			};

			AoPS.Ui.Modal.showMessage(Lang["private-adding-user-blocker"], {
				force_response: true,
			});

			/**
			 * Determine the user object based on whether or not we
			 *  got a user from the autocomplete.  If no, then use
			 *  what's in the input box.
			 **/
			submit_properties = _.extend(submit_properties, {
				user: this.hasOwnProperty("user")
					? this.user
					: {
							username: this.$input.val(),
						},
			});

			this.model.checkValidPrivateRecipient({
				username: submit_properties.user.username,
				onFinish: function (response) {
					if (response.is_unreachable) {
						AoPS.Ui.Modal.closeTopModal();
						AoPS.Ui.Modal.showMessage(Lang["private-unreachable-recipient"], {
							force_response: true,
						});
					} else {
						self.model.submitNewParticipant(submit_properties);
					}
				},
			});

			return false;
		},

		/**
		 * This function is fired when the attempt to add the new participant is complete.
		 *  It is fired by Community.Models.Topic.submitNewParticipant
		 *
		 * @param object
		 *		has_error boolean : true if something went wrong
		 *		error_code string : code of the error if any
		 *		username string : username that was submitted.
		 */
		onFinishAdding: function (msg) {
			var self = this;
			// Close the placeholder modal.
			AoPS.Community.Views.delayModalClearing({
				onClose: function () {
					self.close();
				},
			});
		},

		/**
		 * When a user is chosen from the drop down, then this function is fired.
		 *
		 * @param object : item chosen from the drop down.
		 */
		chooseUser: function (item) {
			this.user = {
				username: item.value,
				user_id: parseInt(item.user_id),
			};
			this.$new_participant.html(item.value);
			if (parseInt(item.is_admin) == 1) {
				this.$new_participant.addClass("cmty-user-admin");
			}
			this.$input.hide();
		},

		onClose: function () {
			AoPS.Ui.Modal.closeAllModals();
		},
	});

	/**
	 * ComViews.EditableItemList constructs a list of items that we can add
	 * to or remove items from easily.  Currently used for the editable tag cloud
	 * on a topic
	 * and creating username lists such as the to field for private conversations.
	 *
	 * The "items" in an EditableItemList are not the same as the "items"
	 *	of an Itembox.  The items here differ from child to child.
	 *	Each has the property "label", which is the display string.
	 *	The remaining properties depend on the child.  See EditableUserList
	 *	and EditableTagBox for more details.
	 *
	 * Required options for initialization:
	 *   items : array of { label string , is_visible optional boolean default true } of the items.  May be empty.
	 *		Most implementations of EditableItemList expect items to have
	 *		other properties, such as item_id or user_id
	 *
	 * items must be unique by label
	 *
	 * See children for more details on items (EditableUserList and EditableTagBox).
	 *
	 * Other properties you can pass :
	 *
	 * onAddItem : fires after item added
	 * onRemoveItem : fires after item removed
	 *
	 * Properties
	 *
	 * item_class : class added to each item in the list (overwritten in most children)
	 *
	 * num_matches : Max number of items to show when matching (0 = no limit)
	 *
	 * submitted_item : The label of the item that has been submitted (used for
	 * 		avoiding a double-submit; see notes in constructAutocomplete
	 *
	 *
	 * Methods
	 *
	 * Methods for building the autocomplete.
	 *
	 * prepareAutocomplete():
	 *    Get the autocompleter ready.  Usually overwritten in children.  By default,
	 *    we plow ahead to constructItemAutocomplete.
	 *
	 * getAutocompleteSource():
	 * 		Get in children; get the input for the source parameter in aopsAutocomplete.
	 *
	 * getAutocompleteOnOpen()
	 * 		Set in children; define what happens when the autocomplete box opens.
	 *
	 * constructAutocompleteArgs()
	 *  	Construct the additional arguments used for autocomplete; usually overwritten in children.
	 *
	 * constructItemAutocomplete()
	 *  	Build the autocomplete field and all the behaviors when users are typing in the input box.
	 *
	 *
	 * Methods for processing new items.
	 *
	 * removeItem($deleted_item)
	 * 		What to do in the view when this item is deleted.
	 *
	 * processRemovedItem(removed_item)
	 *  	What to do outside the view when this item is deleted (overwritten in children).
	 *
	 * showError(error)
	 *    	Utility function for showing an error.
	 *
	 * performCustomValidation(new_item)
	 *  	In children, perform a custom validation on a new item.
	 *
	 * submitNewItem(new_item)
	 *  	Does common checks for a new item, also calls performCustomValidation.
	 *
	 * buildNewItem(new_item)
	 *  	All the steps for creating a new item.
	 *
	 * applyCssToNewItem($item, new_item)
	 *     	Makes the new item pretty; overwritten in children.
	 *
	 * putItemInBox(new_item)
	 *  	Nuts and bolts of new item to add.
	 *
	 * processNewItem(new_item)
	 * 		Stuff that needs to be done to new items; set in child.
	 *
	 * resetInput()
	 *		Clean out the input box and set focus.
	 *
	 * onAddItem(item)
	 *		Optional method that is passed in upon initialization that fires whenever an item is added.
	 *
	 * onRemoveItem(item)
	 *		Optional method that is passed in upon initialization that fires whenever an item is removed.
	 *
	 */
	ComViews.EditableItemList = AoPS.View.extend({
		// Reset in most children; must be a single class!!!!!
		//  Used as a selector to find DOM nodes.
		item_class: "aops-editable-item-list-item",

		item_limit: 100,

		item_name: "item",

		has_close: false, // Has the little check to click to close.

		className: "cmty-items-input-box",

		num_matches: 0, // Max number of items to show when matching (0 = no limit)

		submitted_item: "",

		submit_on_special_keys: true, // submit on enter, comma, tab even if they don't have a match

		item_selected: false,

		initialize: function (options) {
			var self = this;
			$.extend(this, options);
			// Build input_box from passed classes.	Or build in children.  Or set class here, and deal with
			//  CSSing through the className
			if (this.has_close) {
				this.$close_me = $(
					$.parseHTML('<div class="cmty-editable-item-close">q</div>')
				);
				this.$el.append(this.$close_me);
			}
			// See notes in resetInput for why this is here.
			this.counter = 1;
			this.sending_to_rebuild = false;

			this.constructInput();

			// This probably lives here, but I am not sure.
			//  I suspect we might be able to nix this.
			/* RR COMMENTED OUT 7/9/14
			this.$el.on('click', function (e) {
				e.stopPropagation();
				e.preventDefault();
				return false;
			});*/
			this.suppress_autofocus = false;
			this.$items = [];
			// Parse pre-set items.
			_.each(this.items, function (item) {
				self.putItemInBox(item);
			});
		},

		events: {
			"click .cmty-delete-item": "onClickDeleteItem",
			"click .cmty-editable-item-close": "onClickClose",
		},

		/**
		 * Get the autocompleter ready.  Sometimes overwritten in children.  By default,
		 *    we plow ahead to constructItemAutocomplete.  The main purpose for this
		 *    function is to allow asynchronous fetching of data for constructing
		 *    the Autocomplete (see ComViews.EditableTagbox)
		 */
		prepareAutocomplete: function () {
			this.constructItemAutocomplete();
		},

		/**
		 * Set in children; get the input for the source parameter in aopsAutocomplete.
		 */
		getAutocompleteSource: function () {
			return;
		},

		/**
		 * Set in children; define what happens when the autocomplete box opens.
		 */
		getAutocompleteOnOpen: function () {
			return _.bind(function (input_box) {
				return;
			}, this);
		},

		/**
		 * Construct additional arguments (or overwrite defaults) that
		 *  are sent to aopsAutocomplete.
		 *
		 * Set in children.
		 */
		constructAutocompleteArgs: function () {
			return {};
		},

		/**
		 * Build the autocomplete field and all the behaviors when users are typing in the input box.
		 */
		constructItemAutocomplete: function () {
			var autocompleteArgs = _.extend(
				{
					match_type: "from_start_then_any",
					delay: 250, // No idea what is best here -- pass in through defaults
					is_case_sensitive: false, // Pass through defaults
					source: this.getAutocompleteSource(),
					num_matches: this.num_matches,
					blockResponse: _.bind(function () {
						// If an item has been submitted before the autocomplete source returns,
						//  then we need to block the autocomplete from responding
						return this.item_submitted;
					}, this),
					position: {
						my: "left top+5",
					},
					//		onOpen : this.getAutocompleteOnOpen(),
					onSelect: _.bind(function (event, ui) {
						// Return has been clicked.
						/**
						 * If return is clicked, then we need to check
						 *  if the string in the input box matches the selected value.
						 *  These may not match if the user types very fast.
						 **/
						if (event.keyCode === 13) {
							if (
								this.$input_box.val().toLowerCase() !==
								ui.item.value.toLowerCase()
							) {
								// When they don't match, we take what's in the box.
								this.submitNewItem({
									label: this.$input_box.val(),
									item_id: 0,
								});
								// We mark the item as submitted and as selected.
								// The item_submitted prevents the next block from firing.
								// The item
								this.item_submitted = true;
								this.item_selected = true;
							}
						}
						// If an item has already been submitted, then we need to
						//  block it getting submitted a second time.
						//  (Needed for blocking typists hitting enter at just the wrong time.)
						if (!this.item_submitted) {
							// IMPORTANT: Must turn this to false in processPostConstruction
							//   if you are trying to do something on the "return" keypress
							//   that you want to block if we have selected something from the autocomplete
							this.item_selected = true;
							this.item_submitted = true;
							this.submitNewItem(ui.item);
							this.submitted_item = ui.item.value;
						}

						event.stopPropagation();
						event.preventDefault();
					}, this),
				},
				this.constructAutocompleteArgs()
			);

			this.$input_box.aopsAutocomplete(autocompleteArgs);

			if (typeof this.onClose === "function") {
				this.$input_box.blur(this.onClose);
			}

			this.processPostConstruction();

			/* Move the goofy helper span to the beginning, so as not to interfere with
				backspace.
				TODO: Find a better solution.
			*/
			//this.$el.prepend(this.$el.find('.ui-helper-hidden-accessible'));
		},

		/**
		 * What we do on paste into an item list.
		 **/
		onPaste: function (e) {
			return;
		},

		processPostConstruction: function () {
			var self = this;

			this.$input_box.on("paste", function (e) {
				self.onPaste(e);
			});
			/** If we are going to hijack the search tag autocomplete, then this will have to
			 be included after the search tag autocomplete is used  **/

			this.$input_box.on(
				"keydown",
				_.bind(function (e) {
					var key_pressed = e.which || e.keyCode,
						$previous_item,
						input_value = this.$input_box.val();
					// TODO : Figure out what 188 is; I don't think it is comma.
					//  At least, it ins't in Chrome/Mac
					/**
					 * We mark an item submitted in submitNewItem; on any keypress, we
					 *  turn that off until another item is submitted.  This is
					 *  used in blockResponse of the autocomplete arguments.
					 **/
					this.item_submitted = false;
					if (key_pressed === 13 || key_pressed === 188 || key_pressed === 9) {
						// Enter, comma, tab
						// Don't want the comma to show up.  Don't want tab to send you to the next
						// focus in the form if there is anything in the
						// input box; submitNewItem will put it in the input of EditableItem
						if (
							key_pressed === 188 ||
							(key_pressed === 9 && input_value.length > 0)
						) {
							e.preventDefault();
							e.stopPropagation();
						}

						if (input_value.length > 1) {
							if (
								this.submitted_item.toLowerCase() !== input_value.toLowerCase()
							) {
								//Bug here; causing the submit to happen twice if an item is selected.

								if (!this.item_selected && this.submit_on_special_keys) {
									//this.item_submitted = true;
									this.submitNewItem({
										label: input_value,
										item_id: 0,
									});
								}
							}
						}
					}

					/**
					 * If we backspace and remove the only character remaining in the input
					 * box, and we are between items (we have left arrowed back in the list),
					 * then we want to shrink the input box so the cursor appears to simply
					 * sit between items.  If we are at the end of the item list, then
					 * we don't want to shrink, or we'll have this weird activity where the
					 * input box may go back and forth between lines (vertically) on screen
					 * if we are at the right end of the item box.
					 **/
					/*  KEEP THIS AROUND BECAUSE DEALING WITH BACKARROW AND FRONTARROW WAS A BEAR TO FIGURE OUT
				if ((key_pressed === 8) && (input_value.length === 1) &&
					this.$input_box.next().hasClass(this.item_class)) {
						this.$input_box.width(2);
				}
			*/
					if (input_value.length === 0) {
						/* KEEP THIS AROUND BECAUSE DEALING WITH BACKARROW AND FRONTARROW WAS A BEAR TO FIGURE OUT
					if (key_pressed === 37) { // Left -- go back through the items.
						this.$input_box.width(2);
						this.$input_box.after(this.$input_box.prev());
// 						this.$input_box.prev().before(this.$input_box); THIS WAS COMMENTED OUT EVEN BEFORE I CUT THE ARROWS OUT
					} else if (key_pressed === 39) { //right -- go forward through the items.
						this.$input_box.before(this.$input_box.next());
//						this.$input_box.next().after(this.$input_box); THIS WAS COMMENTED OUT EVEN BEFORE I CUT THE ARROWS OUT
					} else*/
						if (key_pressed === 8) {
							// backspace  THIS IS GOING TO BE TRICKY HOW DEAL WITH THE CLASSES HERE?
							if (this.$input_box.prev().hasClass(this.item_class)) {
								this.tryToRemoveItem(this.$input_box.prev());
							} else {
								// go try to find a previous item that has the item class
								$previous_item = this.$input_box
									.prevUntil("." + this.item_class)
									.last()
									.prev();
								if ($previous_item.length > 0) {
									this.tryToRemoveItem($previous_item);
								}
							}
						} else if (key_pressed === 46) {
							// delete
							this.tryToRemoveItem(this.$input_box.next());
						} else {
							// if starting to type new tag, move the input box
							// to the end.
							// The below was a big fail in IE, since it causes input_box to lose focus.
							//  We can still move the input box to the end if we want, but taking each following
							//  item and putting it previous to the input box (see the work about for
							//  keypress left.
							/*if (this.$input_box.next().length > 0) {
							this.$input_box.parent().append(this.$input_box);
						}*/
							this.$input_box.width(Constants.itembox_input_width);
						}
						// Fix width if we've narrowed this thing
						// May want to bring this back if we change some of the behavior above.
						//if (this.$input_box.next().length === 0) {
						//	this.$input_box.width(150);
						//}
						this.$input_box.focus();
					}

					this.item_selected = false;

					if (!this.validateCharacter(e)) {
						e.stopPropagation();
						e.preventDefault();
					}
				}, this)
			);

			this.$input_box.parent().on("click", function (e) {
				self.$input_box.focus();
				e.stopPropagation();
			});

			/*
			THE LINES BELOW ARE NEEDED IF WE BRING BACK ARROW NAVIGATION WITHIN AN ITEMLIST;
			THEY MOVE THE INPUT_BOX TO THE END IN THE CASE THAT THE USER ARROWS BACK, THEN BLURS
			OR CLICKS ELSEWHERE IN THE LIST DIV.  THE GOOFY TIMEOUT THING IS AN IE WORKAROUND
			this.$el.on('click', function() {
				self.$input_box.detach();
				self.$el.append(self.$input_box);
				//setTimeout(function () {
					self.$input_box.focus();
				//}, 10);
			});*/
		},

		/**
		 * Is this character code allowed for this entry?
		 *
		 * @param int character code.
		 **/
		validateCharacter: function (e) {
			return true;
		},

		/**
		 * What to do in the view when this item is deleted.
		 *
		 * @param jQuery object|item object : item in the box that needs to be nuked.
		 *
		 * Can pass either the jQuery object of the item or the 'item' object that
		 *  the jQuery object is built on.
		 */
		removeItem: function (obj) {
			var $deleted_item, deleted_item;

			if (obj instanceof jQuery) {
				$deleted_item = obj;
				deleted_item = obj.data("item");
			} else {
				deleted_item = obj;
				$deleted_item = _.find(this.$items, function ($item) {
					return $item.data("item") === deleted_item;
				});
				if (_.isUndefined($deleted_item)) {
					return;
				}
			}

			this.processRemovedItem(deleted_item);
			this.items = _.without(this.items, deleted_item);
			this.$items = _.without(this.$items, $deleted_item);
			$deleted_item.remove();

			if (this.hasOwnProperty("onRemoveItem")) {
				this.onRemoveItem(deleted_item);
			}
		},

		onClickDeleteItem: function (e) {
			this.tryToRemoveItem($(e.target).parent());
		},

		/**
		 * In some children, we overwrite this function to provide a warning/check
		 *  before removing the item.
		 *
		 * @param jQuery object|item object : item in the box that needs to be nuked.
		 **/
		tryToRemoveItem: function (item) {
			this.removeItem(item);
		},

		/**
		 * What to do outside the view when this item is deleted (overwritten in children).
		 *
		 * @param object : removed_item_object (from the items array)
		 */
		processRemovedItem: function (removed_item) {
			return; /* More interesting function in child objects */
		},

		/**
		 * Utility function to show an alert with an error, and then reset the
		 *  input box on OK.
		 *
		 * @param string : error message
		 */
		showError: function (error) {
			AoPS.Ui.Modal.showAlert(error, {
				onClose: _.bind(this.resetInput, this),
			});
		},

		/**
		 * Allows children to have custom validation functions.
		 *
		 * @param obj : submitted item object.
		 *
		 *  In those, if you have to do an Ajax call, return false here,
		 *   and call buildNewItem(new_item) if your test is passed.
		 */
		performCustomValidation: function (new_item) {
			return true;
		},

		/**
		 * Validate the newly submitted item.
		 *
		 * @param obj : submitted item object.
		 *
		 * Note that this function calls performCustomValidation to allow children
		 *  to add custom validation functions.
		 */
		submitNewItem: function (new_item) {
			new_item.label = new_item.label.trim();
			this.item_submitted = true;

			if (this.countItems() >= this.item_limit) {
				this.showError(
					Lang["new-item-too-many-1"] +
						this.item_limit +
						" " +
						this.item_name +
						Lang["new-item-too-many-2"]
				);
				return false;
			}

			if (new_item.label.length < 2) {
				this.showError(Lang["new-item-too-short"]);
				return false;
			}
			if (this.checkItemExists(new_item)) {
				this.showError(
					Lang["new-item-already-added"] + "<b>" + new_item.label + "</b>."
				);
				return false;
			}

			if (this.performCustomValidation(new_item)) {
				this.buildNewItem(new_item);
			}
		},

		countItems: function () {
			return this.items.length;
		},

		/**
		 * Check if this item already exists among the items array.
		 **/
		checkItemExists: function (new_item) {
			return !_.isUndefined(
				_.find(this.items, function (item_in_array) {
					return (
						item_in_array.label.toLowerCase() === new_item.label.toLowerCase()
					);
				})
			);
		},

		/**
		 * Build the new item that has passed validation.
		 *
		 * @param obj : item to be built.
		 */
		buildNewItem: function (new_item) {
			var $item;
			if (!new_item.hasOwnProperty("is_visible")) {
				new_item.is_visible = true;
			}
			this.items.push(new_item);
			this.processNewItem(new_item);
			$item = this.putItemInBox(new_item);
			if (this.hasOwnProperty("onAddItem")) {
				this.onAddItem(new_item, $item);
			}
			this.resetInput();
		},

		/**
		 * Make the newly added item pretty.
		 *
		 * @param jQuery object of newly added item.
		 * @param obj new item to add.
		 *
		 * Set in Child
		 **/
		applyCssToNewItem: function ($item, new_item) {
			return;
		},

		/**
		 * Submit a new item, but fail silently if the item
		 *	already exists.  Used for autotagging.
		 **/
		submitItemSilent: function (new_item) {
			if (this.countItems() >= this.item_limit) {
				return;
			}

			if (!this.checkItemExists(new_item)) {
				this.suppress_autofocus = true;

				this.buildNewItem(new_item);
				this.suppress_autofocus = false;
			}
		},

		/**
		 * Nuts and bolts of constructing a new item on screen.
		 *
		 * @param obj of new item to add
		 */
		putItemInBox: function (new_item) {
			var $item;

			if (new_item.hasOwnProperty("is_visible") && !new_item.is_visible) {
				return;
			}
			if (
				typeof new_item.label !== "string" &&
				typeof new_item.value === "string"
			) {
				new_item.label = new_item.value;
			}

			if (
				typeof new_item.value !== "string" &&
				typeof new_item.label === "string"
			) {
				new_item.value = new_item.label;
			}

			$item = $(
				$.parseHTML(
					'<div class="' +
						this.item_class +
						'">' +
						new_item.label +
						' <span class="cmty-delete-item aops-font">J</span></div>'
				)
			);
			if (typeof new_item.is_special === "boolean" && new_item.is_special) {
				$item.addClass("cmty-special-item");
			}
			this.applyCssToNewItem($item, new_item);

			$item.data("item", new_item);
			$item.data("item_label", new_item.label);
			this.$items.push($item);

			this.$input_box.before($item);
			return $item;
		},

		/**
		 * Stuff that needs to be done to new items; set in child.
		 *
		 * @param obj for new item.
		 */
		processNewItem: function (new_item) {
			return; /* More interesting function in child objects */
		},

		/**
		 * Clean out the input box and set focus.
		 */
		resetInput: function () {
			var self = this;
			this.$input_box.val("");
			/**
			 * This rustles my jimmies. For some peculiar reason,
			 *  if you click on the stuff in the drop down, autocomplete
			 *  won't ever fire the select event again until you click away
			 *  and come back.  There must be a bug deep in autocomplete. (I
			 *  have simpler test versions of autocompletes that have the
			 *  same behavior.)  So, my workaround is to destroy the autocomplete
			 *  and rebuild it.  Fortunately, that's very fast.  The timeout
			 *  is because the resetInput function is called in the middle of a
			 *  select event within the autocomplete, and all sorts of
			 *  fun happens if you don't let the autocomplete finish before calling this.
			 *
			 *
			 * The counter is used to keep track of which autocomplete input_box instance
			 *  sent requests to the back end.  We can check that the current counter
			 *  matches the counter at time of autocomplete request in order to see
			 *  if should process the return results.
			 **/
			this.counter += 1;

			// Block tab navigation during submit, so that we can enter multiple items
			this.$input_box.data("suppress_tab", true);
			setTimeout(
				_.partial(function (suppress_autofocus) {
					self.rebuildInput(suppress_autofocus);
				}, this.suppress_autofocus),
				10
			);
		},

		constructInput: function () {
			var self = this;
			this.$input_box = $(
				$.parseHTML(
					'<input type="text" class="cmty-items-input" maxlength="30"></input>'
				)
			);
			this.$el.append(this.$input_box);
			/*	this.$input_box.on('focus.styling', function () {
				self.$el.addClass('cmty-focused-editableitemlist');
			});

			this.$input_box.on('blur.styling', function () {
				self.$el.removeClass('cmty-focused-editableitemlist');
			});*/
			if (typeof this.onInputBoxBlur === "function") {
				this.$input_box.on("blur", function () {
					self.onInputBoxBlur();
				});
			}
			this.prepareAutocomplete();
		},

		/**
		 * Rebuild the input box in order to reset the autocomplete.  Autocomplete's destroy
		 *  wasn't good enough, so we rebuild the whole input node.  See resetInput above for more details.
		 **/
		rebuildInput: function (suppress_autofocus) {
			this.$input_box.remove();
			if (this.hasOwnProperty("$no_results")) {
				this.$no_results.hide();
			}

			this.constructInput();

			if (arguments.length == 0 || !suppress_autofocus) {
				this.$input_box.focus();
			}
		},

		onClickClose: function () {
			if (this.$input_box.val().length > 1) {
				this.submitNewItem({
					label: this.$input_box.val(),
				});
			}
			this.close();
		},
	});

	/**
	 * Construct an editable tagbox.
	 *
	 * Extends Community.Views.EditableItemList, and overwrites several parent functions.
	 *
	 * Set input_on_blur to true if you want the tag inputted on click-away blurring;
	 *	default is false.
	 *
	 * model : Community.Models.Topic
	 *
	 * All methods defined here overwrite parent methods.  See Community.Views.EditableItemList
	 *  documentation for details.
	 *
	 * New properties:
	 *
	 * category : forum of this tag (required to be submitted on initialization)
	 * tag_colors : {main_color, secondary_color} read from category or topic (in EditableTagBoxExistingTopic).
	 *
	 *
	 * Any pre-set items for the editable tagbox must have the following structure (to
	 *		match what is coming out of the autocompletes):
	 *
	 *	item_id : int
	 *	value : string, item's text,
	 *  item_forum_id int
	 *	main_color string
	 *	secondary_color string,
	 *  label string, also the item's text.  Isn't autocomplete fun?,
	 */
	ComViews.EditableTagBox = ComViews.EditableItemList.extend({
		item_class: "cmty-item-tag",

		item_limit: Constants.max_tags_per_topic,

		has_search_icon: false,

		item_name: "tag",

		num_matches: 15,

		initialize: function (options) {
			this.category = options.hasOwnProperty("category")
				? options.category
				: this.model.get("master").fetchCategory(this.model.get("category_id"));
			// These should get passed in, or parsed in children

			this.setTagColors();
			ComViews.EditableItemList.prototype.initialize.apply(this, [options]);

			this.$no_results = $(
				'<div class="cmty-no-results-found">' +
					Lang["autocomplete-new-tag"] +
					"</div>"
			);
			this.$input_box.before(this.$no_results);
			this.input_on_blur =
				options.hasOwnProperty("input_on_blur") && options.input_on_blur;
		},

		onInputBoxBlur: function () {
			if (
				ComViews.clicking &&
				this.$input_box.val().length > 0 &&
				this.input_on_blur
			) {
				this.suppress_autofocus = true;
				this.submitNewItem({
					label: this.$input_box.val(),
					item_id: 0,
				});
				this.suppress_autofocus = false;
			}
			this.$no_results.hide();
		},

		/**
		 * Extra stuff we do if there's a match on autocomplete. (Hide the no results message.)
		 **/
		onMatch: function (counter) {
			this.$no_results.hide();
		},

		/**
		 * Extra stuff if there's no match on autocomplete : we check if the
		 *  counter now matches the counter at the time the autocomplete was fired.
		 *  If so, then we show the $no_results message.
		 *
		 * @param int counter at the time the autocomplete was called.
		 **/
		onNoMatch: function (counter) {
			if (counter === this.counter) {
				this.$no_results.show();
				this.$no_results.position({
					my: "left-1 top+1",
					at: "left bottom",
					of: this.$input_box,
				});
			}
		},

		countItems: function () {
			return _.where(this.items, {
				is_visible: true,
			}).length;
		},

		setTagColors: function () {
			this.tag_colors = {
				main_color: this.category.get("main_color"),
				secondary_color: this.category.get("secondary_color"),
			};
		},

		/****  MIX IN FUNCTIONS FROM SEARCH TAG BOX ****/
		/****  MAY MIX IN WITHIN THE PARENT ITEM ***/

		/**
		 * Get the autocomplete array from the model to use as autocomplete source
		 */
		getAutocompleteSource: function () {
			var self = this,
				current_count = this.counter,
				$current_input = this.$input_box;

			if (_.isUndefined(this.category)) {
				return;
			}

			return _.bind(function (request, response) {
				this.category.fetchItemAutocompleteMatches({
					request: request,
					response: response,
					checkSquelch: function () {
						return (
							request.term !==
								$current_input
									.val()
									.substr(0, $current_input[0].selectionStart) &&
							request.term !== $current_input.val()
						);
					},
					checkInputExists: function () {
						// If the autocomplete has been destroyed before autocompleter returns,
						// then we need to squelch the Ajax action on the return.  This is due to
						// autocomplete having a deep, weird bug causing us to have to rebuild the
						// autocomplete each time we build an item.
						return self.counter === current_count;
					},
					onMatch: function () {
						if (typeof self.onMatch === "function") {
							self.onMatch(self.counter);
						}
					},
					onNoMatch: function () {
						if (typeof self.onNoMatch === "function") {
							self.onNoMatch(self.counter);
						}
					},
					additional_params: self.hasOwnProperty(
						"additional_autocomplete_params"
					)
						? self.additional_autocomplete_params
						: {},
				});
			}, this);

			//			return this.category.get('tag_autocomplete_array');
		},

		/**
		 * Create the onOpen action for the autocomplete (apply css)
		 * I BELEIVE THIS IS DEPRECATED.
		 */
		getAutocompleteOnOpen: function () {
			return _.bind(function (input_box) {
				var menu = $(input_box).data("ui-autocomplete").menu;
				menu.element
					.find("a")
					.css({
						"background-color": this.tag_colors.main_color,
					})
					.addClass(this.item_class);
			}, this);
		},

		/**
		 * Css to apply to new items.
		 */
		applyCssToNewItem: function ($item, new_item) {
			$item.css({
				"background-color": this.tag_colors.main_color,
			});
		},

		/**
		 * Construct the additional arguments needed to create the autocomplete for this
		 *  item type.
		 *
		 * Mixed into AoPS.Community.Views.buildTagAutocomplete()
		 */
		constructAutocompleteArgs: function () {
			var position;

			position = this.has_search_icon ? "left-21 top+5" : "left-1 top+5";
			return {
				/**
				 * When an item is focused, we need to color it appropriately, and
				 *  un-color the old focus element.
				 */
				onFocus: _.bind(function (event, ui) {
					if (
						this.hasOwnProperty("focus_element") &&
						!_.isNull(this.focus_element)
					) {
						this.focus_element.css({
							color: "white",
							"background-color": this.focus_element.data("main-color"),
						});
					}
					this.focus_element = $(event.originalEvent.target).find(
						"a.ui-state-focus"
					);

					this.focus_element.css({
						color: this.focus_element.data("main-color"),
						"background-color": this.focus_element.data("secondary-color"),
					});
				}, this),
				onOpen: _.bind(function () {
					this.$input_box
						.autocomplete("widget")
						.width(Constants.tag_autocomplete_width);
				}, this),
				/**
				 * When we render an item in this list, we need to color it based on properties of that item
				 */
				_renderItem: function (ul, item) {
					var $tag = $("<a>")
						.text(item.label)
						.css({
							"background-color": item.main_color,
						})
						.data({
							"main-color": item.main_color,
							"secondary-color": item.secondary_color,
						});
					return $("<li>").append($tag).appendTo(ul);
				},
				position: {
					my: position,
					at: "left bottom",
					of: this.$input_box,
				},
			};
		},

		/**
		 * After we build the item list, we first go through the usual post construction
		 *  of an editable list, then tack on a little extra binding for color processing
		 *  of tags when we arrow past an end of tag box.
		 */
		processPostConstruction: function () {
			ComViews.EditableItemList.prototype.processPostConstruction.apply(this);

			this.processTagBoxDropdownArrowing();
		},

		onPaste: ComViews.onTagPaste,

		/**
		 * Is this character code allowed for this entry?
		 *
		 * @param int character code.
		 **/
		validateCharacter: ComViews.validateTagCharacter,

		/**
		 * When we arrow off the bottom or top of the autocomplete list, the onFocus won't
		 *  fire, and we have to fix the colors of the tags.  This takes care of it.
		 *
		 * Mixed in to CategoryCellCategoryTop
		 */
		processTagBoxDropdownArrowing: function () {
			this.$input_box.on(
				"keydown.post_construction",
				_.bind(function (e) {
					var code = e.keyCode || e.which;
					if (code === 38 || code === 40) {
						if (
							this.$input_box
								.data("ui-autocomplete")
								.menu.element.find(".ui-state-focus").length === 0
						) {
							_.each(
								this.$input_box.data("ui-autocomplete").menu.element.find("a"),
								function (element) {
									$(element).css({
										"background-color": $(element).data("main-color"),
										color: "#fff",
									});
								}
							);
						}
					}
				}, this)
			);
		},
	});

	/**
	 * Extension of EditableItemList just for users.
	 *
	 * Each item in an EditableUserList should have the properties:
	 *
	 *		label string : username
	 *		user_id int : user id
	 *		is_admin 0|1
	 *		is_visible boolean optional default true
	 **/
	ComViews.EditableUserList = ComViews.EditableItemList.extend({
		item_class: "cmty-itemlist-username",

		item_limit: 1000,

		item_name: "user",

		// Need to submit actions for processNewItem and processRemovedItem.  Hard, because they will be
		//  different from list to list.  Probably have to bass them to the toggleableUserlist, and
		//  thereby have them passed along.  That works, and at the Category model, only
		//  make the Ajax call if the category_id is nonzero.
		initialize: function (options) {
			this.is_checking_username = false;
			ComViews.EditableItemList.prototype.initialize.apply(this, [options]);
		},

		/**
		 * Create the function that the autocompleter will use to fetch the usernames
		 *  that match.  Case-insensitive.
		 *
		 * Overwrites parent function.
		 */
		getAutocompleteSource: function () {
			var $input = this.$input_box;

			return _.bind(function (request, response) {
				Utils.fetchUsernameMatches({
					request: request,
					response: response,
					checkSquelch: function () {
						return (
							request.term !==
								$input.val().substr(0, $input[0].selectionStart) &&
							request.term !== $input.val()
						);
					},
				});
			}, this);
		},

		/**
		 * Construct the additional arguments needed for aopsAutocomplete.
		 *
		 * _renderItem is what we do when we make each item in the list.  Here,
		 *  we tack on the class 'aops-admin' to the admins.
		 *
		 * Overwrites parent function.
		 */
		constructAutocompleteArgs: function () {
			return {
				ui_class: "cmty-username-autocomplete",
				_renderItem: function (ul, item) {
					var $list_item = $("<li></li>"),
						$link = $("<a>" + item.label + "</a>");

					$list_item.append($link);

					if (item.is_admin === "1") {
						$link.addClass("cmty-user-admin");
					}
					return $list_item.appendTo(ul);
				},
			};
		},

		/**
		 * Apply custom CSS to a newly selected username.
		 *
		 * Overwrites parent function.
		 *
		 * @param jQuery Object : the item whose CSS we are working on.
		 * @param obj : item object that created this item (has data we'll use).
		 */
		applyCssToNewItem: function ($item, new_item) {
			if (new_item.is_admin === "1" || new_item.is_admin === 1) {
				$item.addClass("cmty-user-admin");
			}
		},

		/**
		 * We throw a blocker up when we make an Ajax call to check the
		 *  username.  We need to leave that blocker up long enough
		 *  to read it, so if the Ajax call finished too fast, we need
		 *  to buy a little time before continuing.
		 **/
		processUsernameCheckDelay: function (new_item, obj, time) {
			var wait = new Date().getTime() - time,
				self = this;
			if (wait >= Constants.message_readability_delay) {
				this.processUsernameCheck(new_item, obj);
			} else {
				setTimeout(function () {
					self.processUsernameCheck(new_item, obj);
				}, Constants.message_readability_delay - wait);
			}
		},

		/**
		 * Process the results from a Recipient check.
		 *
		 * @param object : item object that was submitted for validation
		 * @param object : result of the ajax call in Community.Models.Master.checkValidPrivateRecipient
		 *
		 * Throws error or processes the item.
		 *
		 * Probably overwritten in children
		 */
		processUsernameCheck: function (new_item, obj) {
			// TODO: Rework below to remove the flicker. (maybe done?)
			this.is_checking_username = false;
			if (this.isUsernameOK(new_item, obj)) {
				new_item.user_id = obj.user_id;
				new_item.is_admin = obj.is_admin;
				this.buildNewItem(new_item);
				AoPS.Ui.Modal.closeTopModal();
			} else {
				AoPS.Ui.Modal.replaceTopModal({
					type: "alert",
					body: Utils.formatString(Lang["invalid-user"], [new_item.label]),
					frame_class: "aops-modal-quick",
				});
			}
		},

		// Usually overwritten in children.
		isUsernameOK: function (new_item, obj) {
			return obj.user_id > 0;
		},
	});

	/**
	 * Editable user lists for the category administration (and creation) pages.
	 *
	 * model : AoPS.Community.Category (or a child).
	 *
	 * Some notes on "user_id" and "item_id".  This view inherits from
	 * 	EditableItemList, in which every item in the list has an "item_id".
	 *  So, any user that is already in the list has "item_id" set to the
	 *  user's user_id.  However, the users in the model's users array, and
	 *  the objects that come back from the autocomplete fetches, have "user_id"
	 *	set rather than item_id.  So, whenever we are adding a user to the
	 * 	list, we set item_id to be the user_id (so EditableItemList will know what
	 * 	to do with it), and whenever we need to pull an item out of the
	 *	list and do something with it, we know that its 'item_id' is the user's user_id.
	 **/
	ComViews.EditableUserListCategoryAdmin = ComViews.EditableUserList.extend({
		has_close: true, // Has the little check to click to close.

		initialize: function (options) {
			this.role = options.role;
			ComViews.EditableUserList.prototype.initialize.apply(this, [options]);
		},

		/**
		 * What happens when we add a user
		 *
		 * @param obj : an added item from EditableItemlist.
		 *
		 * Note: when we are moving a user from one role to another,
		 *  we call an update procedure, so we suppress adding the user again here.
		 **/
		processNewItem: function (new_user) {
			if (!new_user.hasOwnProperty("suppress_add_to_model")) {
				this.model.addUser({
					role: this.role,
					username: new_user.value,
					user_id: parseInt(new_user.user_id),
					is_admin: parseInt(new_user.is_admin),
				});
			} else {
				delete new_user.suppress_add_to_model;
			}
		},

		/**
		 * What happens when we remove a user
		 *
		 * @param obj : a removed item from EditableItemlist.
		 **/
		processRemovedItem: function (removed_user) {
			this.model.removeUser({
				user_id: parseInt(removed_user.user_id),
			});
		},

		/**
		 * Create the function that the autocompleter will use to fetch the usernames
		 *  that match.  Case-insensitive.
		 *
		 * Overwrites parent function.
		 */
		getAutocompleteSource: function () {
			var $input = this.$input_box;
			return _.bind(function (request, response) {
				Utils.fetchUsernameMatches({
					request: request,
					response: response,
					checkSquelch: function () {
						return (
							request.term !==
								$input.val().substr(0, $input[0].selectionStart) &&
							request.term !== $input.val()
						);
					},
				});
			}, this);
		},

		/**
		 * Perform the validation needed on the submitted username.
		 *
		 * @param object : item object for the submitted item.
		 *
		 * Always returns false, triggers the event processUsernameCheck when the
		 *  Ajax call finishes.
		 *
		 * Overwrites a parent function.
		 */
		performCustomValidation: function (new_item) {
			var self = this,
				existing_role,
				message,
				now;

			if (this.isNewUserAdmin(new_item)) {
				return false;
			}

			existing_role = this.model.checkUserRole(new_item.label);

			if (existing_role.role !== "none") {
				this.is_checking_username = true;
				message = Utils.formatString(Lang["cat-admin-perms-existing-user"], [
					new_item.label,
					Lang[
						"cat-admin-user-types-" +
							this.model.getAdminLangType() +
							"-" +
							existing_role.role
					],
				]);

				/**
				 * If the user is allowed to edit the existing role of the user they are trying
				 *  to add, then we give them the option of moving the user to the new role.
				 **/
				if (this.model.getPermission("c_can_edit_" + existing_role.role)) {
					AoPS.Ui.Modal.showConfirm(
						message +
							Lang["cat-admin-perms-existing-user-3"] +
							" <b>" +
							Lang[
								"cat-admin-user-types-" +
									this.model.getAdminLangType() +
									"-" +
									this.role
							] +
							"</b>.",
						function (ok) {
							if (ok) {
								// was new_item.item_id =...
								new_item.user_id = parseInt(existing_role.user_id);
								new_item.suppress_add_to_model = true;
								self.model.updateUserRole(new_item, self.role);
								self.buildNewItem(new_item);

								// Will need some sort of routine here for when we go to the database.
								// Maybe.
							}
							self.reset();
						},
						{
							width: "450px",
						}
					);
				} else {
					AoPS.Ui.Modal.showAlert(message, {
						width: "450px",
						onClose: function () {
							self.reset();
						},
					});
				}
				return false;
			} else if (!new_item.hasOwnProperty("user_id")) {
				ComViews.throwBlockingMessage(Lang["user-list-validation-blocker"]);
				now = new Date().getTime(); // Used to time the blocker; do not remove.

				this.is_checking_username = true;

				this.model.checkAddedUsername({
					username: new_item.label,
					onFinish: function (response) {
						self.processUsernameCheckDelay(new_item, response, now);
					},
				});

				return false;
			}

			// Set the item_id so this object can be added to the Itembox.
			// (Note: See ComViews.Itembox for details on what items in
			//   Itemboxes must look like.
			new_item.item_id = parseInt(new_item.user_id);

			return true;
		},

		processUsernameCheck: function (new_item, obj) {
			var self = this;
			// TODO: Rework below to remove the flicker. (maybe done?)

			if (parseInt(obj.user_id) === 0) {
				AoPS.Ui.Modal.replaceTopModal({
					type: "alert",
					body: Utils.formatString(Lang["invalid-user"], [new_item.label]),
					frame_class: "aops-modal-quick",
					onClose: function () {
						self.resetInput();
						self.is_checking_username = false;
					},
				});
				return false;
			} else {
				new_item.user_id = obj.user_id;
				new_item.label = obj.username; // Fixes lower/uppercase
				new_item.value = obj.username; // Fixes lower/uppercase
				new_item.is_admin = obj.is_admin;
				if (this.performCustomValidation(new_item)) {
					this.buildNewItem(new_item);
					AoPS.Ui.Modal.closeAllModals();
					this.is_checking_username = false;
					return true;
				} else {
					return false;
				}
			}
		},

		/**
		 * Checks if the user we are attempting to add is an admin.  If so, we
		 *  throw an error.
		 *
		 * One exception : an admin making him or herself owner of a forum.
		 *		This allows admins to push forums into their own My Forums.
		 **/
		isNewUserAdmin: function (new_item) {
			var self = this;
			if (
				parseInt(new_item.is_admin) === 1 &&
				(this.role !== "owner" || AoPS.session.user_id != new_item.user_id)
			) {
				this.is_checking_username = true;
				AoPS.Ui.Modal.showAlert(
					Lang["cat-admin-no-add-admin-start"] +
						new_item.label +
						Lang["cat-admin-no-add-admin-end"],
					{
						width: "450px",
						onClose: function () {
							self.reset();
						},
					}
				);
				return true;
			}
			return false;
		},

		/**
		 * Get everything back to "normal" after an alert or confirm box while inputting names.
		 **/
		reset: function () {
			AoPS.Ui.Modal.closeAllModals();
			// We may need a call to "resetInput" here to rebuild the autocomplete entirely.
			this.$input_box.focus();
			this.is_checking_username = false;
		},

		/**
		 * Here is what happens when you click the checkmark.
		 **/
		onClickClose: function () {
			var self = this,
				new_item,
				username,
				now;

			if (this.$input_box.val().length > 1) {
				// have to prevent the input_box blur from triggering a close
				this.is_checking_username = true;
				username = this.$input_box.val();

				new_item = {
					label: username,
					value: username,
				};

				ComViews.throwBlockingMessage(Lang["user-list-validation-blocker"]);

				this.is_checking_username = true;

				this.model.checkAddedUsername({
					username: new_item.label,
					onFinish: function (response) {
						setTimeout(function () {
							if (self.processUsernameCheck(new_item, response, now)) {
								self.close();
							}
						}, 500); // Give time to read blocker
					},
				});

				/*AoPS.Ui.Modal.showAlertQuick(Lang['cat-admin-permissions-close-userlist-early'],
					{
						onClose : function () {
							self.is_checking_username = false;
							self.$input_box.focus();
						}
					}
				);*/
			} else {
				this.close();
			}
		},
	});

	/**
	 * Static list of users.
	 *
	 * Initialize with:
	 * @param user_list array of objects:
	 *		is_admin 0|1
	 *		username string
	 *		user_id int
	 **/
	ComViews.StaticUserList = AoPS.View.extend({
		className: "cmty-static-user-list",

		no_users_message: "",

		initialize: function (options) {
			var $edit_user_list_cell,
				self = this,
				has_is_logged_in_user =
					typeof options.onMatchLoggedInUser === "function";

			if (options.hasOwnProperty("no_users_message")) {
				this.no_users_message = options.no_users_message;
			}

			if (options.user_list.length > 0) {
				_.each(options.user_list, function (user) {
					var url, classes, $user_cell;

					classes =
						"cmty-itemlist-username" +
						(parseInt(user.is_admin) === 1 ? " cmty-user-admin" : "");

					url = "/user/" + user.user_id;

					$user_cell = $(
						'<a data-cmty href="' +
							ComViews.makeLinkUrl(url) +
							'">' +
							'<span class="' +
							classes +
							'">' +
							user.username +
							"</span></a>"
					);
					if (has_is_logged_in_user && user.user_id == AoPS.session.user_id) {
						options.onMatchLoggedInUser($user_cell, user);
					}
					self.$el.append($user_cell);
					self.$el.append(" ");
				});
			} else {
				this.$el.append(this.no_users_message);
			}
			if (options.is_editable) {
				$edit_user_list_cell = $(
					'<div title="' +
						Lang["userlist-edit"] +
						'" class="cmty-edit-user-list aops-font">L</div>'
				);
				this.$el.append($edit_user_list_cell);
			}
		},
	});

	/**
	 * A user list that can be toggled between static and editable.
	 *
	 * initialize with
	 * @param object
	 *		user_list : array of objects for the users.  Each has properties
	 *			user_id int
	 *			is_admin boolean
	 *			username string
	 */
	ComViews.ToggleableUserList = AoPS.View.extend({
		editableUserlistView: ComViews.EditableUserList,

		staticUserlistView: ComViews.StaticUserList,

		no_users_message: Lang["None"],

		initialize: function (options) {
			this.user_list = options.user_list;

			this.constructStaticUserlist();
		},

		events: {
			"click .cmty-edit-user-list": "toggleUserlist",
		},

		toggleUserlist: function () {
			if (this.is_static) {
				this.static_userlist.close();
				this.constructEditableUserlist();
			} else {
				location.reload();
				this.editable_userlist.close();
				this.constructStaticUserlist();
			}
		},

		constructStaticUserlist: function () {
			this.static_userlist = new AoPS.Community.Views.StaticUserList({
				user_list: this.getUserList(),
				is_editable: true,
				no_users_message: this.no_users_message,
			});
			this.is_static = true;
			this.$el.html(this.static_userlist.$el);
		},

		constructEditableUserlist: function () {
			var self = this;
			this.editable_userlist = new this.editableUserlistView(
				_.extend(
					{
						items: this.getEditableUserList(),
						model: this.model,
						onClose: function () {
							setTimeout(function () {
								if (
									self.editable_userlist.$el.find("input")[0] !==
									document.activeElement
								) {
									if (
										!self.is_static &&
										!self.editable_userlist.is_checking_username
									) {
										self.toggleUserlist();
									}
								}
							}, 200);
						},
					},
					this.getAdditionalEditableOptions()
				)
			);
			this.is_static = false;
			this.$el.html(this.editable_userlist.$el);
			this.editable_userlist.$input_box.focus();
		},

		onClose: function () {
			if (this.is_static) {
				this.static_userlist.close();
			} else {
				this.editable_userlist.close();
			}
		},

		getAdditionalEditableOptions: function () {
			return {};
		},

		getUserList: function () {
			return this.user_list;
		},

		getEditableUserList: function () {
			return this.user_list;
		},
	});

	/**
	 *
	 * model : AoPS.Community.Models.Category (or child)
	 **/
	ComViews.ToggleableUserListCategoryAdmin = ComViews.ToggleableUserList.extend(
		{
			editableUserlistView: ComViews.EditableUserListCategoryAdmin,

			initialize: function (options) {
				this.user_list = _.filter(this.model.get("users"), function (user) {
					return user.role === options.role;
				});

				this.role = options.role;
				if (options.role === "owner") {
					this.no_users_message = Lang["cat-admin-site-admins-are-admins"];
				}
				this.constructStaticUserlist();
				this.listenTo(this.model, "users_changed", this.onUsersChange);
			},

			onUsersChange: function () {
				if (this.is_static) {
					this.static_userlist.close();
					this.constructStaticUserlist();
				}
			},

			getAdditionalEditableOptions: function () {
				return {
					role: this.role,
				};
			},

			getUserList: function () {
				var self = this;
				this.user_list = _.filter(this.model.get("users"), function (user) {
					return user.role === self.role;
				});

				return this.user_list;
			},

			getEditableUserList: function () {
				var user_list = this.getUserList();

				return _.map(user_list, function (user) {
					return {
						user_id: user.user_id,
						label: user.username,
						is_admin: user.is_admin,
					};
				});
			},
		}
	);

	/**
	 * Create an editable box in which we add a bunch of usernames.
	 *
	 * Eventually need to figure out if we tie this to some private message category.
	 * We will probably abstract this object further -- we will create
	 *  EditableUsernameList, and RecipientBox will extend that.
	 * The editable username list is going to be very useful in other places,
	 *  I think.
	 *
	 *
	 * model : Community.Models.Master
	 *
	 *
	 * Methods
	 *
	 * getAutocompleteSource()
	 *	Construct the autocomplete list given a piece of a username.
	 *
	 * constructAutocompleteArgs()
	 *  Make the extra options that we send to aopsAutocomplete
	 *
	 * applyCssToNewItem($item, new_item)
	 *  Apply css to the item we just created (admin gets own style).
	 *
	 * performCustomValidation(new_item)
	 *  Perform validation of the recipient chosen.
	 *
	 * processUsernameCheck (new_item, obj)
	 *  Process the output of a recipient check Ajax call
	 *
	 */
	ComViews.EditableRecipientBox = ComViews.EditableUserList.extend({
		// TODO : Define what usernames will look like, and deal with that here

		/**
		 * Perform the validation needed on the submitted recipient name.
		 *
		 * @param object : item object for the submitted item.
		 *
		 * Always returns false, triggers the event processUsernameCheck when the
		 *  Ajax call finishes.
		 *
		 * Overwrites a parent function.
		 */
		performCustomValidation: function (new_item) {
			var self = this,
				now;

			this.is_checking_username = true;
			// No talking to yourself!!
			if (
				new_item.label.toLowerCase() === AoPS.session.username.toLowerCase()
			) {
				this.showError(Lang["private-no-add-self"]);
				this.is_checking_username = false;
				return false;
			} else if (
				this.items.length >=
				AoPS.Community.Constants.max_conversation_participants - 1
			) {
				this.showError(Lang["private-cant-add-more"]);
				return false;
			} else {
				ComViews.throwBlockingMessage(Lang["private-validation-blocker"]);
				now = new Date().getTime(); // Used to time blocker; don't delete
				setTimeout(function () {
					$(window).trigger("resize");
				}, 0);
				this.model.checkValidPrivateRecipient({
					username: new_item.label,
					onFinish: function (response) {
						if (response.is_unreachable) {
							AoPS.Ui.Modal.replaceTopModal({
								type: "alert",
								body: Lang["private-unreachable-recipient"],
								frame_class: "aops-modal-quick",
								onClose: _.bind(self.resetInput, self),
							});
						} else {
							self.processUsernameCheckDelay(new_item, response, now);
						}
					},
				});

				return false;
			}
		},

		isUsernameOK: function (new_item, obj) {
			return obj.is_valid_recipient;
		},
	});

	/**
	 * Construct an editable userlist in which we validate each entered username
	 *  with a plain vanilla username check.
	 **/
	ComViews.EditableValidatedUserList = ComViews.EditableUserList.extend({
		performCustomValidation: function (new_item) {
			var self = this;
			if (!new_item.hasOwnProperty("user_id")) {
				ComViews.throwBlockingMessage(Lang["user-list-validation-blocker"]);
				var now = new Date().getTime();

				Utils.checkValidUsername({
					username: new_item.label,
					onFinish: function (response) {
						self.processUsernameCheckDelay(new_item, response, now);
					},
				});

				return false;
			}
			return true;
		},

		isUsernameOK: function (new_item, obj) {
			return obj.is_valid;
		},
	});

	ComViews.EditableTagBoxExistingTopic = ComViews.EditableTagBox.extend({
		has_close: true,

		setTagColors: function () {
			this.tag_colors = {
				main_color: this.model.get("category_main_color"),
				secondary_color: this.model.get("category_secondary_color"),
			};
		},

		/**
		 * Note: if a user sends an invalid tag here, no notice will be thrown.
		 *  When they finish their editing, the bad tag will just disapper.
		 *  It will frustrate them, which is funny.  If I get enough whining
		 *  about it, I'll trigger a flyout or something.
		 **/
		processNewItem: function (new_tag) {
			this.topic.addNewTag(new_tag.tag_id, new_tag.label);
		},

		processRemovedItem: function (removed_tag) {
			this.topic.removeTag(removed_tag.tag_id, removed_tag.label);
		},
	});

	ComViews.EditableForumList = ComViews.EditableItemList.extend({
		item_class: "cmty-item-forum",

		submit_on_special_keys: false,

		initialize: function (options) {
			this.ajax_call = options.hasOwnProperty("ajax_call")
				? options.ajax_call
				: "fetch_forum_autocomplete";
			this.$no_results = $(
				'<div class="cmty-no-results-found">' +
					Lang["search-no-match"] +
					"</div>"
			);
			ComViews.EditableItemList.prototype.initialize.apply(this, [options]);

			this.$input_box.before(this.$no_results);
		},

		onInputBoxBlur: function () {
			this.$no_results.hide();
		},

		prepareAutocomplete: function () {
			var self = this;
			// TODO : try invoking the Utils buildCategoryAutocomplete from here.

			// call processPostConstruction.  Take a look at the flow for EditableItemList;
			//  I think this might even work .
			Utils.buildCategoryAutocomplete(this.$input_box, {
				ajax_call: this.ajax_call,
				autocomplete_settings: {
					blockResponse: _.bind(function () {
						// If an item has been submitted before the autocomplete source returns,
						//  then we need to block the autocomplete from responding
						return this.item_submitted;
					}, this),
					onSelect: function (event, ui) {
						// If an item has already been submitted, then we need to
						//  block it getting submitted a second time.
						//  (Needed for blocking typists hitting enter at just the wrong time.)
						if (!self.item_submitted) {
							// IMPORTANT: Must turn this to false in processPostConstruction
							//   if you are trying to do something on the "return" keypress
							//   that you want to block if we have selected something from the autocomplete
							self.item_selected = true;
							self.item_submitted = true;
							self.submitNewItem(ui.item);
							self.submitted_item = ui.item.value;
						}

						event.stopPropagation();
						event.preventDefault();
					},
				},
				$no_results: this.$no_results,
				include_wrapper: false,
				show_no_results_msg: true,
			});
			this.processPostConstruction();
		},

		/**
		 * Css to apply to new items.
		 */
		applyCssToNewItem: function ($item, new_item) {
			$item.css({
				color: new_item.main_color,
			});
		},
	});

	/**
	 * ComViews.TopicFull shows an entire topic.  It has a heading of tags
	 *  at the top, and then a pile of PostFulls.
	 *
	 * model : VineModels.Topic
	 *
	 * Properties passed in:
	 * route_category_id (optional, defaults to category_id of topic) :
	 *   the category_id for the category that we're looking at when we
	 *   choose this topic.  (If we are in a view, this category_id
	 *   will not be the same as the category_id of the topic.)
	 * reveal_type : Describes what we should show when loading the topic
	 *   'show_from_start' or 'show_from_end', tells which way we're loading
	 *
	 * Other properties:
	 * $bookmark : div with the bookmark
	 * master : ComModels.Master (read from topic)
	 * tagbox : ComViews.TopicTagbox for this topic
	 * tagbox_state string : 'editing' or 'static' to tell us which tagbox is open
	 * editable_tagbox : ComViews.EditableTagBoxExistingTopic for this topic
	 * filterPost : Method used to filter posts to determine if it's visible
	 *     Defined in setPostFilter
	 * $loader : The loader we put up when fetching posts
	 * max_post_num_at_reply_start : Maximum post number in the topic at the time a reply starts.
	 * $posts_outer_wrapper : window in which the posts box scrolls through.
	 * $posts_inner_wrapper : scrolling div that holds the $posts_box
	 * $posts_box: The container that holds all the posts
	 * posts : Array of ComViews.Post
	 * reply_open : Is the reply window open
	 * $reply_window : Window that holds the reply box.
	 * snipe_warning_open : Is the snipe warning up?
	 * $scrollbar : Slider for the posts window.
	 * $top_panel : The div holding all the data at the top (everything but the posts).
	 * $quick_reply : bar to click for quick reply (sits in the scrollable posts window at end)
	 *
	 * TODO : Clean and document
	 * TODO : Make call on what to do about the reply boxes when user not logged in.
	 * TODO : Deal with scroll slider being itty bitty
	 */
	ComViews.TopicFull = AoPS.View.extend({
		template_id: "#cmty-topic-full-tpl",

		viewing_source: "master", // Reading in the main window (overwritten in feed)

		className: "cmty-topic-full",

		reply_open: false,

		postView: ComViews.Post,

		has_source: false, // Does topic have source set for display?

		staticTagboxView: ComViews.TopicTagbox,

		editableTagboxView: ComViews.EditableTagBoxExistingTopic,

		scrollbar_settings: {
			autosize_exclusions: [
				{
					min: 841,
					max: 100000,
				},
			],
		},

		initialize: function (options) {
			ComViews.setRouteInfo(this, options);
			this.reply_box = null;
			this.$loader = AoPS.Page.buildLoader();
			this.spoofing_scrollbar = false;
			this.reveal_type = options.reveal_type;

			this.waitInitialization(options);
		},

		waitInitialization: function (options) {
			var self = this;
			if (this.model) {
				self.continueInitialization(options);
			} else {
				setTimeout(function () {
					self.waitInitialization(options);
				}, 100);
			}
		},

		continueInitialization: function (options) {
			if (!this.model) {
				return;
			}

			var self = this;

			// We track where this topic is upon open, so we know if it has already moved
			//  should this user try to move it.
			this.topic_category_at_initialization = this.model.get("category_id");
			this.topic_id = this.model.get("topic_id");

			this.loaded_from_post_id = 0;
			this.fullscreen_triggered_by_reply = false;
			this.from_middle = {
				init: false,
			};

			this.unread_posts = [];
			this.posts = [];

			/**
			 * Time of last reading, according to the database, at the time
			 *  this is added to the page.
			 **/
			this.mark_time_at_add = this.model.get("db_mark_time");
			this.start_post_id = -1;
			this.is_initialized = false;
			this.is_on_page = false;
			this.is_full_reply = false;
			/**
			 * If there are no posts loaded, then we have to get posts before doing anything
			 *  else.
			 *
			 * Most topics have the first post pre-loaded.  If that's the case, and we're showing
			 *  from start, then we want to show that post before fetching more posts, because
			 *  that is cool (and necessary in, say, blogs).  But if we aren't viewing from
			 *  the start, and we haven't fetched all the posts, then
			 *  we need to fetch the initial posts before building anymore.
			 */

			if (
				this.model.get("posts").length === 0 ||
				(this.reveal_type != "show_from_start" &&
					this.model.get("posts").length === 1 &&
					!this.model.get("all_posts_fetched"))
			) {
				// We don't append to the post_box here because the post_box hasn't been built yet!
				this.$el.append(this.$loader);

				// We are only here if this topic is off loading
				this.fetchTopicInitialPosts(function () {
					self.completeInitialization(options);
				});
			} else {
				this.completeInitialization(options);
			}
			this.snipe_warning_open = false;
			this.snipe_warning_type = this.model
				.get("master")
				.get("current_user")
				.get("warn_on_snipes");

			this.listenTo(
				this.model.get("master").get("current_user"),
				"change:warn_on_snipes",
				function () {
					self.snipe_warning_type = self.model
						.get("master")
						.get("warn_on_snipes");
				}
			);
			this.listenTo(this.model, "change:deleted", this.onDelete);
			this.listenTo(this.model, "change:state", this.renderState);
			this.listenTo(this.model, "change:target_url", this.onChangeTargetUrl);
			this.listenTo(
				this.model,
				"office_hours_person_here",
				this.onOfficeHoursPersonHere
			);
		},

		canModerate: function () {
			return (
				this.model.getPermission("c_can_move_topic_out") ||
				this.model.getPermission("c_can_delete") ||
				this.model.getPermission("c_can_lock_topic") ||
				this.model.getPermission("c_can_announce") ||
				this.model.getPermission("c_can_hard_delete")
			);
		},

		onChangeTargetUrl: function () {
			if (this.model.get("target_url").length == 0) {
				this.$(".cmty-target-url").parent().remove();
			}
		},

		/**
		 * Check if this is a private message for the current user.
		 *
		 * We treat regular PMs a little differently in display than
		 *  when admins are viewing others' messages.
		 **/
		checkIsPrivate: function () {
			// Not private?  Then fail.
			if (this.model.get("topic_type") !== "private") {
				return false;
			}

			// Only my PMs are in the feed.
			if (this.viewing_source === "feed") {
				return true;
			}

			// I'm not in the feed, so need to check if I'm in a priv category.
			//  If not, then I am in one of my pm categories, and should treat
			//  this as my private message.
			return (
				!_.isNull(this.master.get("focus_category")) &&
				!_.isUndefined(this.master.get("focus_category")) &&
				this.master.get("focus_category").get("category_type") !== "priv"
			);
		},

		completeInitialization: function (options) {
			var self = this,
				has_state,
				sought_url,
				full_target_url,
				target_attr = "",
				has_target_url = this.model.checkShowTargetLink(),
				search_text,
				posts_start_height,
				drag_start,
				can_moderate = this.canModerate(),
				textarea_start_height;

			has_state =
				this.model.getPermission("c_can_monitor") &&
				this.model.get("state") !== "none";
			// Parse submitted initialize data.
			this.master = this.model.get("master");
			/*this.category = this.master.fetchCategory(this.model.get('category_id'));*/

			// TODO : Consider making a TopicFullPrivate class if
			//   this diverges enough
			this.is_private = this.checkIsPrivate();

			// We might have reached this topic via a view rather than via the topic's
			//  parent forum.  This is needed for the action when we close
			//  the topic.
			this.route_category_id = options.hasOwnProperty("route_category_id")
				? options.route_category_id
				: this.model.get("category_id");

			if (this.model.get("target_url").length > 0) {
				sought_url = new RegExp(document.domain + "/" + AoPS.router_root);
				full_target_url = document.domain + this.model.get("target_url");
				target_attr = sought_url.test(full_target_url)
					? AoPS.pushState_attr
					: "";
			}

			// Construct the page and define various variables for parts of the topic.
			// TODO : Put a class on the appropriate box to deal with no reply.
			this.$el.html(
				this.getTemplate(this.template_id, {
					topic_title: this.model.get("topic_title"),
					category_name: this.model.get("category_name"),
					category_id: this.model.get("category_id"),
					topic_id: this.model.get("topic_id"),
					can_reply: true,
					has_target_url: has_target_url,
					target_attr: target_attr,
					target_url: this.model.get("target_url"),
					tooltip_target: Lang["topic-full-target-tooltip"],
					viewed_in_own_forum:
						this.route_category_id === this.model.get("category_id"),
					lang_topic_tooltip: Lang["topic-full-title-tooltip"],
					lang_tag_tooltip: Lang["tag-tooltip-forum"],
					can_moderate: !this.is_private && can_moderate, // Here is where we block admin for privates.
					has_participants: this.is_private,
					can_unlock: this.model.getPermission("c_can_lock_topic"),
					can_unlock_forum: this.model.getPermission("c_can_lock_category"),
					tooltip_expand: Lang["topic-full-expand-tooltip"],
					tooltip_close: Lang["topic-full-close-tooltip"],
					tooltip_moderate: Lang["topic-full-moderate-tooltip"],
					// Bookmark tooltipped in setBookmarStatus
					tooltip_locked: this.model.getPermission("c_can_lock_topic")
						? Lang["topic-full-locked-tooltip-mod"]
						: Lang["topic-full-locked-tooltip"],
					tooltip_forum_locked: this.model.getPermission("c_can_lock_category")
						? Lang["topic-full-locked-forum-tooltip-mod"]
						: Lang["topic-full-locked-forum-tooltip"],
					tooltip_reply: Lang["topic-full-reply-tooltip"],
					locked: Lang["topic-full-locked"],
					forum_locked: Lang["topic-full-locked"],
					reply: Lang["topic-full-reply"],
					lang_Mod: Lang["Mod"],
					has_topic_state: has_state,
					tooltip_state:
						Lang["topic-full-state-tooltip"] + this.model.get("state"),
					topic_state: this.fetchStateSymbol(),
					tooltip_feed_topic_title: Lang["feed-topic-title-tooltip"],
					tooltip_feed_forum_title: Lang["feed-forum-title-tooltip"],
					lang_click_for_tags: Lang["topic-full-click-for-tags"],
				})
			);

			this.$top_panel = this.$el.find(".cmty-topic-full-top");
			this.$top_panel_placeholder = this.$el.find(
				".cmty-topic-full-top-placeholder"
			);
			this.$bottom_panel = this.$el.find(".cmty-topic-full-bottom");
			if (this.is_private) {
				this.$participants = this.$el.find(".cmty-topic-participants");
				this.addParticipants();
				this.listenTo(this.model, "change:participants", this.addParticipants);
			}

			if (has_target_url || has_state) {
				this.$top_panel.addClass("too-many-icons");
			}
			this.$posts_box = $("<div/>", {
				class: "cmty-postbox-inner-box",
			});

			if (this.model.get("can_have_source")) {
				this.has_source = true;
				this.$source = $('<div class="cmty-topic-source-display"></div>');
				this.renderSource();
				this.$posts_box.append(this.$source);
				this.listenTo(this.model, "change:source", this.renderSource);
			}
			this.$who_is_typing = $('<div class="cmty-who-is-typing"></div>');
			this.$quick_reply = $(
				$.parseHTML(
					'<div class="cmty-topic-posts-bottom"><div class="cmty-topic-mini-reply"><span class="aops-font">N</span> ' +
						Lang["topic-full-post-reply"] +
						"</div></div>"
				)
			);
			this.parseLockedVisibility();

			this.$posts_outer_wrapper = this.$el.find(
				".cmty-topic-posts-outer-wrapper"
			);
			this.$reply_window = this.$el.find(".cmty-reply-window");
			this.$reply_divider = this.$(".cmty-reply-divider");
			this.$drag_wrapper = this.$(".cmty-topic-full-drag-wrapper");

			this.$reply_divider.draggable({
				axis: "y",
				containment: this.$drag_wrapper,
				start: function (event, ui) {
					posts_start_height = self.$posts_outer_wrapper.height();
					drag_start = ui.offset.top;
					textarea_start_height = self.$reply_window.find("textarea").height();
				},
				/*stop : function (event, ui) {
					self.$reply_divider.css({
						top : 0
					});
				},*/
				helper: "clone",
				drag: function (event, ui) {
					var diff = ui.offset.top - drag_start;

					self.$(".ui-draggable-dragging").css({
						left: "0px",
					});
					self.$reply_window
						.find("textarea")
						.height(textarea_start_height - diff);
					self.$posts_outer_wrapper.height(posts_start_height + diff);
				},
			});

			this.$who_is_typing.css(
				"background",
				this.model.get("category_secondary_color")
			);

			this.$bookmark = this.$el.find(".cmty-topic-bookmark");

			if (this.model.get("topic_type") === "private") {
				this.setArchiveStatus();
			} else {
				this.setBookmarkStatus();
			}

			this.$posts_outer_wrapper.prepend(
				AoPS.Community.Views.buildCommunityScrollbar(
					this.$posts_box,
					this.scrollbar_settings
				)
			);

			this.$scrollbar = this.$posts_outer_wrapper.find(".aops-scroll-bar");

			this.$posts_inner_wrapper = this.$posts_box.parent();

			this.$posts_inner_wrapper
				.parent()
				.append(this.$el.find(".cmty-topic-jump"));

			// Prepare the window for show_from_start or show_from_end (TODO : from_middle)
			//  Then add the posts and filter them.
			this.setPostFilter();
			this.model.get("posts").each(function (post) {
				self.addPost(post);
			});

			this.initializeTagbox();
			this.doExtraInitialization();
			// Build the Listeners
			this.listenTo(this.model, "goto_last_post", this.goToLastPost);
			this.listenTo(
				this.model.get("posts"),
				"add",
				this.addPostAfterPageConstruction
			);
			this.listenTo(
				this.model,
				"change:is_bookmarked change:in_feed change:is_watched",
				this.setBookmarkStatus
			);
			this.listenTo(this.model, "post_load_complete", this.removeLoader);
			this.listenTo(this.model, "tag_removed tag_added", this.setHeight);
			this.listenTo(
				this.model,
				"change:locked change:forum_locked",
				this.parseLockedVisibility
			);
			this.listenTo(this.model, "change:topic_title", this.onChangeTopicTitle);
			// This is an imperfect proxy for a topic that is in office hours,
			//  but we only want to set this listener for office hours topics
			if (has_state && this.master.get("monitoring_office_hours")) {
				this.listenTo(
					this.master,
					"reset_office_hours_topics",
					this.onResetOfficeHours
				);
			}

			this.$posts_box.append(this.$who_is_typing);

			/**
			 * If we haven't loaded posts for this topic yet, then go get them.
			 */
			if (this.posts.length === 0) {
				/** Do something for when there are no posts in a topic **/
			} else {
				this.$posts_box.append(this.$quick_reply);
				// Must be after quick reply is appended...
				//this.setInitialPostBoxLocation();
			}

			this.setHeight();

			// See PROJ-14069
			setTimeout(() => this.setHeight(), 500);
			setTimeout(() => this.setHeight(), 1000);

			/**
			 * Most topics are loaded with the first post pre-loaded.
			 *  If that's all we have when this view is built, then
			 *  we want to go get the rest of the topic's initialization.
			 *  Unless that's the only post.
			 **/
			if (
				this.model.get("posts").length === 1 &&
				!this.model.get("all_posts_fetched")
			) {
				this.$posts_box.append(this.$loader);
				this.fetchTopicInitialPosts(function () {
					self.onEndInitialization();
				});
			} else {
				this.onEndInitialization();
			}
			if (this.model.get("is_search_result")) {
				search_text = this.model.fetchSearchText("title");
				if (search_text.length > 0) {
					this.$(".cmty-topic-subject").extendedHighlightText(
						"cmty-highlight",
						search_text
					);
				}
			}
			/**
			 * Little sleight of hand here.  Typically when we build a topic, we have the first post already, so
			 *  we immediately load that and then go fetch the rest.  If the topic is long enough to cause a scrollbar
			 *  to appear after the initial posts load, then there will be an annoying jiggle as the first post
			 *  adjusts when the rest of the posts are loaded and the scrollbar appears (thereby narrowing the post
			 *  window).  So, we predict here that the scrollbar will appear if there are more than 3 posts, and
			 *  narrow the window on load.
			 *
			 * See addPost for how the class gets cleaned off.
			 *
			 * NOTE : RR moved this from end of function on 9/22 and added the check on the length of posts
			 ***/
			if (
				this.model.get("num_posts") > 3 &&
				this.model.get("posts").length === 1
			) {
				this.$posts_inner_wrapper
					.parent()
					.addClass("aops-spoof-scrollbar-visible");
				this.spoofing_scrollbar = true;
			}
		},

		/**
		 * A full topic is fixed height if it is in the feed or
		 *  if it is not in phone mode.
		 **/
		isFixedHeight: function () {
			return (
				this.viewing_source === "feed" ||
				$(window).width() > Constants.phone_mode_max_width
			);
		},

		fetchStateSymbol: function () {
			switch (this.model.get("state")) {
				case "open":
					return "O";

				case "closed":
					return "C";

				case "not_monitored":
					return "N";

				default:
					return "";
			}
		},

		renderState: function () {
			var $state = this.$(".cmty-topic-state");
			if ($state.length > 0) {
				$state.html(this.fetchStateSymbol());
				$state[0].title =
					Lang["topic-full-state-tooltip"] + this.model.get("state");
			}
		},

		onClickState: function () {
			var new_state;

			switch (this.model.get("state")) {
				case "open":
					new_state = "closed";
					break;

				case "closed":
					new_state = "not_monitored";
					break;

				case "not_monitored":
					new_state = "open";
					break;

				default:
					new_state = this.model.get("state");
					break;
			}

			this.model.setState({
				state: new_state,
			});
		},

		renderSource: function () {
			var source = this.model.get("source");

			if (source.length > 0) {
				this.$source.html(
					'<span class="cmty-source-title">' +
						Lang["topic-full-source"] +
						"</span>: " +
						this.model.get("source")
				);
				this.$source.css({display: "block"});
			} else {
				this.$source.css({display: "none"});
			}
			if (this.model.get("is_search_result")) {
				var search_text = this.model.fetchSearchText("source");
				if (search_text.length > 0) {
					this.$source.extendedHighlightText("cmty-highlight", search_text);
				}
			}
		},

		onChangeTopicTitle: function () {
			this.$(".cmty-topic-subject").html(this.model.get("topic_title"));
		},

		/**
		 * Fetch the initial topic posts, and then do whatever is supposed to come next.
		 *
		 * @param function to execute after load of initial posts.
		 */
		fetchTopicInitialPosts: function (onFinish) {
			this.listenToOnce(this.model, "post_load_complete", function () {
				onFinish();
			});
		},

		/**
		 * What we do at the very end of initializing the view.  Initial
		 *  posts are loaded now, and it's time to move on if the view is on the page.
		 **/
		onEndInitialization: function () {
			this.is_initialized = true;
			/**
			 * If this view has already been added to the page,
			 *  then add_to_page_settings is set, and we need to finish
			 *  the post-add-to-page operations.
			 **/
			if (this.is_on_page) {
				this.finishOnAddToPage(this.add_to_page_settings);
			}
		},
		/**
		 * Add the participants row to the topic.
		 */
		addParticipants: function () {
			this.$participants.html(
				this.getTemplate("#cmty-private-participants-tpl", {
					participants: this.is_private ? this.buildParticipants() : [],
					lang_removed: Lang["private-user-removed"],
					lang_remove_me: Lang["private-remove-me"],
					lang_add_participant: Lang["private-add-participant"],
					can_add_more:
						this.is_private &&
						this.model.get("category_id") == Constants.private_messages_id &&
						this.model.getPermission("p_can_add_participant")
							? this.model.get("participants").length <
								Constants.max_conversation_participants
							: false,
				})
			);
			this.setHeight();
		},

		buildParticipants: function () {
			return _.map(this.model.get("participants"), function (participant) {
				return _.defaults(
					{
						is_me: AoPS.session.user_id === participant.user_id,
					},
					participant
				);
			});
		},

		/**
		 * Sets the visible
		 *  posts and window based on which direction we are viewing.
		 *  Will change after we provide a way to aim at a particular post.
		 */
		setInitialPostBoxLocation: function () {
			if (this.reveal_type === "show_from_end") {
				this.goToLastPost();
			} else if (this.reveal_type === "show_from_start") {
				this.goToFirstPost();
			}
		},

		/**
		 * This view has children with some different initialization
		 *  needs; the extra portions of the initialization get
		 *  tucked in this function.
		 */
		doExtraInitialization: function () {},

		initializeTagbox: function () {
			var user;

			if (!this.is_private) {
				user = this.model.get("master").get("current_user");
				if (user.get("hide_tags_on_topic")) {
					this.$el.addClass("cmty-hide-topic-tags");
				}
				this.listenTo(user, "change:hide_tags_on_topic", function () {
					this.$el.toggleClass(
						"cmty-hide-topic-tags",
						user.get("hide_tags_on_topic")
					);
				});
			}

			this.constructStaticTagbox();

			/**
			 * If this user changes the tags, then the tag_added event will
			 *   get triggered right away, but the change:tags won't get changed
			 *  	until the next topic_update.  So, we watch tag_added, too
			 **/
			this.listenTo(this.model, "change:tags tag_added", this.onTagsChanged);
		},

		/**
		 * Set Bookmark status on this topic.
		 */
		setBookmarkStatus: function () {
			var $icon = this.$bookmark.find(".bkmk-icon"),
				$text = this.$bookmark.find(".bkmk-text");
			this.$bookmark.prop(
				"title",
				this.model.get("is_bookmarked")
					? Lang["topic-full-remove-bookmark-tooltip"]
					: Lang["topic-full-bookmark-tooltip"]
			);

			$text.html(
				this.model.get("is_bookmarked")
					? Lang["bookmark-remove"]
					: Lang["bookmark-follow"]
			);
			$icon.html(
				ComViews.makeBookmark({
					is_bookmarked: this.model.get("is_bookmarked"),
					in_feed: this.model.get("in_feed"),
					is_watched: this.model.get("is_watched"),
				})
			);
		},

		/**
		 * Set the archive status of this topic (private messages only)
		 **/
		setArchiveStatus: function () {
			if (!this.hasOwnProperty(this.$archive_status)) {
				this.$archive_status = $(
					'<span class="cmty-topic-archive cmty-icon-w-text clickable"></span>'
				);
				this.$(".cmty-topic-bookmark").replaceWith(this.$archive_status);
			}
			if (this.model.get("status") === "active") {
				this.$archive_status.append(
					'<span class="aops-icon">(</span>' + Lang["private-Archive-btn"]
				);
				this.$archive_status[0].title = Lang["private-archive-topic"];
			} else {
				this.$archive_status.append(
					'<span class="aops-icon">)</span>' + Lang["private-Unarchive-btn"]
				);
				this.$archive_status[0].title = Lang["private-unarchive-topic"];
			}
		},

		onResetOfficeHours: function () {
			// Get the focus topic.
			var focus_topic = this.model.get("is_feed_focus")
				? this.feed && this.feed.get("focus_topic")
				: this.master && this.master.get("focus_topic");

			// Don't do anything if this is not the focused topic.
			if (
				!focus_topic ||
				focus_topic.get("topic_id") !== this.model.get("topic_id")
			) {
				return;
			}

			// Remove all who is typing notification bars.
			this.$who_is_typing.html("");

			this.$el.removeClass("cmty-office-hours-person-here");

			// Reprocess height since it may have changed.
			this.setHeight();
		},

		onOfficeHoursPersonHere: function (ohp_user) {
			// Don't do anything in Private messages.
			var category = this.model.get("category");
			if (category && category.get("category_type") === "my_privates") {
				return;
			}

			var topic_id = this.model.get("topic_id");
			if (!topic_id) {
				return;
			}

			// This is not the focused topic, so get outta here.
			var focused_topic_ids = this.master.getFocusedTopicIds();
			if (
				topic_id !== focused_topic_ids.master &&
				topic_id !== focused_topic_ids.feed
			) {
				return;
			}

			// Is the user reported as typing but the reply window is not open?
			// Let's tell the server we're not typing here and abort.
			// This fixes an issue where the typing notification never goes away
			// if the user refreshes while typing a reply, since their visit
			// time continues to update.
			if (
				AoPS.session.user_id === parseInt(ohp_user.user_id) &&
				parseInt(ohp_user.is_typing) &&
				!this.reply_open
			) {
				this.master.updateIsTyping(this.model, 0);
				ohp_user.is_typing = false;
			}

			// Build the who is typing notification bar for this user.
			if (parseInt(ohp_user.is_typing)) {
				var $userNotification = this.$who_is_typing.find(
					'[data-user-id="' + ohp_user.user_id + '"]'
				);
				// Prevent notification from rendering twice.
				if (!$userNotification.length) {
					this.$who_is_typing.append(
						this.getTemplate("#cmty-user-is-typing", ohp_user)
					);
				}
			}

			if (AoPS.session.user_id != ohp_user.user_id) {
				this.$el.addClass("cmty-office-hours-person-here");
			}

			// Reprocess height since it may have changed.
			this.setHeight();

			// If the user is reasonably close to the bottom of the thread while replying
			// then let's snap the scroller to the bottom when this notification appears.
			var $posts_scroller =
				this.$posts_outer_wrapper.find(".aops-scroll-inner");
			var newScrollHeight = $posts_scroller.prop("scrollHeight");
			var outerHeight = $posts_scroller.outerHeight();
			var userNearBottom = !this.$posts_outer_wrapper
				.find(".aops-scroll-outer > .aops-scroll-fade-bottom")
				.is(":visible");
			if (this.reply_open && userNearBottom) {
				var newScrollTop = newScrollHeight - outerHeight;
				$posts_scroller.scrollTop(newScrollTop);
			}
		},

		/** End initialization-related functions **/

		events: {
			"click .cmty-topic-mini-reply": "onClickReply",
			"click .cmty-itembox .cmty-edit-tag": "toggleTagbox",
			"click .cmty-topic-bookmark": "onClickBookmark",
			"click .cmty-topic-jump-bottom": "goToLastPost",
			"click .cmty-topic-jump-top": "goToFirstPost",
			"click .cmty-topic-close": "onClickClose",
			"click .cmty-add-participant": "onClickAddParticipant",
			"click .cmty-full-screen": "onClickFullScreen",
			"click .cmty-topic-moderate": "onClickModerate",
			"click .cmty-topic-can-unlock, .cmty-topic-reply": "onClickFullReply",
			"click .cmty-remove-me": "onClickRemoveMe",
			"click .cmty-topic-archive": "onClickArchiveToggle",
			"click .cmty-click-for-tags": "onClickForTags",
			"click .cmty-topic-state": "onClickState",
		},

		/**
		 * Show the tags on click for tags.
		 **/
		onClickForTags: function (e) {
			this.$el.removeClass("cmty-hide-topic-tags");
			e.stopPropagation();
			e.preventDefault();
		},

		/**
		 * What we do when we click Archive/Unarchive on a PM.  Change the status,
		 *  throw a flyout, and either go to message in Inbox, or go to toplevel of Inbox.
		 **/
		onClickArchiveToggle: function () {
			var master = this.model.get("master");
			if (this.model.get("status") === "active") {
				this.model.setMyStatus({
					status: "archived",
				});
				if (this.viewing_source !== "feed") {
					master.get("my_privates").trigger("check_for_more_topics");
				} else {
					if (this.model.get("master").get("fullscreen_mode") === "feed") {
						this.performFullScreenEvents(false);
					}
				}
				this.completeParticipantStatusChange(
					"/c" + Constants.private_messages_id
				);
				AoPS.Ui.Flyout.display(Lang["private-message-archived"]);
			} else {
				this.model.setMyStatus({
					status: "active",
				});
				// Trigger check_for_more_topics on archive if we decide to stay in Archive here
				this.completeParticipantStatusChange("/h" + this.model.get("topic_id"));
				//				this.completeParticipantStatusChange(ComViews.constructUrlFromFocus(this.model.get('master')) + '_moved');
				AoPS.Ui.Flyout.display(Lang["private-message-unarchived"]);
			}
		},

		onClickFullScreen: function (e) {
			this.performFullScreenEvents(false);
		},

		/**
		 * If we flip into fullscreen mode from the feed while in full-reply mode from
		 *  the community, then we jump out of full reply mode in the community.
		 *  This is because leaving the full reply mode in the feed would otherwise
		 *  put the community topic in a weird state, and I don't feel like having
		 *  separate machinery for feed-in-full-reply and other-in-full-reply.
		 **/
		onChangeFullscreenMode: function () {
			if (
				this.model.get("master").get("fullscreen_mode") === "feed" &&
				this.viewing_source === "master"
			) {
				this.is_full_reply = false;
			}
		},

		/**
		 * Perform the actions required by clicking on "fullscreen".
		 *
		 * @param boolean is this auto-triggered by clicking Reply?
		 **/
		performFullScreenEvents: function (triggered_by_reply) {
			var anchor_at_bottom = false,
				new_fullscreen_mode =
					this.model.get("master").get("fullscreen_mode") === "none"
						? "master"
						: "none";

			if (
				this.$posts_box.height() -
					this.$posts_inner_wrapper.scrollTop() -
					this.$posts_inner_wrapper.height() <
				Constants.reply_jump_to_bottom_window
			) {
				anchor_at_bottom = true;
			}

			this.model.get("master").set("fullscreen_mode", new_fullscreen_mode);

			$(window).trigger("resize");

			if (anchor_at_bottom) {
				this.goToLastPost();
			}
		},

		onClickRemoveMe: function () {
			var message,
				private_category,
				self = this;
			if (this.model.get("status") === "archived") {
				message = Lang["private-remove-from-archived"];
				private_category = "my_privates_archive";
			} else {
				message = Lang["private-remove-from-active"];
				private_category = "my_privates";
			}
			AoPS.Ui.Modal.showConfirm(
				message,
				function (val) {
					var target,
						topic = self.model,
						master = topic.get("master");
					if (val) {
						if (self.viewing_source === "feed") {
							target = "";
						} else {
							target = ComViews.constructUrlFromFocus(topic.get("master"), {
								strip_topic: true,
							});
						}
						// Must come before the setMyStatus call, because setMyStatus will
						//  end up destroying this View by destroying the model.
						self.completeParticipantStatusChange(target);
						topic.setMyStatus({
							status: "removed",
						});
						master.get(private_category).trigger("check_for_more_topics");
					}
				},
				{
					confirm_button_ok: Lang["private-remove-me-ok"],
					width: "450px",
				}
			);
		},

		/**
		 * What happens at the end of a changing your participant status in a PM.
		 *  Needed because this action is different in the feed.
		 *
		 * @param string URL to go to.
		 **/
		completeParticipantStatusChange: function (target) {
			Backbone.history.navigate(target, {trigger: true});
		},

		onClickModerate: function () {
			// eslint-disable-next-line no-new
			new AoPS.Community.Views.ModerateTopic({
				model: this.model,
				topic_category_at_initialization: this.topic_category_at_initialization,
				url_cmty_path: this.url_cmty_path,
				url_router_base: this.url_router_base,
				push_state_attribute: this.push_state_attribute,
			});
		},

		/**
		 * When we click the button to add a participant, we fire up the view to do so.
		 */
		onClickAddParticipant: function () {
			// eslint-disable-next-line no-new
			new AoPS.Community.Views.ModalToAddParticipant({
				model: this.model,
			});
		},

		/**
		 * When the topic's tags change, rebuild the itembox.
		 */
		onTagsChanged: function () {
			if (this.tagbox_state === "static") {
				this.tagbox.close();
				this.constructStaticTagbox();
			}
		},

		/**
		 * When we click close, we go back to the category from whence we
		 *  came.
		 */
		onClickClose: function (e) {
			var focus_tag = this.model.get("master").get("focus_tag"),
				focus_category = this.master.get("focus_category"),
				category_type = focus_category.get("category_type"),
				target_url;

			this.model.get("master").set("fullscreen_mode", "none");
			$(window).trigger("resize");

			if (category_type === "user_search_posts") {
				target_url = "/u" + focus_category.get("user_id");
			} else if (category_type === "search") {
				target_url =
					"/q" +
					focus_category.get("search_id") +
					(focus_category.has("encoded_search_text")
						? "_" + focus_category.get("encoded_search_text")
						: "");
			} else if (
				category_type === "my_privates" &&
				focus_category.get("category_status") === "archived"
			) {
				target_url = "/my-messages-archive";
				if (!_.isNull(focus_tag)) {
					target_url +=
						"/t" + focus_tag.item_id + "f" + focus_tag.item_forum_id;
				}
			} else if (category_type === "priv") {
				target_url = "/x" + focus_category.get("user_id");
			} else {
				target_url =
					"/c" +
					this.route_category_id +
					(!_.isNull(focus_tag)
						? "t" + focus_tag.item_id + "f" + focus_tag.item_forum_id
						: "");
			}

			ComViews.followUrlOnClick(
				e,
				target_url,
				this.url_router_base,
				this.url_cmty_path
			);

			// This assumes that we are turning off fullscreen when you close a topic.
			this.fullscreen_triggered_by_reply = false;
		},

		/**
		 * Here's what happens when we click the bookmark area.
		 */
		onClickBookmark: function () {
			// Check for general access
			if (
				!ComViews.hasCommunityGeneralAccess(
					"bookmark-not-logged-in",
					"bookmark-free-resource",
					this.model.getPermission("c_undo_global_ban")
				)
			) {
				return false;
			} else {
				if (this.model.get("is_bookmarked")) {
					this.model.setBookmarkState({
						is_bookmarked: false,
						in_feed: false,
						is_watched: false,
					});
				} else {
					ComViews.fireBookmarkModal(
						"topic",
						Utils.formatString(Lang["bookmark-modal-topic"], [
							this.model.get("topic_title"),
							this.model.get("category_name"),
						]),
						_.bind(this.model.setBookmarkState, this.model)
					);
				}
			}
		},

		/**
		 * If the initialization hasn't finished, then we log
		 *  the starting options, and we'll use those to finish
		 *  adding to page after the initialization has finished.
		 */
		onAddToPage: function (options) {
			var self = this;

			if (this.is_full_reply) {
				this.setFullReplyStyle();
			}

			if (this.model) {
				this.listenTo(
					this.model.get("master"),
					"change:fullscreen_mode",
					this.onChangeFullscreenMode
				);
			}

			/**
			 * What we do when we're ready to take care of business
			 **/
			function continueBuilding() {
				self.finishOnAddToPage(options);
				self.is_on_page = true;
			}

			if (this.viewing_source === "master") {
				Backbone.trigger("squelch_scroll_to_top");
			}

			this.is_on_page = true;

			this.setFocusListener();

			/**
			 * If this has already been on-screen once, then
			 *  there are a bunch of different things that might happen
			 **/
			if (this.is_initialized && this.model) {
				/**
				 * The change_focus_topic script isn't going to affect anything if all posts are fetched.
				 **/
				if (this.model.get("all_posts_fetched")) {
					continueBuilding();
					return;
				}
				/**
				 * Each time we visit a topic, we call a Master model routine that has
				 *  an Ajax call that's going to get stuff for this topic.
				 **/
				if (this.model.get("master").get("in_change_focus_topic")) {
					/**
					 * If the user is looking from the start, go ahead and set the window there.
					 * Otherwise, set them at the end.
					 *
					 * In either case, hide the reply bar and throw the loader for the time being.
					 *  We think we need more topics...
					 **/
					if (options.reveal_type === "show_from_start") {
						this.goToFirstPost();
					} else if (options.reveal_type === "show_from_middle") {
						this.goToPostId(options.post_id);
					} else {
						this.goToLastPost();
					}
					// The browser window height may have changed since last time we were here, so
					// we don't want to wait for the master ajax call to finish to fix the window.
					this.setHeight();
					this.$posts_box.append(this.$loader);

					this.$quick_reply.hide();

					/**
					 * Once the master finishes its Ajax call, it'll tell us.
					 **/
					this.listenToOnce(
						this.model.get("master"),
						"change_topic_post_finish",
						function () {
							self.$loader.detach();
							continueBuilding();
						}
					);
				} else {
					// Not in the master Ajax call, just keep going.
					continueBuilding();
				}
			} else {
				// If we're waiting for initialization to finish, we
				//  still need to set height because there's probably one
				//  post (the first) shown on the page.
				if (this.hasOwnProperty("$posts_outer_wrapper")) {
					this.setHeight();
				}
				this.add_to_page_settings = options;
			}
		},

		/**
		 * After we have added the view to the page, we have to get it situated correctly.
		 *
		 * @param object
		 *		reveal_type string : show_from_start, show_from_end, show_unread, show_from_middle
		 *		post_id int (optional) : jumping directly to a post
		 */
		finishOnAddToPage: function (options) {
			var self = this,
				show_unread = false;
			var new_top;

			this.mark_time_at_add = this.model.get("db_mark_time");

			this.reveal_type = options.reveal_type;

			/** If we're jumping right to a post ID, then set start_post_id **/
			if (options.hasOwnProperty("post_id")) {
				this.start_post_id = options.post_id;
			}

			if (this.reveal_type === "show_unread") {
				show_unread = true;
			}

			this.setHeight();

			this.setInitialPostBoxLocation();

			/**
			 * If all the posts are fetched, but our reveal_type is
			 *  show_from_middle (from a post_id) or show_unread,
			 *  then we re-cast the reveal_type and move the posts box
			 *  to the appropriate place (post_id or last unread post).
			 **/
			if (this.model.get("all_posts_fetched")) {
				if (
					this.reveal_type !== "show_from_start" &&
					this.reveal_type !== "show_from_end"
				) {
					this.reveal_type = "show_from_start";
					this.setPostFilter();
					this.applyPostFilter();
				}

				if (this.start_post_id > 0) {
					this.goToPostId(this.start_post_id);
				} else if (show_unread) {
					/*target_post = _.find(this.posts, function (post) {
						return post.model.get('post_time') > self.mark_time_at_add;
					});*/
					var target_post = this.locateFirstUnreadPostBox();
					/**
					 * If there are no unread posts, just go to the end.
					 **/
					if (!_.isUndefined(target_post)) {
						new_top = Math.min(
							this.$posts_box.height() - this.$posts_inner_wrapper.height(),
							target_post.$el.position().top
						);
						this.$posts_inner_wrapper.scrollTop(new_top);
						//this.setPostsBox(target_post.$el, 0, 0);
					} else {
						this.goToLastPost();
					}
				}
			}
			if (
				this.reveal_type === "show_from_middle" ||
				this.reveal_type === "show_unread"
			) {
				this.reveal_type = "show_from_middle";
				this.from_middle = {
					init: false,
				};
				if (_.isUndefined(options.post_id)) {
					options.post_id = 0;
				}

				/**
				 * If we have loaded this topic before, and we are trying to jump to unread,
				 *  then we know we have all the posts from the last read until the end.
				 *  We don't want to make a "fetchMorePosts" call because we already have
				 *  all the posts.
				 * IF SOMETHING IS BADLY BROKEN IN THIS AREA OF THE COMMUNITY,
				 *  THEN REMOVE THIS if STATEMENT, BUT KEEP THE ENSUING "else if"
				 *  AS JUST AN "if" statement
				 **/
				if (this.model.get("read_since_loading") && show_unread) {
					var jump_to_post = this.locateFirstUnreadPostBox();
					this.reveal_type = "show_from_end";
					this.setQuickReplyVisibility();
					this.reveal_type = "show_from_middle"; // OMG hack, look away.

					new_top = Math.min(
						this.$posts_box.height() - this.$posts_inner_wrapper.height(),
						jump_to_post.$el.position().top
					);
					this.$posts_inner_wrapper.scrollTop(new_top);
					// Regarding the else if block below
					// We only need to fetch more posts if the post_id is 0 (meaning we have "show_unread")
					//  or if the the loaded_from_post_id is 0, meaning we have never completely
					//  built the topic from the middle yet.  (this.loaded_from_post_id is set
					//  at the end of this function).  This assumes that we will only ever jump
					//  to a single post_id for a particular view.  That is, options.post_id
					//  will never take two nonzero values for the same TopicFull view.  Currently,
					//  only direct links and searches make post_id nonzero, and each are set to only
					//  allow that single post_id for this particular constructed view.  (Only
					//  post searches, including fetch user's posts, provide links to post_ids that
					//  won't cause a full page reload.
				} else if (options.post_id === 0 || this.loaded_from_post_id === 0) {
					this.maskLoading();
					this.fetchMorePosts("both");
				}
			}

			this.model.set(
				"is_read",
				true
			); /** Can I deal with this in master change_topic? **/
			$(window).bind("resize.cmty-topic-" + this.cid, function () {
				self.setHeight();
			});

			this.setUpOnPageListeners();

			if (!this.model.get("read_since_loading") || !show_unread) {
				this.setQuickReplyVisibility();
			}

			this.model.set("read_since_loading", true);

			this.loaded_from_post_id = options.post_id;

			// this.setFocusListener(); MOVED TO START OF ADD TO PAGE
		},

		setUpOnPageListeners: function () {
			this.listenTo(this.model, "topic_updated", this.setQuickReplyVisibility);
		},

		/**
		 * Set up a listener for changes in the focus topic.  Overwritten in feed.
		 *
		 * Must be called right when added to page, so we can handle rapid clicking.
		 *  If we put it later in the flow (in finishOnAdd, for example, then the user
		 *  clicking away during the initial post fetch will cause certain events
		 *  not to happen.  That is bad.
		 **/
		setFocusListener: function () {
			this.listenTo(
				this.model,
				"change:is_master_focus",
				this.onChangeFocusTopic
			);
		},

		/**
		 * Sometimes when we load posts, we don't know where the post window will end up when
		 *  we are done (show_unread, show_from_middle).  Rather than have the posts window load
		 *  and then jump to the correct spot after the new posts are loaded,
		 *  we hide everything but the loader during the posts load.
		 **/
		maskLoading: function () {
			if (
				!this.model.get("all_posts_fetched") &&
				!this.model.get("is_fetching_posts")
			) {
				this.setQuickReplyVisibility();
				_.each(this.posts, function (post) {
					post.$el.hide();
				});
			}
		},

		onChangeFocusTopic: function () {
			if (this.fetchFocusTopic() !== this.model) {
				// this check is probably superfluous, but just in case.
				this.$el.detach();
				this.onRemoveFromPage();
			}
		},

		/**
		 * Overwritten in feed, which has its own focus topic.
		 **/
		fetchFocusTopic: function () {
			return this.model.get("master").get("focus_topic");
		},

		/**
		 * What we do when this gets deleted.
		 **/
		onDelete: function () {
			var self = this,
				lang_property = "topic-full-message-deleted",
				deleted_by_me =
					arguments.length > 1 &&
					arguments[2].hasOwnProperty("deleted_by_me") &&
					arguments[2].deleted_by_me,
				no_permission =
					arguments.length > 1 &&
					arguments[2].hasOwnProperty("error_code") &&
					arguments[2].error_code === "E_NO_PERMISSION";

			if (no_permission) {
				if (AoPS.session.logged_in) {
					lang_property = "topic-full-deleted-loss-permission";
				} else {
					lang_property = "topic-full-deleted-not-logged-in";
				}
			}

			if (
				this.model.get("deleted") &&
				this.model.get("master").get("focus_topic") == this.model
			) {
				if (!deleted_by_me) {
					var $topic = $(".cmty-new-topic-popup");
					var extra_text = "";
					// If the user is in the middle of writing a new topic, the topic
					//  delete will wipe out the user's work.  So, we intervene and
					//  give them a chance to save their work.
					if ($topic.length > 0) {
						var post_content = $topic.first().find(".cmty-post-textarea").val();
						if (post_content.length > 0) {
							extra_text +=
								Lang["topic-full-deleted-extra"] +
								"<textarea>" +
								post_content +
								"</textarea>";
						}
					}
					AoPS.Ui.Modal.showAlert(Lang[lang_property] + extra_text, {
						onClose: function () {
							self.navigateAfterDelete();
						},
						frame_class:
							extra_text.length > 0
								? "aops-modal-standard cmty-deleted-topic-w-extra"
								: "aops-modal-standard",
					});
				}

				this.close();
				if (deleted_by_me) {
					this.navigateAfterDelete();
				}
			}
		},

		navigateAfterDelete: function () {
			var master = this.model.get("master"),
				category,
				category_id;

			//Uncomment the below if we go back to Backbone.history
			Modal.closeAllModals();
			category = master.get("focus_category");
			if (category.get("is_post_search")) {
				if (category.get("category_type") === "user_search_posts") {
					Backbone.history.navigate("/u" + category.get("user_id"), {
						trigger: true,
					});
					//	window.location.href = '/u' + category.get('user_id');
				} else {
					Backbone.history.navigate("/q" + category.get("search_id"), {
						trigger: true,
					});
					//	window.location.href = '/q' + category.get('search_id');
				}
			} else if (category.get("category_type") === "priv") {
				Backbone.history.navigate("/x" + category.get("user_id"), {
					trigger: true,
				});
			} else {
				category_id = category.get("category_id");
				// TODO : Make this handle other types of categories?
				//window.location.href = this.url_router_base + this.url_cmty_path + '/c' + category_id;
				Backbone.history.navigate(this.url_cmty_path + "/c" + category_id, {
					trigger: true,
				});
			}
		},

		parseLockedVisibility: function () {
			if (this.model.get("locked") || this.model.get("forum_locked")) {
				if (this.reply_open) {
					if (this.$el.is(":visible")) {
						AoPS.Ui.Modal.showMessage(Lang["topic-full-just-locked"]);
					}
					this.closeNewReply();
				}
				this.$quick_reply.hide();
				this.$(".cmty-topic-reply").addClass("force-hidden");

				this.$(
					!this.model.get("forum_locked")
						? ".cmty-topic-locked"
						: ".cmty-topic-forum-locked"
				).removeClass("force-hidden");

				this.$(
					this.model.get("forum_locked")
						? ".cmty-topic-locked"
						: ".cmty-topic-forum-locked"
				).addClass("force-hidden");
			} else {
				this.setQuickReplyVisibility();
				this.$(".cmty-topic-locked").addClass("force-hidden");
				this.$(".cmty-topic-forum-locked").addClass("force-hidden");
				this.$(".cmty-topic-reply").removeClass("force-hidden");
			}
		},

		/**
		 * Set a class on the full topic window based on whether or not there's a double row of
		 *  tags.  There's some hackery here, since we're using the
		 *  height of the top bar to infer a change in what's going on in the top of the
		 *  topic.  I think this is a bit better than setting the CSS property directly,
		 *  but we may go that route in the future.
		 */
		setHeight: function () {
			var top_panel_height,
				posts_window_height,
				available_textarea_height,
				bottom_panel_height = 0,
				$preview_panel,
				$divider,
				$drag_wrapper,
				drag_top,
				preview_heights;

			// TODO TODO : If in phone mode, remove the height CSS property!!
			// Maybe set a value in Community.data to compare the window width to?
			if (!this.hasOwnProperty("$top_panel")) {
				return;
			}

			if (!this.hasOwnProperty("$posts_outer_wrapper")) {
				// not ready yet.
				return;
			}

			if (
				this.is_full_reply &&
				this.reply_open &&
				this.reply_box.is_previewing
			) {
				this.removeFullReplyStyle();
				this.setFullReplyStyle();
				//				return;
			}

			top_panel_height = this.$top_panel.outerHeight();
			this.$top_panel_placeholder.outerHeight(top_panel_height);

			if (this.reply_open) {
				$drag_wrapper = this.$(".cmty-topic-full-drag-wrapper");
				drag_top = top_panel_height + Constants.min_posts_window_height;
				$drag_wrapper.css({
					top: drag_top,
				});
				if (this.isFixedHeight()) {
					if (this.is_full_reply) {
						$drag_wrapper.height(this.$el.height() - drag_top - 100);
					} else {
						$drag_wrapper.css({
							height: "",
						});
					}
				} else {
					$drag_wrapper.height(this.$posts_inner_wrapper.height());
				}
			}

			if (this.isFixedHeight()) {
				if (top_panel_height === 0) {
					// not ready yet.
					return;
				}
				posts_window_height =
					this.$posts_outer_wrapper.parent().height() - top_panel_height;

				this.$el.toggleClass(
					"cmty-no-preview",
					posts_window_height < Constants.min_preview_height
				);
				this.$el.toggleClass(
					"cmty-tiny-viewport",
					this.reply_open &&
						posts_window_height < Constants.min_draggable_reply_height
				);
				if (this.reply_open) {
					/*$drag_wrapper = this.$('.cmty-topic-full-drag-wrapper');
					drag_top = top_panel_height + Constants.min_posts_window_height;
					$drag_wrapper.css({
						top : drag_top,
					});
					if (this.is_full_reply) {
						$drag_wrapper.height(this.$el.height() - drag_top - 100);
					} else {
						$drag_wrapper.css({
							height : ''
						});
					}*/
					preview_heights = 0;
					if (this.reply_box.is_previewing && !this.is_full_reply) {
						$preview_panel = this.$reply_window.find(".cmty-post-preview");
						if ($preview_panel.is(":visible")) {
							preview_heights =
								this.$reply_window
									.find(".cmty-posting-preview-bar")
									.outerHeight() + $preview_panel.outerHeight();
						}
					}

					$divider = this.$reply_window.find(".cmty-reply-divider");
					available_textarea_height =
						posts_window_height -
						Constants.min_posts_window_height -
						($divider.is(":visible")
							? this.$reply_window.find(".cmty-reply-divider").outerHeight()
							: 0) -
						this.$reply_window.find(".cmty-posting-button-row").outerHeight() -
						preview_heights;
					if (
						this.$reply_window.find("textarea").outerHeight() >
						available_textarea_height
					) {
						this.$reply_window
							.find("textarea")
							.outerHeight(
								Math.max(
									available_textarea_height,
									Constants.min_stupid_view_reply_textarea
								)
							);
					}
					bottom_panel_height = this.$bottom_panel.outerHeight();
				}

				this.$posts_outer_wrapper.outerHeight(
					Math.max(
						posts_window_height - bottom_panel_height,
						Constants.min_posts_window_height
					)
				); /*this.$bottom_panel.outerHeight());*/

				return;
			} else {
				this.$posts_outer_wrapper.height("");
			}
		},

		removeFocusListener: function () {
			this.stopListening(this.model.get("master"), "change:focus_topic");
		},

		/**
		 * Remove the resize event binding so we don't have a zillion resizes triggering
		 *  after someone has surfed the site for a while.
		 **/
		onRemoveFromPage: function () {
			var last_post;
			this.removeListeners();
			this.$el.removeClass("cmty-not-at-top");
			if (this.is_full_reply) {
				this.removeFullReplyStyle();
			}

			$("body").removeClass("cmty-hide-header");
			$(window).unbind("resize.cmty-topic-" + this.cid);
			// Assuming that if user completely leaves a list, we want to start from the top next time we return.
			this.stored_window_top = 0;
			$("#community-all").removeClass("reply-focused");
			$(window).unbind("scroll.topic_full_from_start-" + this.cid);
			$(window).unbind("scroll.topic_full_from_end-" + this.cid);
			$(window).unbind("touchmove.topic_full_from_start-" + this.cid);
			$(window).unbind("touchmove.topic_full_from_end-" + this.cid);

			// Reset snipe warnings in case user turned them off just for this viewing.
			this.snipe_warning_type = this.model
				.get("master")
				.get("current_user")
				.get("warn_on_snipes");

			// Mark all loaded posts read.
			if (AoPS.session.logged_in_and_initialized) {
				_.each(this.unread_posts, function (post) {
					post.markRead();
				});
				// Move the mark time forward to the last post we currently have
				//  if there were unread posts.  Ensures that if we load this topic
				//  in a separate view, we will have the unread posts marked correct.
				//  For example, we might visit this topic in the feed, and then
				//  again in the community during the same page load.
				if (this.unread_posts.length > 0) {
					last_post = this.unread_posts[this.unread_posts.length - 1].model;
					this.model.set("db_mark_time", last_post.get("post_time"));
				}
				this.unread_posts = [];
			}
			this.is_on_page = false;

			this.start_post_id = -1;

			this.endReplyTriggeredFullscreen();
		},

		removeListeners: function () {
			this.stopListening(this.model, "topic_updated");
			this.removeFocusListener();
			this.stopListening(this.model.get("master"), "change:fullscreen_mode");
		},

		/** Start Tagbox Methods. **/

		/***
		 * We have two tagboxes in this view and we toggle between them
		 *  based on whether or not the user is editing the tags.
		 */

		/**
		 * Build a non-editable tagbox.
		 *
		 * MIXED INTO Views.TopicCellBlog
		 */
		constructStaticTagbox: function () {
			var search_text,
				in_feed = this.viewing_source === "feed",
				render_titles =
					this.hasOwnProperty("route_category_id") &&
					this.route_category_id !== this.model.get("route_category_id");
			this.tagbox = new this.staticTagboxView({
				render_titles: render_titles,
				model: this.model,
				url_cmty_path: in_feed ? "" : this.url_cmty_path,
				url_router_base: in_feed ? "/community" : this.url_router_base,
				push_state_attribute: in_feed ? "data-cmty" : this.push_state_attribute,
			});
			this.$el.find(".cmty-tags-itembox-wrapper").append(this.tagbox.$el);
			this.tagbox_state = "static";
			if (this.model.get("is_search_result")) {
				search_text = this.model.fetchSearchText("tags");
				if (search_text.length > 0) {
					this.tagbox.$el.extendedHighlightText("cmty-highlight", search_text);
				}
			}
		},

		/**
		 * Build the editable tagbox.
		 *
		 * MIXED INTO Views.TopicCellBlog
		 */
		constructEditableTagbox: function () {
			this.closing = false;
			this.editable_tagbox = new this.editableTagboxView({
				topic: this.model,
				model: this.model,
				items: _.map(this.model.get("tags"), function (tag) {
					return {
						label: tag.tag_text,
						item_id: tag.tag_id,
						is_visible: tag.is_visible,
					};
				}),
				// I tried to tuck the timeout trickery inside EditableItem, but just couldn't get it to fly.
				onClose: _.bind(function (e) {
					setTimeout(
						_.bind(function () {
							if (
								this.editable_tagbox.$el.find("input")[0] !==
								document.activeElement
							) {
								if (this.tagbox_state !== "static") {
									this.toggleTagbox();
								}
							}
						}, this),
						200
					);
				}, this),
			});

			this.$el
				.find(".cmty-tags-itembox-wrapper")
				.append(this.editable_tagbox.$el);
			this.tagbox_state = "editing";
			this.editable_tagbox.$input_box.focus();
		},

		/**
		 * Switch the tagbox between editable and static.
		 *
		 * MIXED INTO Views.TopicCellBlog
		 */
		toggleTagbox: function () {
			if (this.tagbox_state === "static") {
				this.tagbox.close();
				this.constructEditableTagbox();
			} else {
				this.editable_tagbox.close();
				this.constructStaticTagbox();
			}
			this.setHeight();
		},

		/** End Tagbox functions **/

		/** Start post management/post_box management functions. **/

		/**
		 * goToLastPost sets the posts frame to focus on the last post.
		 * IMPORTANT NOTE: This thing loads faster than the images; we need to cast the image
		 *  sizes everywhere, or we will jack everything up on loading pages that need to go to bottom.
		 */
		goToLastPost: function () {
			var window_height, posts_box_height, last_post_loc;
			this.reveal_type = "show_from_end";
			// TODO : figure out correct sequencing/positioning to prevent there from being jerkiness upon
			// jumping to bottom.
			this.setPostFilter();

			this.applyPostFilter();
			if (this.posts.length === 0) {
				return;
			}

			this.setHeight();

			window_height = this.$posts_outer_wrapper.outerHeight();
			posts_box_height = this.$posts_box.height();
			last_post_loc = this.posts[this.posts.length - 1].$el.position().top;

			if (window_height > posts_box_height) {
				// posts don't fill window; do nothing.
				return;
			}
			if (this.isFixedHeight()) {
				// Set the box so that we can see the top of the last post.
				//  (Long last post, we align top of post to top of box.  Otherwise, align
				//    bottom of post to bottom of box.)
				this.$posts_inner_wrapper.scrollTop(
					Math.min(last_post_loc, -window_height + posts_box_height)
				);
			} else {
				window.scrollTo(0, document.body.scrollHeight);
			}
			this.setPageHeaderVisibility();
		},

		/**
		 * goToFirstPost sets the posts frame to focus on the first post.
		 * IMPORTANT NOTE: This thing loads faster than the images; we need to cast the image
		 *  sizes everywhere, or we will jack everything up on loading pages that need to go to bottom.
		 */
		goToFirstPost: function () {
			this.reveal_type = "show_from_start";
			this.setPostFilter();
			// MAKE SURE THIS isn't being called twice..
			this.applyPostFilter();

			// Set the box to the top.
			this.$posts_inner_wrapper.scrollTop(0);
			if (!this.isFixedHeight()) {
				window.scrollTo(0, 0);
			}

			this.setPageHeaderVisibility();
		},

		goToPostId: function (post_id) {
			var post_box;
			post_box = _.find(this.posts, function (post) {
				return post.model.get("post_id") === post_id;
			});

			if (_.isUndefined(post_box)) {
				this.onNoPostFound();
			} else {
				this.setPostsBox(post_box.$el, 0, 0);
			}
		},

		goToPostNumber: function (post_number) {
			var post_box;

			post_box = _.find(this.posts, function (post) {
				return post.model.get("post_number") === post_number;
			});

			if (_.isUndefined(post_box)) {
				this.onNoPostFound();
			} else {
				this.setPostsBox(post_box.$el, 0, 0);
			}
		},

		onNoPostFound: function () {
			ComViews.showError(Lang["topic-full-no-post-found"]);
			this.goToFirstPost();
		},

		/**
		 * setPostFilter sets view behavior based on whether we are viewing topics from the start or from the
		 *  end.  Mainly, it sets scrollbar behavior and the filter function (filterPost) that is
		 *  used to determine which posts to show.
		 *
		 * TODO: Figure out what to do if we're loading from the middle!
		 */
		setPostFilter: function () {
			var self = this;
			if (
				this.reveal_type === "show_from_start" ||
				this.reveal_type === "show_from_end"
			) {
				this.filterPost = _.bind(function (post) {
					return post.get(this.reveal_type);
				}, this);
			} else {
				this.filterPost = _.bind(function (post) {
					var post_number = post.get("post_number");

					return (
						post_number >= this.from_middle.first_shown_post_num &&
						post_number <= this.from_middle.last_shown_post_num
					);
				}, this);
			}

			this.$scrollbar.off("slider_at_start.topic_full");
			this.$scrollbar.off("slider_at_end.topic_full");
			// TODO construct filter type for post range (what happens if we are in middle)
			if (
				this.reveal_type === "show_from_start" ||
				this.reveal_type === "show_from_middle"
			) {
				this.$scrollbar.on(
					"slider_at_end.topic_full",
					_.bind(function () {
						this.fetchMorePosts("forwards");
					}, this)
				);

				/**
				 * When we go into phone mode, we need to watch the window
				 *  scrollbar for when to trigger fetching more posts.
				 * TODO : figure out how we are going to deal with
				 *  "show_from_bottom" in phone mode.
				 *
				 **/
				if (this.viewing_source === "master") {
					$(window).on(
						"scroll.topic_full_from_start-" +
							this.cid +
							" touchmove.topic_full_from_start-" +
							this.cid,
						function () {
							if (self.$el.is(":visible") && !self.$scrollbar.is(":visible")) {
								if (
									document.documentElement.clientHeight +
										$(document).scrollTop() +
										Constants.phone_more_posts_sensitivity >=
									document.body.offsetHeight
								) {
									self.fetchMorePosts("forwards");
								}
							}
						}
					);
					$(window).unbind("scroll.topic_full_from_end-" + this.cid);
					$(window).unbind("touchmove.topic_full_from_end-" + this.cid);
				}
			}

			if (
				this.reveal_type === "show_from_end" ||
				this.reveal_type === "show_from_middle"
			) {
				this.$scrollbar.on(
					"slider_at_start.topic_full",
					_.bind(function () {
						this.fetchMorePosts("backwards");
					}, this)
				);

				/**
				 * When we go into phone mode, we need to watch the window
				 *  scrollbar for when to trigger fetching more posts.
				 * TODO : figure out how we are going to deal with
				 *  "show_from_bottom" in phone mode.
				 **/
				if (this.viewing_source === "master") {
					$(window).on(
						"scroll.topic_full_from_end-" +
							this.cid +
							" touchmove.topic_full_from_end-" +
							this.cid,
						function () {
							if (self.$el.is(":visible") && !self.$scrollbar.is(":visible")) {
								if (
									$(document).scrollTop() <
									$("#header-wrapper").outerHeight() +
										parseInt($("#main-content").css("padding-top")) +
										$("#cmty-topic-view-top").height()
								) {
									self.fetchMorePosts("backwards");
								}
							}
						}
					);

					$(window).unbind("scroll.topic_full_from_start-" + this.cid);
					$(window).unbind("touchmove.topic_full_from_start-" + this.cid);
				}
			}
		},

		setQuickReplyVisibility: function () {
			if (
				!this.reply_open &&
				!this.model.get("locked") &&
				!this.model.get("forum_locked") &&
				(this.reveal_type === "show_from_end" ||
					this.model.get("all_posts_fetched"))
			) {
				this.$quick_reply.css({
					display: "block",
				});
			} else {
				this.$quick_reply.css({
					display: "none",
				});
			}
		},

		/**
		 * applyPostFilter decides whether or not each post should be visible.
		 */
		applyPostFilter: function () {
			var self = this;
			this.setQuickReplyVisibility();
			_.each(this.posts, function (post) {
				self.setPostVisibility(post);
			});
		},

		/**
		 * setPostVisibility decides whether or not a certain post is visible.
		 *
		 * @post ComViews.Post object to check if is visible.
		 */
		setPostVisibility: function (post) {
			post.$el.toggle(this.filterPost(post.model));
		},

		/**
		 * setPostsBox positions the posts box based on a pre-set calibration mark and calibration post.
		 *  This allows us to keep the posts_box window in the proper position when we add posts prior to
		 *  those we are currently viewing.  (If we didn't do this, then adding the posts would push
		 *  the current posts down, which is bad.)  So, prior to adding posts, we mark
		 *  a post as a calibration_post and make a calibration_mark for where that post should
		 *  be relative to the viewing window after posts are added.
		 *
		 * This function positions the posts_box so that this post is properly positioned, thereby making
		 *  everything else fall into place.
		 *
		 * TODO : Deal with the fact that the "more posts above" shading for the scrollbox doesn't appear
		 *  when there are more posts above that haven't yet loaded.  This makes it look like the box shifts
		 *  a little bit after posts load, but that's not at all what is happening.
		 *  The "more posts above" shader is appearing after the posts load.
		 */
		setPostsBox: function (
			$calibration_post,
			calibration_mark,
			old_posts_box_top
		) {
			if (_.isUndefined($calibration_post) || _.isNull($calibration_post)) {
				return;
			}
			//  See TODO above before touching this; if you are trying to fix something,
			//   then you may be dealing with an optical illusion.
			//  Note: + this.posts_box.position().top - old_posts_box_top is needed to deal with
			//   the fact that the box may move while posts are being loaded.
			/*			this.posts_box.css({
				top : calibration_mark - calibration_post.position().top + this.posts_box.position().top - old_posts_box_top
			});*/

			if (this.isFixedHeight()) {
				this.$posts_inner_wrapper.scrollTop(
					-(
						calibration_mark -
						$calibration_post.position().top +
						this.$posts_box.position().top -
						old_posts_box_top
					)
				);
			} else {
				window.scrollTo(0, $calibration_post.position().top);
			}
			this.setPageHeaderVisibility();
		},

		setPageHeaderVisibility: function () {
			if (
				this.is_on_page &&
				!this.isFixedHeight() &&
				this.posts[0].model.get("post_number") === 1 &&
				!this.posts[0].$el.is(":visible")
			) {
				$("body").addClass("cmty-hide-header");
			} else {
				$("body").removeClass("cmty-hide-header");
			}
			$(window).trigger("resize");
		},

		/**
		 * Fetch more posts for this topic.  We use this.reveal_type to determine
		 *  in which direction we are fetching posts.
		 *
		 * TODO : What happens if we are starting from the middle of a topic?
		 **/
		fetchMorePosts: function (direction) {
			var i,
				loader_function = "append",
				n_posts = this.posts.length,
				$curr_post,
				self = this,
				curr_top,
				$calibration_post,
				calibration_mark,
				posts_box_top,
				fetch_options;

			/**
			 * Already have 'em all?
			 **/
			if (this.model.get("all_posts_fetched")) {
				return;
			}

			/**
			 * Already getting some?
			 **/
			if (this.model.get("is_fetching_posts")) {
				return;
			}
			// Stop the scrollbar from being able to continue being dragged;
			//  needed to keep a bunch of load more events from firing.

			$(document).trigger("mouseup");

			/**
			 * Not ready for anything?
			 **/
			if (!this.is_initialized) {
				return;
			}

			switch (this.reveal_type) {
				case "show_from_start":
					fetch_options = {
						onFinish: _.bind(function () {
							this.applyPostFilter();
						}, this),
						start_post_num: _.last(
							_.filter(
								this.posts,
								_.bind(function (post) {
									return this.filterPost(post.model);
								}, this)
							)
						).model.get("post_number"), // BE VERY CAREFUL ABOUT OFF BY ONE; MAYBE SHIFT POST NUMBERS TO START AT 0
					};
					break;

				case "show_from_end":
					fetch_options = {
						start_post_num: _.find(
							this.posts,
							_.bind(function (post) {
								return this.filterPost(post.model);
							}, this)
						).model.get("post_number"), // BE VERY CAREFUL ABOUT OFF BY ONE; MAYBE SHIFT POST NUMBERS TO START AT 0
						onFinish: _.bind(function () {
							this.setPostsBox(
								$calibration_post,
								calibration_mark,
								posts_box_top
							);
							this.applyPostFilter();
						}, this),
					};
					break;

				case "show_from_middle":
					/**
					 * We have already initialized showing from the middle for this
					 *  visit to the topic.
					 **/
					if (this.from_middle.init) {
						fetch_options = {
							start_post_num:
								direction === "forwards"
									? this.from_middle.last_shown_post_num
									: this.from_middle.first_shown_post_num,
						};
					} else {
						fetch_options = {
							start_post_id: this.start_post_id,
							show_from_time: this.mark_time_at_add,
						};
					}

					fetch_options.onFinish = _.bind(function (obj) {
						var go_to_post_number = -1;

						// Check if we need to change the range of visible posts.
						if (
							!this.from_middle.init ||
							obj.low_num < this.from_middle.first_shown_post_num
						) {
							this.from_middle.first_shown_post_num = obj.low_num;
						}

						if (
							!this.from_middle.init ||
							obj.high_num > this.from_middle.last_shown_post_num
						) {
							this.from_middle.last_shown_post_num = obj.high_num;
						}

						// On initial load from the middle, we need to find the post number
						//  so we know where to put the posts window.
						if (!this.from_middle.init) {
							go_to_post_number =
								obj.hasOwnProperty("target_post_number") &&
								!_.isNull(obj.target_post_number)
									? obj.target_post_number
									: -1;
						}

						this.from_middle.init = true;

						// If the earliest post in our range has "show_from_start" set true,
						//  then we have loaded from the target middle post all the way back
						//  to the beginning, so from now on we behave with reveal_type show_from_start
						if (
							this.model
								.get("posts")
								.findWhere({
									post_number: obj.low_num,
								})
								.get("show_from_start")
						) {
							this.model.get("posts").each(function (post) {
								if (
									post.get("post_number") <=
									self.from_middle.last_shown_post_num
								) {
									post.set("show_from_start", true);
								}
							});

							this.reveal_type = "show_from_start";
						}

						// If the latest post in our range has "show_from_end" set true,
						//  then we have loaded from the target middle post all the way
						//  to the end, so from now on we behave with reveal_type show_from_end
						if (
							this.model
								.get("posts")
								.findWhere({
									post_number: obj.high_num,
								})
								.get("show_from_end")
						) {
							this.model.get("posts").each(function (post) {
								if (
									post.get("post_number") >=
									self.from_middle.first_shown_post_num
								) {
									post.set("show_from_end", true);
								}
							});

							this.reveal_type = "show_from_end";
						}
						// Now that we have the parameters needed for our filter, we
						//  set and apply it.
						this.setPostFilter();
						this.applyPostFilter();

						// If we were surfing backwards through a topic,
						//  then set the window to the appropriate
						//  location (see below for how this computed prior to fetch call).
						if (direction === "backwards") {
							this.setPostsBox(
								$calibration_post,
								calibration_mark,
								posts_box_top
							);
						}

						// If we were aiming for a particular post (an id was sent, or
						//  we are looking for unread posts), then send the post box there.
						if (go_to_post_number > -1) {
							this.goToPostNumber(go_to_post_number);
						}
					}, this);
					break;

				default:
					console.log(
						"Uhoh.  fetchMorePosts called without reveal_type set properly"
					);
					break;
			}

			fetch_options.direction = direction;
			fetch_options.show_from_setting = this.reveal_type;
			if (direction === "backwards") {
				loader_function = "prepend";
			}

			this.$posts_box[loader_function](this.$loader);

			/**
			 * If we are going backwards, then we need to mark where to set the box
			 * after the posts are loaded so we can set the box
			 * appropriately after load.  See the
			 * setPostsBox method for more documentation.
			 */
			if (direction === "backwards") {
				posts_box_top = -this.$posts_inner_wrapper.scrollTop();
				for (i = 0; i < n_posts; i++) {
					$curr_post = this.posts[i].$el;
					if ($curr_post.is(":visible")) {
						// Find the first post that has anything visible.
						//  Mark its top relative to the top of the viewing box.
						curr_top = $curr_post.position().top;
						if (posts_box_top + curr_top + $curr_post.height() > 0) {
							$calibration_post = $curr_post;
							calibration_mark = curr_top + posts_box_top;
							i = n_posts;
						}
					}
				}
			}

			// Go get the posts; a listener will hear when they are loaded.
			if (direction === "forwards") {
				this.$posts_inner_wrapper.scrollTop(
					this.$posts_box.height() - this.$posts_inner_wrapper.height()
				);
			}
			if (direction === "backwards") {
				this.$posts_inner_wrapper.scrollTop(0);
			}

			fetch_options.onError = function (obj) {
				if (obj.error_code === "E_AJAX_CANCEL") {
					self.$loader.detach();
				}
				// TODO : timeout?
			};

			fetch_options.source = this.viewing_source;
			this.model.fetchMorePosts(fetch_options);
		},

		/**
		 * Remove the loader when the posts have been fetched.
		 **/
		removeLoader: function () {
			this.$loader.detach();
		},

		/**
		 * addPost adds a post to this thread of posts, runs the filter
		 *  to see if it should be visible on load.  (On initialization,
		 *  we load posts from both ends, so we don't want to make
		 *  them all visible.)
		 *
		 * @param post: ComModels.Post
		 *
		 * Mixed in to Blogs
		 */
		addPost: function (post) {
			var new_post = new this.postView({
					model: post,
					topic: this,
				}),
				i,
				post_number = post.get("post_number"),
				current_post,
				self = this,
				n_posts = this.posts.length;
			var post_placed = false;

			/**
			 * This is here to reduce the amount of jiggle/flicker caused by topics with many posts first
			 *  loading one post (no scrollbar yet), then fetching the rest of the posts, which causes
			 *  the scrollbar to appear and then compress the first post.  Annoying.  The lines below
			 *  don't completely kill the problem, but make it rare.
			 *  See end of completeInitialization for more info.
			 **/
			if (this.spoofing_scrollbar) {
				this.spoofing_scrollbar = false;
				setTimeout(function () {
					self.$posts_inner_wrapper
						.parent()
						.removeClass("aops-spoof-scrollbar-visible");
				}, 330);
			}

			// Hide the post for now; we'll run our filter after
			//  placing the post in the DOM to decide if we should show it.
			new_post.$el.css({display: "none"});
			for (i = n_posts - 1; i >= 0; i--) {
				current_post = this.posts[i];
				if (current_post.model.get("post_number") < post_number) {
					current_post.$el.after(new_post.$el);

					this.posts.splice(i + 1, 0, new_post);

					if (this.filterPost(post)) {
						new_post.$el.css({display: "block"});
					}
					post_placed = true;
					i = 0;
				}
			}
			if (!post_placed) {
				// Put this post at the start.
				this.posts.splice(0, 0, new_post);
				if (this.has_source) {
					this.$source.after(new_post.$el);
				} else {
					this.$posts_box.prepend(new_post.$el);
				}
				if (this.filterPost(post)) {
					new_post.$el.css({display: "block"});
				}
			}

			/**
			 * If user is logged in, check if this post has already been read
			 *  by comparing its post_time to the mark_time of the topic
			 *  at the time this topic was added to the page.
			 **/
			if (AoPS.session.logged_in_and_initialized) {
				if (
					new_post.model.get("post_time") > this.mark_time_at_add &&
					new_post.model.get("poster_id") !== AoPS.session.user_id
				) {
					new_post.markUnread();
					this.unread_posts.push(new_post);
				}
			}
		},

		/**
		 * Remove a Post view from this topic.
		 *
		 * @param ComViews.Post
		 **/
		removePost: function (post) {
			this.posts = _.without(this.posts, post);
			post.close();
		},

		locateFirstUnreadPostBox: function () {
			var num_posts = this.posts.length;

			// Check if all posts read.
			if (this.posts[num_posts - 1].is_read) {
				return this.posts[num_posts - 1];
			}
			for (var i = num_posts - 2; i > 0; i--) {
				if (this.posts[i].is_read) {
					return this.posts[i + 1];
				}
			}
			return this.posts[0];
		},

		/**
		 * If a post is added to this topic post-construction, we need to check if
		 *  we have to warn about sniping.
		 *
		 * @param AoPS.Community.Models.Post
		 **/
		addPostAfterPageConstruction: function (post) {
			this.addPost(post);

			if (
				!this.model.get("is_fetching_past_posts") &&
				this.$el.is(":visible")
			) {
				if (AoPS.session.admin && this.viewing_source !== "feed") {
					if (post.get("poster_id") !== AoPS.session.user_id) {
						document.title =
							"(new) " +
							ComViews.decodeHtmlEntities(this.model.get("topic_title"));
					} else {
						document.title = ComViews.decodeHtmlEntities(
							this.model.get("topic_title")
						);
					}
				}
				if (
					this.reply_open &&
					!_.isNull(this.reply_box) &&
					!this.reply_box.sending_to_database &&
					this.snipe_warning_type !== "none"
				) {
					if (
						this.max_post_num_at_reply_start < post.get("post_number") &&
						post.get("poster_id") !== AoPS.session.user_id &&
						post.get("poster_id") !== Constants.halp_user_id
					) {
						//Small hole here: Halp posts will never trigger snipe warning
						//  because we can't pass real_poster_id forward to check who
						//  the Halp comes from.
						this.warnAboutSniping();
					}
				}
			}
		},

		/**
		 * If a new post is fetched while the reply window is open, then throw a warning.
		 **/
		warnAboutSniping: function () {
			var buttons,
				self = this;

			if (!this.snipe_warning_open) {
				this.snipe_warning_open = true;
				buttons = [
					{
						text: Lang["snipe-option-never"],
						value: "none",
					},
					{
						text: Lang["snipe-option-not-this-time"],
						value: "now",
					},
					{
						text: Lang["snipe-option-flyout"],
						value: "flyout",
					},
					{
						text: Lang["snipe-option-close"],
						value: "close",
					},
				];

				if (this.snipe_warning_type === "modal") {
					AoPS.Ui.Modal.showMessage(Lang["snipe-warning-body"], {
						type: "buttons",
						title: Lang["snipe-title"],
						buttons: buttons,
						width: "450px",
						close_on_button_click: false,
						onButtonClick: _.bind(function (value) {
							if (value === "now") {
								this.snipe_warning_type = "none";
							}

							if (value === "none" || value === "flyout") {
								this.model.get("master").get("current_user").setUserSetting({
									field: "warn_on_snipes",
									value: value,
								});
								this.snipe_warning_type = value;
							}
							AoPS.Ui.Modal.closeAllModals();
							// TODO : Reset the snipe warnings on close (and wherever we have same in feed).
							return false;
						}, this),
						onClose: _.bind(function () {
							this.snipe_warning_open = false;
						}, this),
					});
					$("textarea.cmty-post-textarea").last().focus();
				} else {
					Flyout.display(Lang["snipe-warning-flyout"]);
					// Kludge because Flyout doesn't allow passing an onClose method :(
					setTimeout(function () {
						self.snipe_warning_open = false;
					}, 2000);
				}
			}
		},

		/** End post/posts_box management functions **/

		/** Start Reply functions.  **/

		/**
		 * Put the screen in full-reply mode.  Because IE forgets scroll position
		 *  of display:none elements, this is much harder and dicier than it should be.
		 *
		 * We might someday need actions specific to this topic, which is why I have
		 *  this function-calling-a-function setup.
		 **/
		setFullReplyStyle: function () {
			ComViews.setFullReplyStyle();
		},

		/**
		 * Take the screen out of full-reply mode.  Because IE forgets scroll position
		 *  of display:none elements, this is much harder and dicier than it should be.
		 **/
		removeFullReplyStyle: function () {
			ComViews.removeFullReplyStyle();
		},

		onClickFullReply: function () {
			/*  To deactivate full reply, uncomment below */

			/*this.onClickReply();
			return;
			*/
			this.completeReplyClick(
				this.viewing_source === "feed" ? "quick" : "full"
			);
		},

		/**
		 * Check if this user can reply.
		 **/
		checkReplyAvailable: function () {
			// Check for general access
			if (
				!ComViews.hasCommunityGeneralAccess(
					"topic-full-not-logged-in-reply",
					"new-reply-no-permission-free-resource",
					this.model.getPermission("c_undo_global_ban")
				)
			) {
				return false;
			}
			// Check for specific permissions
			else if (
				!this.model.getPermission("c_can_reply") &&
				!this.model.getPermission("c_undo_global_ban")
			) {
				AoPS.Ui.Modal.showMessage(Lang["new-reply-no-permission"], {
					width: "450px",
				});
				return false;
			}
			return true;
		},

		/**
		 * What to do when Reply is clicked
		 *
		 */
		onClickReply: function () {
			var mode = "quick";

			if (
				this.model
					.get("master")
					.get("current_user")
					.get("posting_fullscreen_reply") &&
				this.viewing_source != "feed"
			) {
				mode = "full";
			}
			this.completeReplyClick(mode);
		},

		/**
		 * Complete the actions for any type of reply click (full or quick).
		 *
		 * @param mode string full|quick
		 **/
		completeReplyClick: function (mode) {
			var use_full_reply,
				reopen_preview = false;
			if (!this.checkReplyAvailable()) {
				return;
			}

			use_full_reply = mode === "full";

			if (use_full_reply) {
				this.setFullReplyStyle();
				this.is_full_reply = true;
				if (this.reply_open) {
					if (this.reply_box.is_previewing) {
						reopen_preview = true;
						this.reply_box.onClickClosePreview();
					}
				}
			}

			if (!this.reply_open) {
				this.openNewReply();
			} else {
				if (!_.isNull(this.reply_box)) {
					this.reply_box.$post_box.focus();
				}
				if (!this.isFixedHeight()) {
					this.goToLastPost();
				}
			}

			if (use_full_reply) {
				$(window).trigger("resize");
				if (reopen_preview) {
					this.reply_box.previewPost();
				}
			}
		},

		/**
		 * openFullReply opens up the reply box and hides the reply buttons and the buttons at the
		 *  bottom of the page.
		 */
		openNewReply: function () {
			var anchor_at_bottom = false,
				self = this,
				preset_extra_options;
			//	TODO : deal with "full editor" being clicked while working with quick reply
			this.max_post_num_at_reply_start = this.model
				.get("posts")
				.last()
				.get("post_number");

			preset_extra_options = {
				notify_email:
					this.model.get("is_watched") ||
					this.model
						.get("master")
						.get("current_user")
						.get("posting_subscribe_reply"),
				bookmark_feed:
					this.model.get("in_feed") ||
					this.model
						.get("master")
						.get("current_user")
						.get("posting_subscribe_reply"),
			};
			this.reply_box = new ComViews.NewReply({
				topic_id: this.model.get("topic_id"),
				category_id: this.model.get("category_id"),
				topic: this.model,
				master: this.master,
				onPreview: function () {
					self.$el.addClass("cmty-open-preview");
					self.setHeight();
				},
				onRevealPreview: function () {
					if (self.is_full_reply) {
						window.scrollTo(
							0,
							self.$(".cmty-posting-preview-bar").offset().top - 20
						);
					}
				},
				onClosePreview: _.bind(function () {
					this.$el.removeClass("cmty-open-preview");
					this.setHeight();
				}, this),
				onSubmit: _.bind(function () {
					// Will probably edit when we have to deal with
					// possible errors.
					//this.closeNewReply();

					// Here, we throw a modal and watch for new_post_processed, then
					// call closeReply and jumpToBottom.  May choose to do the close Reply
					// immediately?
					this.listenToOnce(
						this.model,
						"new_post_processed",
						this.onSubmittedPostProcessed
					);
				}, this),
				onCancel: _.bind(function () {
					this.closeNewReply();
				}, this),
				preset_extra_options: preset_extra_options,
			});
			this.reply_box.$post_box
				.on("focus", function () {
					$("#community-all").addClass("reply-focused");
				})
				.on("blur", function () {
					setTimeout(function () {
						$("#community-all").removeClass("reply-focused");
						// Make sure the SUBMIT button gets on-screen on blur
					}, 10);
				});
			if (
				this.$posts_box.height() -
					this.$posts_inner_wrapper.scrollTop() -
					this.$posts_inner_wrapper.height() <
				Constants.reply_jump_to_bottom_window
			) {
				anchor_at_bottom = true;
			}
			this.$quick_reply.hide();
			this.$reply_window.show();
			this.$reply_window.append(this.reply_box.$el);
			this.reply_open = true;
			this.$el.addClass("reply-open");

			/*
			if (this.model.get('master').get('current_user').get('posting_fullscreen_reply') &&
					(this.model.get('master').get('fullscreen_mode') === 'none')) {
				this.fullscreen_triggered_by_reply = true;
				this.performFullScreenEvents(true);
			}
			*/

			if (this.master.get("monitoring_office_hours")) {
				// Tell the backend that the user is typing.
				this.master.updateIsTyping(this.model, 1);
				this.$who_is_typing.append(
					this.getTemplate("#cmty-user-is-typing", AoPS.session)
				);

				// Fetch OHP locations + is_typing statuses right away.
				this.master.fetchOfficeHoursData(true);
			}

			this.setHeight();

			this.reply_box.$el.find("textarea").focus();
			// Resize the posts_window to make room.
			if (anchor_at_bottom) {
				this.goToLastPost();
			}
		},

		appendToReply: function (string) {
			if (this.reply_open) {
				this.reply_box.addContent(string);
			} else {
				this.openNewReply();
				this.reply_box.addContent(string);
			}
		},

		onSubmittedPostProcessed: function () {
			this.closeNewReply();
			this.goToLastPost();
			setTimeout(function () {
				AoPS.Ui.Modal.closeAllModals();
			}, Constants.new_reply_modal_delay);
		},

		/**
		 * closeNewReply resets the page to what it should look like without the NewReply window open.
		 */
		closeNewReply: function () {
			this.reply_open = false;
			this.$el.removeClass("reply-open");

			// Notify the backend that the user is no longer typing here.
			this.master.updateIsTyping(this.model, 0);
			var $userNotification = this.$who_is_typing.find(
				'[data-user-id="' + AoPS.session.user_id + '"]'
			);
			$userNotification.remove();

			this.setQuickReplyVisibility();
			if (!_.isNull(this.reply_box)) {
				this.reply_box.close();
			}
			this.reply_box = null;
			this.$reply_window.hide();
			this.setHeight();

			if (this.is_full_reply) {
				this.is_full_reply = false;
				this.removeFullReplyStyle();
			}

			// SEE NOTE IN FUNCTION DEFINITION BELOW
			//this.endReplyTriggeredFullscreen();
		},

		/**
		 * If the fullscreen action was triggered by a reply, then we need to
		 *  end the fullscreen action here.
		 *
		 * DEPRECATED BY THE NEW FULL-REPLY.  LEAVING HERE FOR NOW
		 *  IN CASE WE BRING THIS BACK
		 **/
		endReplyTriggeredFullscreen: function () {
			if (this.fullscreen_triggered_by_reply) {
				this.fullscreen_triggered_by_reply = false;
				this.model.get("master").set("fullscreen_mode", "none");
				$(window).trigger("resize");
			}
		},

		onClose: function () {
			if (
				this.hasOwnProperty("reply_box") &&
				!_.isNull(this.reply_box) &&
				typeof this.reply_box.close === "function"
			) {
				this.reply_box.close();
			}
			_.each(this.posts, function (post) {
				post.close();
			});
			Backbone.trigger("destroy_topic_view", {
				category_id: this.topic_category_at_initialization,
				topic_id: this.topic_id,
			});
		},
	});

	/**
	 * ComViews.CategoryCell is a header + tags for a single category that is a forum or a view.
	 *
	 * model : VineModels.Category
	 *
	 * $active_triangle : Little triangle marker that sits under active aspect of
	 *     	tag cloud/topic list
	 * can_bookmark : Can this Category be bookmarked
	 * $category_heading : top bar of the box
	 * $category_description : description bar on the bottom of the box
	 * itembox : ComViews.Itembox for the tag cloud
	 * $itembox_bar : Bar underneath "Popular Tags"
	 * $itembox_container : div that holds the Itembox
	 * $topic_bar : Little bar underneath "Topics" listing
	 * topic_box : ComViews.CategoryCellTopics for this category
	 * topic_box_constructed : is the Topics box for this category (if any)
	 *  	already constructed?
	 *
	 */
	ComViews.CategoryCell = AoPS.View.extend({
		template_id: "#cmty-category-cell-tpl",

		className: "cmty-category-cell",

		can_bookmark: false,

		has_own_url: false,

		has_search: false,

		has_small_header: false,

		// set to true to replace "TAGS" with "FORUMS" in the navigation box.
		//  Used for bookmarked forums, is also the trigger to use the topic's category
		//  on the topic cells inside the topic list of the category cell.
		forums_not_tags: false,

		default_to_tags: true,

		force_to_tags: false,

		has_topics: true, // TODO: Change "has_topics" to "has_numbers", I think

		fetch_topics_immediately: false,

		has_numbers: true,

		has_items: true,

		has_help: false,

		has_search_link: false,

		has_bottom: true,

		has_jump_to_top: false,

		placeholder_text: Lang["cat-cell-no-tags-yet"],

		use_own_color: true,

		topics_box_constructor: ComViews.CategoryCellTopics,

		items_box_constructor: ComViews.Itembox,

		topic_box_constructed: false,

		//stay_in_router : true, DELETE 11/15

		tags_topics_in_topbar: false,

		topics_title: Lang["cat-cell-forum-topics"],

		items_title: Lang["cat-cell-tags-title"],

		show_description: false,

		initialize: function (options) {
			var category_type = Utils.displayCategoryType(
					this.model.get("category_type")
				),
				has_info = this.model.get("category_id") > 1, // Set 1 to 0 to turn the info page on for private messages
				can_add =
					this.model.get("can_add_type") !== "none" &&
					this.model.get("master").fetchPermission("can_create_category"), // TODO : clean
				template_data,
				can_unlock = this.model.getPermission("c_can_lock_category"),
				can_add_title = can_add
					? Lang["Create"] + " new " + this.model.get("can_add_type")
					: "";

			if (
				options.hasOwnProperty("default_to_topics") &&
				options.default_to_topics
			) {
				this.default_to_tags = false;
			} else if (
				!this.force_to_tags &&
				this.model.has("active_topics") &&
				(this.model.get("all_topics_loaded") ||
					this.model.get("active_topics").length > 3)
			) {
				this.default_to_tags = false;
			}
			ComViews.setRouteInfo(this, options);

			this.constructUrls(has_info);

			var can_post =
				this.model.get("can_start_topic") &&
				!this.model.get("is_locked") &&
				(this.model.getPermission("c_undo_global_ban") ||
					AoPS.hasFreeResourceAccess() ||
					ComViews.in_academy);

			template_data = {
				has_small_header: this.has_small_header,
				category_name: this.model.get("category_name"),
				short_description: this.model.get("short_description"),
				long_description:
					this.model.get(
						"short_description"
					) /** NEWNEWNEW was long_description; if keep, change the template **/,
				url: AoPS.Community.Views.makeLinkUrl(
					this.url,
					this.url_router_base + this.url_cmty_path
				),
				push_state_stay: this.push_state_attribute,
				can_post: can_post,
				is_locked:
					this.model.get("can_own_topics") && this.model.get("is_locked"),
				lang_category_locked_title: can_unlock
					? Lang["cat-cell-forum-locked-title-mod"]
					: Lang["cat-cell-forum-locked-title"],
				Locked: Lang["cat-cell-Locked"],
				can_unlock: can_unlock,
				can_add: can_add,
				can_add_title: can_add_title,
				hide_desc_phone: this.model.get("hide_desc_on_phone"),
				has_numbers: this.has_numbers,
				has_items: this.has_items,
				has_jump_to_top: this.has_jump_to_top,
				show_description:
					!(this.has_numbers || this.has_topics) || this.show_description,
				has_bottom: this.has_bottom,
				can_bookmark: this.can_bookmark,
				mark_read: Lang["cat-cell-mark-read"],
				new_post: this.model.get("is_private")
					? Lang["cat-cell-new-message"]
					: Lang["cat-cell-new-topic"],
				category_id: this.model.get("category_id"),
				can_mark_all_read:
					AoPS.session.logged_in_and_initialized &&
					this.model.get("can_mark_all_read"),
				has_info: has_info, //TODO
				has_search_link:
					this.has_search_link &&
					_.indexOf(
						Constants.unsearchable_fora,
						this.model.get("category_id")
					) == -1, //TODO may not need forum_class?
				//	url_info : AoPS.Community.Views.makeLinkUrl(this.url_info),
				lang_search: this.model.get("is_private")
					? Lang["cat-cell-search-pm"]
					: Lang["cat-cell-search-forum"],
				lang_information:
					Utils.capitalizeFirstLetter(category_type) +
					" " +
					Lang["information"],
				lang_mark_read_title: Lang["cat-cell-mark-read-title"],
				lang_bookmark_title: Lang["cat-cell-bookmark-title"] + category_type,
				lang_new_topic_title: this.model.get("is_private")
					? Lang["cat-cell-new-pm-title"]
					: Lang["cat-cell-new-topic-title"],
				lang_additional_options: Lang["cat-cell-more-options-title"],
				has_help: this.has_help,
				has_search: this.has_search,
				lang_help_title: Lang["cat-cell-help-title"],
			};

			this.$el.html(this.getTemplate(this.template_id, template_data));

			/**
			 * Text of "POPULAR TAGS" or "POPULAR FORUMS" controlled via
			 *  CSS in order to deal with responsive design.
			 */
			if (this.forums_not_tags) {
				this.$el.addClass("cmty-forums-not-tags");
			}

			if (this.model.get("can_own_topics")) {
				this.listenTo(this.model, "change:is_locked", this.parseLockStatus);
			}
			this.$category_heading = this.$el.find(".cmty-category-cell-heading");
			this.$new_topic = this.$category_heading.find(".cmty-new-topic-button");
			this.$locked = this.$category_heading.find(
				".cmty-category-locked-button"
			);
			this.$category_description = this.$el.find(".cmty-category-description");
			this.$menu = this.$el.find(".cmty-cat-cell-menu");

			if (this.has_items || this.has_topics) {
				this.$itembox_container = this.$el.find(
					".cmty-category-itembox-wrapper"
				);
			}

			if (this.has_items) {
				this.$itembox_bar = this.$el.find(".cmty-category-cell-poptags");
				this.$active_triangle = this.$el.find(
					".cmty-category-cell-sublink-triangle"
				);
				if (this.$itembox_bar.length > 0) {
					this.$itembox_bar[0].title = this.items_title;
				}
				if (this.default_to_tags) {
					this.onClickPopularTags();
				}
			}

			if (this.has_numbers) {
				this.$num_topics = this.$el.find(".cmty-category-cell-num-topics");
				this.$num_users = this.$el.find(".cmty-category-cell-num-users");
				this.setNumTopics();
				//this.setNumPosts();
				this.setNumUsers();

				this.listenTo(this.model, "change:num_topics", this.onChangeNumTopics);
				this.listenTo(this.model, "change:num_posts", this.setNumPosts);
				this.listenTo(this.model, "change:num_users", this.onChangeNumUsers);
			}

			if (this.has_search) {
				this.buildCategorySearch();
			}

			this.applyColor();

			if (this.has_topics) {
				this.$topic_bar = this.$el.find(".cmty-category-cell-topics");
				if (!this.default_to_tags) {
					this.onClickTopics();
				}
				if (this.$topic_bar.length > 0) {
					this.$topic_bar[0].title = this.topics_title;
				}
			}

			if (
				this.model.get("can_mark_all_read") &&
				AoPS.session.logged_in_and_initialized
			) {
				this.parseAllRead();
				this.listenTo(this.model, "change:all_read", this.parseAllRead);
			}

			if (this.tags_topics_in_topbar) {
				this.$(".cmty-category-cell-right").append(this.$topic_bar);
				this.$(".cmty-category-cell-right").append(this.$itembox_bar);
			}
			this.listenTo(this.model, "change:deleted", this.onDeleteCategory);

			// check if we need to pull up the post editor for a new topic
			if (AoPS.bd.post_topic) {
				var post_topic_vars = AoPS.bd.post_topic_vars;
				this.launchNewTopic({
					category_id: post_topic_vars.category_id,
					topic_title: post_topic_vars.title,
					special_item: post_topic_vars.linked_tag_text,
					target_url: post_topic_vars.target_url,
					target_url_application: post_topic_vars.application || null,
					target_text: post_topic_vars.target_text,
					tags: [
						...post_topic_vars.additional_tag_texts,
						post_topic_vars.linked_tag_text,
					],
					content:
						"[b]What I've tried so far:[/b]\n\n" +
						"<Describe what you have tried so far here. That way, we can do a better job helping you!>\n\n" +
						"[b]Where I'm stuck:[/b]\n\n" +
						"<Describe what's confusing you, or what your question is here!>",
				});
			}
		},

		parseLockStatus: function () {
			if (this.model.get("can_own_topics")) {
				this.$new_topic.toggleClass(
					"force-hidden",
					this.model.get("is_locked")
				);
				this.$locked.toggleClass("force-hidden", !this.model.get("is_locked"));
			}
		},

		constructUrls: function (has_info) {
			this.url = this.has_own_url
				? this.own_url
				: "/c" +
					this.model.get("category_id") +
					"_" +
					ComViews.convertToUrlFragment(this.model.get("category_name"));

			this.url_info = has_info
				? "/category-admin/" + this.model.get("category_id")
				: "";
		},

		events: {
			"mouseenter .cmty-full-cell-link": "onHoverHeading",
			"mouseleave .cmty-full-cell-link": "onUnhoverHeading",
			"click .cmty-category-cell-poptags": "onClickPopularTags",
			"click .cmty-category-cell-topics": "onClickTopics",
			"click .cmty-new-topic-button": "onClickLaunchNewTopic",
			"click .cmty-category-cell-heading": "onClickHeading",
			"click .cmty-mark-all-read": "onClickMarkAllRead",
			"click .cmty-cat-cell-cat-info": "onClickInfo",
			"click .cmty-add-new-category": "onClickAddNew",
			"click .cmty-cat-admin-help-wrap": "onClickHelp",
			"click .cmty-category-locked-button": "onClickLocked",
			"click .cmty-cat-cell-search": "onClickSearch",
		},

		onDeleteCategory: function () {
			if (this.model.get("deleted")) {
				this.close();
			}
		},

		onClickLocked: function (e) {
			if (this.model.getPermission("c_can_lock_category")) {
				this.onClickLaunchNewTopic(e);
				return;
			}

			ComViews.showError(Lang["cat-cell-locked-modal"]);

			e.stopPropagation();
			e.preventDefault();
		},

		onClickAddNew: function (e) {
			if (this.model.get("can_add_type") === "forum") {
				ComViews.followUrlOnClick(e, "/category-admin/forum");
			}
			if (this.model.get("can_add_type") === "collection") {
				AoPS.Ui.Modal.showAlert(
					this.getTemplate("#cmty-create-collection-modal-body-tpl", {}),
					{
						title: Lang["cat-cell-create-collection"],
						alert_button_ok: Lang["Cancel"],
						width: "600px",
					}
				);
			}

			if (this.model.get("can_add_type") === "blog") {
				ComViews.followUrlOnClick(e, "/category-admin/blog");
			}

			e.preventDefault();
			e.stopPropagation();
		},

		onClickSearch: function (e) {
			var url =
				this.model.get("category_id") == 1
					? "/search-private"
					: "/search-forum/" + this.model.get("category_id");

			if (this.url_router_base === "/community") {
				ComViews.followUrlOnClick(e, url);
			} else {
				ComViews.leaveRouterOnClick(e, url);
			}
		},

		/** DELETE 11/15
		 * This is here because IE10 is stone-cold-stupid.  It won't see the span
		 *  that makes this whole topic cell a link unless the user is not hovering
		 *  over text.  That's stupid.  So, to get click to work, we need this.
		 *  But we want right-click and ctrl-click to work wherever we can, so
		 *  we have to keep the span-based link, which is constructed in the template.
		 *
		 * People who use IE probably don't know about Ctrl-click or right click,
		 *  so having that only work sometimes on IE is probably OK, and those
		 *  people get what they deserve.
		 *
		 * Need to overwrite in some of the children, like bookmarks
		 */
		/*onClickHeading : function (e) {
			// TODO REVISIT THIS FOR THE IE issue
			// AARRRGH I hate IE
			if (this.stay_in_router) {
				ComViews.followUrlOnClick(e, this.url, this.url_router_base, this.url_cmty_path);
			} else {
				ComViews.leaveRouterOnClick(e, this.url);
			}

		},*/

		onClickInfo: function (e) {
			if (this.url_router_base === "/community") {
				ComViews.followUrlOnClick(e, this.url_info);
			} else {
				ComViews.leaveRouterOnClick(e, this.url_info);
			}
		},

		onClickMarkAllRead: function (e) {
			this.model.markAllTopicsRead();
			e.preventDefault();
			e.stopPropagation();
			return false;
		},

		onClickHelp: function (e) {
			var message = this.getTemplate(this.help_template, {
				is_logged_in: AoPS.session.logged_in,
				is_initialized: AoPS.session.is_initialized,
			});
			if (this.help_template.length === 0) {
				console.log(
					"oh no; there is a help box on a category with no help_template set."
				);
			}

			AoPS.Ui.Modal.showAlert(message, {
				title: Lang[this.help_template_title_setting],
				width: "450px",
				scrollable: true,
			});

			e.preventDefault();
			e.stopPropagation();
		},

		/**
		 * Overwritten in CategoryCellCategoryTop, so only put material here
		 *  for the Category Cells inside folders, etc.
		 **/
		onAddToPage: function () {
			if (this.hasOwnProperty("topic_box")) {
				this.topic_box.on_page = true;
				this.checkNeedLoadTopics();
			}
		},

		/**
		 * Overwritten in CategoryCellCategoryTop, so only put material here
		 *  for the Category Cells inside folders, etc.
		 **/
		onRemoveFromPage: function () {
			if (this.hasOwnProperty("topic_box")) {
				this.topic_box.on_page = false;
			}
		},

		onHoverHeading: function (e) {
			if (this.use_own_color) {
				this.$category_heading.find(".cmty-category-cell-left").css({
					color: "#fff",
				});
			}
		},

		onUnhoverHeading: function (e) {
			if (this.use_own_color) {
				this.$category_heading.find(".cmty-category-cell-left").css({
					color: this.model.get("secondary_color"),
				});
			}
		},

		/**
		 * What we do if we click on the popular tags link.
		 */
		onClickPopularTags: function (e) {
			if (!this.hasOwnProperty("itembox")) {
				this.constructItembox();
			}
			this.itembox.$el.show();
			if (this.topic_box_constructed) {
				this.topic_box.$el.hide();
			}
			this.topic_box_revealed = false;
			this.setBars(this.$itembox_bar, this.$topic_bar);
			if (arguments.length > 0) {
				e.stopPropagation();
			}
		},

		/**
		 * What we do if we click on the topics link.
		 *  Note that the topics box is not built upon
		 *  the construction of this View.  The topics box
		 *  is built the first time we request it.
		 */
		onClickTopics: function (e) {
			if (!this.topic_box_constructed) {
				this.constructTopicBox();
			}
			if (this.hasOwnProperty("itembox")) {
				this.itembox.$el.hide();
			}
			this.topic_box.$el.show();
			this.topic_box.on_page = true;
			this.topic_box_revealed = true;
			this.checkNeedLoadTopics();
			this.setBars(this.$topic_bar, this.$itembox_bar);
			if (arguments.length > 0) {
				e.stopPropagation();
			}
		},

		/**
		 * Some collections get reset upon changes to their categories' items.
		 *  (Bookmarks are the main culprit.)  If this happens, then the list will be
		 *  emptied.  So, whenever we add the topic list to the page, we have
		 *  to check and see if this unfortunate event occurred, so that we know
		 *  to go get more topics.
		 */
		checkNeedLoadTopics: function () {
			if (this.topic_box_revealed && this.topic_box.collection.length === 0) {
				this.topic_box.checkMoreTopicsNeeded();
			}
		},

		parseAllRead: function () {
			this.$el.toggleClass("cmty-all-read", this.model.get("all_read"));
		},

		buildCategorySearch: function () {
			/*
			placeholder removed because at some widths, we can't have it, and I can't
			figure out how to CSS it away.

			*/

			var $new_input = $(
				'<input type="search" class="cmty-tag-search-input" placeholder="' +
					Lang["cat-search-placeholder-" + this.model.get("category_id")] +
					'"></input>'
			);

			Utils.buildCategoryAutocomplete($new_input, {
				ajax_call: this.category_search_autocomplete,
				has_search_icon: true,

				autocomplete_settings: {
					onSelect: function (e, ui) {
						$new_input.val("");
						$new_input.autocomplete("close");
						//$new_input.remove();
						//self.buildCategorySearch();
						Backbone.history.navigate(
							"/c" +
								ui.item.category_id +
								"_" +
								ComViews.convertToUrlFragment(ui.item.label),
							{trigger: true}
						);
						e.stopPropagation();
						e.preventDefault();
					},
				},
				show_no_results_msg: true,
			});

			$new_input.parent().on("click touchstart", function (e) {
				$new_input.focus();
				e.stopPropagation();
				e.preventDefault();
			});

			this.$el.find(".cmty-category-cell-right").append($new_input.parent());
		},

		/**
		 * Animation when the number of topics changes.
		 **/
		onChangeNumTopics: function () {
			var self = this,
				$cell = this.$num_topics.find(".cmty-category-cell-number");
			$cell.fadeOut(300, function () {
				self.setNumTopics();

				$cell.show();
			});
		},

		/**
		 * Set the number of topics cell.
		 **/
		setNumTopics: function () {
			// TODO remove the has check below?
			var num_topics = this.model.has("num_topics")
					? Utils.renderNumberWithCommas(this.model.get("num_topics"))
					: "1,729",
				topic_tag =
					num_topics === 1 ? Lang["cat-cell-topic"] : Lang["cat-cell-topics"];

			this.$num_topics.html(
				this.getTemplate("#cmty-category-cell-num-topics-tpl", {
					num_topics: num_topics + " " + topic_tag,
					url: AoPS.Community.Views.makeLinkUrl(this.url),
				})
			);
			var findTopics = this.$num_topics.find("a");
			if (findTopics.length) {
				findTopics[0].style.color = this.model.get("main_color");
			}
		},

		/**
		 * Set the number of posts in the topics number title.
		 **/
		setNumPosts: function () {
			// TODO remove the has check below?
			var num_posts = this.model.has("num_posts")
					? this.model.get("num_posts")
					: 1030401,
				post_tag =
					num_posts === 1 ? Lang["cat-cell-post"] : Lang["cat-cell-posts"];
			this.$num_topics[0].title = num_posts + " " + post_tag;
		},

		/**
		 * Animation when the number of users changes.
		 **/
		onChangeNumUsers: function () {
			var self = this,
				$cell = this.$num_users.find(".cmty-category-cell-number");

			$cell.fadeOut(300, function () {
				self.setNumUsers();
				$cell.show();
			});
		},

		/**
		 * Set the number of users cell.
		 **/
		setNumUsers: function () {
			var num_users = this.model.has("num_users")
					? this.model.get("num_users")
					: 31,
				num_users_tag =
					num_users === 1 ? Lang["cat-cell-user"] : Lang["cat-cell-users"];

			this.$num_users.html(
				this.getTemplate("#cmty-category-cell-num-users-tpl", {
					num_users: num_users + " " + num_users_tag,
				})
			);
			if (this.$num_users[0]) {
				this.$num_users[0].title = Lang["cat-cell-num-user-title"];
			}
		},

		/**
		 * Set the bars beneath the Popular Tags and Recent
		 *  Topics appropriately.
		 *
		 * @param $obj : Bar under the active topic
		 * @param $obj : Bar under the inactive topic
		 */
		setBars: function ($active, $inactive) {
			$active.addClass("active-sublink").append(this.$active_triangle);
			if (!_.isUndefined($inactive)) {
				$inactive.removeClass("active-sublink");
			}
		},

		/**
		 * Build the Itembox for this category
		 **/
		constructItembox: function () {
			this.itembox = new this.items_box_constructor({
				model: this.model,
				placeholder_text: this.placeholder_text,
				url_router_base: this.url_router_base,
				url_cmty_path: this.url_cmty_path,
				scrollbar_arguments: {
					autosize_exclusions: [
						{
							min: 841,
							max: 100000,
						},
					],
				},
				push_state_attribute: this.push_state_attribute,
			});
			this.$itembox_container.append(this.itembox.$el);
		},

		/***
		 * Build the list of topics for this category.
		 */
		constructTopicBox: function () {
			var topic_list = this.model.get("master").fetchFilteredTopicList({
				category: this.model,
				category_id: this.model.get("category_id"),
				tag_ids: [],
			});
			//			console.log('build topics in ');
			//			var start_time = new Date().getTime();
			this.topic_box = new this.topics_box_constructor({
				collection: topic_list,
				main_color: this.model.get("main_color"),
				secondary_color: this.model.get("secondary_color"),
				master: this.model.get("master"),
				category_id: this.model.get("category_id"),
				suppress_initial_fetch: !(
					this.default_to_tags || this.fetch_topics_immediately
				), //Don't go loading more topics when you throw this cell on the page
				use_topic_category: this.forums_not_tags,
			});
			//			console.log(new Date().getTime() - start_time);
			this.$itembox_container.append(this.topic_box.$el);

			this.topic_box_constructed = true;

			/**
			 * Forums with few topics will have an obvious dissonance between the
			 *  forum's little cells and the number of listed topics.  For example,
			 *  a forum with 1 announcement and no other topics
			 *  will say 1 topic, but have no topics in the grid.
			 *  So, we go ahead and show the announcement if there aren't many topics.
			 *  A forum with just 6 announcements deserves what it gets.
			 **/
			if (
				this.model.get("is_forum") &&
				this.model.has("num_topics") &&
				this.model.get("num_topics") < 6
			) {
				this.$el.addClass("cmty-short-forum");
			}
		},

		/**
		 * applyColor puts the relevant category colors on everything.
		 */
		applyColor: function () {
			var main_color = this.model.get("main_color"),
				secondary_color = this.model.get("secondary_color");
			if (this.use_own_color) {
				this.$category_heading.css({
					"background-color": main_color,
					color: secondary_color,
				});
				this.$el.find(".cmty-category-cell-numbers").css({
					color: main_color,
				});
			}
		},

		/**
		 * Utility: close subviews.
		 */
		onClose: function () {
			if (this.hasOwnProperty("itembox")) {
				this.itembox.close();
			}
			if (this.hasOwnProperty("topic_box")) {
				this.topic_box.close();
			}
			if (this.hasOwnProperty("tag_filter")) {
				this.tag_filter.close();
			}
		},
		onClickLaunchNewTopic: function (e, new_topic_overrides) {
			e.preventDefault();
			e.stopPropagation();

			this.launchNewTopic(new_topic_overrides);
		},

		/**
		 * launchNewTopic fires up the post topic atop the page.
		 *
		 */
		launchNewTopic: function (new_topic_overrides) {
			var new_topic_parameters;

			// Check for general access
			if (
				!ComViews.hasCommunityGeneralAccess(
					"new-topic-not-logged-in",
					"cat-cell-no-perm-free-resource",
					this.model.getPermission("c_undo_global_ban")
				)
			) {
				return false;
			} else if (
				!this.model.getPermission("c_can_start_topic") &&
				!this.model.getPermission("c_undo_global_ban")
			) {
				AoPS.Ui.Modal.showMessage(Lang["cat-cell-no-perm-start-topic"], {
					width: "450px",
				});
			} else {
				new_topic_parameters = {
					model: this.model,
					master: this.model.get("master"),
					url_cmty_path: this.url_cmty_path,
					...new_topic_overrides,
				};

				// new_topic_parameters.tags = arguments[1].tags;

				if (!_.isNull(this.model.get("master").get("focus_tag"))) {
					new_topic_parameters.tags = [
						this.model.get("master").get("focus_tag").item_text,
					];
				}
				// eslint-disable-next-line no-new
				new ComViews.NewTopic(new_topic_parameters);
			}
			return false;
		},
	});

	ComViews.CategoryCellBlog = ComViews.CategoryCell.extend({
		className:
			ComViews.CategoryCell.prototype.className +
			" cmty-category-cell-blog cmty-category-cell-folder ",

		template_id: "#cmty-category-cell-blog-tpl",

		has_items: false,

		default_to_tags: false,

		has_numbers: false,

		//stay_in_router : false, DELETE 11/15

		use_own_color: false,

		initialize: function (options) {
			// exclude the shoutbox if it exists.
			var num_topics = this.model.get("num_topics"),
				entries_msg = num_topics + " ";

			ComViews.CategoryCell.prototype.initialize.apply(this, [options]);
			this.$(".cmty-blog-cell-avatar").append(
				'<img src="' +
					this.model.get("creator_avatar") +
					'" width="52" height="52">'
			);
			if (num_topics === 1) {
				entries_msg += Lang["blog-Entry"];
			} else {
				entries_msg += Lang["blog-Entries"];
			}
			this.$(".cmty-blog-cell-entry-count").html(entries_msg);
		},
	});

	ComViews.CategoryCellMyBooks = ComViews.CategoryCell.extend({
		has_topics: false,

		has_numbers: false,

		placeholder_text: "BOOKS WILL BE HERE",

		can_bookmark: false,

		has_own_url: true,

		own_url: "MYBOOKSURL",

		onClickHeading: function () {
			//TODO -- point to the right place.
		},
	});

	ComViews.CategoryCellMyClasses = ComViews.CategoryCell.extend({
		has_topics: false,

		can_bookmark: false,

		has_numbers: false,

		placeholder_text: "CLASSES WILL BE HERE",

		has_own_url: true,

		own_url: "MYCLASSESURL",

		onClickHeading: function () {
			//TODO -- point to the right place.
		},
	});

	ComViews.CategoryCellFolder = ComViews.CategoryCell.extend({
		className:
			ComViews.CategoryCell.prototype.className +
			" cmty-category-cell-folder  cmty-category-cell-no-numrow",

		has_topics: false,

		placeholder_text: Lang["cat-cell-no-items-yet"],

		can_bookmark: false,

		has_numbers: false,

		use_own_color: false,

		applyColor: function () {
			var main_color = this.model.get("main_color");

			this.$category_heading.css({
				"border-top": "5px solid " + main_color,
			});
			this.$el.find(".cmty-category-cell-title").css({
				color: main_color,
			});
		},
	});

	ComViews.CategoryCellBookmarkUsers = ComViews.CategoryCellFolder.extend({
		placeholder_text: Lang["cat-cell-no-users-bookmarked"],
	});

	ComViews.CategoryCellMyBookmarks = ComViews.CategoryCellFolder.extend({
		has_own_url: true,

		has_numbers: false,
		// URLHERE
		own_url: "/my-bookmarks", // We have a custom route for mybookmarks because the my bookmarks category is
		// wholly synthetic on the front end.  We may change our minds about this.  This route has not yet been built.

		/** Grr IE 10 **/
		onClickHeading: function (e) {
			//URLHERE
			ComViews.followUrlOnClick(e, "/my-bookmarks");
		},
	});

	ComViews.CategoryCellForumView = ComViews.CategoryCell.extend({
		className:
			ComViews.CategoryCell.prototype.className + " cmty-category-cell-folder",

		can_bookmark: false,

		has_numbers: false,

		show_description: false,

		use_own_color: false,

		tags_topics_in_topbar: true,

		topics_title: Lang["cat-cell-forum-view-topics"],

		items_title: Lang["cat-cell-items-title-forum-view"],

		forums_not_tags: true,
	});

	ComViews.CategoryCellForumBookmarks = ComViews.CategoryCellForumView.extend({
		placeholder_text: Lang["bookmark-no-forums-bookmarked"],

		items_title: Lang["cat-cell-items-title-forum-bookmark"],
	});

	ComViews.CategoryCellTagView = ComViews.CategoryCell.extend({
		className:
			ComViews.CategoryCell.prototype.className +
			" cmty-category-cell-view-tags cmty-category-cell-folder",

		can_bookmark: false,

		has_numbers: false,

		show_description: false,

		use_own_color: false,

		topics_title: Lang["cat-cell-tag-view-topics"],

		items_title: Lang["cat-cell-items-title-tag-view"],

		tags_topics_in_topbar: true,

		applyColor: ComViews.CategoryCellFolder.prototype.applyColor,
	});

	ComViews.CategoryCellPostView = ComViews.CategoryCell.extend({
		className:
			ComViews.CategoryCell.prototype.className + " cmty-category-cell-folder",

		can_bookmark: false,

		placeholder_text: Lang["cat-cell-no-posts-yet"],

		has_numbers: false,

		use_own_color: false,

		has_topics: false,

		items_box_constructor: ComViews.ItemboxPosts,

		applyColor: function () {
			var main_color = this.model.get("main_color");
			this.$category_heading.css({
				"border-top": "5px solid " + main_color,
			});
			this.$el.find(".cmty-category-cell-title").css({
				color: main_color,
			});
		},
	});

	ComViews.CategoryCellTagBookmarks = ComViews.CategoryCellTagView.extend({
		placeholder_text: Lang["bookmark-no-tags-bookmarked"],

		items_title: Lang["cat-cell-items-title-tag-bookmark"],
	});

	ComViews.CategoryCellTopicView = ComViews.CategoryCell.extend({
		can_bookmark: false,

		className:
			ComViews.CategoryCell.prototype.className + " cmty-category-cell-folder", //cmty-category-cell-view-topics',

		has_items: false,

		use_own_color: false,

		has_numbers: false,

		default_to_tags: false,

		fetch_topics_immediately: false,
	});

	ComViews.CategoryCellTopicBookmarks = ComViews.CategoryCellTopicView.extend({
		placeholder_text: Lang["bookmark-no-topics-bookmarked"],
	});

	ComViews.CategoryCellMyPrivates = ComViews.CategoryCell.extend({
		can_bookmark: false,

		default_to_tags: false,

		has_numbers: false,

		topics_box_constructor: ComViews.CategoryCellPrivatesTopics,

		// TODO:
		// Think about whether or not I really need the forum/private distinction.  Is the cat_id enough?
		// Get the new topic tagged "private" on the submit to the database.
		// Make it so that clicking on new topic doesn't go down a route (in the category cell box)
		// Make the recipients appear in the view for the full topic.

		/*	has_own_url : 'true',

		own_url : '#my-private-conversations', // We have a custom route for mybookmarks because the my bookmarks category is
		// wholly synthetic on the front end.  We may change our minds about this.  This route has not yet been built.

		// GRR IE 10
		onClickHeading : function () {
			Backbone.history.navigate('#my-private-conversations', {trigger : true});
		},*/
		onClickLaunchNewTopic: function (e) {
			if (!AoPS.session.initialized) {
				AoPS.Initialize.display({escapable: true});
			} else if (AoPS.isUserCoppaBlocked()) {
				AoPS.displayCoppaBlockedModal({escapable: true});
			} else if (!AoPS.in_academy && !AoPS.hasFreeResourceAccess()) {
				const message = Lang["new-pm-no-permission-free-resource"];
				AoPS.Ui.Modal.showMessage(message, {
					width: "450px",
				});
			} else if (
				!this.model.getPermission("c_can_start_topic") &&
				!this.model.getPermission("c_undo_global_ban")
			) {
				AoPS.Ui.Modal.showMessage(Lang["new-pm-no-permission"], {
					width: "450px",
				});
			} else {
				// eslint-disable-next-line no-new
				new ComViews.NewPrivateConversation({
					// TODO : Improve this!
					category_name: "", // PROBABLY put all of these in NewPrivateConversation as defaults.
					category_id: Constants.private_messages_id,
					model: this.model,
					master: this.model.get("master"),
				});
			}
			if (!_.isUndefined(e)) {
				e.stopPropagation();
				e.preventDefault();
				return false;
			}
		},
	});

	ComViews.CategoryCellOtherForums = ComViews.CategoryCellFolder.extend({
		category_search_autocomplete: "fetch_forum_autocomplete",

		has_search: true,

		className:
			ComViews.CategoryCell.prototype.className +
			" cmty-category-cell-no-numrow cmty-category-cell-folder",
	});

	ComViews.CategoryCellSpecialCollections = ComViews.CategoryCellFolder.extend({
		category_search_autocomplete:
			"fetch_folder_collections_contents_autocomplete",

		has_search: true,

		className:
			ComViews.CategoryCell.prototype.className +
			" cmty-category-cell-no-numrow cmty-category-cell-folder",
	});

	/**
	 * Category cell on top of a view of a single category.
	 *
	 *
	 */

	ComViews.category_cell_category_top_new_properties = {
		num_matches: 15, // Number of matches to show when tag searching

		default_to_tags: true,

		has_small_header: true,

		force_to_tags: true,

		has_jump_to_top: true,

		initialize: function (options) {
			// TODO do we really need forum_class here?
			if (this.model.get("is_forum")) {
				if (!this.model.get("is_private")) {
					this.can_bookmark = true;
				}
				this.has_search_link = true;
			}

			if (this.model.get("special_url").length > 0) {
				this.url = this.model.get("special_url");
				this.constructUrls = function () {};
			}

			ComViews.CategoryCell.prototype.initialize.apply(this, [options]);

			// Make the text for the heading white.
			if (
				this.model.get("category_type") === "forum" ||
				this.model.get("category_type") === "my_privates"
			) {
				this.$category_heading.find(".cmty-category-cell-left").css({
					color: "#fff",
				});
			}

			if (this.model.get("has_tag_filter")) {
				this.tag_filter = new ComViews.CategoryTagFilter(options);
				this.$itembox_container.before(this.tag_filter.$el);
			}
			if (this.can_bookmark) {
				this.$bookmark = this.$el.find(".cmty-category-cell-bookmark");
				this.setForumBookmarkStatus();
				this.listenTo(
					this.model,
					"change:is_bookmarked change:is_watched change:in_feed",
					this.setForumBookmarkStatus
				);
			}

			if (this.model.get("is_private") && !this.model.get("is_archive")) {
				this.setArchivedButton();
			}

			this.listenTo(
				this.model,
				"reset_tag_bookmark",
				this.setTagBookmarkStatus
			);
		},

		setArchivedButton: function () {
			var $button_row = this.$category_heading.find(
				".cmty-category-cell-right"
			);

			$button_row.prepend(
				'<span title="' +
					Lang["private-archive-title"] +
					'"\
				 class="cmty-category-cell-archive cmty-icon-w-text clickable"><span class="cmty-cat-cell-aops-font-icon">(</span>\
				 <span class="cmty-cat-cell-symbol-tag">' +
					Lang["private-View-Archive-btn"] +
					"</span></span>&nbsp;"
			);
		},

		events: _.extend(
			{
				"click .cmty-category-cell-bookmark": "onClickForumBookmark",
				"click .cmty-category-cell-archive": "onClickArchive",
			},
			ComViews.CategoryCell.prototype.events
		),

		onAddToPage: function () {
			if (this.model.get("has_tag_filter")) {
				this.tag_filter.onAddToPage();
			}
			if (this.has_topics && this.model.has("master")) {
				this.insertFocusTag();
			}
		},

		onRemoveFromPage: function () {
			if (this.has_topics && this.model.has("master")) {
				this.removeFocusTag();
			}
		},

		/**
		 * Insert a shadow tag in the category cell that we
		 *  need in Tablet or Phone view because the focus tag box is
		 *  removed from the category cell.
		 **/
		insertFocusTag: function () {
			var $item, curr_url, tag_val, url, focus_tag;

			if (_.isNull(this.model.get("master").get("focus_tag"))) {
				return;
			}

			focus_tag = _.clone(this.model.get("master").get("focus_tag"));
			focus_tag.item_can_remove = true;
			$item = this.itembox.constructItem(focus_tag);
			var $item_div = $item.find(".cmty-item-tag");
			$item_div
				.css({
					"background-color": focus_tag.item_secondary_color,
					color: focus_tag.item_main_color,
					border: "1px solid " + focus_tag.item_main_color,
				})
				.on("mouseleave", function (e) {
					$item_div.css({
						"background-color": focus_tag.item_secondary_color,
						color: focus_tag.item_main_color,
					});
				});

			$item.addClass("cmty-cat-cell-focus-shadow cmty-tablet-inline");

			this.itembox.$itembox.prepend($item);

			/**
			 * The itembox's constructItem method puts a URL on the
			 *  tag that points at the tag itself.  Here, we point it
			 *  back at the category for the "remove tag" functionality
			 **/
			curr_url = $item.attr("href");
			tag_val = curr_url.match(/t\d+f\d+/);
			if (!_.isNull(tag_val)) {
				url = curr_url.split(tag_val)[0];
				$item.attr("href", url);
			}

			this.$focus_tag = $item;
		},

		removeFocusTag: function () {
			if (this.hasOwnProperty("$focus_tag")) {
				this.$focus_tag.remove();
			}
		},

		onClickArchive: function (e) {
			ComViews.followUrlOnClick(e, "/my-messages-archive");
		},

		/**
		 * Action when we click on the forum-level bookmark.
		 */
		onClickForumBookmark: function (e) {
			e.preventDefault();
			e.stopPropagation();

			// Check for general access
			if (
				!ComViews.hasCommunityGeneralAccess(
					"bookmark-not-logged-in",
					"bookmark-free-resource",
					this.model.getPermission("c_undo_global_ban")
				)
			) {
				return false;
			} else {
				if (this.model.get("is_bookmarked")) {
					// Currently bookmarked, remove the bookmark
					this.model.setBookmarkState({is_bookmarked: false});
				} else {
					// Give them their options for bookmarking
					ComViews.fireBookmarkModal(
						"forum",
						Utils.formatString(Lang["bookmark-modal-forum"], [
							this.model.get("category_name"),
						]),
						_.bind(this.model.setBookmarkState, this.model)
					);
				}
			}
		},

		/**
		 * Mix-in the setBookmarkStatus from TopicFull, since the actions for bookmarking
		 *  a topic and bookmarking a forum are the same.
		 */
		setForumBookmarkStatus: ComViews.TopicFull.prototype.setBookmarkStatus,

		/**
		 * What to do when we submit an entry to the tag box.
		 *  We head down the route for that tag.
		 *
		 * @param object : the new item (the ui.item from autocomplete)
		 *
		 * TODO : extend operation to work for views (get the forum_id into the autocomplete source
		 * TODO : Antonio if they don't pick a tag.
		 */
		submitNewItem: function (item) {
			var self = this;
			this.model.addItem({
				item_id: parseInt(item.item_id),
				item_type: "tag",
				item_forum_id: this.model.get("category_id"),
				item_text: item.value,
				item_main_color: item.main_color,
				item_secondary_color: item.secondary_color,
			});

			setTimeout(function () {
				self.$input_box.autocomplete("disable");
				self.$input_box.autocomplete("enable");

				Backbone.history.navigate(
					self.url_cmty_path +
						"/c" +
						self.model.get("category_id") +
						"t" +
						item.item_id +
						"f" +
						item.item_forum_id,
					{trigger: true}
				);
			}, 100);
			this.$input_box.val("");
		},

		onUnhoverHeading: function (e) {
			if (this.use_own_color) {
				this.$category_heading.find(".cmty-category-cell-left").css({
					color: "#fff",
				});
			}
		},

		onHoverHeading: function (e) {
			if (this.use_own_color) {
				this.$category_heading.find(".cmty-category-cell-left").css({
					color: this.model.get("secondary_color"),
				});
			}
		},
	};

	ComViews.CategoryTagFilter = AoPS.View.extend({
		template_id: "#cmty-category-cell-focus-tpl",

		has_own_url: false,

		className: "cmty-tag-filter",

		initialize: function (options) {
			this.focus_tag = options.focus_tag;
			if (this.model.get("special_url").length > 0) {
				this.url = this.model.get("special_url");
			} else {
				this.url =
					"/c" +
					this.model.get("category_id") +
					"_" +
					ComViews.convertToUrlFragment(this.model.get("category_name"));
			}

			ComViews.setRouteInfo(this, options);

			this.render();
			this.$focus_tag_line = this.$el.find(".cmty-focus-tag-line");

			this.$focus_tag_box = this.$focus_tag_line.parent();
			this.listenTo(
				this.model.get("master"),
				"change:focus_tag",
				this.onChangeFocusTag
			);

			this.listenTo(this.model, "tag_bookmarked", this.setTagBookmarkStatus);
		},

		render: function () {
			this.$el.html(
				this.getTemplate(this.template_id, {
					filter_placeholder: Lang["cat-cell-filter-placeholder"],
				})
			);
		},

		events: {
			"click .cmty-focus-tag-line .bkmk-icon": "onClickTagBookmark",
		},

		constructUrls: ComViews.CategoryCell.prototype.constructUrls,

		onAddToPage: function () {
			this.buildInputAutocomplete();
			this.setTagBookmarkStatus();
		},

		/**
		 * What to do when we change focus_tag; if we are focused on this category,
		 *  change the focus tag box.
		 */
		onChangeFocusTag: function () {
			if (this.model.get("master").get("focus_category") === this.model) {
				this.focus_tag = this.model.get("master").get("focus_tag");
				this.setFocusTag();
			}
		},

		/**
		 * This is here because I can't figure out how to get the *$@#$ing
		 *  jQuery autocomplete 'select' event to fire more than once.
		 *  There's a subtle timing issue that I've tried and tried to dig out,
		 *  but if you do anything during a select event with jQuery's autocomplete,
		 *  then sometimes it won't ever fire a 'select' event again, even though
		 *	it will still fire other events.  I get around this by simply
		 *	rebuilding the autocompletes whenever I need them.  Unfortunately,
		 *  this forces building one every time this view is loaded.
		 **/
		buildInputAutocomplete: function () {
			var $new_input = $(
					'<input type="search" class="cmty-tag-search-input" placeholder="' +
						Lang["cat-cell-filter-placeholder"] +
						'"></input>'
				),
				self = this;

			if (this.hasOwnProperty("$input_box")) {
				this.$input_box.parent().replaceWith($new_input);
			} else {
				this.$focus_tag_box.append($new_input);
			}
			this.$input_box = $new_input;

			AoPS.Community.Views.buildTagAutocomplete({
				$input_box: this.$input_box,
				model: this.model,
				show_no_results_msg: true,
				submitNewItem: function (item) {
					self.submitNewItem(item);
				},
				has_search_icon: true,
			});
			this.setFocusTag();
		},

		setTagBookmarkStatus: function () {
			var $bkmk_icon;
			// No bookmarking private tags.
			if (_.isNull(this.focus_tag) || this.model.get("is_private")) {
				return;
			}
			this.tag_bookmark_state = this.model
				.get("master")
				.fetchBookmarkStatus(this.focus_tag);

			$bkmk_icon = this.$focus_tag_line.find(".bkmk-icon");
			$bkmk_icon.html(ComViews.makeBookmark(this.tag_bookmark_state));

			$bkmk_icon[0].title = this.tag_bookmark_state.is_bookmarked
				? Lang["remove-bookmarked-tag-tooltip"]
				: Lang["bookmark-tag-tooltip"];
		},

		onClickTagBookmark: function () {
			// Check for general access
			if (
				!ComViews.hasCommunityGeneralAccess(
					"bookmark-not-logged-in",
					"bookmark-free-resource",
					this.model.getPermission("c_undo_global_ban")
				)
			) {
				return false;
			} else {
				if (this.tag_bookmark_state.is_bookmarked) {
					this.model
						.get("master")
						.removeTagBookmark(
							_.defaults(this.tag_bookmark_state, this.focus_tag)
						);
					this.model.trigger("tag_bookmarked");

					this.setTagBookmarkStatus();
				} else {
					ComViews.fireBookmarkModal(
						"tag",
						Utils.formatString(Lang["bookmark-modal-tag"], [
							this.focus_tag.item_text,
							this.model.get("category_name"),
						]),
						_.bind(function (setting) {
							if (this.model.get("category_type") === "forum") {
								this.focus_tag.item_category_name =
									this.model.get("category_name");
							}
							this.model.get("master").addTagBookmark({
								item: _.defaults(setting, this.focus_tag),
							});
							this.model.trigger("tag_bookmarked");
						}, this)
					);
				}
			}
		},

		/**
		 * setFocusTag fills the focus tag box.  CLEAN THIS UP
		 */
		setFocusTag: function () {
			var html;
			this.$el.find(".cmty-focus-tag-line").empty();
			if (this.focus_tag != null) {
				this.tag_colors = {
					main_color: this.focus_tag.item_main_color,
					secondary_color: this.focus_tag.item_secondary_color,
				};

				// TODO : Check if this tag is bookmarked to determine class
				html =
					"<a " +
					this.push_state_attribute +
					' href="' +
					ComViews.makeLinkUrl(
						this.url,
						this.url_router_base + this.url_cmty_path
					) +
					'"><div class="cmty-item-tag focused">' +
					this.focus_tag.item_text +
					' </div></a><div class="bkmk-icon clickable"></div>';
			} else {
				html = "";
			}
			this.$focus_tag_line.append($($.parseHTML(html)));
			this.setTagBookmarkStatus();
			if (this.focus_tag != null) {
				this.$focus_tag_line.find(".cmty-item-tag").css({
					border: "1px solid " + this.tag_colors.main_color,
					"background-color": this.tag_colors.secondary_color,
					color: this.tag_colors.main_color,
				});
				this.$focus_tag_line.find(".bkmk-icon").css({
					color: this.tag_colors.main_color,
				});
			}
		},

		/**
		 * What to do when we submit an entry to the tag box.
		 *  We head down the route for that tag.
		 *
		 * @param object : the new item (the ui.item from autocomplete)
		 *
		 * TODO : extend operation to work for views (get the forum_id into the autocomplete source
		 * TODO : Antonio if they don't pick a tag.
		 */
		submitNewItem: function (item) {
			var self = this;
			this.model.addItem({
				item_id: parseInt(item.item_id),
				item_type: "tag",
				item_forum_id: this.model.get("category_id"),
				item_text: item.value,
				item_main_color: item.main_color,
				item_secondary_color: item.secondary_color,
			});

			setTimeout(function () {
				self.$input_box.autocomplete("disable");
				self.$input_box.autocomplete("enable");

				Backbone.history.navigate(
					self.url_cmty_path +
						"/c" +
						self.model.get("category_id") +
						"t" +
						item.item_id +
						"f" +
						item.item_forum_id,
					{trigger: true}
				);
			}, 100);
			this.$input_box.val("");
		},
	});

	ComViews.category_cell_category_top_new_properties_view_forums = _.defaults(
		{
			className:
				ComViews.CategoryCellForumView.prototype.className +
				" cmty-view-folder-top cmty-category-cell-view-forums",

			use_own_color: false,

			can_bookmark: false,
		},
		ComViews.category_cell_category_top_new_properties
	);

	ComViews.category_cell_category_top_new_properties_view_topics = _.defaults(
		{
			has_bottom: false,

			className:
				ComViews.CategoryCell.prototype.className +
				"  cmty-folder-top cmty-flat-top ",

			use_own_color: false,

			has_help: true,

			help_template: "#cmty-view_topics-help-tpl",

			help_template_title_setting: "cat-cell-view_topics-help-title",

			can_bookmark: false,

			/**
			 * I'm sad about this, but this is the least painful way to get
			 *	correct the heights of the boxes that hold the topics.
			 **/
			onAddToPage: function () {
				$("#community-all").addClass("cmty-view-topics-page");
			},

			onRemoveFromPage: function () {
				$("#community-all").removeClass("cmty-view-topics-page");
			},
		},
		ComViews.category_cell_category_top_new_properties
	);

	ComViews.category_cell_category_top_new_properties_view_tags = _.defaults(
		{
			className:
				ComViews.CategoryCell.prototype.className +
				" cmty-folder-top cmty-flat-top",

			help_template: "#cmty-view_tags-help-tpl",

			help_template_title_setting: "cat-cell-view_tags-help-title",

			has_help: true,

			use_own_color: false,
		},
		ComViews.category_cell_category_top_new_properties
	);

	ComViews.CategoryCellCategoryTop = ComViews.CategoryCell.extend(
		ComViews.category_cell_category_top_new_properties
	);

	ComViews.CategoryCellCategoryTopViewTags = ComViews.CategoryCell.extend(
		ComViews.category_cell_category_top_new_properties_view_tags
	);

	ComViews.CategoryCellCategoryTopMyPrivates =
		ComViews.CategoryCellMyPrivates.extend(
			ComViews.category_cell_category_top_new_properties
		);

	ComViews.CategoryCellCategoryTopViewForums = ComViews.CategoryCell.extend(
		ComViews.category_cell_category_top_new_properties_view_forums
	);

	ComViews.CategoryCellCategoryTopViewTopics =
		ComViews.CategoryCellTopicView.extend(
			ComViews.category_cell_category_top_new_properties_view_topics
		);

	ComViews.CategoryCellCategoryTopUserSearchPosts = AoPS.View.extend({
		template_id: "#cmty-user-search-posts-top-tpl",

		className: "cmty-folder-top",

		initialize: function () {
			this.$el.html(
				this.getTemplate(this.template_id, {
					category_name: this.model.get("category_name"),
					url: "/community/u" + this.model.get("user_id"),
				})
			);
		},
	});

	ComViews.CategoryCellCategoryTopSearch = AoPS.View.extend({
		template_id: "#cmty-search-results-top-tpl",

		className: "cmty-folder-top cmty-search-results",

		initialize: function () {
			var has_search_text = this.model
					.get("search_settings")
					.hasOwnProperty("search_text"),
				search_text = has_search_text
					? this.model.get("search_settings").search_text
					: "",
				encoded_search_text = has_search_text
					? encodeURIComponent(search_text)
					: "",
				can_edit = this.model.has("search_page_id"),
				edit_url = can_edit
					? "/community/edit-search/" + this.model.get("search_id")
					: "";

			this.$el.html(
				this.getTemplate(this.template_id, {
					category_name: this.model.get("category_name"),
					search_text: Utils.formatString(
						Lang["search-results-title-with-text"],
						[search_text]
					),
					has_search_text: has_search_text,
					url: "/community/q" + this.model.get("search_id"),
					encoded_search_text: encoded_search_text,
					can_edit: can_edit,
					edit_url: edit_url,
					lang_edit_search: Lang["search-results-edit"],
					lang_search_placeholder: Lang["main-crumb-search-placeholder"],
				})
			);
		},

		events: {
			"keydown input": "onKeyDownSearch",
			"click .cmty-search-bar-icon": "onClickSearchIcon",
		},

		onClickSearchIcon: function (e) {
			var content = $.trim(this.$("input").val());

			Backbone.history.navigate("/search/" + encodeURIComponent(content), {
				trigger: true,
			});
			this.$("input").val("");
		},

		onKeyDownSearch: function (e) {
			var key_pressed = e.which || e.keyCode,
				target;
			if (key_pressed === 13) {
				target = e.currentTarget.value;
				if (target.length > 0) {
					// un-comment below to turn search input back on
					Backbone.history.navigate(
						"/search/" + encodeURIComponent(e.currentTarget.value),
						{trigger: true}
					);
					e.currentTarget.value = "";
				}
			}
		},
	});

	/**
	 * Folder is the master view for a folder.  Displays a grid of
	 *  CategoryBox instances, one for each item in the folder.
	 *
	 * model : VineModels.Category of the folder
	 *
	 * Properties:
	 *
	 * cat_box_holder : div that holds all the category boxes
	 * cat_boxes : Array of ComViews.CategoryBox, one per item in the folder
	 */
	ComViews.Folder = AoPS.View.extend({
		template_id: "#cmty-folder-top-tpl",

		className: "cmty-folder-top",

		has_header: true,

		has_subheader: false,

		own_url: "",

		has_own_url: false,

		has_info: true,

		initialize: function () {
			var has_info = this.model.get("category_id") > 0,
				can_add =
					this.model.get("can_add_type") !== "none" &&
					this.model.get("master").fetchPermission("can_create_category"); // TODO : clean

			this.url = this.has_own_url
				? this.own_url
				: "/c" +
					this.model.get("category_id") +
					"_" +
					ComViews.convertToUrlFragment(this.model.get("category_name"));

			this.url_info = has_info
				? "/category-admin/" + this.model.get("category_id")
				: "";

			this.$nothing_here = $(
				'<div class="cmty-folder-empty">' +
					Lang["folder-empty-" + this.model.get("category_type")] +
					"</div>"
			);

			this.$el.html(
				this.getTemplate(this.template_id, {
					can_add: can_add,
					can_add_title: can_add
						? Lang["Create"] + " new " + this.model.get("can_add_type")
						: "",
					has_header: this.has_header,
					has_pdf: false,
					lang_pdf: Lang["view-pdf-tooltip"],
					category_id: this.model.get("category_id"),
					has_subheader: this.has_subheader,
					url: ComViews.makeLinkUrl(this.url),
					category_name: this.model.get("category_name"),
					short_description: this.model.get("short_description"),
					subheader: this.model.get("long_description"),
					long_description: this.model.get("long_description"),
					has_info: this.has_info,
					has_jump_to_top: true,
					lang_information: Utils.capitalizeFirstLetter(Lang["information"]),
				})
			);
			this.$category_heading = this.$el.find(".cmty-category-cell-heading");
			if (this.has_header) {
				this.applyColor();
			}

			this.cat_box_holder = this.$el.find(".cmty-folder-grid-container");
			this.cat_boxes = [];
			this.start_item_index = 0;
			this.$loader = AoPS.Page.buildLoader();

			this.constructItems();
			this.onFinishConstructingItems();

			if (
				this.start_item_index < 8 &&
				!this.model.get("all_subcategories_loaded")
			) {
				this.fetchMoreCategories();
			}
			this.setScrollListener();

			if (this.model.get("items").length === 0) {
				this.$el.append(this.$nothing_here);
			}
			this.listenTo(this.model, "item_removed", this.onRemoveItem);
			if (this.model.get("category_type") === "bookmark_forums") {
				this.listenTo(this.model, "item_added", this.onAddItem);
			}
		},

		events: {
			"click .cmty-cat-cell-cat-info": "onClickInfo",
			"click .cmty-add-new-category": "onClickAddNew",
			"click .cmty-cat-cell-jump-top": "onClickJumpTop",
			"click .cmty-small-category-heading": "onClickHeading",
		},

		onClickJumpTop: function (e) {
			window.scrollTo(0, 0);
			e.stopPropagation();
			e.preventDefault();
		},

		onClickHeading: function (e) {
			if ($(window).width() <= Constants.phone_mode_max_width) {
				this.onClickJumpTop(e);
			}
		},

		onClickAddNew: ComViews.CategoryCell.prototype.onClickAddNew,

		setScrollListener: function () {
			var self = this;

			if (!this.model.get("all_subcategories_loaded")) {
				$(window).on(
					"scroll." + this.model.cid + " touchmove." + this.model.cid,
					function (ev) {
						if (
							window.innerHeight + window.pageYOffset + 10 >=
							document.body.offsetHeight
						) {
							if (
								!self.model.get("loading_subcategories") &&
								!self.model.get("all_subcategories_loaded")
							) {
								self.fetchMoreCategories();
							}
						}
					}
				);
			}
		},

		stopScrollListener: function () {
			$(window).off(
				"scroll." + this.model.cid + " touchmove." + this.model.cid
			);
		},

		onRemoveItem: function (item) {
			var i,
				cat_box = null,
				num_cat_boxes = this.cat_boxes.length;

			if (!item.hasOwnProperty("category")) {
				return;
			}
			for (i = 0; i < num_cat_boxes; i++) {
				if (this.cat_boxes[i].model === item.category) {
					cat_box = this.cat_boxes[i];
					break;
				}
			}
			if (!_.isNull(cat_box)) {
				this.cat_boxes = _.without(this.cat_boxes, cat_box);
				cat_box.close();
				this.start_item_index--;
			}

			if (this.cat_boxes.length === 0) {
				this.$el.append(this.$nothing_here);
			}
		},

		/**
		 * What we do when we add an item to this category.
		 *  This function is only executed for category_type bookmark_forums.
		 *  All the rest deal with added items in the scroll listener function.
		 *
		 * @param item
		 **/
		onAddItem: function (item) {
			var category;

			category = this.model.get("master").fetchCategory(item.item_id);
			if (_.isUndefined(category)) {
				return;
			}

			this.addCategoryBox(category);
		},

		constructItems: function () {
			var items = this.model.get("items"),
				i,
				item,
				category,
				num_items = items.length;

			if (num_items > 0) {
				this.$nothing_here.detach();
			}

			for (i = this.start_item_index; i < num_items; i++) {
				item = items[i];
				if (item.hasOwnProperty("category")) {
					category = item.category;
					this.addCategoryBox(category);
				} else {
					break;
				}
			}
		},

		/** Overwritten in some children **/
		onFinishConstructingItems: function () {
			return;
		},

		addCategoryBox: function (category) {
			var new_cat_box;
			this.start_item_index++;

			// Most categories are filtered on the back end, but
			//  not the main aops categories.
			if (category.getPermission("c_can_read")) {
				new_cat_box = new (ComViews.fetchCategoryCellConstructor(
					category.get("category_type")
				))({
					model: category,
				});
				this.cat_boxes.push(new_cat_box);
				this.cat_box_holder.append(new_cat_box.$el);
			}
		},

		fetchMoreCategories: function () {
			var self = this;
			this.cat_box_holder.append(this.$loader);
			this.listenToOnce(this.model, "subcategories_loaded", function () {
				var current_top = $(window).scrollTop();
				self.$loader.detach();
				self.constructItems();
				window.scrollTo(0, current_top);
			});
			this.model.fetchMoreCategoryItems({
				start_idx: this.start_item_index,
			});
		},

		onClose: function () {
			_.each(this.cat_boxes, function (cat_box) {
				cat_box.close();
			});
		},

		onAddToPage: function () {
			_.each(this.cat_boxes, function (cat_box) {
				if (typeof cat_box.onAddToPage === "function") {
					cat_box.onAddToPage();
				}
			});

			/**
			 * If this folder has forums, and is not waytoolong, then
			 *  we set up a cron to check for changes in the users data.
			 **/
			if (
				this.cat_boxes.length < Constants.max_forums_user_update &&
				!_.isUndefined(
					_.findWhere(this.model.get("items"), {
						item_type: "forum",
					})
				)
			) {
				this.model.startUsersMonitoring();
			}

			this.setScrollListener();
		},

		onClickInfo: function (e) {
			ComViews.followUrlOnClick(e, this.url_info);
		},

		onRemoveFromPage: function () {
			this.model.stopUsersMonitoring();
			this.stopScrollListener();
			_.each(this.cat_boxes, function (cat_box) {
				if (typeof cat_box.onRemoveFromPage === "function") {
					cat_box.onRemoveFromPage();
				}
			});
			/*			if (this.hasOwnProperty('interval')) {
				clearInterval(this.interval);
			}*/
		},

		applyColor: function () {
			var main_color = this.model.get("main_color");

			this.$el.find(".cmty-category-cell-heading").css({
				color: main_color,
			});
			this.$el.find(".cmty-category-cell-title").css({
				color: main_color,
			});
			//			ComViews.CategoryCell.prototype.applyColor.apply(this);
		},
	});

	ComViews.HeadlessFolder = ComViews.Folder.extend({
		has_header: false,
	});

	ComViews.FolderMyBookmarks = ComViews.Folder.extend({
		has_own_url: true,

		has_subheader: true,

		own_url: "/my-bookmarks",

		has_info: false,
	});

	ComViews.FolderMyForums = ComViews.Folder.extend({
		has_own_url: true,

		has_subheader: true,

		own_url: "/my-forums",

		onClickInfo: function (e) {
			if (this.model.get("category_id") === 0) {
				AoPS.Ui.Modal.showAlert(Lang["user-profile-no-my-forums"], {
					width: "450px",
				});
				return;
			}

			ComViews.Folder.prototype.onClickInfo.apply(this, [e]);
		},

		//		has_info : false
	});

	// NOTE: Add new collection has been removed via CSS until it is improved.  See community.css
	ComViews.FolderMyCollections = ComViews.Folder.extend({
		has_own_url: true,

		has_subheader: true,

		own_url: "/my-collections",

		onClickInfo: function (e) {
			if (this.model.get("category_id") === 0) {
				AoPS.Ui.Modal.showAlert(Lang["user-profile-no-my-collections"], {
					width: "450px",
				});
				return;
			}

			ComViews.Folder.prototype.onClickInfo.apply(this, [e]);
		},
		//		has_info : false
	});

	ComViews.FolderMyBlogs = ComViews.Folder.extend({
		has_own_url: true,

		has_subheader: true,

		own_url: "/my-blogs",

		onClickInfo: function (e) {
			if (this.model.get("category_id") === 0) {
				AoPS.Ui.Modal.showAlert(Lang["user-profile-no-my-blogs"], {
					width: "450px",
				});
				return;
			}
			ComViews.Folder.prototype.onClickInfo.apply(this, [e]);
		},
		//		has_info : false
	});

	ComViews.MyAoPSTop = AoPS.View.extend({
		template_id: "#cmty-my-aops-top-tpl",

		id: "cmty-my-aops-top",

		initialize: function () {
			var self = this,
				buttons = [
					{
						class_stub: "profile",
						url: "/my-aops",
					},
					{
						class_stub: "bookmarks",
						url: "/my-bookmarks",
					},
					{
						class_stub: "messages",
						url: "/my-messages",
					},
					{
						class_stub: "my-forums",
						url: "/my-forums",
					},
					{
						class_stub: "my-collections",
						url: "/my-collections",
					},
					{
						class_stub: "my-blogs",
						url: "/my-blogs",
					},
				];

			this.render();
			_.each(buttons, function (button) {
				self
					.$(".cmty-my-aops-" + button.class_stub + "-btn")
					.on("click", function (e) {
						ComViews.followUrlOnClick(e, button.url);
					});
			});
			this.listenTo(
				this.model.get("current_user"),
				"change:location",
				this.onChangeLocation
			);
		},

		events: {},

		render: function () {
			var user = this.model.get("current_user"),
				private_messages;
			this.$el.html(
				this.getTemplate(this.template_id, {
					has_books: user.get("has_ebooks"),
					has_classes: user.get("has_classes"),
					location: user.get("location"),
					avatar: this.model.get("my_avatar"),
					username: AoPS.session.username,
					email: user.get("email"),
					lang_Edit_Settings: Lang["my-aops-Community-Settings"],
					lang_Edit_Profile: Lang["my-aops-Edit-Profile"],
					lang_Profile: Lang["Profile"],
					lang_My_AoPS: Lang["MyAoPS"],
					lang_Bookmarks: Lang["Bookmarks"],
					lang_Messages: Lang["Messages"],
					lang_My_Forums: Lang["my-aops-MyForums"],
					lang_My_Collections: Lang["my-aops-MyCollections"],
					lang_My_Blogs: Lang["my-aops-MyBlogs"],
					lang_My_Books: Lang["my-aops-MyBooks"],
					lang_My_Classes: Lang["my-aops-MyClasses"],
					lang_phone_PM: Lang["my-aops-phone-PM"],
					lang_phone_Bkmk: Lang["my-aops-phone-Bkmk"],
					lang_phone_Fora: Lang["my-aops-phone-Fora"],
					lang_phone_Coll: Lang["my-aops-phone-Coll"],
					lang_phone_Blogs: Lang["my-aops-phone-Blogs"],
				})
			);

			this.$messages_btn = this.$(".cmty-my-aops-messages-btn");
			private_messages = this.model.fetchCategory(1);
			// This will likely change somehow when we introduce "archived_topics"?
			if (private_messages) {
				this.private_messages_topics = private_messages.get("active_topics");
				this.listenTo(
					this.private_messages_topics,
					"change:is_read add remove",
					this.markMessagesReadStatus
				);
				this.markMessagesReadStatus();
			}
		},

		onChangeLocation: function () {
			this.$(".cmty-my-aops-top-data-left > .cmty-my-aops-data-middle").text(
				this.model.get("current_user").get("location")
			);
		},

		markMessagesReadStatus: function () {
			this.$messages_btn.toggleClass(
				"cmty-messages-btn-unread",
				!_.isUndefined(
					this.private_messages_topics.findWhere({
						is_read: false,
					})
				)
			);
		},

		// Set the page class, use that to highlight the button of the active panel
	});

	/** Kludgy, lots of not-generalizable stuff here.  Probably fine for front page. **/

	ComViews.AoPSCollectionTop = AoPS.View.extend({
		template_id: "#cmty-header-box-logged-in-tpl",

		className: "header-box community-background-color",

		initialize: function () {
			this.$el.append(
				this.getTemplate(this.template_id, {
					// parameters here
					username: AoPS.session.username,
					is_logged_in: AoPS.session.logged_in,
					is_initialized: AoPS.session.initialized,
					is_logged_in_and_initialized: AoPS.session.logged_in_and_initialized,
					avatar: this.model.get("my_avatar"),
					user_id: AoPS.session.user_id,
					lang_Community: Lang["Community"],
					lang_Welcome: Lang["Welcome"],
					lang_MyAoPS: Lang["MyAoPS"],
					lang_Bookmarks: Lang["Bookmarks"],
					lang_Conversations: Lang["Messages"],
					lang_search_placeholder: Lang["main-crumb-search-placeholder"],
					lang_advanced_search: Lang["main-crumb-advanced-search"],
				})
			);
		},

		events: {
			"keydown input": "onKeyDownSearch",
			"click .cmty-search-bar-icon": "onClickSearchIcon",
		},

		onClickSearchIcon:
			ComViews.CategoryCellCategoryTopSearch.prototype.onClickSearchIcon,

		onKeyDownSearch:
			ComViews.CategoryCellCategoryTopSearch.prototype.onKeyDownSearch,
	});

	ComViews.Announcement = AoPS.View.extend({
		className: "cmty-home-announce",

		initialize: function (options) {
			this.$el.html(
				this.getTemplate("#cmty-announcement-tpl", {
					content: options.content,
				})
			);
		},
	});

	ComViews.AoPSMasterCollection = ComViews.HeadlessFolder.extend({
		has_extra_box: true,

		on_page: false,

		events: ComViews.Folder.prototype.events,

		onAddToPage: function () {
			ComViews.Folder.prototype.onAddToPage.apply(this);
			this.on_page = true;
		},

		onRemoveFromPage: function () {
			ComViews.Folder.prototype.onRemoveFromPage.apply(this);
			this.on_page = false;
		},

		constructItems: function () {
			var new_cat_box,
				items = this.model.get("items"),
				i,
				item,
				category,
				topics_preloaded = AoPS.hasOwnProperty("preload_topics"),
				num_items = items.length,
				self = this;
			this.$extra_box = $(
				'<div class="cmty-master-collection-extra-fora"></div>'
			);

			this.$extra_box.append(
				'<div class="cmty-master-heading">' +
					Lang["master-other-forums"] +
					'<div class="cmty-help cmty-no-phone">?</div></div>'
			);
			this.$el.find(".cmty-folder-grid").append(this.$extra_box);
			for (i = this.start_item_index; i < num_items; i++) {
				item = items[i];
				if (item.hasOwnProperty("category")) {
					this.start_item_index++;
					category = item.category;
					// Most categories are filtered on the back end, but
					//  not the main aops categories.
					if (category.getPermission("c_can_read")) {
						if (category.get("category_id") === 9) {
							new_cat_box = new ComViews.CategoryCellOtherForums({
								model: category,
							});
							self.$extra_box.append(new_cat_box.$el);
						} else if (category.get("category_id") === 12) {
							new_cat_box = new ComViews.CategoryCellSpecialCollections({
								model: category,
							});
							self.$extra_box.append(new_cat_box.$el);
						} else {
							new_cat_box = new (ComViews.fetchCategoryCellConstructor(
								category.get("category_type")
							))({
								model: category,
								default_to_topics:
									topics_preloaded &&
									category.get("category_id") !== 11 &&
									category.get("category_id") !== 13,
							});
							if (
								category.get("category_id") === 11 ||
								category.get("category_id") === 13
							) {
								self.$extra_box.append(new_cat_box.$el);
							} else {
								self.cat_box_holder.append(new_cat_box.$el);
							}
						}
						self.cat_boxes.push(new_cat_box);
					}
				}
			}

			this.$ad_banner = $('<div class="cmty-ad-banner"></div>');
			this.$ad_banner.append(
				'<a href="/school"><img src="/assets/images/internalads/horizontal-banner.gif" class="ready-for-next"></img></a>'
			);
			this.$el.find(".cmty-folder-grid").append(this.$ad_banner);

			this.$extra_box.find(".cmty-help").on("click", function () {
				self.onClickExtraHelp();
			});

			this.extra_help = this.getTemplate(
				"#cmty-toplevel-extras-help-modal-tpl",
				{
					can_create_forums: this.model
						.get("master")
						.fetchPermission("can_create_category"),
				}
			);
		},

		onFinishConstructingItems: function () {
			if (this.model.get("master").has("cmtystats")) {
				this.$whois_online = $('<div class="cmty-whois"></div>');
				this.buildStats();
				this.$el.find(".cmty-folder-grid").append(this.$whois_online);
				this.constructExtraNote();
			}
		},

		/**
		 * Fill the Statistics section with current data.
		 **/
		buildStats: function () {
			var cmty_stats = this.model.get("master").get("cmtystats");
			this.$whois_online.html(
				this.getTemplate("#cmty-stats-content-tpl", {
					stats_heading: Lang["master-statistics-title"],
					stats_data: Utils.formatString(Lang["master-statistics-data"], [
						Utils.renderNumberWithCommas(cmty_stats.num_posts),
						Utils.renderNumberWithCommas(cmty_stats.num_topics),
						Utils.renderNumberWithCommas(cmty_stats.num_users),
					]),
				})
			);
		},

		constructExtraNote: function () {
			// overwritten in child
		},

		onClickExtraHelp: function (e) {
			Modal.showMessage(this.extra_help, {
				title: Lang["master-collections-modal-title"],
				width: "450px",
				scrollable: true,
			});
		},

		attachCategories: function () {
			var new_cat_box,
				self = this;
			this.$extra_box = $(
				'<div class="cmty-master-collection-extra-fora"></div>'
			);
			this.$extra_box.append("<br>");
			this.$el.find(".cmty-folder-grid").append(this.$extra_box);

			_.each(this.model.get("items"), function (item) {
				var category;
				if (item.hasOwnProperty("category")) {
					category = item.category;
					if (category.getPermission("c_can_read")) {
						new_cat_box = new (ComViews.fetchCategoryCellConstructor(
							category.get("category_type")
						))({
							model: category,
						});
						if (category.get("category_id") <= 8) {
							self.cat_box_holder.append(new_cat_box.$el);
						} else {
							self.$extra_box.append(new_cat_box.$el);
						}
						self.cat_boxes.push(new_cat_box);
					}
				}
			});

			/*			this.model.get('categories').each(function(category) {
				if (category.getPermission('c_can_read')) {
					new_cat_box = new (ComViews.fetchCategoryCellConstructor(category.get('category_type')))({
						model : category
					});

					if (category.get('category_id') <= 8) {
						self.cat_box_holder.append(new_cat_box.$el);
					} else {
						self.$extra_box.append(new_cat_box.$el);
					}
					self.cat_boxes.push(new_cat_box);
				}
			});*/
		},
	});

	ComViews.AoPSPortal = ComViews.AoPSMasterCollection.extend({
		has_header: true,

		has_info: false,

		constructItems: function () {
			var new_cat_box,
				items = this.model.get("items"),
				i,
				item,
				category,
				topics_preloaded = AoPS.hasOwnProperty("preload_topics"),
				num_items = items.length,
				self = this;

			this.$featured_content = $(
				'<div class="cmty-master-collection-extra-fora cmty-portal-featured"></div>'
			);
			this.$featured_content.append(
				'<div class="cmty-master-heading">' +
					Lang["master-featured-content"] +
					'<div class="cmty-help">?</div></div>'
			);
			this.$el.find(".cmty-folder-grid").append(this.$featured_content);

			//
			this.$extra_box = $(
				'<div class="cmty-master-collection-extra-fora"></div>'
			);
			this.$extra_box.append(
				'<div class="cmty-master-heading">' +
					Lang["portal-extra-content"] +
					'<div class="cmty-help">?</div></div>'
			);
			this.$el.find(".cmty-folder-grid").append(this.$extra_box);

			for (i = this.start_item_index; i < num_items; i++) {
				item = items[i];
				if (item.hasOwnProperty("category")) {
					this.start_item_index++;
					category = item.category;
					// Most categories are filtered on the back end, but
					//  not the main aops categories.
					if (category.getPermission("c_can_read")) {
						if (category.get("category_id") === 9) {
							new_cat_box = new ComViews.CategoryCellOtherForums({
								model: category,
							});
							self.$extra_box.append(new_cat_box.$el);
						} else if (category.get("category_id") === 12) {
							new_cat_box = new ComViews.CategoryCellSpecialCollections({
								model: category,
							});
							self.$extra_box.append(new_cat_box.$el);
						} else {
							new_cat_box = new (ComViews.fetchCategoryCellConstructor(
								category.get("category_type")
							))({
								model: category,
								default_to_topics:
									topics_preloaded &&
									(category.get("category_id") === 6 ||
										category.get("category_id") === 7),
							});
						}

						if (
							category.get("category_id") === 90 ||
							category.get("category_id") === 91
						) {
							this.$featured_content.append(new_cat_box.$el);
						} else if (
							category.get("category_id") === 6 ||
							category.get("category_id") === 7
						) {
							self.cat_box_holder.append(new_cat_box.$el);
						} else {
							this.$extra_box.append(new_cat_box.$el);
						}
						self.cat_boxes.push(new_cat_box);
					}
				}
			}

			this.$featured_content.find(".cmty-help").on("click", function () {
				self.onClickFeaturedHelp();
			});
			this.featured_content_help = this.getTemplate(
				"#cmty-featured-content-help-tpl"
			);

			this.$extra_box.find(".cmty-help").on("click", function () {
				self.onClickExtraHelp();
			});

			this.extra_help = this.getTemplate("#cmty-portal-special-views-help-tpl");
		},

		onClickFeaturedHelp: function () {
			Modal.showMessage(this.featured_content_help, {
				title: Lang["portal-featured-help-title"],
				width: "450px",
			});
		},

		onClickExtraHelp: function () {
			Modal.showMessage(this.extra_help, {
				title: Lang["portal-extra-help-title"],
				width: "450px",
			});
		},

		constructExtraNote: function () {
			this.$el.append(
				'<div class="cmty-portal-extra">' +
					Lang["portal-extra-note"] +
					(AoPS.session.logged_in ? Lang["portal-extra-logged-in"] : "") +
					"</div>"
			);
		},
	});

	/**
	 * View for a collection of posts
	 * Assumes all of the posts are loaded.
	 *
	 * model : AoPS.Community.Models.CategoryViewPosts
	 */
	ComViews.ViewPosts = AoPS.View.extend({
		template_id: "#cmty-folder-top-tpl",

		className: "cmty-folder-top",

		initialize: function () {
			var self = this,
				has_subheader = this.model.get("short_description").length > 0;
			this.url = this.has_own_url
				? this.own_url
				: "/c" +
					this.model.get("category_id") +
					"_" +
					ComViews.convertToUrlFragment(this.model.get("category_name"));

			this.has_label_column = this.hasLabel();
			this.url_info = "/category-admin/" + this.model.get("category_id");

			this.$el.html(
				this.getTemplate(this.template_id, {
					has_header: true,
					category_name: this.model.get("category_name"),
					can_add: false,
					category_id: this.model.get("category_id"),
					has_info: true,
					has_pdf: true,
					lang_pdf: Lang["view-pdf-tooltip"],
					has_subheader: has_subheader,
					subheader: this.model.get("short_description"),
					url: ComViews.makeLinkUrl(this.url),
					lang_information: Utils.capitalizeFirstLetter(Lang["information"]),
				})
			);

			this.item_views = [];

			this.$posts_box = this.$(".cmty-folder-grid-container");

			_.each(this.model.get("items"), function (item) {
				self.addItem(item);
			});

			if (this.model.get("items").length === 0) {
				this.$el.append(
					'<div class="cmty-folder-empty">' +
						Lang["folder-empty-view_posts"] +
						"</div>"
				);
			}

			this.applyColor();
		},

		events: {
			"click .cmty-cat-cell-cat-info": "onClickInfo",
		},

		applyColor: function () {
			var main_color = this.model.get("main_color");
			console.log(main_color);

			this.$el.find(".cmty-category-cell-heading").css({
				color: main_color,
			});
			this.$el.find(".cmty-category-cell-title").css({
				color: main_color,
			});
		},

		onClickInfo: ComViews.Folder.prototype.onClickInfo,

		addItem: function (item) {
			var item_view = new AoPS.Community.Views.ViewPostsItem({
				item: item,
				model: this.model,
				has_label_column: this.has_label_column,
			});
			this.item_views.push(item_view);
			this.$posts_box.append(item_view.$el);
		},

		/**
		 * Determines if this view_posts will have a label column anywhere.
		 **/
		hasLabel: function () {
			var labeled_post = _.find(this.model.get("items"), function (item) {
				return item.item_type === "post" && item.item_text.length > 0;
			});
			return !_.isUndefined(labeled_post);
		},

		onClose: function () {
			_.each(this.item_views, function (item_view) {
				item_view.close();
			});
		},
	});

	/**
	 * A single item (post) in a view of posts.
	 *
	 * model : AoPS.Community.Models.CategoryViewPosts
	 *
	 * Must send in { item : <item of the category you are building> } to the constructor.
	 *
	 * There are several types of posts that might be in a view_posts
	 *	A) Text entered directly to the view_posts for use only in that view.
	 *		If there is a label on such a post, the label in item.item_text.
	 *		The text of the post is in item.post_data.html
	 *		The poster is not shown on the page.
	 *
	 *	B) A post that is included from the community and directly revealed.
	 *		If there is a label on such a post, the label in item.item_text.
	 *		The text of the post is in item.post_data.html
	 *		The poster is shown on the page.  Clicking in that cell takes us to the topic.
	 *
	 *	C) A post that is included from the community but hidden on this page in the same
	 *		manner that content can be hidden with hide tags.
	 *		If custom "click here to reveal" text exists for this item, then that text is in item.item_text.
	 *		The text of the post is in item.post_data.html; all hidden content within the post is
	 *			automatically un-hidden when this post is revealed.
	 *		The poster is shown on the page.  Clicking in that cell takes us to the topic.
	 **/
	ComViews.ViewPostsItem = AoPS.View.extend({
		template_id: "#cmty-view-posts-item-tpl",

		hidden_template_id: "#cmty-view-posts-item-hidden-tpl",

		className: "cmty-view-posts-item",

		/**
		 * @param obj
		 *		item : obj from category's items (see ComViews.Itembox for structure)
		 **/
		initialize: function (settings) {
			var item = settings.item,
				is_hidden = item.item_type === "post_hidden",
				template_id = is_hidden ? this.hidden_template_id : this.template_id,
				has_url = item.post_data.post_type !== "view_posts_text",
				has_label =
					(is_hidden && settings.has_label_column) || item.item_text.length > 0;
			if (is_hidden && item.item_text.length === 0) {
				item.item_text = Lang["view-posts-click-hidden"];
			}

			if (has_url) {
				this.url =
					"/c" +
					item.post_data.category_id +
					"h" +
					item.post_data.topic_id +
					"p" +
					item.item_id;
			} else {
				this.url = "";
			}

			this.$el.html(
				this.getTemplate(template_id, {
					has_label: has_label,
					label: item.item_text,
					has_poster: has_url, // has a poster if it has a url.
					poster_avatar: item.post_data.poster_avatar,
					poster_username: item.post_data.username,
					post: item.post_data.post_rendered,
					view_topic_text: Lang["view-posts-view-topic"],
					//	has_url : has_url,
					url: this.url,
				})
			);
			if (has_label && !is_hidden) {
				this.$el.addClass("cmty-view-post-item-w-label");
			}

			// pywindow causes us to render this separately; we will change this back to
			// running through handlebars if we stick with onclick
			//this.$('.cmty-view-post-item-text').html(item.post_data.post_rendered);
			/**
			 * If this post row is hidden, then we want to un-hide any of the hidden content that was in the
			 *	corresponding post
			 */
			if (is_hidden) {
				this.$hidden_content = this.$(".cmty-post-item-hidden-content");
				this.$(".cmty-hide-heading").remove();
				this.$(".cmty-hide-content")
					.css({
						display: "inline-block",
					})
					.removeClass("cmty-hide-content");
			}

			/** Set a class on the whole row that is used to set the
				width of the middle column.  This is the sort of fun
				we need to get the up-to-three consecutive divs to have the
				same height.  We need display-style table-cell, but that
				doesn't work and play well with widths, sigh.
			**/
			if (has_label) {
				if (has_url) {
					this.$el.addClass("cmty-vp-both");
				} else {
					this.$el.addClass("cmty-vp-left");
				}
			} else {
				if (has_url) {
					this.$el.addClass("cmty-vp-right");
				}
			}
		},

		events: {
			"click .cmty-post-item-hidden-bar": "onClickHiddenBar",
			"click .cmty-view-post-poster": "onClickPost",
		},

		onClickHiddenBar: function () {
			this.$el.toggleClass("cmty-view-posts-item-reveal");
		},

		onClickPost: function (e) {
			if (this.url.length > 0) {
				ComViews.followUrlOnClick(e, this.url);
			}
		},
	});

	/**
	 * Produces just the header bar for a Category, with none of the extra
	 *  stuff you can click on.
	 *
	 * model : AoPS.Community.Models.Category (or child)
	 */
	ComViews.BasicCategoryTitleBar = AoPS.View.extend({
		template_id: "#cmty-category-basic-title-tpl",

		className: "cmty-category-cell",

		initialize: function () {
			var main_color = this.model.get("main_color");

			this.url = this.has_own_url
				? this.own_url
				: "/c" +
					this.model.get("category_id") +
					"_" +
					ComViews.convertToUrlFragment(this.model.get("category_name"));

			this.$el.html(
				this.getTemplate(this.template_id, {
					category_name: this.model.get("category_name"),
					short_description: this.model.get("short_description"),
					url: AoPS.Community.Views.makeLinkUrl(this.url),
				})
			);
			/**
			 * applyColor puts the relevant category colors on everything.
			 */
			this.$category_heading = this.$el.find(".cmty-category-cell-heading");

			this.$category_heading.css({
				"background-color": main_color,
				color: "#fff",
			});
		},

		events: {
			"mouseenter .cmty-full-cell-link": "onHoverHeading",
			"mouseleave .cmty-full-cell-link": "onUnhoverHeading",
			"click .cmty-category-cell-heading": "onClickHeading",
		},

		onClickHeading: ComViews.Folder.prototype.onClickHeading,

		onHoverHeading:
			ComViews.category_cell_category_top_new_properties.onHoverHeading,

		onUnhoverHeading:
			ComViews.category_cell_category_top_new_properties.onUnhoverHeading,
	});

	/**
	 *
	 * model : No model assumed in PostingEnviron.  Some of its children have models.
	 *
	 *
	 * $submenu : The currently active submenu item.
	 *
	 * Settings you can pass in that this View knows about; these are in
	 * this.settings.  We may cull this list after building out everything.
	 *
	 * 		onPreview : function to execute when the Preview button is clicked.
	 *      onSubmit : what to do upon submit
	 *
	 *      category_name : text of the forum we are posting to (if relevant)
	 *      topic : topic we're replying to (for NewReply)
	 *      category_id : id of forum to which we are posting
	 *      topic_id : topic id of the post we're replying to (for NewReply).
	 *      master
	 */
	ComViews.PostingEnviron = AoPS.View.extend({
		template_id: "#cmty-posting-frame-tpl",

		className: "cmty-posting-environ",

		has_bbcode_buttons: true,

		is_new_pm: false,

		has_email_subscribe: true,

		has_add_to_feed: true,

		sending_blocker: Lang["new-topic-send-blocker"],

		initialize: function (options) {
			var self = this;
			this.settings = options;

			// Flip this to false to gray out and disable the bbcode-parsed buttons
			this.is_bbcode_enabled = true;

			if (this.settings.hasOwnProperty("has_add_to_feed")) {
				this.has_add_to_feed = this.settings.has_add_to_feed;
			}

			if (this.settings.hasOwnProperty("has_email_subscribe")) {
				this.has_email_subscribe = this.settings.has_email_subscribe;
			}

			// The settings below cannot be attached to the prototype;
			//  we need them for each instance.
			_.extend(this, {
				submenus: {}, // Some posting buttons have submenus.  This object holds the menus once they are created
				is_building_subwindow: false, // Is this click constructing a subwindow?
				is_previewing: false, // Are we currently previewing the post?
				is_preview_processing: false, // Are we processing a preview currently?
				extra_options: {}, // Extra options we can set, like disable bbCode, add to feed, etc
			});
			this.has_poll = false;

			this.attachments = [];

			this.render();

			this.allow_latex_errors = false;
			this.$posting_buttons = this.$el.find(".cmty-bbcode-buttons");
			this.$post_box = this.$el.find(".cmty-post-textarea");
			this.$title_box = this.$el.find(".cmty-subject-input");
			this.$preview_box = this.$el.find(".cmty-post-preview");
			this.$preview_text = this.$el.find(".cmty-post-preview-text");
			this.$preview_button = this.$el.find(".cmty-preview-button");
			this.$submit_button = this.$el.find(".cmty-submit-button");
			this.$el
				.find(".cmty-post-preview")
				.append(
					AoPS.Community.Views.buildCommunityScrollbar(this.$preview_text)
				);
			this.$loader = AoPS.Page.buildLoader();
			if (this.has_bbcode_buttons) {
				this.constructBbCodeButtons();
				this.styleAttachmentsButton();
			}

			this.$active_submenu_button = null; // Currently active submenu button
			/*			AoPS.Ui.buildAopsScrollbar({
				$scrollbar : this.$el.find('.cmty-post-preview-scrollbox'),
				$content : this.$el.find('.cmty-post-preview-text')
			});*/

			this.$el.on("keydown", function (e) {
				var key_pressed = e.which || e.keyCode;
				if (key_pressed === 13 && (e.ctrlKey || e.metaKey)) {
					self.submitPost();
				}
			});

			if (this.settings.hasOwnProperty("preset_extra_options")) {
				_.each(_.keys(this.settings.preset_extra_options), function (option) {
					if (!self.has_email_subscribe && option === "notify_email") {
						return;
					}

					if (!self.has_add_to_feed && option === "bookmark_feed") {
						return;
					}

					self.extra_options[option] =
						self.settings.preset_extra_options[option];
				});
			}

			/**
			 * Eventually we'll be using this for editing posts, and we'll
			 *  want to choose whether or not to reveal the Preview button
			 *  based on whether or not there's stuff already in the box.
			 */
			this.setPreviewButton();

			if (
				typeof options.topic_title === "string" &&
				options.topic_title.length > 0
			) {
				this.setTitle(options.topic_title);
			}

			if (typeof options.content === "string" && options.content.length > 0) {
				this.addContent(options.content);
			}
		},

		/**
		 * Is this error code to be treated like a latex error?
		 *
		 * @param string Error code
		 * @return boolean
		 **/
		isLatexError: function (code) {
			return code === "E_LATEX_ERROR" || code === "E_ASY_ERROR";
		},

		/**
		 * Throw a message that there is a LaTeX error in this post.  Figure out what
		 *  the user wants to do about it.
		 *
		 * @param string E_LATEX_ERROR | E_ASY_ERROR | you get what you deserve
		 **/
		throwLatexErrorMessage: function (code) {
			var self = this;
			Modal.showConfirm(
				Utils.formatString(Lang["error-latex-posting-confirm"], [
					code === "E_LATEX_ERROR" ? "LaTeX" : "Asymptote",
				]),
				function (ok) {
					if (ok) {
						self.allow_latex_errors = true;
						// Close this modal.  Needed here rather than on close because
						//  the onclose will nail the loader fired by submitPost.
						Modal.closeTopModal();
						self.submitPost();
					} else {
						// Close this modal and the loader that preceded it
						Modal.closeTopModal();
						Modal.closeTopModal();
						self.$post_box.focus();
					}
				},
				{
					confirm_button_cancel: Lang["error-latex-i-will-fix"],
					confirm_button_ok: Lang["error-latex-post-anyway"],
					width: "450px",
					closeX: false,
					force_response: true,
					close_on_button_click: false,
				}
			);
		},

		/**
		 * Build the row of bbCode buttons.
		 */
		constructBbCodeButtons: function () {
			var self = this,
				// buttons that are not tagged is_bbcode : false get turned off if bbcode is disabled.
				buttons = [
					{
						button_class: "cmty-bbcode-other",
						onClick: function ($button) {
							self.showSubMenu($button, "extra_options");
						},
						is_bbcode: false,
					},
					{
						button_class: "cmty-bbcode-bold",
						title: Lang["bbcode-title-bold"],
						stub: "b",
					},
					{
						button_class: "cmty-bbcode-underline",
						stub: "u",
						title: Lang["bbcode-title-underline"],
					},
					{
						button_class: "cmty-bbcode-italic",
						stub: "i",
						title: Lang["bbcode-title-italic"],
					},
					{
						button_class: "cmty-bbcode-text-size",
						stub: "size",
						title: Lang["bbcode-title-text-size"],
						onClick: function ($button) {
							self.showSubMenu($button, "font_size");
						},
					},
					{
						button_class: "cmty-bbcode-text-color",
						stub: "color",
						title: Lang["bbcode-title-text-color"],
						onClick: function ($button) {
							self.showSubMenu($button, "font_color");
						},
					},
					{
						button_class: "cmty-bbcode-quote",
						title: Lang["bbcode-title-quote"],
						stub: "quote",
					},
					/*{ List is stupid
					button_class : 'cmty-bbcode-list',
					title : Lang['bbcode-title-list'],
					stub : 'list'
				},*/ {
						button_class: "cmty-bbcode-hide",
						title: Lang["bbcode-title-hide"],
						stub: "hide",
					},
					{
						button_class: "cmty-bbcode-code",
						title: Lang["bbcode-title-code"],
						stub: "code",
					},
					{
						button_class: "cmty-bbcode-smiley",
						title: Lang["bbcode-title-smiley"],
						onClick: function ($button) {
							self.showSubMenu($button, "smiley");
						},
					},
					{
						has_permission:
							this.settings.master.fetchPermission("can_post_images"),
						button_class: "cmty-bbcode-img",
						title: Lang["bbcode-title-img"],
						stub: "img",
					},
					{
						button_class: "cmty-bbcode-url",
						title: Lang["bbcode-title-url"],
						stub: "url",
					},
					{
						has_permission:
							this.settings.master.fetchPermission("can_attach_files"),
						button_class: "cmty-bbcode-attachment",
						title: Lang["bbcode-title-attachment"],
						is_bbcode: false,
						onClick: function () {
							self.openAttachmentPanel();
							//AoPS.Ui.Modal.showAlert('You\'ll be able to attach documents to your posts right after rrusczyk figures out how to get that to work.');
						},
					},
					{
						button_class: "cmty-bbcode-poll",
						title: Lang["bbcode-title-poll"],
						onClick: function () {
							self.togglePoll();
						},
						is_bbcode: false,
					},
				];

			_.each(buttons, function (button) {
				var $button;
				if (button.hasOwnProperty("has_permission") && !button.has_permission) {
					return;
				}
				if (typeof button.is_bbcode !== "boolean" || button.is_bbcode) {
					button.button_class += " cmty-is-bbcode";
				}
				$button = $("<div/>", {
					class: button.button_class + " clickable cmty-bbcode-btn",
					title: button.hasOwnProperty("title") ? button.title : "",
				});

				$button.data("button_settings", button);

				$button.on("click", function (e) {
					if (typeof button.is_bbcode !== "boolean" || button.is_bbcode) {
						if (!self.is_bbcode_enabled) {
							return;
						}
					}

					// Check if the button has a custom onClick method
					if (button.hasOwnProperty("onClick")) {
						button.onClick($button);
					} else if (button.hasOwnProperty("stub")) {
						// If the button doesn't have a custom method, but has
						//  a stub, then use the stub as a wrapper.
						self.applyBbCode(button);
					}
				});
				self.$posting_buttons.append($button);
			});
		},

		events: {
			"click .cmty-posting-preview-bar": "previewPost",
			"click .cmty-submit-button": "submitPost",
			"keyup .cmty-post-textarea": "onPostKeypress",
			"click .cmty-cancel-button,.cmty-cancel-posting-x": "onClickCancel",
			"click .cmty-refresh-preview": "generatePreview",
			click: "onAnyClick",
			"keydown .cmty-subject-input": "onSubjectKeypress",
			'change [name="cmty-post-extra-disable-bbcode"]': "onClickDisableBbCode",
			"click .cmty-poll-cancel-btn": "onClickCancelPoll",
			"click .cmty-preview-bar-attachments": "onClickPreviewBarAttachments",
		},

		onClickDisableBbCode: function (e) {
			this.$el.toggleClass("cmty-bbcode-disabled", e.currentTarget.checked);
			this.is_bbcode_enabled = !e.currentTarget.checked;
		},

		onAnyClick: function () {
			if (this.hasOwnProperty("$submenu") && !this.is_building_subwindow) {
				this.$submenu.detach();
				this.$active_submenu_button = null;
			}
			this.is_building_subwindow = false;
		},

		/**
		 * Actions to take when we type in the subject box
		 **/
		onSubjectKeypress: function () {
			// overwritten in some children
		},

		/**
		 * Actions to take when we type in the posting box.
		 **/
		onPostKeypress: function () {
			// overwritten in some children
		},

		setPreviewButton: function () {
			this.$preview_button.toggle(this.$post_box.val().length > 8);
		},

		onClickClosePreview: function () {
			if (this.settings.hasOwnProperty("onClosePreview")) {
				this.settings.onClosePreview();
			}
			this.setHeight();
		},

		onClickPreviewBarAttachments: function (e) {
			e.stopPropagation();
			e.preventDefault();
			this.openAttachmentPanel();
		},

		openAttachmentPanel: function () {
			if (!this.hasOwnProperty("attachments_view")) {
				this.attachments_view = new ComViews.PostingAttachments({
					model: this.settings.master,
					parent_view: this,
				});
			}
			this.attachments_view.show();
		},

		/**
		 * When the attachments are changed, we need to rebuild the attachments array
		 *  then style the attachments button.
		 *
		 * @param ComViews.PostingAttachment for this post.
		 **/
		processAttachments: function (attachment_view) {
			var dz_obj = attachment_view.dropzone,
				existing_files = attachment_view.existing_attachments,
				self = this;

			this.attachments = [];

			_.each(existing_files, function (f) {
				self.attachments.push({
					url: f.url,
					existing: 1,
					name: f.name,
				});
			});
			_.each(dz_obj.files, function (file) {
				self.attachments.push({
					tmp_name: file.tmp_name,
					existing: 0,
					name: file.name,
				});
			});
			this.styleAttachmentsButton();
		},

		/**
		 * Shade/unshade the attachments button and put the title on the attachments tag.
		 **/
		styleAttachmentsButton: function () {
			var title,
				$button = this.$(".cmty-bbcode-attachment");

			if ($button.length == 0) {
				return;
			}
			if (this.attachments.length == 0) {
				title = Lang["bbcode-title-attachment"];
				this.$el.removeClass("cmty-posting-with-attachments");
			} else {
				title = Lang["bbcode-title-has-attachments"];
				this.$el.addClass("cmty-posting-with-attachments");
				_.each(this.attachments, function (f) {
					title += "\n  " + f.name;
				});
			}
			$button[0].title = title;
		},

		// Overwritten in many children.
		setHeight: function () {},

		applyBbCode: function (button) {
			var wrap_start, scroll_loc, wrap_end;

			scroll_loc = this.$post_box.scrollTop();
			wrap_start = "[" + button.stub;

			// See if there's a second thing to process here,
			//  like who is being quoted or a color code.
			if (button.hasOwnProperty("secondary")) {
				wrap_start += "=" + button.secondary;
			}

			wrap_start += "]";
			wrap_end = "[/" + button.stub + "]";

			this.wrapTextareaSelection(wrap_start, wrap_end);
			this.$post_box.scrollTop(scroll_loc);
		},

		/**
		 * Show a submenu for a bbcode button.
		 *
		 * @param jQuery object : button for which we are showing a submenu
		 * @param string : type of submenu to show.
		 *
		 * After we make a submenu item, we store it for future use.
		 */
		showSubMenu: function ($button, submenu) {
			var sel_start = this.$post_box[0].selectionStart,
				sel_end = this.$post_box[0].selectionEnd;
			// Clicks in the posting environment will close submenus...
			//  unless is_building_subwindow is set to true.
			//  Step 1: clean out the current submenu
			//  Step 2: If we are clicking on the button that created that menu,
			//      we are done (since users will expect that the same button
			//      will open and close the submenu)
			//  Step 3: Build the new subwindow, setting is_building_subwindow
			//      to true to make sure click propagation doesn't make our
			//      new subwindow get closed.

			// The 'extra_options' submenu has is_building_subwindow set to true.
			//  This is to block propagation when user clicks on the submenu's
			//  checkboxes.  So, for the cleanout of Step 1, we need to set
			//  this.is_building_subwindow to false.
			this.is_building_subwindow = false;
			/** Keep the selected text selected. **/
			this.$post_box[0].setSelectionRange(sel_start, sel_end);
			if ($button === this.$active_submenu_button) {
				this.onAnyClick();
				return;
			}

			this.onAnyClick();

			this.is_building_subwindow = true;
			if (!this.submenus.hasOwnProperty(submenu)) {
				this.submenus[submenu] = this.createSubMenu($button, submenu);
			}

			this.$posting_buttons.append(this.submenus[submenu]);
			this.$submenu = this.submenus[submenu];
			this.$active_submenu_button = $button;
		},

		/**
		 * Add a string to the textarea at the location of the cursor (or before highlighted text)
		 *
		 * IF NEED TO OVERWRITE HIGHLIGHTED TEXT, LOOK AT replaceTextareaSelection.
		 *  Currently this function is only used for clicking Quote in a post.
		 *  I could imagine people being unhappy with that overwriting something they have
		 *  highlighted.
		 *
		 * @param string: string to add
		 */
		addContent: function (string) {
			this.wrapTextareaSelection(string, "");
		},

		/**
		 * Sets the value of the title input box.
		 *
		 * @param {string}: The new title/subject.
		 */
		setTitle: function (string) {
			if (this.$title_box.length) {
				this.$title_box.val(string);
			}
		},

		/**
		 * Create a submenu for a bbcode button.
		 *
		 * @param jQuery object : button for which we are showing a submenu
		 * @param string : type of submenu to show.
		 */
		createSubMenu: function ($button, submenu) {
			var $submenu = $('<div class="cmty-posting-submenu"></div>'),
				button_position = $button.position(),
				self = this,
				has_announce = false,
				extra_options,
				$smiley_holder;
			switch (submenu) {
				case "font_color":
					$submenu.addClass("cmty-posting-submenu-font-color");
					// Each line corresponds to one row in the rendered table.
					//  Please don't mess with the line breaks.

					_.each(Constants.bbCode.font_colors, function (color) {
						var $swatch;

						$swatch = $('<div class="cmty-posting-font-color-swatch"></div>')
							.css({
								"background-color": color,
							})
							.on("click", function () {
								self.applyBbCode(
									_.extend($button.data("button_settings"), {
										secondary: color,
									})
								);
							});
						$submenu.append($swatch);
					});
					break;

				case "smiley":
					$submenu.addClass("cmty-posting-submenu-smileys");

					$smiley_holder = $('<div class="cmty-posting-smiley-holder"></div>');
					// Todo: build a scrollable enviroment, jam
					//  a div full of smileys in it.
					// Use .wrapWithScroll, and document wrapWithScroll
					// in /private/docs/
					_.each(Constants.bbCode.smileys, function (smiley) {
						var $smiley;

						$smiley = $(
							'<img src="/assets/images/smilies/' +
								smiley[1] +
								'" alt="' +
								smiley[0] +
								'" title="' +
								smiley[0] +
								'" class="bbcode_smiley">'
						);
						//  Need a space around the smiley code to get bbCode to see it.
						$smiley.on("click", function () {
							self.replaceTextareaSelection(" " + smiley[0] + " ");
						});
						$smiley_holder.append($smiley);
					});
					$submenu.append(
						AoPS.Community.Views.buildCommunityScrollbar($smiley_holder)
					);
					break;

				case "font_size":
					$submenu.addClass("cmty-posting-submenu-sizes");

					_.each(Constants.bbCode.font_sizes, function (size) {
						var $size = $(
							'<div class="cmty-posting-font-size" style="font-size:' +
								size.size +
								'%">' +
								size.text +
								"</div>"
						).on("click", function () {
							self.applyBbCode(
								_.extend($button.data("button_settings"), {
									secondary: size.size,
								})
							);
						});

						$submenu.append($size);
					});
					break;

				case "extra_options":
					$submenu.addClass("cmty-posting-submenu-extras");
					extra_options = Constants.bbCode.extra_options;

					if (this.canSetAnnounce()) {
						// Can't push, since don't want to add this to the
						//  array in Community.Constants.
						extra_options = extra_options.concat([
							{
								property: "is_local_announcement",
								text: Lang["post-environ-extra-announce"],
								class_id: "cmty-post-extra-local-announce",
							},
						]);
						has_announce = true;
					}

					if (this.canSetGlobalAnnounce()) {
						// Can't push, since don't want to add this to the
						//  array in Community.Constants.
						extra_options = extra_options.concat([
							{
								property: "is_global_announcement",
								text: Lang["post-environ-global-announce"],
								class_id: "cmty-post-extra-global-announce",
							},
						]);
						has_announce = true;
					}

					_.each(extra_options, function (extra_option) {
						var pre_checked;

						if (
							!self.has_email_subscribe &&
							extra_option.property === "notify_email"
						) {
							return;
						}

						if (
							!self.has_add_to_feed &&
							extra_option.property === "bookmark_feed"
						) {
							return;
						}

						pre_checked =
							self.extra_options.hasOwnProperty(extra_option.property) &&
							self.extra_options[extra_option.property];

						var $input = $(
							'<label><input name="' +
								extra_option.class_id +
								'" type="checkbox"' +
								(pre_checked ? " checked" : "") +
								"> " +
								extra_option.text +
								"</label><br>"
						).on("click", function (e) {
							// We don't want this window to close immediately.
							self.is_building_subwindow = true;
							self.extra_options[extra_option.property] = e.target.checked;
						});
						$submenu.append($input);
					});

					if (has_announce) {
						this.$announce_through = $(
							'<div class="cmty-posting-announce-extra">' +
								Lang["post-environ-announce-through"] +
								'<br><input type="text" class="cmty-posting-announce-through" placeholder="yyyy-mm-dd"></div>'
						);
						$submenu.append(self.$announce_through);
						this.$announce_through.on("click", function (e) {
							e.stopPropagation();
						});
						ComViews.makeAnnounceDateInput(
							self.$announce_through.find("input")
						);
						/*$announce_input.on('blur', function (e) {
							var date_val = $announce_input.val(),
								moment_date = moment(date_val, 'YYYY-MM-DD');

							if (!moment_date.isValid()) {
								ComViews.showErrorAtopAModal(Lang['post-environ-invalid-announce-date']);
								$announce_input.val('');
							} else if (moment().diff(moment(date_val, 'YYYY-MM-DD'), 'days') > 0) {
								ComViews.showErrorAtopAModal(Lang['post-environ-announce-date-too-early']);
								$announce_input.val('');
							}
						});*/
					}

					break;
			}

			// Position the submenu where it will look pretty.
			$submenu.css({
				left: button_position.left + parseInt($button.css("margin-left")),
				top: button_position.top + $button.height(),
			});

			return $submenu;
		},

		togglePoll: function () {
			if (this.has_poll) {
				this.onClickCancelPoll();
			} else {
				this.showPoll();
			}
		},

		showPoll: function () {
			if (!this.hasOwnProperty("$poll")) {
				this.createPoll();
			}
			this.$el.addClass("cmty-posting-with-poll");
			this.has_poll = true;
			this.setHeight();
			this.$poll_question.focus();
		},

		hidePoll: function () {
			this.$el.removeClass("cmty-posting-with-poll");
			this.has_poll = false;
			this.setHeight();
		},

		createPoll: function () {
			var template_data;

			template_data = {
				lang_poll_question: Lang["poll-question"],
				lang_poll_options: Lang["poll-options"],
				lang_poll_options_desc: Lang["poll-options-desc"],
				lang_options_per: Lang["poll-options-per"],
				lang_poll_length: Lang["poll-length"],
				lang_len_unlimited: Lang["poll-unlimited"],
				lang_len_1_day: Lang["poll-len-1-day"],
				lang_len_2_days: Lang["poll-len-2-days"],
				lang_len_3_days: Lang["poll-len-3-days"],
				lang_len_1_week: Lang["poll-len-1-week"],
				lang_len_2_weeks: Lang["poll-len-2-weeks"],
				lang_len_1_month: Lang["poll-len-1-month"],
				lang_revoting: Lang["poll-revoting"],
				No: Lang["No"],
				Yes: Lang["Yes"],
				lang_cancel_poll: Lang["poll-cancel"],
			};
			this.$poll = $(this.getTemplate("#cmty-poll-build-tpl", template_data));
			this.$poll_question = this.$poll.find("input.cmty-poll-question");
			this.$poll_inputs = this.$poll.find("textarea.cmty-poll-inputs");
			this.$el.find(".cmty-posting-box-container").before(this.$poll);
			this.has_poll_built = true;
		},

		onClickCancelPoll: function () {
			var self = this;

			if (
				this.$poll_question.val().length > 0 ||
				this.$poll_inputs.val().length > 0
			) {
				AoPS.Ui.Modal.showConfirm(
					Lang["poll-cancel-confirm"],
					function (ok) {
						if (ok) {
							self.hidePoll();
						}
					},
					{
						title: Lang["poll-cancel-title"],
						confirm_button_ok: Lang["poll-cancel"],
						confirm_button_cancel: Lang["poll-cancel-no"],
						width: "450px",
					}
				);
			} else {
				this.hidePoll();
			}
		},

		/**
		 * Children have more interesting conditions
		 * (NewTopic can allow setting announcement status from posting environ.)
		 **/
		canSetAnnounce: function () {
			return false;
		},

		/**
		 * Children have more interesting conditions
		 * (NewTopic can allow setting announcement status from posting environ.)
		 **/
		canSetGlobalAnnounce: function () {
			return false;
		},

		/**
		 * Wrap a textarea selection with some text.  Used for
		 *  the bbCode buttons.
		 *
		 * @param string : Stuff to put before selection.
		 * @param string : Stuff to put after selection.
		 **/
		wrapTextareaSelection: function (wrap_start, wrap_end) {
			var val = this.$post_box.val(),
				sel_start = this.$post_box[0].selectionStart,
				sel_end = this.$post_box[0].selectionEnd,
				new_string;

			new_string =
				val.slice(0, sel_start) +
				wrap_start +
				val.slice(sel_start, sel_end) +
				wrap_end +
				val.slice(sel_end);

			this.$post_box.val(new_string);
			this.$post_box.focus();
			this.$post_box[0].setSelectionRange(
				sel_start + wrap_start.length,
				sel_end + wrap_start.length
			);
		},

		replaceTextareaSelection: function (new_content) {
			var val = this.$post_box.val(),
				sel_start = this.$post_box[0].selectionStart,
				sel_end = this.$post_box[0].selectionEnd,
				new_string;

			new_string = val.slice(0, sel_start) + new_content + val.slice(sel_end);

			this.$post_box.val(new_string);
			this.$post_box.focus();
			this.$post_box[0].setSelectionRange(
				sel_start + new_content.length,
				sel_start + new_content.length
			);
		},

		/**
		 * previewPost previews the current post.
		 *
		 * TODO: Do we need a 'rendering preview' loader that gets removed upon finish?
		 */
		previewPost: function () {
			//var post_text = ;//.replace(/\r?\n/g, '<br />');
			// Send to master, render, get back and show.
			// 1) Put up a "rendering post" message?
			// 2) On load, show the rendered post.  Probably do this with
			//   a handler we pass in.

			// Are we already in the process of generating a preview?
			if (this.is_preview_processing) {
				return;
			}

			// Are we currently previewing?  If so, stop.
			//  Maybe toggling here is dumb.
			if (this.is_previewing) {
				this.$el.removeClass("cmty-posting-previewing");
				this.is_previewing = false;
				clearInterval(this.preview_interval);
				this.onClickClosePreview();
				return;
			}

			this.openPreviewWindow();

			this.generatePreview();
		},

		openPreviewWindow: function () {
			this.is_previewing = true;

			this.$el.addClass("cmty-posting-previewing");

			this.setHeight();
			if (this.settings.hasOwnProperty("onPreview")) {
				this.settings.onPreview();
			}
		},

		generatePreview: function (e) {
			var previous_preview,
				self = this;
			if (arguments.length > 0) {
				e.stopPropagation();
			}
			if (this.is_preview_processing) {
				return;
			}
			if (!Utils.cmty_ajax.ajax_active) {
				ComViews.showErrorAtopAModal(
					Utils.is_cmty_asleep
						? Lang["community-asleep-save"]
						: Lang["ajax-error-E_AJAX_UNKNOWN"]
				);
				return;
			}

			this.is_preview_processing = true;

			if (
				this.$post_box.val().length === 0 ||
				(this.extra_options.hasOwnProperty("disable_bbcode") &&
					this.extra_options.disable_bbcode)
			) {
				this.revealPreview(this.$post_box.val().replace(/\r?\n/g, "<br />"));
			} else {
				previous_preview = this.$preview_text.html();
				this.$preview_text.html("");

				this.$preview_text.append(this.$loader);

				this.settings.master.parseBBCode({
					text: this.$post_box.val(),
					post_format: "bbcode",
					onFinish: function (data) {
						self.revealPreview(data.rendered_text);
					},
					onAjaxFilter: function () {
						self.revealPreview(previous_preview);
					},
					onError: function (msg) {
						var bbCode_result;

						bbCode_result = self.checkCommonErrors(msg.error_code);

						AoPS.Ui.Modal.showAlertQuick(bbCode_result.message, {
							width: "400px",
						});
						if (bbCode_result.action === "close") {
							self.revealPreview("");
							self.onClickClosePreview();
						} else if (bbCode_result.action === "reveal_rendered") {
							// We won't get here, will we?
							self.revealPreview(msg.response.error_data);
							self.onClickClosePreview();
						}
					},
				});
			}
		},

		/**
		 * Check an error_code returned from Ajax for a common error.
		 *
		 * @param string error code
		 * @return object
		 *		action string: action to take due to this error
		 *			'reveal_rendered' : the rendered string was sent back along with the error;
		 *				you can fetch the response from the error and open up the preview window
		 *				with it.
		 *		close : close the preview window if open.
		 *		no_error_match : error_code doesn't match one of the common errors.
		 */
		checkCommonErrors: function (error_code) {
			var message = "",
				action = "";
			switch (error_code) {
				case "E_QUOTE_DEPTH":
					message = Lang["posting-quote-depth"];
					action = "close";
					break;

				case "E_HIDE_DEPTH":
					message = Lang["posting-hide-depth"];
					action = "close";
					break;

				case "E_UNBALANCED_TAGS":
					message = Lang["posting-unbalanced-tags"];
					action = "close";
					break;

				case "E_NAUGHTY_TERM_USED":
					message = Lang["new-topic-banned-term"];
					action = "close";
					break;

				case "E_POST_AUTO_FLAGGED_FIRST":
					message = Lang["posting-auto-flagged-first"];
					action = "close";
					break;

				case "E_POST_AUTO_FLAGGED_REPEAT":
					message = Lang["posting-auto-flagged-repeat"];
					action = "close";
					break;

				case "E_EDIT_AUTO_FLAGGED":
					message = Lang["edit-auto-flagged"];
					action = "close";
					break;

				case "E_FLAGGED_FOR_SELF_HARM":
					message = Lang["posting-flagged-for-self-harm"];
					action = "close";
					break;

				case "E_MODERATOR_COOLDOWN":
					message = Lang["posting-moderator-cooldown"];
					action = "close";
					break;

				case "E_NO_LINK_POSTING":
					message = Lang["new-topic-no-links"];
					action = "close";
					break;

				case "E_NO_IMAGE_POSTING":
					message = Lang["new-topic-no-images"];
					action = "close";
					break;

				case "E_INVALID_CHARACTER":
					message = Lang["new-topic-invalid-character"];
					action = "close";
					break;

				case "E_TOO_MANY_EMOJI":
					message = Lang["new-topic-too-many-emoji"];
					action = "close";
					break;

				case "E_LATEX_ERROR":
					message = Lang["posting-latex-error"];
					action = "reveal_rendered";
					break;

				case "E_ASY_ERROR":
					message = Lang["posting-asy-error"];
					action = "reveal_rendered";
					break;

				case "E_YOUTUBE_ERROR":
					message = Lang["posting-youtube-error"];
					action = "close";
					break;

				case "E_POST_TOO_SHORT":
					message = Lang["new-topic-post-too-short"];
					action = "close";
					break;

				case "E_POST_TOO_LONG":
					message = Lang["new-topic-post-too-long"];
					action = "close";
					break;

				case "E_POST_TOO_LONG_PYTHON":
					message = Lang["new-topic-post-too-long-python"];
					action = "close";
					break;

				case "E_TOPIC_TITLE_TOO_SHORT":
					message = Lang["new-topic-title-too-short"];
					action = "close";
					break;

				case "E_TOPIC_TITLE_TOO_LONG":
					message = Lang["new-topic-title-too-long"];
					action = "close";
					break;

				case "E_NO_FLOODING":
					message = Lang["posting-no-flooding-error"];
					action = "close";
					break;

				case "E_NO_SUCH_CATEGORIES":
					message = Lang["new-topic-category-deleted"];
					action = "close";
					break;

				case "E_DENYLISTED":
					message = Lang["new-topic-denylist-trigger"];
					action = "close";
					break;

				case "E_NEW_USER_TEXT_DENYLIST":
					message = Lang["new-topic-denylist-text-trigger"];
					action = "close";
					break;

				case "E_INVALID_ANNOUNCE_DATE":
					message = Lang["post-environ-invalid-announce-date"];
					action = "close";
					break;

				case "E_IMG_ERROR":
					message = Lang["post-environ-image-error"];
					action = "close";
					break;

				case "E_TIP_ERROR":
					message = Lang["post-environ-tip-error"];
					action = "close";
					break;

				case "E_ANNOUNCE_DATE_IN_PAST":
					message = Lang["post-environ-announce-date-too-early"];
					action = "close";
					break;

				case "E_NEW_USER_LIMITED":
					message = Lang["new-reply-err-E_NEW_USER_LIMITED"];
					action = "close";
					break;

				case "E_NEW_VPN_USER_LIMITED":
					message = Lang["new-reply-err-E_NEW_VPN_USER_LIMITED"];
					action = "close";
					break;

				case "E_AJAX_TIMEOUT":
					message = Lang["generic-ajax-timeout"];
					action = "close";
					break;

				case "E_MAX_IMAGES_EXCEEDED":
					message = "Maximum number of images exceeded.";
					action = "close";
					break;

				default:
					message = "An unknown error occured.";
					action = "no_error_match";
					break;
			}

			return {
				action: action,
				message: message,
			};
		},

		/* eslint-disable no-undef */

		/**
		 * revealPreview shows the rendered preview text.
		 *
		 * @param preview: rendered text to show the user.
		 */
		revealPreview: function (preview) {
			this.$loader.detach();
			this.$preview_text.html(preview);

			this.setHeight();
			this.is_preview_processing = false;

			// Process highlights
			if (this.$preview_text.length > 0 && typeof Prism !== "undefined") {
				Prism.plugins.autoloader.languages_path =
					"https://cdnjs.cloudflare.com/ajax/libs/prism/1.17.1/components/";
				var elements = this.$preview_text[0].querySelectorAll("pre code");
				for (var i = 0; i < elements.length; i++) {
					Prism.highlightElement(elements[i]);
				}
			}

			if (typeof this.settings.onRevealPreview === "function") {
				this.settings.onRevealPreview();
			}
		},

		/* eslint-enable no-undef */

		/**
		 * Currently overwritten by extensions.
		 */
		submitPost: function () {
			// If it's a reply, throw an antonio delay, then close
			// If a new topic, then throw a delay antonio and close
			// Maybe wait for the post to complete -- yeah, that's a good idea
			//  Throw antonio -- sending your post to
			//   AoPS HQ.  On return, throw a new antonio on delay.
			/*
			  If topic, then forum must be set.  Also, antonio an
			   "Are you sure?" if no tags are set.
			*/
		},

		/**
		 * Get the contents of the post.
		 **/
		fetchPostContent: function () {
			return this.$post_box.val();
		},

		/**
		 * checkPost checks whether the body of a post fits whatever restrictions we
		 *  like.  Currently just checks the length.
		 */
		checkPost: function () {
			var post_length = $.trim(this.fetchPostContent()).length,
				poll_question_length,
				poll_inputs_length;

			if (!Utils.cmty_ajax.ajax_active) {
				ComViews.showErrorAtopAModal(
					Utils.is_cmty_asleep
						? Lang["community-asleep-save"]
						: Lang["ajax-error-E_AJAX_UNKNOWN"]
				);
				return false;
			}

			if (post_length < Constants.min_post_length) {
				this.showError(Lang["new-topic-post-too-short"]);
				return false;
			} else if (post_length > Constants.max_post_length) {
				this.showError(Lang["new-topic-post-too-long"]);
				return false;
			} else if (
				this.has_poll &&
				(this.$poll_question.val().length > 0 ||
					this.$poll_inputs.val().length > 0)
			) {
				poll_question_length = $.trim(this.$poll_question.val()).length;
				if (poll_question_length == 0) {
					this.showError(Lang["poll-no-question-error"]);
					return false;
				}
				if (poll_question_length < Constants.min_poll_question_length) {
					this.showError(Lang["poll-question-too-short"]);
					return false;
				}
				if (poll_question_length > Constants.max_poll_question_length) {
					this.showError(Lang["poll-question-too-long"]);
					return false;
				}
				poll_inputs_length = $.trim(this.$poll_inputs.val());
				if (poll_inputs_length == 0) {
					this.showError(Lang["poll-no-inputs-error"]);
					return false;
				}
			}
			return true;
		},

		/**
		 * Show an error.
		 *
		 * @param string : Error message.
		 **/
		showError: function (error) {
			AoPS.Ui.Modal.showAlert(error);
			return;
		},

		/**
		 * checkTitle checks whether the title of a post fits whatever restrictions we
		 *  like.  Currently just checks the length.
		 */
		checkTitle: function () {
			if (
				$.trim(this.$title_box.val()).length < Constants.min_topic_title_length
			) {
				this.showError(Lang["new-topic-title-too-short"]);
				return false;
			}
			return true;
		},

		onClose: function () {
			if (this.hasOwnProperty("preview_interval")) {
				clearInterval(this.preview_interval);
			}
			if (this.hasOwnProperty("attachments_view")) {
				this.attachments_view.close();
			}
		},
	});

	/**
	 * Attachments to a post.
	 **/
	ComViews.PostingAttachments = AoPS.View.extend({
		template_id: "#cmty-posting-attachments-tpl",

		className: "cmty-posting-attachments",

		initialize: function (options) {
			var self = this,
				post_model = AoPS.Utils.getKeyChain(
					options.parent_view,
					"settings",
					"post_model"
				);
			this.parent_view = options.parent_view;
			if (!_.isUndefined(post_model)) {
				this.existing_attachments = post_model.get("attachments");
			} else {
				this.existing_attachments = [];
			}

			this.$el.html(
				this.getTemplate(this.template_id, {
					lang_upload: Lang["post-attachments-default"],
					has_existing_attachments: this.existing_attachments.length > 0,
					attachments: this.existing_attachments,
					lang_attach_done: Lang["post-attachments-done"],
					lang_already_attached: Lang["post-attachments-already-attached"],
				})
			);

			this.$post_attachments = this.$("#post-attachments");

			this.$post_attachments.dropzone({
				url: "/m/community/ajax.php",
				maxFiles:
					Constants.max_attachments_per_post - this.existing_attachments.length,
				addRemoveLinks: true,
				sending: function (file, xhr, formData) {
					formData.append("a", "upload_post_attachment");
					formData.append("aops_session_id", AoPS.session.id);
				},
				removedfile: function (file) {
					var _ref;
					self.parent_view.processAttachments(self);
					if ((_ref = file.previewElement) != null) {
						_ref.parentNode.removeChild(file.previewElement);
					}
					return this._updateMaxFilesReachedClass();
				},
				accept: function (file, done) {
					if (/[^a-zA-Z0-9\.\ \_\-]/.test(file.name)) {
						done("err-invalid-character");
					} else {
						done();
					}
				},
				fallback: function () {
					AoPS.Ui.Modal.showAlert(Lang["err-dropzone-fallback"], {
						width: "450px",
					});
					setTimeout(function () {
						AoPS.Ui.Modal.closeTopModal();
					}, 100);
				},
				maxFilesize: AoPS.Community.Constants.max_attachment_size / 1000,
				success: function (file, msg) {
					var error_msg;
					if (msg.hasOwnProperty("error_code")) {
						switch (msg.error_code) {
							case "E_TOO_MANY_FILES":
								error_msg = Lang["edit-avatar-too-many"];
								break;

							case "E_NO_FILE_SENT":
								error_msg = Lang["edit-avatar-no-file"];
								break;

							case "E_FILE_TOO_LARGE":
								error_msg = Lang["post-attachments-file-too-big"];
								break;

							case "E_NO_PERMISSION":
								error_msg = Lang["post-attachments-no-permission"];
								break;

							// CHANGE AS APPROPRIATE
							case "E_BAD_FILE_TYPE":
								error_msg = Utils.formatString(
									Lang["post-attachments-bad-file-type"],
									[file.name]
								);
								break;

							case "E_SPOOFED_FILE":
								error_msg = Lang["post-attachments-spoofed"];
								break;

							default:
								error_msg = Lang["unexpected-error-code"] + msg.error_code;
								break;
						}
						ComViews.showErrorAtopAModal(error_msg);
						this.removeFile(file);
					} else {
						file.tmp_name = msg.response.tmp_name;
						$(file.previewElement).addClass("dz-success");
						self.parent_view.processAttachments(self);
					}
				},
				error: function (file, error) {
					if (error === "err-invalid-character") {
						ComViews.showErrorAtopAModal(
							Lang["post-attachments-invalid-character"]
						);
					} else if (error.substr(0, 15) === "File is too big") {
						ComViews.showErrorAtopAModal(Lang["post-attachments-file-too-big"]);
					} else if (
						error.substr(0, 35) === "You can't upload files of this type"
					) {
						ComViews.showErrorAtopAModal(
							Utils.formatString(Lang["post-attachments-bad-file-type"], [
								file.name,
							])
						);
					}
					this.removeFile(file);
				},
			});
			this.dropzone = this.$post_attachments[0].dropzone;
		},

		events: {
			"click .post-attachment-existing-row .aops-font":
				"removeExistingAttachment",
			"click .cmty-attach-done": "onClickDone",
		},

		removeExistingAttachment: function (e) {
			var removed_attachment,
				target = e.currentTarget,
				url;
			url = $(target.parentNode).find("input").val();
			removed_attachment = _.findWhere(this.existing_attachments, {
				url: url,
			});
			this.existing_attachments = _.without(
				this.existing_attachments,
				removed_attachment
			);
			this.dropzone.options.maxFiles =
				Constants.max_attachments_per_post - this.existing_attachments.length;

			if (this.existing_attachments.length == 0) {
				this.$(".post-attachments-existing").remove();
			} else {
				target.parentNode.parentNode.removeChild(target.parentNode);
			}
			this.parent_view.processAttachments(this);
		},

		onClickDone: function () {
			Modal.closeTopModal();
		},

		show: function () {
			var self = this;
			this.$el.showModal({
				title: Lang["post-attachments-title"],
				width: "400px",
				frame_class: "aops-modal-standard cmty-upload-modal",
				onClose: function () {
					self.parent_view.$post_box.focus();
				},
			});
		},
	});

	/**
	 * Throw a confirm window for the MIT PRIMES Polymath.
	 **/
	ComViews.throwPolymathConfirm = function (obj) {
		var confirm_view;

		confirm_view = new ComViews.PolymathConfirmation(obj);

		confirm_view.$el.showModal({
			type: "confirm",
			width: "450px",
			close_on_button_click: false,
			scrollable: true,
			onButtonClick: function (value) {
				if (value) {
					// Get the selected radio button.  If none, then must
					//  tell them to choose one.
					if (
						!confirm_view.$('input[name="agree"]')[0].checked ||
						(!confirm_view.$('input[name="is_student"]')[0].checked &&
							!confirm_view.$('input[name="is_student"]')[1].checked)
					) {
						// THROW AN ERROR
						ComViews.showErrorAtopAModal(Lang["polymath-force-choice"]);
					} else {
						ComViews.throwLoaderBlockingMessage(
							Lang["polymath-confirm-blocker"]
						);
						AoPS.Community.MasterModel.sendPolymathConfirm({
							category_id: obj.category_id,
							student_type: confirm_view
								.$('input[name="is_student"]:checked')
								.val(),
							onFinish: function () {
								Modal.closeTopModal();
								Modal.closeTopModal();
							},
							onError: function (msg) {
								// Should do something smarter here once I know what the errors are.
								Modal.showAlert(
									Utils.formatString(Lang["polymath-confirm-unknown-error"], [
										msg.error_code,
									]),
									{
										width: "400px",
										onClose: function () {
											Modal.closeTopModal();
											Modal.closeTopModal();
										},
									}
								);
							},
						});
						// Send answer to mother ship and close this window.
					}
				} else {
					Modal.closeTopModal();
				}
			},
			onClose: function () {
				confirm_view.close();
			},
		});
	};

	ComViews.PolymathConfirmation = AoPS.View.extend({
		template_id: "#cmty-polymath-confirm-tpl",

		initialize: function (obj) {
			this.$el.html(
				this.getTemplate(this.template_id, {
					error_message: obj.error,
				})
			);
		},
	});

	/**
	 * NewTopic extends PostingEnviron for posting new topics in the Community.
	 *  See PostingEnviron for many more details.
	 *
	 * model : AoPS.Community.CategoryForum
	 *
	 * Methods defined here:
	 * validatePost()
	 *  	Make sure i's dotted and t's crossed before sending to database.
	 *
	 * submitPost()
	 *  	What to do when user hits submit.
	 *
	 * TODO : Deal with Forum and with Tags.
	 */
	ComViews.NewTopic = ComViews.PostingEnviron.extend({
		className:
			ComViews.PostingEnviron.prototype.className + " cmty-new-topic-popup",

		topic_type: "forum",

		render: function () {
			var self = this;

			if (
				this.model
					.get("master")
					.get("current_user")
					.get("posting_subscribe_new_topic")
			) {
				this.extra_options["notify_email"] = true;
				this.extra_options["bookmark_feed"] = true;
			}

			// TODO : Move these settings into the parent object and use inheritance.
			// See PrivateConversation for which are going to have to be overwritten
			//  Probably just have a handlebars_settings, and use extend to overwrite?
			this.$el.append(
				this.getTemplate(this.template_id, {
					category_name: this.model.get("category_name"),
					has_subject: true,
					has_forum: true,
					has_halp:
						this.model.get("has_halp") &&
						this.model.get("master").fetchPermission("can_post_as_halp"),
					has_tags: true,
					has_recipients: false,
					is_new_pm: this.is_new_pm,
					lang_view_attachments: Lang["new-topic-preview-bar-attachments"],
					lang_subject: Lang["new-topic-subject"],
					lang_tags: Lang["new-topic-tags"],
					lang_recipients: Lang["new-topic-to"],
					lang_post_anonymous: Lang["new-topic-post-anon"],
					lang_preview: Lang["new-topic-preview"],
					lang_close_preview: Lang["new-topic-close-preview"],
					lang_refresh: Lang["new-topic-refresh-preview"],
					max_post_length: Constants.max_post_length,
					max_title_length: Constants.max_topic_title_length,
					has_source: this.model.get("has_source"),
					lang_source: Lang["topic-cell-source"],
					max_source_length: Constants.max_source_length,
					source_placeholder: Lang["new-topic-source-placeholder"],
				})
			);
			this.$source = this.$("input.cmty-source-input");
			this.$el.find(".cmty-posting-forum-name").css({
				"background-color": this.model.get("main_color"),
			});
			this.in_autotag_delete = false; // True when deleting all autotags for whole post delete
			this.removed_autotags = [];
			Utils.autotagger.dictionary = this.model.getTermTagDictionary();
			if (this.model.get("allow_autotag")) {
				if (this.model.get("has_source")) {
					this.$source.on("keyup", function (e) {
						self.onSourceKeypress(e);
					});
				}
			}

			this.tag_warning_issued = false;

			this.finishRender();
			this.autotagging_disabled = this.model
				.get("master")
				.get("current_user")
				.get("turn_off_autotagging");
		},

		finishRender: function () {
			var self = this;
			this.appendTagBox();

			// This makes me sad.  When we can set heights to 'calc(100%-5px)' or some such
			//  by Javascript (IE fails), then we can remove this.
			$(window).on("resize.new-topic-" + this.cid, function () {
				self.setHeight();
			});
			this.$el.showModal({
				frame_class: "cmty-posting-modal",
				mask_fade_in_speed: 200,
				scrollable: false,
				draggable: true,
				draggable_options: {containment: "window"},
				max_width: "1000px",
				onClickMask: function (e) {
					// self.onClickCancel();
					return false;
				},
				onClickX: function () {
					self.onClickCancel();
					return false;
				},
			});
			if (this.$el.find(".cmty-private-recipients")) {
				this.$el.find(".cmty-private-recipients input").focus();
			} else {
				this.$el.find(".cmty-subject-input").focus();
			}
			this.setHeight();
			this.listenTo(Backbone, "community_disabled", this.onDeactivated);
			ComViews.setTabTarget(this.$("textarea"), this.$(".cmty-submit-button"));
			ComViews.setTabTarget(
				this.$(".cmty-cancel-button"),
				this.$(".cmty-subject-input")
			);
			ComViews.setTabTarget(
				this.$(".cmty-submit-button"),
				this.$(".cmty-cancel-button")
			);
			ComViews.setTabTarget(
				this.$('input[type="text"]').last(),
				this.$("textarea")
			);
		},

		/**
		 * Actions to take when we type in the subject box
		 **/
		onSubjectKeypress: function (e) {
			var char_code = e.which || e.keyCode;
			if (!this.model.get("allow_autotag")) {
				return;
			}

			if (char_code !== 32) {
				return;
			}

			// We process starting from where the cursor is, not from the end of the textarea.
			this.processTextForAutotagging(
				e.currentTarget.value.substr(0, e.currentTarget.selectionStart)
			);
		},

		onSourceKeypress: function (e) {
			var char_code = e.which || e.keyCode;
			if (!this.model.get("allow_autotag")) {
				return;
			}

			if (char_code !== 32) {
				return;
			}
			// We process starting from where the cursor is, not from the end of the textarea.
			this.processTextForAutotagging(
				e.currentTarget.value.substr(0, e.currentTarget.selectionStart)
			);
		},

		onPostKeypress: function (e) {
			var char_code = e.which || e.keyCode,
				text = this.$post_box.val();

			if (!this.model.get("allow_autotag")) {
				return;
			}

			if (char_code !== 32 && char_code !== 13) {
				return;
			}

			// We process starting from where the cursor is, not from the end of the textarea.
			text = text.substr(0, e.currentTarget.selectionStart);
			this.processTextForAutotagging(text);
		},

		processTextForAutotagging: function (text) {
			var tags = [],
				last_words,
				last_two_words,
				last_word,
				self = this;

			if (this.autotagging_disabled) {
				return;
			}
			if (_.isUndefined(text) || text.length === 0) {
				return;
			}

			last_words = _.last(
				text
					.replace(/(;|:|\.|,|\r\n|\n|\r)/gm, " ")
					.replace(/\s{2,}/g, " ")
					.trim()
					.split(" "),
				3
			);
			last_word = last_words[last_words.length - 1].toLowerCase();

			if (last_words.length > 1) {
				last_two_words =
					last_words[last_words.length - 2].toLowerCase() + " " + last_word;
				tags = tags.concat(Utils.autotagger.tag(last_two_words));
				if (last_words.length === 3) {
					tags = tags.concat(
						Utils.autotagger.tag(
							last_words[0].toLowerCase() + " " + last_two_words
						)
					);
				}
			}

			tags = tags.concat(Utils.autotagger.tag(last_word));

			_.each(tags, function (tag) {
				if (
					_.isUndefined(
						_.findWhere(self.removed_autotags, {
							item_id: tag.id,
						})
					)
				) {
					self.editable_tagbox.submitItemSilent({
						item_id: tag.id,
						label: tag.text,
						term_text: tag.term_text,
						term_id: tag.term_id,
						item_forum_id: self.model.get("category_id"),
						is_visible: true,
						main_color: self.model.get("main_color"),
						secondary_color: self.model.get("secondary_color"),
						tag_source: "auto",
					});
				}
			});
		},

		removeAllAutoTags: function () {
			var $items = this.editable_tagbox.$items,
				self = this;
			this.in_autotag_delete = true;
			_.each($items, function ($item) {
				if (
					$item.data("item").hasOwnProperty("tag_source") &&
					$item.data("item").tag_source === "auto"
				) {
					self.editable_tagbox.removeItem($item);
				}
			});
			this.in_autotag_delete = false;
		},

		// Assumes that posting a new topic is always on a Modal?
		onClickCancel: function () {
			if (this.fetchPostContent().length > Constants.posting_warn_limit) {
				AoPS.Ui.Modal.showConfirm(
					Lang["new-topic-are-sure"],
					_.bind(function (val) {
						if (val) {
							AoPS.Ui.Modal.closeAllModals();
							this.close();
						} else {
							AoPS.Ui.Modal.closeTopModal();
						}
					}, this),
					{
						confirm_button_cancel: Lang["new-topic-confirm-cancel"],
						confirm_button_ok: Lang["new-topic-confirm-OK"],
						close_on_button_click: false,
					}
				);
			} else {
				AoPS.Ui.Modal.closeAllModals();
			}
		},

		/**
		 * Can this user make this topic an announcement?
		 **/
		canSetAnnounce: function () {
			return this.model.getPermission("c_can_announce");
		},

		/**
		 * Can this user make this topic a global announcement?
		 **/
		canSetGlobalAnnounce: function () {
			return this.model.getPermission("c_can_global_announce");
		},

		// Overwritten in PrivateConversation
		validatePost: function (onValidated) {
			var result = this.checkPost() && this.checkTitle();
			onValidated(result);
		},

		parseSubmittedTags: function () {
			var self = this;

			if (!this.settings.hasOwnProperty("tags")) {
				return [];
			}

			return _.map(this.settings.tags, function (tag) {
				return {
					item_id: 0,
					value: tag,
					item_forum_id: self.model.get("category_id"),
					main_color: self.model.get("main_color"),
					secondary_color: self.model.get("secondary_color"),
					label: tag,
					is_visible: true,
					is_special:
						self.settings &&
						self.settings.special_item &&
						tag &&
						self.settings.special_item.toLowerCase() === tag.toLowerCase(),
				};
			});
		},

		/**
		 * Add the tag box to the posting environment.
		 */
		appendTagBox: function () {
			var tags_items = this.parseSubmittedTags();
			var self = this;

			/**
			 * We can't have something like
			 * this.tags = [];
			 * and then pass that into EditableTagBox as items because
			 * removal of an item causes the items array to get re-created.
			 **/
			this.editable_tagbox = new ComViews.EditableTagBox({
				category: this.model,
				items: tags_items,
				input_on_blur: true,
				onAddItem: function (item, $item) {
					self.checkSpecialItem(item, $item);
					self.setHeight();
				},
				tryToRemoveItem: function (obj) {
					var $focused = $(":focus"),
						item,
						focused_on_tag_input = $focused === self.editable_tagbox.$input_box;

					if (obj instanceof jQuery) {
						item = obj.data("item");
					} else {
						item = obj;
					}

					if (
						self.fetchSpecialItemText().toLowerCase() ===
						item.label.toLowerCase()
					) {
						Modal.showConfirm(
							Utils.formatString(Lang["new-topic-remove-link-confirm"], [
								self.model.get("category_name"),
							]),
							function (ok) {
								if (ok) {
									self.editable_tagbox.removeItem(obj);
								} else {
								}
								if (focused_on_tag_input) {
									self.editable_tagbox.$input_box.focus();
								} else {
									$focused.focus();
								}
							},
							{
								width: "450px",
							}
						);
					} else {
						self.editable_tagbox.removeItem(obj);
					}
				},
				onRemoveItem: function (item) {
					if (
						!self.in_autotag_delete &&
						item.hasOwnProperty("tag_source") &&
						item.tag_source === "auto"
					) {
						self.removed_autotags.push(item);
					}
					self.setHeight();
				},
			});
			this.$el.find(".cmty-tags-line").append(this.editable_tagbox.$el);
		},

		/**
		 * When a tag is added, check if it is the "special item" in the Itembox, and
		 *  put the class on the item if it is.
		 *
		 * Used for the linked_tag when a topic is linked to something on the site.
		 *  If the user deletes the linked tag and then adds it back, we re-link the topic.
		 *
		 * @param object item from a Tagbox (which is an extension of Itembox)
		 * @param jQuery object for the item
		 **/
		checkSpecialItem: function (item, $item) {
			var special_tag = this.fetchSpecialItemText();
			if (special_tag.toLowerCase() === item.label.toLowerCase()) {
				$item.addClass("cmty-special-item");
			}
		},

		fetchSpecialItemText: function () {
			return typeof this.settings.special_item === "string"
				? this.settings.special_item
				: "";
		},

		setHeight: function () {
			var poll_height = this.has_poll ? this.$poll.outerHeight() : 0,
				total_height_others =
					poll_height +
					this.$el.find(".cmty-posting-top").outerHeight() +
					this.$el.find(".cmty-posting-button-row").outerHeight() +
					this.$el.find(".cmty-posting-preview-bar").outerHeight(),
				parent_height = this.$el.height();

			if (this.is_previewing) {
				// When all browsers support setting height to a 'calc' via javascript, edit this and
				//  remove the $(window).on('resize') event in render and in the onClose.
				this.$el
					.find(".cmty-posting-box-container")
					.height((parent_height - total_height_others) / 2);
				this.$(".cmty-post-preview").height(
					(parent_height - total_height_others) / 2
				);
			} else {
				this.$el
					.find(".cmty-posting-box-container")
					.height(parent_height - total_height_others);
			}
		},

		/**
		 * submitPost are the actions to take when the user hits submit.
		 *  DOCUMENT WHAT's up with recipients.
		 */
		submitPost: function () {
			var self = this,
				throw_warning = false,
				warning_message,
				template,
				modal_title,
				$warning;

			this.validatePost(function (result) {
				if (!result) {
					return;
				}

				if (self.model.get("allow_autotag")) {
					self.processTextForAutotagging(self.$title_box.val());
					if (self.model.get("has_source")) {
						self.processTextForAutotagging(self.$source.val());
					}
				}

				if (self.model.get("category_id") === Constants.olympiad_forum_id) {
					if (
						!self.tag_warning_issued &&
						(self.editable_tagbox.items.length === 0 ||
							!self.doesEssentialTagExist(Constants.essential_tags_olympiad))
					) {
						throw_warning = true;
						warning_message = Lang["new-topic-olympiad-tags-warning"];
						modal_title = Lang["new-topic-olympiad-tag-warning-title"];
						template = "#cmty-olympiad-tag-modal-tpl";
						self.tag_warning_issued = true;
					}
				} else if (
					self.model.get("category_id") === Constants.college_math_forum_id
				) {
					if (
						!self.tag_warning_issued &&
						(self.editable_tagbox.items.length === 0 ||
							!self.doesEssentialTagExist(Constants.essential_tags_college))
					) {
						throw_warning = true;
						warning_message = Lang["new-topic-college-tags-warning"];
						modal_title = Lang["new-topic-college-tag-warning-title"];
						template = "#cmty-college-tag-modal-tpl";
						self.tag_warning_issued = true;
					}
				}
				if (throw_warning) {
					$warning = $(
						self.getTemplate(template, {
							message: warning_message,
						})
					);
					$warning.showModal({
						title: modal_title,
						width: "460px",
					});
					$warning.find(".cmty-item-tag").on("click", function (e) {
						var num_tags = self.editable_tagbox.items.length;

						if (num_tags === Constants.max_tags_per_topic) {
							self.editable_tagbox.removeItem(
								self.editable_tagbox.items[num_tags - 1]
							);
						}
						self.editable_tagbox.buildNewItem({
							item_id: parseInt(e.currentTarget.getAttribute("tag_id")),
							value: e.currentTarget.innerHTML,
							item_forum_id: self.model.get("category_id"),
							main_color: self.model.get("main_color"),
							secondary_color: self.model.get("secondary_color"),
							label: e.currentTarget.innerHTML,
							is_special: false,
						});
						Modal.closeTopModal();
					});
				} else if (
					self.editable_tagbox.items.length === 0 &&
					self.topic_type === "forum"
				) {
					AoPS.Ui.Modal.showConfirm(
						Lang["new-topic-no-tags-message"],
						function (ok) {
							if (ok) {
								self.finishSubmitPost(true);
							} else {
								AoPS.Ui.Modal.closeTopModal();
							}
						},
						{
							confirm_button_ok: Lang["new-topic-no-tags-confirm-yes"],
							confirm_button_cancel: Lang["new-topic-no-tags-confirm-no"],
							width: "400px",
							close_on_button_click: false,
						}
					);
				} else {
					self.finishSubmitPost(false);
				}
			});
		},

		doesEssentialTagExist: function (tags) {
			var n_tags = tags.length,
				tag_strings = [],
				i;

			tag_strings = _.map(this.editable_tagbox.items, function (tag) {
				return tag.value.toLowerCase();
			});

			for (i = 0; i < n_tags; i++) {
				if (_.indexOf(tag_strings, tags[i]) > -1) {
					return true;
				}
			}

			return false;
		},

		isPostingAsSheriff: function () {
			return (
				this.is_new_pm &&
				this.model.get("master").fetchPermission("can_pm_as_sheriff") &&
				this.$(".cmty-posting-sheriff input")[0].checked
			);
		},

		isPostingAsHalp: function () {
			return (
				this.model.get("has_halp") &&
				this.model.get("master").fetchPermission("can_post_as_halp") &&
				this.$(".cmty-posting-halp input")[0].checked
			);
		},

		finishSubmitPost: function (replace_top_modal) {
			var self = this,
				title = this.$title_box.val(),
				topic_settings;

			this.prepareToSubmitPost(replace_top_modal);

			topic_settings = _.extend(
				{
					category_id: this.model.get("category_id"),
					topic_type: this.topic_type,
					title: title,
					has_poll: 0,
					allow_latex_errors: this.allow_latex_errors,
					target_url: this.settings.hasOwnProperty("target_url")
						? this.settings.target_url
						: "",
					target_url_application: this.settings.hasOwnProperty(
						"target_url_application"
					)
						? this.settings.target_url_application
						: "",
					target_text: this.settings.hasOwnProperty("target_text")
						? this.settings.target_text
						: "",
					problem_text: this.settings.hasOwnProperty("problem_text")
						? this.settings.problem_text
						: "",
					post_text: this.fetchPostContent(),
					post_as_halp: this.isPostingAsHalp(),
					attachments: this.attachments,
					pm_as_sheriff: this.isPostingAsSheriff(),
					tags: this.editable_tagbox.items,
					linked_tag:
						typeof this.settings.special_item === "string"
							? this.settings.special_item
							: "",
					removed_autotags: this.hasOwnProperty("removed_autotags")
						? this.removed_autotags
						: [],
					hidden_tags: this.settings.hasOwnProperty("hidden_tags")
						? this.settings.hidden_tags
						: [],
					restricted_tags: this.settings.hasOwnProperty("restricted_tags")
						? this.settings.restricted_tags
						: [],
					source: _.isUndefined(this.$source) ? "" : this.$source.val(),
					onFinish: function (msg) {
						var topic_id = msg.topic_id;
						ComViews.delayModalClearing({
							onClose: function () {
								self.onPostedNewTopic({
									topic: msg.topic_model,
									topic_id: topic_id,
									title: title,
								});

								self.close();
							},
						});
					},
					onDeactivated: function () {
						self.onDeactivated();
					},
					onError: function (msg) {
						var output_string, username;

						if (typeof Lang["new-topic-err-" + msg.error_code] === "string") {
							output_string = Lang["new-topic-err-" + msg.error_code];
						} else if (msg.error_code === "E_TOPIC_FORUM_LOCKED") {
							output_string = Lang["new-topic-forum-locked"];
							self.model.setFrontEndLocked(true);
						} else if (msg.error_code === "E_NO_PERMISSION") {
							if (
								self.model.get("category_id") === Constants.private_messages_id
							) {
								if (!AoPS.hasFreeResourceAccess()) {
									output_string = Lang["new-pm-no-permission-free-resource"];
								} else {
									output_string = Lang["new-pm-no-permission"];
								}
							} else {
								output_string = Lang["new-topic-no-permission"];
							}
						} else if (msg.error_code === "E_AJAX_TIMEOUT") {
							output_string = Lang["new-topic-timeout"];
						} else if (msg.error_code === "E_USER_EXCLUDE_SELF") {
							username = self.removeParticipant(msg.response.error_data);
							output_string = Utils.formatString(
								Lang["private-user-excluded"],
								[username]
							);
						} else if (msg.error_code === "E_PM_SHERIFF") {
							username = self.removeParticipant(msg.response.error_data);
							output_string = Utils.formatString(Lang["private-user-sheriff"], [
								username,
							]);
						} else if (msg.error_code === "E_PM_EXTENSIONS") {
							username = self.removeParticipant(msg.response.error_data);
							output_string = Utils.formatString(
								Lang["private-user-extensions"],
								[username]
							);
						} else if (msg.error_code === "E_USER_EXCLUDED_FROM_PM") {
							username = self.removeParticipant(msg.response.error_data);
							output_string = Utils.formatString(
								Lang["private-user-excluded-by-system"],
								[username]
							);
						} else if (msg.error_code === "E_TOO_MANY_PARTICIPANTS") {
							output_string = Lang["private-new-msg-too-many-participants"];
						} else if (msg.error_code === "E_POLYMATH_NOT_OPTED_IN") {
							// Handled later.  Ick
						} else {
							var bbcode_error = self.checkCommonErrors(msg.error_code);

							if (bbcode_error.action === "reveal_rendered") {
								self.openPreviewWindow();
								self.revealPreview(msg.response.error_data);
							}
							output_string = bbcode_error.message;

							if (bbcode_error.action === "no_error_match") {
								output_string = Lang["unexpected-error-code"] + msg.error_code;
							}
						}

						if (
							msg.error_code === "E_LATEX_ERROR" ||
							msg.error_code === "E_ASY_ERROR"
						) {
							self.throwLatexErrorMessage(msg.error_code);
						} else if (msg.error_code === "E_POLYMATH_NOT_OPTED_IN") {
							AoPS.Ui.Modal.closeTopModal();
							ComViews.throwPolymathConfirm({
								category_id: self.model.get("category_id"),
								error: Lang["polymath-new-topic-confirm"],
							});
						} else {
							AoPS.Ui.Modal.showAlertQuick(output_string, {
								width: "400px",
								onClose: function () {
									AoPS.Ui.Modal.closeTopModal();
								},
							});
						}
					},
					recipients: this.hasOwnProperty("editable_recipient_box")
						? _.map(this.editable_recipient_box.items, function (recipient) {
								return recipient.user_id;
							})
						: [],
				},
				this.extra_options
			);
			topic_settings.announce_through = this.hasOwnProperty("$announce_through")
				? this.$announce_through.find("input").val()
				: "";

			if (this.has_poll) {
				topic_settings.has_poll = 1;
				topic_settings.poll_data = {
					question: this.$poll_question.val(),
					allow_revote: this.$poll.find('select[name="poll-revoting"]').val(),
					num_selections: this.$poll
						.find('select[name="poll-num-options"]')
						.val(),
					options: this.$poll_inputs.val(),
					length: this.$poll.find('select[name="poll-length"]').val(),
				};
			}
			this.settings.master.submitNewTopic(topic_settings);
		},

		onDeactivated: function () {
			Modal.closeAllModals();
			this.close();
		},

		prepareToSubmitPost: function (replace_top_modal) {
			// TODO: Why is this here?
			this.title = this.$title_box.val();

			if (replace_top_modal) {
				ComViews.replaceWithLoaderBlockingMessage(this.sending_blocker);
			} else {
				ComViews.throwLoaderBlockingMessage(this.sending_blocker);
			}
			this.listenTo(
				this.settings.master.get("topics"),
				"add",
				this.checkAddedTopic
			);
		},

		/**
		 * Here's what we do when we finish a topic.
		 **/
		onPostedNewTopic: function (obj) {
			var url_cmty_path = this.settings.hasOwnProperty("url_cmty_path")
				? this.settings.url_cmty_path
				: "";

			if (
				obj.topic.get("topic_type") === "private" &&
				this.model.get("master").get("current_user").get("pm_archive_on_send")
			) {
				return;
			} else if (!this.model.get("is_private") || ComViews.onPMPage()) {
				Backbone.history.navigate(
					url_cmty_path +
						"/c" +
						this.model.get("category_id") +
						"h" +
						obj.topic_id +
						"_" +
						ComViews.convertToUrlFragment(obj.title),
					{trigger: true}
				);
			}

			if (typeof this.settings.onSuccess === "function") {
				this.settings.onSuccess(obj);
			}
		},

		onClose: function () {
			this.editable_tagbox.close();
			$(window).off("resize.new-topic-" + this.cid);
		},
	});

	/**
	 * ComViews.NewReply extends PostingEnviron for
	 *  the full reply window that appears when you click Reply on a topic.
	 *  See PostingEnviron for many more details.
	 */
	ComViews.NewReply = ComViews.PostingEnviron.extend({
		has_subject: false,
		has_forum: false,
		has_source: false,
		no_permission_lang_property: "new-reply-no-permission",

		render: function () {
			this.sending_to_database = false;

			this.$el.append(
				this.getTemplate(
					this.template_id,
					_.defaults(this.settings, {
						has_subject: this.has_subject,
						has_forum: this.has_forum,
						category_name:
							this.has_forum && this.settings.topic.get("category_name"),
						has_tags: false,
						has_halp: false,
						is_new_pm: this.is_new_pm,
						has_source: this.has_source,
						lang_view_attachments: Lang["new-topic-preview-bar-attachments"],
						lang_subject: Lang["new-topic-subject"],
						lang_preview: Lang["new-topic-preview"],
						lang_close_preview: Lang["new-topic-close-preview"],
						lang_refresh: Lang["new-topic-refresh-preview"],
						max_post_length: Constants.max_post_length,
						max_title_length: Constants.max_topic_title_length,
						lang_source: Lang["topic-cell-source"],
						max_source_length: Constants.max_source_length,
						source_placeholder: Lang["new-topic-source-placeholder"],
					})
				)
			);
			if (this.has_forum) {
				this.$el.find(".cmty-posting-forum-name").css({
					"background-color": this.settings.topic.get("category_main_color"),
				});
			}
			ComViews.setTabTarget(this.$("textarea"), this.$(".cmty-submit-button"));
			ComViews.setTabTarget(this.$(".cmty-submit-button"), this.$("textarea"));
		},

		/**
		 * submitPost are the actions to take when the user hits submit.
		 *
		 * Note: ComViews.BlogShoutbox uses this function, too
		 */
		submitPost: function () {
			var post_text = this.$post_box.val(),
				self = this;

			if (AoPS.session.logged_in && !AoPS.session.initialized) {
				AoPS.Initialize.display({escapable: true});
				return;
			} else if (AoPS.isUserCoppaBlocked()) {
				AoPS.displayCoppaBlockedModal({escapable: true});
				return;
			}

			if (!this.checkPost()) {
				return false;
			}
			// TODO : Check if this is necessary
			if (this.settings.topic.get("topic_type") === "private") {
				this.checkParticipants();
			}

			this.throwBlockingMessage();

			this.sending_to_database = true;

			this.settings.master.submitPost(
				_.extend(
					{
						category_id: this.settings.category_id,
						post_text: post_text,
						topic_id: this.settings.topic_id,
						attachments: this.attachments,
						topic: this.settings.topic,
						allow_latex_errors: this.allow_latex_errors,
						onDeactivated: function () {
							Modal.closeAllModals();
						},
						onError: function (msg) {
							var output_string,
								code = msg.error_code,
								response = msg.response.error_data;

							self.sending_to_database = false;
							if (msg.error_code === "E_TOPIC_FORUM_LOCKED") {
								output_string = Lang["new-reply-forum-locked"];
								self.settings.master.setCategoryLockStatus(
									self.settings.topic.get("category_id"),
									true
								);
							} else if (code === "E_NOT_LOGGED_IN") {
								output_string =
									Lang["new-reply-logged-out-warning"] +
									'<br/><div style="text-align:center">\
							<textarea rows="4" style="width:80%">' +
									post_text +
									"</textarea>";
							} else if (code === "E_NO_PERMISSION") {
								if (!AoPS.hasFreeResourceAccess()) {
									output_string = Lang["new-reply-no-permission-free-resource"];
								} else {
									output_string = Lang[self.no_permission_lang_property];
								}
							} else if (code === "E_TOPIC_LOCKED") {
								output_string = Lang["new-reply-locked"];
							} else if (code === "E_NEW_USER_LIMITED") {
								output_string = Lang["new-reply-err-E_NEW_USER_LIMITED"];
							} else if (code === "E_NEW_VPN_USER_LIMITED") {
								output_string = Lang["new-reply-err-E_NEW_VPN_USER_LIMITED"];
							} else if (code === "E_AJAX_TIMEOUT") {
								output_string = Lang["new-reply-timeout"];
							} else if (code === "E_POLYMATH_NOT_OPTED_IN") {
								// Handled later.  Ick
							} else {
								var bbcode_error = self.checkCommonErrors(code);

								if (bbcode_error.action === "no_error_match") {
									output_string = Lang["unexpected-error-code"] + code;
								} else {
									if (bbcode_error.action === "reveal_rendered") {
										if (typeof self.openPreviewWindow === "function") {
											self.openPreviewWindow();
											self.revealPreview(response);
										}
									}
									output_string = bbcode_error.message;
								}
							}

							if (code === "E_LATEX_ERROR" || code === "E_ASY_ERROR") {
								self.throwLatexErrorMessage(code);
							} else if (code === "E_POLYMATH_NOT_OPTED_IN") {
								AoPS.Ui.Modal.closeTopModal();
								ComViews.throwPolymathConfirm({
									category_id: self.settings.category_id,
									error: Lang["polymath-reply-confirm"],
								});
							} else {
								AoPS.Ui.Modal.closeTopModal();
								AoPS.Community.Views.showError(output_string);
							}
						},
					},
					this.extra_options
				)
			);

			if (this.settings.hasOwnProperty("onSubmit")) {
				this.settings.onSubmit();
			}
			this.onFinishSubmit();
			return false;
		},

		throwBlockingMessage: function () {
			ComViews.throwLoaderBlockingMessage(Lang["topic-full-new-reply-blocker"]);
		},

		checkParticipants: function () {
			var topic = this.settings.topic;

			if (topic.get("participants").length === 1) {
				// talking to self already
				return;
			}

			if (
				_.filter(topic.get("participants"), function (participant) {
					return !participant.removed;
				}).length == 1
			) {
				AoPS.Ui.Flyout.display(Lang["private-reply-no-listeners"]);
			}
		},

		onErrorInPosting: function () {},

		onFinishSubmit: function () {
			//this.close();
		},

		onClickCancel: function () {
			if (this.fetchPostContent().length > Constants.posting_warn_limit) {
				AoPS.Ui.Modal.showConfirm(
					Lang["topic-full-reply-confirm"],
					_.bind(function (val) {
						if (val) {
							this.closeReply();
						}
					}, this),
					{
						confirm_button_cancel: Lang["topic-full-reply-confirm-cancel"],
						confirm_button_ok: Lang["topic-full-reply-confirm-OK"],
					}
				);
			} else {
				this.closeReply();
			}
		},

		closeReply: function () {
			if (this.settings.hasOwnProperty("onCancel")) {
				this.settings.onCancel();
			}
			$("#community-all").removeClass("reply-focused");
			$(window).trigger("resize");
			this.close();
		},
	});

	ComViews.EditPost = ComViews.PostingEnviron.extend({
		has_email_subscribe: false,

		has_add_to_feed: false,

		className:
			ComViews.PostingEnviron.prototype.className +
			" cmty-new-topic-popup cmty-edit-post",

		render: function () {
			this.has_source =
				this.has_source && this.settings.topic.get("can_have_source");
			if (this.settings.post_model.get("attachment")) {
				this.attachments = _.map(
					this.settings.post_model.get("attachments"),
					function (f) {
						return {
							href: f.href,
							existing: true,
							name: f.name,
							url: f.url,
						};
					}
				);
			}
			AoPS.Community.Views.NewReply.prototype.render.apply(this);
			if (this.settings.post_model.get("post_format") !== "bbcode") {
				this.extra_options["disable_bbcode"] = true;
				this.is_bbcode_enabled = false;
				this.$el.addClass("cmty-bbcode-disabled");
			}
			/*	if (this.settings.post_model.get('post_format') !== 'bbcode') {
				this.$el.find('input[name="cmty-post-extra-disable-bbcode"]')[0].checked = true;
			}*/
			if (this.settings.hasOwnProperty("input_text")) {
				this.$el.find("textarea").val(this.settings.input_text);
			}
			// TODO : what about disable bbcode
			$(window).on(
				"resize.edit-post-" + this.cid,
				_.bind(function () {
					this.setHeight();
				}, this)
			);

			if (this.has_source) {
				this.$source = this.$("input.cmty-source-input");
				this.$source.val(
					ComViews.decodeHtmlEntities(this.settings.topic.get("source"))
				);
			}

			if (this.has_subject) {
				this.$(".cmty-subject-input").val(
					ComViews.decodeHtmlEntities(this.settings.topic.get("topic_title"))
				);
			}
		},

		setHeight: ComViews.NewTopic.prototype.setHeight,

		/**
		 * submitPost are the actions to take when the user hits submit.
		 */
		submitPost: function () {
			if (!this.checkPost()) {
				return false;
			}

			if (this.has_subject && !this.checkTitle()) {
				return false;
			}

			/*	new_text = this.$el.find('textarea').val();

			if ($.trim(new_text) === $.trim(this.settings.input_text)) {
				if (!this.extra_options.hasOwnProperty('disable_bbcode') ||
					(this.preset_bbcode_value === this.extra_options.disable_bbcode)) {
					this.showError(Lang['edit-post-nothing-changed']);
					return false;
				}
			}
		*/
			this.requestReason();
		},

		requestReason: function () {
			var self = this,
				$reason = $(
					this.getTemplate("#cmty-edit-post-reason-tpl", {
						lang_instructions: Lang["edit-post-reason-info"],
					})
				);

			$reason.showAlert({
				title: Lang["edit-post-reason-heading"],
				width: "400px",
				focus_on_alert: false,
				frame_class: "cmty-edit-reason-modal aops-modal-standard",
				onButtonClick: function () {
					var reason = $reason.find("textarea").val().substr(0, 255);
					self.sendEdit(reason);
				},
				close_on_button_click: false,
			});

			$reason.find("textarea").focus();
			$reason.on("keydown", function (e) {
				var key_pressed = e.which || e.keyCode;

				if (key_pressed === 13 && (e.metaKey || e.ctrlKey)) {
					self.sendEdit($reason.find("textarea").val().substr(0, 255));
					e.stopPropagation();
					e.preventDefault();
				}
			});
		},

		/**
		 * We have the reason, now send the edit to the database.
		 *
		 * @param string reason for the edit
		 **/
		sendEdit: function (reason) {
			var self = this,
				post_text = this.$post_box.val();

			ComViews.replaceWithLoaderBlockingMessage(Lang["edit-send-blocker"]);

			this.settings.post_model.edit(
				_.extend(
					{
						edited_text: this.$post_box.val(),
						edit_reason: reason,
						allow_latex_errors: this.allow_latex_errors,
						source: this.has_source ? this.$source.val() : "",
						attachments: this.attachments,
						topic_title: this.has_subject ? this.$title_box.val() : "",
						onError: function (data) {
							var output_string,
								code = data.error_code;

							if (code === "E_TOPIC_FORUM_LOCKED") {
								output_string = Lang["new-topic-forum-locked"];
								self.settings.topic
									.get("master")
									.setCategoryLockStatus(
										self.settings.topic.get("category_id"),
										true
									);
							} else if (code === "E_NOT_LOGGED_IN") {
								output_string =
									Lang["edit-post-logged-out-warning"] +
									'<br/><div style="text-align:center">\
							<textarea rows="4" style="width:80%">' +
									post_text +
									"</textarea>";
							} else if (code === "E_NO_PERMISSION") {
								output_string = Lang["edit-post-no-permission"];
							} else if (code === "E_NO_SUCH_POST") {
								output_string = Lang["edit-post-no-post"];
							} else if (code === "E_NO_LINK_POSTING") {
								output_string = Lang["edit-post-no-links"];
							} else if (code === "E_NO_IMAGE_POSTING") {
								output_string = Lang["edit-post-no-images"];
							} else if (code === "E_INVALID_CHARACTER") {
								output_string = Lang["new-topic-invalid-character"];
							} else if (code === "E_TOO_MANY_EMOJI") {
								output_string = Lang["new-topic-too-many-emoji"];
							} else if (code === "E_NO_EDIT_MADE") {
								output_string = Lang["edit-post-nothing-changed"];
							} else if (code === "E_AJAX_TIMEOUT") {
								output_string = Lang["error-timeout"];
							} else {
								var bbcode_error = self.checkCommonErrors(code);

								if (bbcode_error.action === "reveal_rendered") {
									self.openPreviewWindow();
									self.revealPreview(data.response.error_data);
								}
								output_string = bbcode_error.message;
							}

							if (code === "E_LATEX_ERROR" || code === "E_ASY_ERROR") {
								self.throwLatexErrorMessage(code);
							} else {
								/* Don't use show error here since we just want to close top modal */
								AoPS.Ui.Modal.showAlertQuick(output_string, {
									width: "400px",
									onClose: function () {
										// Clear the error and the blocker
										AoPS.Ui.Modal.closeTopModal();
									},
								});
							}
						},
						onFinish: function () {
							setTimeout(function () {
								self.close();
								AoPS.Ui.Modal.closeAllModals();
							}, Constants.new_topic_modal_delay);
						},
					},
					this.extra_options
				)
			);
		},

		onClickCancel: function () {
			AoPS.Ui.Modal.showConfirm(
				Lang["topic-full-edit-confirm"],
				_.bind(function (val) {
					if (val) {
						if (this.settings.hasOwnProperty("onCancel")) {
							this.settings.onCancel();
						}
						AoPS.Ui.Modal.closeAllModals();
						this.close();
					}
				}, this),
				{
					confirm_button_cancel: Lang["topic-full-reply-confirm-cancel"], // re-using another setting
					confirm_button_ok: Lang["topic-full-edit-confirm-OK"],
				}
			);
		},

		onClose: function () {
			$(window).off("resize.edit-post-" + this.cid);
		},
	});

	ComViews.EditFirstPost = ComViews.EditPost.extend({
		has_subject: true,

		has_forum: true,

		has_source: true,
	});

	/**
	 * View for starting a new Private Conversation.
	 * Extends Community.Views.NewTopic
	 *
	 * New properties
	 * recipients array : [{username, user_id, admin}] of the people on this message.
	 * editable_recipient_box CommunityViews.EditableRecipientBox for this message
	 *
	 *
	 * Methods defined here:
	 * checkRecipients ()
	 *		Make sure we have recipients for the message.
	 *
	 * validatePost()
	 *    	Check to see that this post clears all necessary hurdles.
	 *
	 *
	 * preset_recipients is an array of objects of the form
	 *		is_admin int
	 *		is_visible boolean
	 *		label string (username)
	 *		user_id int
	 */
	ComViews.NewPrivateConversation = ComViews.NewTopic.extend({
		topic_type: "private",

		has_email_subscribe: false,

		has_add_to_feed: false,

		is_new_pm: true,

		autotagging_disabled: true,

		sending_blocker: Lang["new-pm-send-blocker"],

		render: function () {
			var initial_recipients = [];

			this.$el.append(
				this.getTemplate(
					this.template_id,
					_.defaults(this.settings, {
						has_subject: true,
						has_tags: true,
						has_recipients: true,
						has_halp: false,
						is_private: this.is_new_pm,
						can_pm_as_sheriff: this.model
							.get("master")
							.fetchPermission("can_pm_as_sheriff"),
						has_forum: false,
						lang_post_as_sheriff: Lang["new-topic-post-as-sheriff"],
						lang_view_attachments: Lang["new-topic-preview-bar-attachments"],
						max_post_length: Constants.max_post_length,
						max_title_length: Constants.max_topic_title_length,
						lang_subject: Lang["new-topic-subject"],
						lang_tags: Lang["new-topic-tags"],
						lang_recipients: Lang["new-topic-to"],
						lang_preview: Lang["new-topic-preview"],
						lang_close_preview: Lang["new-topic-close-preview"],
						lang_refresh: Lang["new-topic-refresh-preview"],
						has_source: false,
					})
				)
			);
			this.$el.addClass("cmty-new-private-conversation");

			this.tag_warning_issued = false;

			if (this.settings.hasOwnProperty("preset_recipients")) {
				initial_recipients = this.settings.preset_recipients;
			}
			/**
			 * We can't have something like
			 * this.recipients = [];
			 * and then pass that into EditableRecipientBox as items because
			 * removal of an item causes the items array to get re-created.
			 **/
			this.editable_recipient_box = new ComViews.EditableRecipientBox({
				model: this.settings.master,
				items: initial_recipients,
				onAddItem: _.bind(function () {
					this.setHeight();
				}, this),
				onRemoveItem: _.bind(function () {
					this.setHeight();
				}, this),
			});

			this.$el
				.find(".cmty-private-recipients")
				.append(this.editable_recipient_box.$el);
			this.finishRender(); // Identical to NewTopic
		},

		/**
		 * Make sure the message has recipients defined.
		 */
		checkRecipients: function (onValidated) {
			if (
				this.editable_recipient_box.items.length === 0 &&
				!this.editable_recipient_box.$input_box.val()
			) {
				this.showError(Lang["private-need-recipients-err"]);
				onValidated(false);
			} else if (this.editable_recipient_box.$input_box.val()) {
				this.model.checkValidPrivateRecipient({
					username: this.editable_recipient_box.$input_box.val(),
					onFinish: function (response) {
						if (response.is_unreachable) {
							var options = {
								type: "alert",
								body: Lang["private-unreachable-recipient"],
								frame_class: "aops-modal-quick",
							};
							AoPS.Ui.Modal.showMessage(this, options);
							onValidated(false);
						} else {
							onValidated(true);
						}
					},
				});
			} else {
				onValidated(true);
			}
		},

		removeParticipant: function (user_id) {
			var recipient_item = _.find(
					this.editable_recipient_box.items,
					function (user) {
						return parseInt(user.user_id) === user_id;
					}
				),
				username;

			if (!_.isUndefined(recipient_item)) {
				username =
					typeof recipient_item.value === "string"
						? recipient_item.value
						: recipient_item.label;
				this.editable_recipient_box.removeItem(recipient_item);
				return username;
			}
			return "";
		},

		/**
		 * Check that all required information has been inputted to this private message.
		 */
		validatePost: function (onValidated) {
			var self = this;
			this.checkRecipients(function (validRecipients) {
				var result = self.checkPost() && self.checkTitle() && validRecipients;
				onValidated(result);
			});
		},

		/**
		 * No announcements in Private Conversations categories.
		 */
		canSetAnnounce: function () {
			return false;
		},

		/**
		 * No global announcements made from private conversation categories.
		 **/
		canSetGlobalAnnounce: function () {
			return false;
		},
	});

	/**
	 * model : Community.Models.Post
	 *
	 */
	ComViews.ReportPost = AoPS.View.extend({
		template_id: "#cmty-report-post-tpl",

		className: "cmty-report-post cmty-modal-form aops-modal-standard",

		initialize: function () {
			this.$el.append(
				this.getTemplate(this.template_id, {
					username: this.model.get("username"),
					spam_text: Lang["topic-full-report-item-spam"],
					warez_text: Lang["topic-full-report-item-warez"],
					cheat_text: Lang["topic-full-report-item-cheat"],
					other_text: Lang["topic-full-report-item-other"],
				})
			);
		},

		events: {
			"submit form": "onFormSubmit",
			"click input[type=button]": "onClickCancel",
		},

		onClickCancel: function () {
			AoPS.Ui.Modal.closeAllModals();
			this.close();
		},

		onFormSubmit: function (e) {
			var reason = this.$el.find("select").val(),
				details = this.$el.find("textarea").val();

			this.model.report(reason, details);
			AoPS.Ui.Modal.showAlert(Lang["topic-full-report-report-sent"], {
				onClose: function () {
					AoPS.Ui.Modal.closeAllModals();
				},
			});
			this.close();

			e.preventDefault();
			e.stopPropagation();
			return false;
		},
	});

	/**
	 * Delete a post.
	 *
	 * model : Community.Models.Post
	 *
	 */
	/** Should be in common views **/
	ComViews.DeletePost = AoPS.View.extend({
		template_id: "#cmty-delete-post-tpl",

		className: "cmty-delete-post cmty-modal-form aops-modal-standard",

		initialize: function (options) {
			this.topic = options.topic;
			this.$el.append(
				this.getTemplate(this.template_id, {
					username: this.model.get("username"),
					can_hard_delete: this.topic.getPermission("c_can_hard_delete"),
					is_first_post: this.model.get("post_number") === 1,
				})
			);

			if (this.model.get("poster_id") !== AoPS.session.user_id) {
				this.$(".aops-modal-body")
					.append($("<h3 />").text("Reason:"))
					.append(Utils.getModerationInputsForType("topic"));
			}
		},

		events: {
			"submit form": "onFormSubmit",
			"click input[type=button]": "onClickCancel",
		},

		onClickCancel: function () {
			AoPS.Ui.Modal.closeAllModals();
			this.close();
		},

		onFormSubmit: function (e, obj) {
			var hard_delete = false,
				self = this,
				force_soft =
					!_.isUndefined(obj) && !_.isUndefined(obj.force_soft)
						? obj.force_soft
						: false,
				reason = this.$("input[name='reason']:checked").val() || "";

			if (!force_soft && this.topic.getPermission("c_can_hard_delete")) {
				hard_delete =
					this.$("input[name=delete_option]:checked").val() === "hard";
			}

			AoPS.Community.Views.throwBlockingMessage(
				Lang["topic-full-delete-post-pending"]
			);

			this.model.delete({
				hard_delete: hard_delete,
				reason: reason,
				onFinish: function (data) {
					if (!data.hasOwnProperty("topic_deleted") || !data.topic_deleted) {
						AoPS.Community.Views.delayModalClearing({
							onClose: function () {
								self.close();
							},
						});
					}
				},
				onError: function (data) {
					var code = data.error_code,
						msg;

					if (code === "E_NO_PERMISSION") {
						msg = Lang["delete-post-no-permission"];
					} else if (code === "E_NOT_LAST_POST") {
						msg = Lang["delete-post-not-last-post"];
					} else if (code === "E_HARD_DELETE") {
						msg = Lang["topic-full-undelete-hard"];
					} else if (code === "E_NO_DELETING_FIRST_POST") {
						msg = Lang["delete-post-sniped"];
					} else {
						msg = Lang["unexpected-error-code"] + code;
					}
					AoPS.Community.Views.showError(msg);
				},
			});

			e.preventDefault();
			e.stopPropagation();
			return false;
		},
	});

	/**
	 * View for the moderator page for all reported posts.
	 *
	 * model : Community.Models.Master (for now)
	 * reported_post_views : array of the PostReport Views for the post_reports held in this view
	 * interval : the SetInterval for the realtime monitor
	 *
	 * $loader : div we pop up during loads of reported posts
	 * $none : div we pop up if there are no reported posts
	 * $reported_posts : div that holds all the reported posts
	 *
	 *
	 */
	ComViews.PostReports = AoPS.View.extend({
		template_id: "#cmty-post-reports-tpl",

		initialize: function () {
			this.listenTo(
				this.model.get("reported_posts"),
				"add",
				this.addReportedPost
			);
			this.listenTo(
				this.model.get("reported_posts"),
				"remove",
				this.onPostReportFetchFinished
			);

			this.reported_post_views = [];
			this.$loader = AoPS.Page.buildLoader();

			this.$el.html(
				this.getTemplate(this.template_id, {
					page_title: Lang["post-report-admin-page-title"],
					top_text: Lang["post-report-admin-page-text"],
					loader: Lang["post-report-admin-loading"],
					none_found: Lang["post-report-admin-none"],
					is_admin: AoPS.session.admin,
				})
			);
			this.$initial_loading = this.$el.find(".cmty-post-reports-loader");
			this.$none = this.$el.find(".cmty-post-reports-none-found");
			this.$reported_posts = this.$el.find(".cmty-post-reports-container");
			this.listenTo(
				this.model,
				"post_reports_fetched",
				this.onPostReportFetchFinished
			);
			// TODO : scroll down, fetch more.
		},

		/**
		 * On added post report, we add a PostReport to this view.
		 *
		 * @param AoPS.Community.Model.PostReport
		 **/
		addReportedPost: function (reported_post) {
			if (reported_post.get("status") === "unresolved") {
				var reported_post_view = new ComViews.PostReport({
					model: reported_post,
				});
				this.reported_post_views.push(reported_post_view);
				this.$reported_posts.append(reported_post_view.$el);
			}
		},

		/**
		 * When we add this to the page, we perform a fetch of new reports and
		 *  call a setInterval to check for more reports "realtime".
		 **/
		onAddToPage: function (options) {
			var self = this;
			this.$initial_loading.show();
			this.$none.hide();

			this.focus = options;

			this.model.fetchReportedPosts();
			this.goToFocus();
			this.interval = setInterval(function () {
				self.model.fetchReportedPosts();
			}, Constants.intervals.current.reported_posts_interval);

			if (!this.model.get("all_past_reported_posts_fetched")) {
				$(window).on("scroll." + this.model.cid, function (ev) {
					if (
						window.innerHeight + window.pageYOffset + 10 >=
						document.body.offsetHeight
					) {
						if (
							!self.model.get("loading_post_reports") &&
							self.model.get("reported_posts").length > 0 &&
							!self.model.get("all_past_reported_posts_fetched")
						) {
							self.$el.append(self.$loader);
							self.model.fetchReportedPosts({
								fetch_before: self.model
									.get("reported_posts")
									.last()
									.get("inserted_at"),
								onFinish: function () {
									self.$loader.detach();
									if (self.model.get("all_past_reported_posts_fetched")) {
										self.$el.append(
											'<div class="cmty-no-more-reports">' +
												Lang["post-report-no-more"] +
												"</div>"
										);
									}
								},
							});
						}
					}
				});
			}
		},

		goToFocus: function () {
			var target_report, target_id;
			if (this.focus.hasOwnProperty("post_id")) {
				target_id = this.focus.post_id;
				target_report = _.find(
					this.reported_post_views,
					function (reported_post) {
						return reported_post.model.get("post_id") === target_id;
					}
				);
			} else if (this.focus.hasOwnProperty("topic_id")) {
				target_id = this.focus.topic_id;
				target_report = _.find(
					this.reported_post_views,
					function (reported_post) {
						return reported_post.model.get("topic_id") === target_id;
					}
				);
			}

			if (!_.isUndefined(target_report)) {
				this.goToTargetReport(target_report);
			}
		},

		goToTargetReport: function (target_report) {
			this.focus = {};
			window.scrollTo(0, target_report.$el.offset().top);
		},

		/**
		 * End the interval when we remove this view.
		 **/
		onRemoveFromPage: function () {
			clearInterval(this.interval);
			$(window).off(
				"scroll." + this.model.cid + " touchmove." + this.model.cid
			);
		},

		/**
		 * When we finish fetching data, we nuke the loader and decide whether or
		 *  not to give the "no reports" message.
		 **/
		onPostReportFetchFinished: function () {
			this.$initial_loading.hide();

			this.$none.toggle(
				_.isUndefined(
					this.model.get("reported_posts").findWhere({
						status: "unresolved",
					})
				)
			);
			this.goToFocus();
			this.focus = {};
		},

		onClose: function () {
			_.each(this.reported_post_views, function (view) {
				view.close();
			});
		},
	});

	/**
	 * Post cell on a Post Report.  Just need to wipe out a function
	 *	that refers to a topic view, since a Post Report Post doesn't
	 *	have a topic view.
	 **/
	ComViews.PostReportPostWindow = ComViews.Post.extend({
		removePostFromTopic: function () {
			return; // No topic in a PostReportPostWindow
		},
	});

	/**
	 * A report for a post.
	 *
	 * model : Community.Models.PostReport
	 */
	ComViews.PostReport = AoPS.View.extend({
		template_id: "#cmty-post-report-tpl",

		className: "cmty-admin-post-report",

		initialize: function () {
			this.post_view = new ComViews.PostReportPostWindow({
				model: this.model.get("post"),
				topic: {
					model: this.model.get("post").get("topic"),
				},
			});
			this.render();
			this.listenTo(this.model, "change:status", this.onChangeStatus);
			this.listenTo(
				this.model.get("post"),
				"change:deleted",
				this.onPostDeleted
			);
			this.listenTo(
				this.model.get("post").get("topic"),
				"change:deleted",
				this.onTopicDeleted
			);
		},

		events: {
			"click .cmty-post-report-admin-btn .btn": "onClickResolved",
			"click .cmty-pm-reporter": "onClickPMReporter",
			"click .cmty-pm-poster": "onClickPMPoster",
		},

		render: function () {
			var topic = this.model.get("post").get("topic"),
				// URLHERE
				category_url,
				category_name,
				mark_for_push_state,
				topic_url;

			if (this.model.get("category_id") === Constants.private_messages_id) {
				category_url = "/x" + this.model.get("post").get("poster_id");
				category_name =
					this.model.get("post").get("username") +
					" " +
					Lang["Private-Messages"];
			} else {
				category_url = "/c" + this.model.get("category_id");
				category_name = this.model.get("category_name");
			}

			topic_url = category_url + "h" + topic.get("topic_id");

			// If post is from a blog, then we don't want to mark this thing as staying in this
			//  router.  We want to reload the page on the next click.
			mark_for_push_state = this.model.get("category_type") != "blog";
			this.$el.html(
				this.getTemplate(this.template_id, {
					category_name: category_name,
					category_url: AoPS.Community.Views.makeLinkUrl(category_url),
					mark_for_push_state: mark_for_push_state,
					topic_title: topic.get("topic_title"),
					topic_url: AoPS.Community.Views.makeLinkUrl(topic_url),
					reported_by_text: Lang["post-report-admin-reported-by"],
					reported_date_text: Lang["post-report-admin-reported-date"],
					user_link: "/community/user/" + this.model.get("reporter_user_id"),
					details_text: Lang["post-report-admin-details"],
					details:
						this.model.get("details").length > 0
							? this.model.get("details")
							: "None given",
					reported_by: this.model.get("username"),
					for_text: Lang["post-report-admin-for"],
					short_reason:
						Lang["topic-full-report-item-" + this.model.get("reason_short")],
					reported_date: Utils.makePrettyTime(this.model.get("inserted_at")),
					show_first_post_note: this.model.get("post").get("post_number") === 1,
					first_post_note: Lang["post-report-first-post-note"],
					lang_pm_poster: Lang["post-report-admin-pm-poster"],
					lang_pm_reporter: Lang["post-report-admin-pm-reporter"],
					lang_send_pm: Lang["post-report-admin-pm"],
				})
			);

			this.$el.find(".feed-topic-forum").css({
				"background-color": this.model.get("main_color"),
				color: this.model.get("secondary_color"),
			});

			this.$el.find(".cmty-post-report-post").append(this.post_view.$el);
		},

		onClose: function () {
			this.post_view.close();
		},

		onClickPMReporter: function (e) {
			var private_message = ComViews.launchNewPrivateMessage({
				user_id: parseInt(this.model.get("reporter_user_id")),
				username: this.model.get("username"),
				is_admin: false,
			});

			var subject = Lang["post-report-pm-subject"];

			var preload_text = Utils.formatString(
				Lang["post-report-pm-reporter-preamble"],
				[
					Constants.base_url +
						"/community/p" +
						this.model.get("post").get("post_id"),
				]
			);
			if (this.model.get("details").length > 0) {
				preload_text +=
					" " +
					Lang["post-report-pm-reporter"] +
					'[quote="' +
					this.model.get("username") +
					'"]' +
					this.model.get("details") +
					"[/quote]";
			}

			private_message.setTitle(subject);
			private_message.addContent(preload_text);
		},

		onClickPMPoster: function (e) {
			var post_data = this.model.get("post_data"),
				poster_id,
				username;

			if (
				post_data.hasOwnProperty("real_poster_id") &&
				post_data.real_poster_id > 0
			) {
				poster_id = parseInt(post_data.real_poster_id);
				username = post_data.real_poster_username;
			} else {
				poster_id = parseInt(post_data.poster_id);
				username = post_data.username;
			}
			ComViews.launchNewPrivateMessage({
				user_id: poster_id,
				username: username,
				is_admin: this.model.get("post_data").admin,
			});
		},

		onClickResolved: function () {
			var self = this;
			AoPS.Ui.Modal.showConfirm(
				this.getTemplate("#cmty-post-report-settle-confirm-tpl", {
					message: Lang["post-report-admin-confirm"],
					notes: Lang["post-report-admin-notes"],
				}),
				function (value) {
					if (value) {
						AoPS.Community.Views.throwBlockingMessage(
							Lang["post-report-admin-block"]
						);
						self.model.settle({
							onFinish: function () {
								AoPS.Community.Views.delayModalClearing();
							},
							notes: $(".cmty-post-report-settle-note").val(),
							onError: function (data) {
								var output_string;

								if (data.error_code === "E_NOT_LOGGED_IN") {
									output_string = Lang["logged-out"];
								} else if (data.error_code === "E_NO_PERMISSION") {
									output_string = Lang["post-report-admin-no-permission"];
								}

								AoPS.Community.Views.showError(output_string);
							},
						});
					} else {
						AoPS.Ui.Modal.closeAllModals();
					}
				},
				{
					title: Lang["post-report-admin-confirm-title"],
					close_on_button_click: false,
					max_width: "400px",
				}
			);
		},

		/**
		 * Nuke this puppy when the report is resolved.
		 **/
		onChangeStatus: function () {
			if (this.model.get("status") === "resolved") {
				this.$el.fadeTo(
					500,
					0,
					_.bind(function () {
						this.close();
					}, this)
				);
			}
		},

		onPostDeleted: function () {
			this.model.decrementNumReports();
			this.model.set("status", "resolved");
		},

		onTopicDeleted: function () {
			this.model.set("status", "resolved");
		},
	});

	/***
	 * Search page
	 *
	 **/
	ComViews.SearchPage = AoPS.View.extend({
		template_id: "#cmty-search-page-tpl",

		className: "cmty-search-page",

		initialize: function (options) {
			this.init_options = options;
			this.init_options.is_private =
				options.preset_settings.hasOwnProperty("is_private") &&
				options.preset_settings.is_private;
			this.render();
			if (this.init_options.is_private) {
				this.$el.addClass("cmty-private-search");
			}
		},

		render: function () {
			this.$el.html(
				this.getTemplate(this.template_id, {
					lang_Search_Page_Title: !this.init_options.is_private
						? Lang["search-page-title"]
						: Lang["search-page-private-title"],
				})
			);

			this.search_form = new ComViews.SearchForm(this.init_options);
			this.$(".form").append(this.search_form.$el);
		},

		onAddToPage: function () {
			this.search_form.$("input").first().focus();
		},
	});

	/***
	 * Form for search
	 *
	 * model : CategorySearch
	 **/
	ComViews.SearchForm = AoPS.View.extend({
		template_id: "#cmty-search-form-tpl", // in community_lang_tpl_en

		className: "cmty-search-form",

		// Here is where to add more preset_settings.
		supported_presets: ["forums"],

		initialize: function (options) {
			var self = this;
			this.search_page_id = options.search_page_id;
			// I put master in its own property in case we someday pass a CategorySearch model into this.
			this.master = this.model;
			this.include_users = [];
			this.forums = [];
			this.is_private =
				options.hasOwnProperty("is_private") && options.is_private;

			if (options.hasOwnProperty("preset_settings")) {
				_.each(this.supported_presets, function (property) {
					if (options.preset_settings.hasOwnProperty(property)) {
						self[property] = options.preset_settings[property];
					}
				});
			}
			this.search_expanded = false;
			this.render();
		},

		render: function () {
			var self = this;
			this.$el.html(this.getTemplate(this.template_id, {}));

			this.$search_term = this.$('[name="search-term"]');
			this.include_user_list = new ComViews.EditableValidatedUserList({
				model: this.master,
				items: this.include_users,
			});
			this.forum_list = new ComViews.EditableForumList({
				model: this.master,
				items: this.forums,
				ajax_call: "fetch_search_forum_autocomplete",
			});
			this.$(".cmty-search-posters-include").append(this.include_user_list.$el);
			this.$(".cmty-search-forums-include").prepend(this.forum_list.$el);
			this.$dates_options = this.$(".cmty-search-dates-select > select");
			this.$dates_range = this.$(".cmty-search-dates-range");
			this.$dates_range_from = this.$dates_range.find("input.cmty-search-from");
			this.$dates_range_to = this.$dates_range.find("input.cmty-search-to");
			this.$dates_range_from.datepicker({
				defaultDate: "+1w",
				changeMonth: true,
				changeYear: true,
				numberOfMonths: 1,
				yearRange: "2003:c",
				minDate: new Date(2003, 0, 1),
				maxDate: 0,
				beforeShow: function () {
					$("#ui-datepicker-div").addClass("cmty-search-datepicker");
				},
				onClose: function (selectedDate) {
					$("#ui-datepicker-div").removeClass("cmty-search-datepicker");
					self.$dates_range_to.datepicker("option", "minDate", selectedDate);
				},
			});

			this.$dates_range_to.datepicker({
				defaultDate: "+1w",
				changeMonth: true,
				changeYear: true,
				numberOfMonths: 1,
				yearRange: "2003:c",
				minDate: new Date(2003, 0, 1),
				maxDate: 0,
				beforeShow: function () {
					$("#ui-datepicker-div").addClass("cmty-search-datepicker");
				},
				onClose: function (selectedDate) {
					$("#ui-datepicker-div").removeClass("cmty-search-datepicker");
					self.$dates_range_from.datepicker("option", "maxDate", selectedDate);
				},
			});
			this.$("input.enter-to-search").on("keydown", function (e) {
				var key_pressed = e.which || e.keyCode;
				if (key_pressed === 13) {
					self.onClickSearch();
				}
			});
		},

		events: {
			"click a.cmty-search-expand-link": "onClickTextToggle",
			"click .cmty-search-clear": "onClickClear",
			"click .cmty-search-go": "onClickSearch",
			"change .cmty-search-dates-select > select": "onSelectDateOption",
		},

		onClickTextToggle: function (e) {
			this.$el.toggleClass("cmty-search-expanded");
			this.search_expanded = !this.search_expanded;
			e.stopPropagation();
			e.preventDefault();
		},

		/**
		 * Clear the form.
		 **/
		onClickClear: function (e) {
			//this.$('input').not(':button').val('');
			// TODO : the dates, users, forums
			this.include_user_list.close();
			this.forum_list.close();
			this.include_users = [];
			this.forums = [];
			this.render();
		},

		onSelectDateOption: function (e) {
			var dates_value = parseInt(this.$dates_options.val());

			this.$dates_range.toggle(dates_value === -1);
		},

		onClickSearch: function (e) {
			var search_text,
				encoded_search_text,
				search_settings = {},
				extra_url_text = "",
				str,
				date_option,
				start_date,
				end_date,
				category;

			if (
				this.include_user_list.$input_box.val().length > 0 ||
				this.forum_list.$input_box.val().length > 0
			) {
				this.validateInput();
				return;
			}
			if (this.search_expanded) {
				str = this.$('[name="title"]').val();
				if (str.length > 0) {
					search_settings.title = str;
				}

				str = this.$('[name="source"]').val();
				if (str.length > 0) {
					search_settings.source = str;
				}

				str = this.$('[name="post-text"]').val();
				if (str.length > 0) {
					search_settings.post_text = str;
				}

				str = this.$('[name="tags"]').val();
				if (str.length > 0) {
					search_settings.tags = str;
				}
				search_settings.first_post = this.$('[name="first-post"]').is(
					":checked"
				)
					? 1
					: 0;
			} else {
				search_text = this.$search_term.val();
				if (search_text.length > 0) {
					search_settings.search_text = search_text;
					encoded_search_text = encodeURIComponent(search_text);
					extra_url_text = "_" + encoded_search_text;
				}
			}

			if (this.include_user_list.items.length > 0) {
				search_settings.include_users = _.pluck(
					this.include_user_list.items,
					"user_id"
				);
			}

			if (this.forum_list.items.length > 0) {
				search_settings.forums = _.pluck(this.forum_list.items, "category_id");
				search_settings.forums_action = this.$(
					'input[name="forum_option"]:checked'
				).val();
			}

			search_settings.sort_by = this.$('input[name="sort_by"]:checked').val();

			if (this.is_private) {
				search_settings.forums_action = "include";
				search_settings.forums = [1];
			}

			// Date munging

			date_option = parseInt(this.$dates_options.val());

			if (date_option === -1) {
				start_date = moment(this.$dates_range_from.val());
				if (!start_date.isValid()) {
					start_date = 0;
				} else {
					start_date = start_date.format("X");
				}

				end_date = moment(this.$dates_range_to.val());
				if (!end_date.isValid()) {
					end_date = 0;
				} else {
					// Add a day to the end date to get to midnight.
					end_date = end_date.add("days", 1).format("X");
				}
			} else if (date_option > 0) {
				end_date = moment().format("X");
				start_date = end_date - date_option;
			}

			if (start_date > 0) {
				search_settings.start_date = start_date;
			}

			if (end_date > 0) {
				search_settings.end_date = end_date;
			}

			if (_.keys(search_settings).length > 0) {
				category = this.master.buildSearchCategory(search_settings);
				category.set("search_page_id", this.search_page_id);
				Backbone.history.navigate(
					"q" + category.get("search_id") + extra_url_text,
					{trigger: true, replace: false}
				);
			}
		},

		validateInput: function () {
			var self = this,
				username = this.include_user_list.$input_box.val(),
				forum = this.forum_list.$input_box.val(),
				error_string;

			ComViews.throwBlockingMessage(Lang["search-validation-blocker"]);
			this.master.validateSearchInput({
				username: username,
				forum: forum,
				onFinish: function (data) {
					var user,
						error = false;
					if (data.hasOwnProperty("user")) {
						if (data.user.is_valid) {
							user = {
								user_id: data.user.user_id,
								item_id: data.user.user_id,
								label: data.user.username,
								value: data.user.username,
								is_admin: data.user.is_admin,
							};
							self.include_user_list.buildNewItem(user);
						} else {
							error = true;
							error_string = Utils.formatString(
								Lang["search-err-no-such-user"],
								[username]
							);
						}
					}

					if (!error && data.hasOwnProperty("forum_found")) {
						if (data.forum_found) {
							data.forum_data.label = data.forum_data.value;
							self.forum_list.buildNewItem(data.forum_data);
						} else {
							error = true;
							error_string = Utils.formatString(
								Lang["search-err-no-such-forum"],
								[forum]
							);
							//TODO ERROR
						}
					}

					if (!error) {
						setTimeout(function () {
							self.onClickSearch();
						}, 500);
					} else {
						ComViews.showError(error_string);
					}
				},
				onError: function (msg) {},
			});
		},
	});

	/**
		Start User Profile
	**/

	/**
	 * User's profile page
	 *
	 * model : ComModels.User
	 **/
	ComViews.UserProfile = AoPS.View.extend({
		template_id: "#cmty-user-profile-tpl",

		className: "cmty-user-profile cmty-folder-top",

		location: "user_profile",

		friend_click_path: "/user/",

		router_base: "/community",

		main_profile_plain_settings: [
			"joined_at",
			"status",
			"goals",
			"interests",
			"website",
			"school",
			"location",
			"occupation",
		],

		activity_settings: [
			{
				attribute: "last_visit_pretty",
				title_lang_attr: "user-profile-last-visit",
				is_html: true,
			},
			{
				attribute: "num_posts",
				title_lang_attr: "user-profile-total-posts",
			},
			{
				attribute: "primary_blog_id",
				title_lang_attr: "user-profile-blog",
				nowrap: true,
			},
			{
				attribute: "thanks_given",
				title_lang_attr: "user-profile-thanks-given",
			},
			{
				attribute: "thanks_received",
				title_lang_attr: "user-profile-thanks-received",
			},
		],

		initialize: function (options) {
			var main_settings_changes = "",
				self = this;
			this.is_session_user = this.model.get("user_id") === AoPS.session.user_id;
			this.$no_friends = $(
				'<div class="cmty-no-friends">' +
					Lang["user-profile-no-friends"] +
					"</div>"
			);

			this.compress_top_fora =
				typeof options.compress_top_fora === "boolean"
					? options.compress_top_fora
					: false;

			this.render();
			if (this.is_session_user) {
				_.each(this.main_profile_plain_settings, function (setting) {
					main_settings_changes += " change:" + setting;
				});
				this.listenTo(this.model, main_settings_changes, this.fillMainProfile);
				this.listenTo(this.model, "change:friends_exclude", function () {
					self.model.set("show_friends", !self.model.get("friends_exclude"));
					self.render();
				});
			}
		},

		events: {
			"click #about-num-posts": "onClickAboutNumPosts",
			"click .cmty-user-profile-pm": "onClickMessage",
			"click .cmty-user-add-new-friend": "onClickAddNewFriend",
			"click .cmty-user-add-this-friend": "onClickAddThisFriend",
			"click .cmty-toggle-user-bookmark": "onClickBookmark",
			"click .cmty-user-add-note": "onClickAddNote",
			"click .cmty-ban-link": "onClickBan",
			"click .cmty-reset-thanks-link": "onClickResetThanks",
			"click .cmty-troll-link": "onClickTroll",
			"click .cmty-vpn-check": "onClickCheckVPN",
			"click .cmty-temp-ban-link": "onClickTempBan",
		},

		render: function () {
			var user = this.model,
				self = this,
				master = this.model.get("master"),
				show_friends;

			// Only show friends of others if they have friends.
			show_friends =
				user.get("show_friends") &&
				(this.is_session_user || user.get("friends").length > 0);

			var can_edit_other_profiles = master
				? master.fetchPermission("can_edit_other_profiles")
				: false;

			this.$el.html(
				this.getTemplate(this.template_id, {
					username: user.get("username"),
					user_id: user.get("user_id"),
					can_pm: user.get("can_pm"),
					is_admin: AoPS.session.admin,
					is_national: AoPS.session.national_staff,
					can_access_user_general: master
						? master.fetchStaffPermission("user-general")
						: false,
					can_access_log: master
						? master.fetchStaffPermission("can-access-log")
						: false,
					can_edit_cmty_perms: master
						? master.fetchStaffPermission("perms-cmty")
						: false,
					can_oneclick_ban:
						!user.get("is_banned") &&
						(master ? master.fetchStaffPermission("one-click-ban") : false),
					temp_ban: user.get("temp_ban"),
					is_this_user_admin: user.get("is_admin"),
					is_session_user: this.is_session_user,
					is_limited: AoPS.session.national_staff && user.get("is_limited"),
					is_banned: AoPS.session.national_staff && user.get("is_banned"),
					is_coppa_blocked:
						AoPS.session.national_staff && user.get("is_coppa_blocked"),
					avatar: user.get("avatar"),
					is_bookmarked: user.get("is_bookmarked"),
					lang_Message: Lang["Message"],
					has_notes:
						!this.is_session_user &&
						user.has("user_notes") &&
						user.get("user_notes").length > 0,
					notes: user.has("user_notes") ? user.get("user_notes") : [],
					can_add_notes: user.has("can_add_notes") && user.get("can_add_notes"),
					lang_User_Profile: Lang["user-profile-title"],
					lang_LIMITED: Lang["user-profile-LIMITED"],
					lang_BANNED: Lang["user-profile-BANNED"],
					lang_COPPA: Lang["user-profile-COPPA"],
					lang_Activity: Lang["user-profile-activity"],
					lang_Notes: Lang["Notes"],
					lang_AddNote: Lang["Add-Note"],
					lang_By: Lang["By"],
					lang_At: Lang["At"],
					lang_Note: Lang["Note"],
					show_friends: show_friends,
					can_edit_other_profiles: can_edit_other_profiles,
					can_edit: this.is_session_user || can_edit_other_profiles,
					lang_edit_profile: Lang["edit-profile-title"],
					lang_Friends: Lang["user-profile-friends"],
					can_befriend: user.get("can_befriend"),
					lang_Add_Friend: Lang["user-profile-add-friend"],
					title_add_friend: Lang["user-profile-add-friend-title"],
					title_pm: Lang["user-profile-pm-title"],
					can_add_friends:
						this.is_session_user && user.get("can_request_friend"),
					can_troll_ban: user.get("can_troll_ban"),
				})
			);

			this.$main_profile = this.$(".cmty-user-profile-main-info");
			this.$activity = this.$(
				".cmty-user-profile-activity > .cmty-user-profile-data"
			);

			this.fillMainProfile();

			if (user.has("top_fora")) {
				this.buildActivityBox();
			} else {
				this.$activity_loader = AoPS.Page.buildLoader();

				user.fetchTopFora({
					onFinish: function () {
						self.$activity_loader.detach();
						self.buildActivityBox();
					},
					onError: function () {
						self.$activity_loader.detach();
					},
				});
			}

			if (this.is_session_user && !this.model.get("friends_exclude")) {
				this.$friends_public_toggle = this.$(
					".cmty-user-profile-friends-toggle"
				);
				this.setFriendsPublicToggle();
				this.listenTo(
					user,
					"change:friends_show_profile",
					this.setFriendsPublicToggle
				);
				this.$friends_public_toggle.on("click", function () {
					user.set("friends_show_profile", !user.get("friends_show_profile"));
					user.setUserSetting({
						value: user.get("friends_show_profile") ? 1 : 0,
						field: "friends_show_profile",
					});
				});
			}

			/**
			 * Friends box.  If the user is displaying a user box.
			 *  For the currently logged-in user, we have to go fetch the data.
			 *  For any other user, the data is loaded prior to building the view.
			 **/
			if (show_friends) {
				this.$friends_box = this.$(".cmty-friends-box");
				this.$loader = AoPS.Page.buildLoader();
				if (user.get("friends_initialized")) {
					this.buildFriends();
					this.startListeners();
				} else {
					this.$friends_box.append(this.$loader);
					user.fetchFriends({
						fetch_type: "initial",
						onFinish: function (data) {
							self.buildFriends();
							self.startListeners();
						},
					});
				}
			}

			var $blocked_list = this.$el.find(
				".cmty-user-profile-blocked-users-list"
			);

			if ($blocked_list.length) {
				// Fetch blocked users and set up listener.
				user.fetchBlockedUsers();

				this.listenTo(user, "change:blocked_users", function () {
					$blocked_list.html("");
					$blocked_list.append(ComViews.buildBlockedUsersWidget(user));
				});

				// Set up the Add User button.
				var $block_user = this.$el.find(
					".cmty-user-profile-blocked-users-wrapper a"
				);

				$block_user.click(ComViews.showBlockUserModal.bind(this, user));
			}

			this.setBookmark();
			this.listenTo(this.model, "change:is_bookmarked", this.setBookmark);
		},

		setBookmark: function () {
			var $bookmark, icon, title, text;

			if (!this.is_session_user) {
				$bookmark = this.$(".cmty-toggle-user-bookmark");
				if (this.model.get("is_bookmarked")) {
					icon = "C";
					text = Lang["bookmark-remove"];
					title = Lang["bookmark-remove-user-title"];
				} else {
					icon = "B";
					text = Lang["bookmark-follow"];
					title = Lang["bookmark-user-title"];
				}

				$bookmark.find(".aops-font").text(icon);
				$bookmark.find(".cmty-user-bookmark-tagline").text(text);
				$bookmark[0].title = title;
			}
		},

		setFriendsPublicToggle: function () {
			var friends_public = this.model.get("friends_show_profile");

			this.$friends_public_toggle.text(friends_public ? "h" : "#");
			this.$friends_public_toggle[0].title =
				Lang[
					friends_public
						? "user-profile-friend-toggle-off"
						: "user-profile-friend-toggle-on"
				];
		},

		onAddToPage: function () {
			this.startListeners();
		},

		onRemoveFromPage: function () {
			this.stopListeners();
		},

		buildActivityBox: function () {
			var self = this,
				user = this.model;

			// Activity box on the upper right
			_.each(this.activity_settings, function (setting) {
				var attr = setting.attribute,
					has_count_note,
					tpl_data;

				// If the user is hidden, then don't show the last visit.
				if (
					setting.attribute === "last_visit_pretty" &&
					!user.get("show_last_visit")
				) {
					return;
				}
				if (
					user.has(attr) &&
					(typeof user.get(attr) === "number" || user.get(attr).length > 0)
				) {
					if (attr == "primary_blog_id") {
						if (user.get(attr) > 0) {
							tpl_data = {
								is_html: true,
								nowrap: self.compress_top_fora,
								has_fora: false,
								content:
									'<a href="/community/c' +
									user.get(attr) +
									'">' +
									user.get("primary_blog_name") +
									"</a>",
							};
						} else {
							return;
						}
					} else if (
						attr === "num_posts" &&
						(user.get("num_posts") > 0 ||
							(user.has("top_fora") && user.get("top_fora").length > 0))
					) {
						var top_fora = user.has("top_fora") ? user.get("top_fora") : [];
						has_count_note = !_.isUndefined(
							_.findWhere(top_fora, {
								in_count: false,
							})
						);
						var has_search_note = !_.isUndefined(
							_.findWhere(top_fora, {
								has_search: false,
							})
						);
						if (self.compress_top_fora) {
							var trim_to =
								7 -
								(user.get("show_last_visit") ? 1 : 0) -
								(user.get("primary_blog_id") > 0 ? 1 : 0) -
								(has_count_note || has_search_note);
							top_fora = _.first(top_fora, trim_to);
						}
						tpl_data = {
							is_html: true,
							content:
								user.get(attr) +
								' (<a data-cmty href="/community/u' +
								user.get("user_id") +
								'">' +
								Lang["user-profile-click-for-posts"] +
								"</a>)",
							has_fora: true,
							user_id: user.get("user_id"),
							top_fora: top_fora,
							nowrap: false,
							has_count_note: has_count_note,
							lang_count_note: Lang["user-profile-no-count-note"],
							has_search_note: has_search_note,
							lang_search_note: Lang["user-profile-no-search-note"],
						};
						var max_len = 0;
						_.each(top_fora, function (forum) {
							var num = forum.total.toString().length;
							if (num > max_len) {
								max_len = num;
							}
						});
						if (max_len < 5) {
							self.$el.addClass("cmty-profile-" + max_len + "-digits");
						}
					} else {
						tpl_data = {
							is_html:
								typeof setting.is_html === "boolean" ? setting.is_html : false,
							has_fora: false,
							nowarp: false,
							content: user.get(attr),
						};
					}
					tpl_data.title = Lang[setting.title_lang_attr];
					if (AoPS.session.admin) {
						if (
							setting.attribute === "thanks_given" &&
							user.has("nothanks_given")
						) {
							tpl_data.is_html = true;
							tpl_data.content +=
								" (" +
								user.get("nothanks_given") +
								' <span class="aops-font">_</span>)';
						}
						if (
							setting.attribute === "thanks_received" &&
							user.has("nothanks_received")
						) {
							tpl_data.is_html = true;
							tpl_data.content +=
								" (" +
								user.get("nothanks_received") +
								' <span class="aops-font">_</span>)';
						}
					}
					if (attr === "num_posts") {
						tpl_data.title =
							"<span id='about-num-posts' class='faux-link aops-font'>?</span> " +
							tpl_data.title;
					}
					self.$activity.append(
						self.getTemplate("#cmty-user-profile-data-row-tpl", tpl_data)
					);
				}

				/*
				// Up next :
				non-in_user_count fora note
				user-forum search

				*/
			});
		},

		fillMainProfile: function () {
			var self = this,
				user = this.model;
			this.$main_profile.empty();
			// Main profile box on the upper left
			_.each(this.main_profile_plain_settings, function (setting) {
				var row;
				if (
					setting === "status" &&
					self.is_session_user &&
					!user.get("is_new_user")
				) {
					row = ComViews.buildEditableRow(
						self.constructEditableRowSettings(setting)
					);
					if (!self.model.get("master").fetchPermission("can_edit_profile")) {
						row.renderUneditable();
					}
					self.$main_profile.append(row.$element);
				} else if (setting === "primary_blog_id") {
					if (user.get(setting) > 0) {
						self.$main_profile.append(
							self.getTemplate("#cmty-user-profile-data-row-tpl", {
								is_html: false,
								has_fora: false,
								nowrap: false,
								title: Lang["user-profile-blog"],
								content:
									'<a href="/community/c' +
									user.get(setting) +
									'">' +
									user.get("primary_blog_name") +
									"</a>",
							})
						);
					} else {
						return;
					}
				} else if (user.has(setting) && user.get(setting).length > 0) {
					self.$main_profile.append(
						self.getTemplate("#cmty-user-profile-data-row-tpl", {
							is_url: setting === "website",
							is_html: false,
							nowrap: false,
							url:
								setting === "website" ? Utils.formatUrl(user.get(setting)) : "",
							content: user.get(setting),
							title: Lang["user-profile-" + setting],
						})
					);
				}
			});
		},

		/**
		 * Build the settings used to create a row with a heading and an editable field.
		 *
		 * @param string field whose settings row is being created.
		 **/
		constructEditableRowSettings: function (field) {
			var self = this;
			return {
				label: Lang["user-profile-" + field],
				placeholder: Lang["edit-profile-" + field + "-placeholder"],
				submit_on_enter: true,
				content: self.model.get(field) ?? "",
				length_limit: Constants.profile_field_length_limit,
				action: _.partial(function (setting, text, this_row) {
					if (setting === "email") {
						ComViews.throwLoaderBlockingMessage(
							Lang["edit-profile-email-change=blocker"]
						);
					}
					self.model.setUserSetting({
						field: setting,
						value: text,
						set_from: self.location,
						onFinish: function (data) {
							if (setting === "email") {
								this_row.contents = self.model.get(setting);
								this_row.reset();
								const lang_string_key = self.model.get("email")
									? "edit-profile-new-email"
									: "edit-profile-new-email-no-email";
								AoPS.Ui.Modal.showAlert(
									Utils.formatString(Lang[lang_string_key], [
										text,
										self.model.get("email"),
									]),
									{
										title: Lang["edit-profile-email-change-title"],
										width: "450px",
										onClose: function () {
											AoPS.Ui.Modal.closeAllModals();
										},
									}
								);
							}
						},
						onCancel: function () {},
						onError: function (data) {
							AoPS.Ui.Modal.closeAllModals();
							var msg,
								msg_type = "flyout";

							switch (data.error_code) {
								case "E_NAUGHTY_TERM_USED":
									msg = Utils.formatString(
										Lang["edit-profile-inappropriate-term"],
										[this_row.label]
									);
									break;

								case "E_NO_PERMISSION":
									msg = Lang["edit-profile-no-perm"];
									break;

								case "E_NOT_LOGGED_IN":
									msg = Lang["edit-profile-not-logged-in"];
									break;

								case "E_EMAIL_IN_USE":
									msg = Lang["edit-profile-email-in-use"];
									msg_type = "modal";
									break;

								case "E_EMAIL_IN_USE_UNVERIFIED":
									msg = Lang["edit-profile-email-in-use"];
									msg_type = "modal";
									break;

								case "E_RATE_LIMIT":
									msg = Lang["edit-profile-email-rate-limit"];
									msg_type = "modal";
									break;

								case "E_INVALID_CHARACTERS":
									msg = Lang["edit-profile-invalid-characters"];
									msg_type = "modal";
									break;

								case "E_INVALID_EMAIL":
									msg = Utils.formatString(
										Lang["edit-profile-email-not-valid"],
										[text]
									);
									msg_type = "modal";
									break;

								case "E_EMAIL_NOT_CHANGED":
									msg = Utils.formatString(
										Lang["edit-profile-email-not-valid"],
										[text]
									);
									break;

								case "E_AJAX_CANCEL":
									if (setting === "email") {
										this_row.contents = self.model.get(setting);
										this_row.reset();
									} else {
										self.model.set(setting, text);
									}
									return;

								default:
									msg =
										data.error_msg ||
										Utils.formatString(Lang["edit-profile-unknown-error"], [
											this_row.label,
											data.error_code,
										]);
									break;
							}

							this_row.contents = self.model.get(setting);
							this_row.reset();

							if (msg_type === "flyout") {
								AoPS.Ui.Flyout.display(msg);
							} else {
								AoPS.Ui.Modal.showAlertQuick(msg, {
									width: "450px",
									onClose: function () {
										AoPS.Ui.Modal.closeAllModals();
									},
								});
							}
						},
					});
				}, field),
			};
		},

		/**
		 * Build the friends box (and friend requests if this is the logged in user's
		 *  profile).
		 **/
		buildFriends: function () {
			var user = this.model,
				self = this;
			this.$loader.detach();

			if (user.get("friends").length === 0) {
				this.$friends_box.append(this.$no_friends);
			} else {
				_.each(user.get("friends"), function (friend) {
					// Put the friend in the friend box.
					self.$friends_box.append(self.buildFriendBox(friend, false));
				});
			}

			if (this.is_session_user) {
				if (user.get("friend_requests").length > 0) {
					this.$friend_requests_box = $(
						'<div class="cmty-friend-requests-box"></div>'
					);
					this.$friend_requests_box.append(
						'<div class="cmty-friend-requests-warning">' +
							Lang["friends-warning"] +
							"</div>"
					);
					this.$friend_requests_wrapper = ComViews.buildCommunityScrollbar(
						this.$friend_requests_box
					);
					this.$friends_box.before(this.$friend_requests_wrapper);
					this.$friend_requests_wrapper
						.find(".aops-scroll-bar")
						.on("slider_at_end", function () {
							self.fetchMoreFriendRequests();
						});
					_.each(user.get("friend_requests"), function (request) {
						self.$friend_requests_box.append(
							self.buildFriendBox(request, true)
						);
					});
					this.setFriendRequestsStyle();
				}
			}
		},

		fetchMoreFriendRequests: function () {
			var self = this,
				user = this.model;
			if (!user.get("loading_friends") && !user.get("all_requests_loaded")) {
				self.$friend_requests_box.append(self.$loader);
				user.fetchFriends({
					fetch_type: "friend_requests",
					onFinish: function (data) {
						self.$loader.detach();
						_.each(data.friend_requests, function (friend) {
							self.$friend_requests_box.append(
								self.buildFriendBox(friend, true)
							);
						});
						if (user.get("all_requests_loaded")) {
							self.$el.find(".aops-scroll-bar").off("slider_at_end");
						}
					},
				});
			}
		},

		/**
		 * Start the listeners on the window scroll events to load more friends.
		 **/
		startListeners: function () {
			var user = this.model,
				self = this;

			if (!user.get("all_friends_loaded") && user.get("friends").length > 0) {
				$(window).on(
					"scroll.user" +
						user.get("user_id") +
						" touchmove.user" +
						user.get("user_id"),
					function (ev) {
						if (
							window.innerHeight + window.pageYOffset + 50 >=
							document.body.offsetHeight
						) {
							if (
								!user.get("loading_friends") &&
								!user.get("all_friends_loaded")
							) {
								self.$friends_box.append(self.$loader);
								user.fetchFriends({
									fetch_type: "friends",
									onFinish: function (data) {
										self.$loader.detach();
										_.each(data.loaded_friends, function (friend) {
											self.$friends_box.append(
												self.buildFriendBox(friend, false)
											);
										});
										if (user.get("all_friends_loaded")) {
											$(window).off(
												"scroll.user" +
													user.get("user_id") +
													" touchmove.user" +
													user.get("user_id")
											);
										}
									},
								});
							}
						}
					}
				);
			}
		},

		/**
		 * Stop the window scroll events.
		 **/
		stopListeners: function () {
			$(window).off("scroll.user" + this.model.get("user_id"));
		},

		/**
		 * Build a box for a friend. Used for both friends and friend requests.
		 *
		 * @param obj describing a friend
		 * @param boolean a friend_request or not
		 **/
		buildFriendBox: function (friend, is_request) {
			var self = this,
				$friend = $(
					this.getTemplate("#cmty-friend-box-tpl", {
						avatar: friend.avatar,
						username: friend.username,
						is_admin: friend.is_admin,
						is_request: is_request,
						message: is_request
							? Lang["user-profile-friend-request"]
							: friend.status,
						lang_DECLINE: Lang["user-profile-friend-DECLINE"],
						lang_ACCEPT: Lang["user-profile-friend-ACCEPT"],
					})
				);
			// add button clicks
			if (this.is_session_user && !is_request) {
				// Delete friend
				$friend.find(".cmty-unfriend").on("click", function (e) {
					self.unFriend(friend, $friend);
					e.stopPropagation();
				});
			}

			if (is_request) {
				$friend.find(".cmty-friend-decline").on("click", function (e) {
					self.closeFriendRequest(friend, $friend, "denied");
					e.stopPropagation();
				});
				$friend.find(".cmty-friend-accept").on("click", function (e) {
					self.closeFriendRequest(friend, $friend, "accepted");
					e.stopPropagation();
				});
			}

			$friend.on("click.backbone", function (e) {
				ComViews.followUrlOnClick(
					e,
					self.friend_click_path + friend.user_id,
					self.router_base,
					""
				);
			});

			return $friend;
		},

		/**
		 * Settle a friend request.
		 *
		 * @param object describing a friend
		 * @param jQuery object for the friend box
		 * @param string accepted|denied
		 **/
		closeFriendRequest: function (friend, $friend, action) {
			var self = this;

			if (AoPS.isUserCoppaBlocked()) {
				AoPS.displayCoppaBlockedModal({escapable: true});
				return;
			}

			if (!AoPS.hasFreeResourceAccess()) {
				const message = Lang["user-profile-err-no-perm-free-resource"];
				AoPS.Ui.Modal.showMessage(message, {width: "450px"});
				return;
			}

			this.model.closeFriendRequest({
				user_id: friend.user_id,
				action: action,
				onFinish: function (data) {
					if (action === "accepted") {
						self.$friends_box.prepend(
							self.buildFriendBox(data.new_friend_data, false)
						);
						self.$no_friends.detach();
					}
					Flyout.display(
						Utils.formatString(Lang["user-profile-friend-request-" + action], [
							friend.username,
						])
					);
				},
				onError: function (data) {
					var msg;
					if (data.error_code === "E_NO_REQUEST_AVAILABLE") {
						msg = Utils.formatString(
							Lang["user-profile-err-no-request-available"],
							[friend.username]
						);
					} else {
						msg = Utils.formatString(Lang["err-unknown"], [data.error_code]);
					}

					Flyout.display(msg);
				},
			});

			$friend.fadeOut(500, function () {
				$friend.remove();
			});

			if (
				this.model.get("friend_requests").length < 6 &&
				!this.model.get("all_requests_loaded")
			) {
				this.fetchMoreFriendRequests();
			}

			this.setFriendRequestsStyle();
		},

		/***
		 * Set the style of the friend requests box based on the number of requests.
		 **/
		setFriendRequestsStyle: function () {
			var num_requests = this.model.get("friend_requests").length,
				three_class = "cmty-three-requests",
				many_class = "cmty-many-requests";
			if (num_requests === 0 && this.model.get("all_requests_loaded")) {
				this.$friend_requests_wrapper.detach();
			}
			this.$friend_requests_wrapper.toggleClass(
				three_class,
				num_requests === 3
			);
			this.$friend_requests_wrapper.toggleClass(many_class, num_requests > 3);
		},

		/**
		 * Display modal about Total Posts list.
		 **/
		onClickAboutNumPosts: function (e) {
			alert(
				"Only the user's top 8 forums are displayed. If one or more of this " +
					"user's top forums is a private forum that you can't access, " +
					"it will not be displayed to you.<br><br>" +
					'Only posts in select forums count towards the "Total Posts" count. ' +
					"If one of a user's top forums is a forum where posts don't count towards the total, " +
					"that forum will be marked with an asterisk (*) here."
			);
		},

		/**
		 * Start a new private message with this user.
		 **/
		onClickMessage: function (e) {
			if (!AoPS.session.logged_in) {
				// Give instructions if not logged in
				AoPS.Ui.buildLoginConfirm(Lang["private-message-not-logged-in"]);
				return;
			} else if (!AoPS.session.initialized) {
				AoPS.Initialize.display({escapable: true});
				return;
			} else if (AoPS.isUserCoppaBlocked()) {
				AoPS.displayCoppaBlockedModal({escapable: true});
				return;
			}

			ComViews.launchNewPrivateMessage({
				user_id: this.model.get("user_id"),
				username: this.model.get("username"),
				is_admin: this.model.get("is_admin"),
			});
			/*			var new_private = new ComViews.NewPrivateConversation({
				'category_name' : '',  // PROBABLY put all of these in NewPrivateConversation as defaults.
				'category_id' : 1,
				model : this.model.get('master').get('my_privates'),
				preset_recipients : [{
					label : this.model.get('username'),
					user_id : this.model.get('user_id'),
					is_visible : true,
					is_admin : this.model.get('is_admin')
				}],
				master : this.model.get('master')
			});
*/
			if (!_.isUndefined(e)) {
				e.stopPropagation();
				e.preventDefault();
				return false;
			}
		},

		onClickBan: AoPS.Community.Utils.onClickBan,

		onClickTroll: AoPS.Community.Utils.onClickTroll,

		onClickTempBan: function (e) {
			var self = this;
			AoPS.Community.Utils.onClickTempBan(
				_.extend(
					{
						user_id: this.model.get("user_id"),
						username: this.model.get("username"),
						success: function (temp_ban) {
							$(e.target).text(
								temp_ban.can_access ? "TEMP RESTRICT" : "UNRESTRICT"
							);
							self.model.set("temp_ban", temp_ban);
						},
					},
					this.model.get("temp_ban")
				)
			);
		},

		onClickResetThanks: function (e) {
			AoPS.Community.MasterModel.resetThanks(e);
		},

		onClickCheckVPN: function (e) {
			var ip = e.currentTarget.getAttribute("ip");
			AoPS.Community.MasterModel.checkVPN({
				ip: ip,
			});
			$(e.currentTarget).hide();
		},

		onClickAddNote: function () {
			var note = this.$('textarea[name="cmty-user-note-input"]').val(),
				self = this;

			if (note.length < 5) {
				return;
			}

			AoPS.Community.Views.throwBlockingMessage(Lang["user-profile-add-note"]);

			setTimeout(function () {
				self.model.addNote({
					note_text: note,
					onFinish: function () {
						location.reload();
					},
				});
			}, 1000);
		},

		/**
		 * What we do when we click add friend in the My AoPS profile of
		 *  the currently logged in user.
		 **/
		onClickAddNewFriend: function () {
			var $new_friend,
				chosen_user = 0,
				username,
				self = this,
				$input_box;

			$new_friend = $(
				this.getTemplate("#cmty-add-friend-tpl", {
					lang_instructions: Lang["user-profile-add-friend-instructions"],
					lang_new_friend: Lang["user-profile-new-friend"],
					placeholder: Lang["Enter-username"],
				})
			);

			$input_box = $new_friend.find("input");

			Utils.buildUsernameAutocomplete($input_box, {
				ajax_call: "fetch_username_matches",
				autocomplete_settings: {
					onSelect: function (e, ui) {
						var $new_friend_display = $new_friend.find(
							".cmty-chosen-new-friend"
						);
						if (parseInt(ui.item.user_id) === AoPS.session.user_id) {
							AoPS.Ui.Modal.showAlertQuick(
								Lang["user-profile-no-friend-self"],
								{
									onButtonClick: function () {
										$input_box.val("");
										$input_box.focus();
									},
								}
							);
						} else {
							chosen_user = ui.item.user_id;
							username = ui.item.label;
							$input_box.hide();
							$new_friend_display.html(ui.item.label);
							if (parseInt(ui.item.is_admin) == 1) {
								$new_friend_display.addClass("cmty-user-admin");
							}
						}
						e.stopPropagation();
						e.preventDefault();
					},
				},
			});

			$new_friend.showModal({
				type: "confirm",
				title: Lang["user-profile-add-friend-modal-title"],
				width: "450px",
				close_on_button_click: false,
				force_response: true,
				onButtonClick: function (value) {
					if (value) {
						if (chosen_user === 0) {
							chosen_user = $input_box.val();
							if (chosen_user.length === 0) {
								AoPS.Ui.Modal.showAlert(
									Lang["user-profile-add-friend-none-chosen"]
								);
								chosen_user = 0;
								return;
							}
							username = chosen_user;
						}
						self.sendFriendRequest(chosen_user, username);
					} else {
						AoPS.Ui.Modal.closeAllModals();
					}
				},
			});

			$input_box.focus();
		},

		/**
		 * What happens when we click on the Add Friend in someone else's User Profile.
		 **/
		onClickAddThisFriend: function () {
			if (!AoPS.session.logged_in) {
				// Give instructions if not logged in
				AoPS.Ui.buildLoginConfirm(
					Lang["user-profile-send-request-not-logged-in"]
				);
				return;
			} else if (!AoPS.session.initialized) {
				AoPS.Initialize.display({escapable: true});
				return;
			} else if (AoPS.isUserCoppaBlocked()) {
				AoPS.displayCoppaBlockedModal({escapable: true});
				return;
			}

			var self = this;
			AoPS.Ui.Modal.showConfirm(
				Utils.formatString(Lang["user-profile-send-request-check"], [
					this.model.get("username"),
				]),
				function (ok) {
					if (ok) {
						self.sendFriendRequest(
							self.model.get("user_id"),
							self.model.get("username")
						);
					} else {
						AoPS.Ui.Modal.closeAllModals();
					}
				},
				{
					close_on_button_click: false,
					force_response: true,
				}
			);
		},

		onClickBookmark: function (e) {
			e.preventDefault();
			e.stopPropagation();

			if (
				!ComViews.hasCommunityGeneralAccess(
					"bookmark-not-logged-in",
					"bookmark-free-resource",
					this.model.get("master").fetchPermission("c_undo_global_ban")
				)
			) {
				return false;
			} else {
				this.model.get("master").setUserBookmarkState({
					user: this.model,
					new_state: !this.model.get("is_bookmarked"),
				});
			}
		},
		/**
		 * Send a friend request.
		 *
		 * @param int|string user identifier (username or id)
		 * @param string username
		 **/
		sendFriendRequest: function (user, username) {
			var self = this;
			AoPS.Community.Views.throwBlockingMessage(
				Lang["user-profile-friend-request-pending"]
			);

			this.model.get("master").submitFriendRequest({
				new_friend: user,
				onFinish: function (msg) {
					setTimeout(function () {
						AoPS.Ui.Modal.closeAllModals();

						self.$el.find(".cmty-user-add-this-friend").remove();
					}, Constants.message_readability_delay);
				},
				onError: function (data) {
					var msg;
					switch (data.error_code) {
						case "E_NO_PERMISSION_TO_REQUEST_FRIEND":
							msg = Lang["user-profile-err-no-perm-friend"];
							break;

						case "E_ALREADY_FRIENDS":
							msg = Utils.formatString(
								Lang["user-profile-err-already-friend"],
								[username]
							);
							break;

						case "E_NO_FRIEND_SELF":
							msg = Lang["user-profile-no-friend-self"];
							break;

						case "E_REQUEST_FROM_POTENTIAL_EXISTS":
							msg = Utils.formatString(
								Lang["user-profile-err-they-asked-you"],
								[username]
							);
							break;

						case "E_YOU_ALREADY_REQUESTED":
							msg = Utils.formatString(Lang["user-profile-err-already-asked"], [
								username,
							]);
							break;

						case "E_NOT_TAKING_FRIEND_REQUESTS":
							msg = Utils.formatString(
								Lang["user-profile-err-not-taking-requests"],
								[username]
							);
							break;

						default:
							msg = Utils.formatString(Lang["err-unknown"], [data.error_code]);
							break;
					}
					setTimeout(function () {
						AoPS.Ui.Modal.showAlert(msg, {
							onClose: function () {
								AoPS.Ui.Modal.closeAllModals();
							},
							width: "450px",
						});
					}, Constants.message_readability_delay);
				},
			});
		},

		/**
		 * Unfriend another user.
		 *
		 * @param friend object from model.get('friends')
		 * @param jQuery object of the friend we are unfriend
		 **/
		unFriend: function (friend, $friend) {
			var user = this.model,
				self = this;

			AoPS.Ui.Modal.showConfirm(
				Utils.formatString(Lang["user-profile-unfriend-confirm"], [
					friend.username,
				]),
				function (ok) {
					if (ok) {
						user.unFriend({
							user_id: friend.user_id,
						});
						$friend.fadeOut(400, function () {
							$friend.remove();
						});
						if (user.get("friends").length === 0) {
							self.$friends_box.append(self.$no_friends);
						}
					}
					AoPS.Ui.Modal.closeAllModals();
				},
				{
					confirm_button_ok: Lang["YES"],
					confirm_button_cancel: Lang["NO"],
				}
			);
		},

		onClose: function () {
			if (this.hasOwnProperty("limited_user_note")) {
				this.limited_user_note.close();
			}
		},
	});

	ComViews.CategoryUserCell = AoPS.View.extend({
		template_id: "#cmty-bookmarked-user-cell-tpl",

		className: "cmty-category-cell cmty-category-cell-user",

		initialize: function () {
			this.render();
		},

		render: function () {
			this.$el.html(
				this.getTemplate(this.template_id, {
					username: this.model.get("username"),
					user_id: this.model.get("user_id"),
					can_befriend: this.model.get("can_befriend"),
					user_tooltip: Lang["user-cell-visit-profile"],
					lang_Add_Friend: Lang["user-profile-add-friend"],
					title_add_friend: Lang["user-profile-add-friend-title"],
					title_pm: Lang["user-profile-pm-title"],
					lang_Message: Lang["Message"],
					can_pm: this.model.get("can_pm"),
					status: this.model.get("status"),
				})
			);

			this.user_profile = new ComViews.UserProfile({
				model: this.model,
				compress_top_fora: true,
			});

			this.$(".cmty-category-cell-bottom").append(this.user_profile.$el);
		},

		events: {
			"click .cmty-user-cell-pm": "onClickMessage",
			"click .cmty-add-cell-friend": "onClickAddNewFriend",
		},

		onClickMessage: ComViews.UserProfile.prototype.onClickMessage,

		onClickAddNewFriend: ComViews.UserProfile.prototype.onClickAddNewFriend,
	});

	/**
	 * Edit a user profile.
	 *
	 * model : AoPS.Community.User
	 **/
	ComViews.EditUserProfile = AoPS.View.extend({
		template_id: "#cmty-edit-profile-tpl",

		className: ComViews.UserProfile.prototype.className,

		location: "edit_user_profile",

		private_profile_fields: ["email", "first_name", "last_name"],

		profile_fields: ["email", "first_name", "last_name"].concat(
			_.without(
				ComViews.UserProfile.prototype.main_profile_plain_settings,
				"joined_at"
			)
		),

		initialize: function () {
			this.is_current_user =
				this.model === this.model.get("master").get("current_user");
			if (this.model.get("has_parent_controller")) {
				this.profile_fields = _.without(
					this.profile_fields,
					"first_name",
					"last_name"
				);
			}
			this.render();
			this.listenTo(this.model, "status_changed", this.onStatusChange);
		},

		render: function () {
			var self = this,
				i,
				can_edit_profile,
				field,
				num_fields = this.profile_fields.length,
				rows = [];

			if (this.is_current_user) {
				can_edit_profile = this.model
					.get("master")
					.fetchPermission("can_edit_profile");
			} else {
				can_edit_profile = this.model
					.get("master")
					.fetchPermission("can_edit_other_profiles");
			}

			this.$el.html(
				this.getTemplate(this.template_id, {
					is_current_user: this.is_current_user,
					has_password: AoPS.bd.platform_user_info.has_password,
					is_new_user: AoPS.isUserNew(),
					is_coppa_blocked: AoPS.isUserCoppaBlocked(),
					user_id: this.model.get("user_id"),
					username: this.model.get("username"),
					lang_Edit_Profile: Lang["edit-profile-title"],
					lang_Profile_Info: Lang["edit-profile-profile-info"],
					lang_Edit_Avatar: Lang["edit-profile-edit-avatar"],
					lang_Delete_Avatar: Lang["edit-profile-delete-avatar"],
					lang_Change_Password: Lang["edit-profile-change-password"],
					lang_Current_Password: Lang["edit-profile-current-password"],
					lang_New_Password: Lang["edit-profile-new-password"],
					lang_Retype_Password: Lang["edit-profile-retype-password"],
					can_add_avatar: this.model
						.get("master")
						.fetchPermission(
							this.is_current_user
								? "can_add_avatar"
								: "can_edit_other_profiles"
						),
					has_avatar: this.model.get("avatar") !== Constants.default_avatar,
					retype_password_placeholder:
						Lang["edit-profile-retype-password-placeholder"],
					new_password_placeholder:
						Lang["edit-profile-new-password-placeholder"],
					current_password_placeholder:
						Lang["edit-profile-current-password-placeholder"],
					avatar: this.model.get("avatar"),
					password_length: Constants.max_password_length,
					lang_SUBMIT: Lang["Submit"].toUpperCase(),
				})
			);

			this.$profile = this.$(".cmty-user-profile-main-info");
			this.$current_password = this.$('input[name="current-password"]');
			this.$new_password = this.$('input[name="new-password"]');
			this.$confirm_password = this.$('input[name="confirm-password"]');
			this.$password_buttons = this.$(".cmty-password-buttons");
			this.$password_warning = this.$(".cmty-password-warning");

			this.$(":password")
				.on("input", function () {
					self.checkPasswordFields();
				})
				.on("keydown", function (e) {
					var key_pressed = e.which || e.keyCode;

					if (key_pressed === 13) {
						self.onClickSubmitPassword();
					}
				});

			var row;
			if (AoPS.isUserNew() || AoPS.isUserCoppaBlocked()) {
				// COPPA-unapproved users can only edit their email (in addition to their password)
				// New users can only edit their email and name (in addition to their password)
				var htmlText =
					Lang[
						`edit-profile-${AoPS.isUserCoppaBlocked() ? "coppa" : "new"}-user`
					];
				this.$profile.append(
					// ignore-security-checks (not external input)
					$("<div />").addClass("cmty-new-user-profile").html(htmlText)
				);
				var editableFields =
					AoPS.isUserCoppaBlocked() || this.model.get("has_parent_controller")
						? ["email"]
						: ["email", "first_name", "last_name"];
				_.each(
					editableFields,
					function (fieldName) {
						row = ComViews.buildEditableRow(
							ComViews.UserProfile.prototype.constructEditableRowSettings.apply(
								this,
								[fieldName]
							)
						);
						this.appendProfileFieldRow(fieldName, row);
					},
					this
				);
			} else {
				// the user can edit their profile
				for (i = 0; i < num_fields; i++) {
					field = this.profile_fields[i];

					row = ComViews.buildEditableRow(
						ComViews.UserProfile.prototype.constructEditableRowSettings.apply(
							this,
							[field]
						)
					);

					if (
						!can_edit_profile &&
						!_.contains(this.private_profile_fields, field)
					) {
						row.renderUneditable();
					}
					rows.push(row);

					// Admins edit email and name elsewhere.  We'll get a link to that page here.
					if (
						_.contains(this.private_profile_fields, field) &&
						!this.is_current_user
					) {
						continue;
					}

					//  Allows us to surf through the fields quickly.
					rows[i].$input.on(
						"keydown",
						_.partial(function (rownum, e) {
							var key_pressed = e.which || e.keyCode;
							if (key_pressed === 13) {
								rows[(rownum + 1) % num_fields].$input.focus();
							}
						}, i)
					);

					self.appendProfileFieldRow(field, row);
				}
			}
		},

		appendProfileFieldRow: function (field, row) {
			// Check if row should be read only
			if (field === "email" && !AoPS.bd.platform_user_info.has_password) {
				row.renderUneditable();
			}
			this.$profile.append(row.$element);
			if (field === "last_name") {
				this.appendEmailNamePrivacyNote();
			}
		},

		appendEmailNamePrivacyNote: function () {
			this.$profile.append(
				$("<div />")
					.addClass("cmty-edit-profile-email-name-privacy")
					// ignore-security-checks (not external input)
					.html(Lang["edit-profile-email-name-private"])
			);
		},

		events: {
			"click .cmty-password-submit": "onClickSubmitPassword",
			"click .cmty-user-edit-avatar": "onClickEditAvatar",
			"click .cmty-user-delete-avatar": "onClickDeleteAvatar",
		},

		emptyAllPasswordFields: function () {
			this.$current_password.val("");
			this.$new_password.val("");
			this.$confirm_password.val("");
		},

		checkPasswordFields: function () {
			var current_password = this.$current_password.val(),
				new_password = this.$new_password.val(),
				confirm_password = this.$confirm_password.val();

			this.$password_buttons.hide();
			this.$password_warning.hide();

			if (new_password.length === 0 || confirm_password.length === 0) {
				return false;
			}

			if (new_password !== confirm_password) {
				this.$password_warning.text(Lang["edit-profile-passwords-dont-match"]);
				this.$password_warning.show();
				return false;
			}

			if (current_password.length === 0) {
				this.$password_warning.text(Lang["edit-profile-enter-password"]);
				this.$password_warning.show();
				return false;
			}

			if (confirm_password.length < Constants.min_password_length) {
				this.$password_warning.text(Lang["edit-profile-password-too-short"]);
				this.$password_warning.show();
				return false;
			}

			this.$password_buttons.show();
			return true;
		},

		onClickSubmitPassword: function () {
			var self = this,
				current_password = this.$current_password.val(),
				new_password = this.$new_password.val();

			this.$password_buttons.hide();
			if (this.checkPasswordFields()) {
				ComViews.throwBlockingMessage(Lang["edit-profile-submit-new-password"]);
				self.emptyAllPasswordFields();
				this.model.submitNewPassword({
					new_password: new_password,
					old_password: current_password,
					onFinish: function (data) {
						ComViews.delayModalClearing({
							onClose: function () {
								AoPS.Ui.Flyout.display(Lang["edit-profile-password-changed"]);
							},
						});
					},
					onError: function (data) {
						var msg;
						switch (data.error_code) {
							case "E_SHORT_PASSWORD":
								msg = data.error_msg;
								break;

							case "E_LONG_PASSWORD":
								msg = data.error_msg;
								break;

							case "E_COMMON_PASSWORD":
								msg = data.error_msg;
								break;

							case "E_INVALID_CURRENT_PASSWORD":
								msg = data.error_msg;
								break;

							case "E_PASSWORD_IS_EMAIL":
								msg = data.error_msg;
								break;

							default:
								msg = Utils.formatString(Lang["edit-profile-unknown-error"], [
									"password",
									data.error_code,
								]);
								break;
						}
						setTimeout(function () {
							AoPS.Ui.Modal.showAlertQuick(msg, {
								width: "450px",
								onClose: function () {
									AoPS.Ui.Modal.closeAllModals();
									self.$current_password.focus();
								},
							});
						}, Constants.message_readability_delay);
					},
				});
			}
		},

		onClickEditAvatar: function () {
			// eslint-disable-next-line no-new
			new ComViews.EditAvatar({
				model: this.model,
			});
		},

		onClickDeleteAvatar: function () {
			var self = this;
			// TODO confirm, if yes, nuke and reload.
			Modal.showConfirm(
				Utils.formatString(Lang["edit-profile-delete-avatar-confirm"], [
					this.is_current_user
						? Lang["edit-profile-your"]
						: Lang["edit-profile-this-user"],
				]),
				function (ok) {
					if (ok) {
						Modal.replaceTopModal({
							type: "message",
							body: Lang["edit-profile-deleting-avatar"],
							closeX: false,
							force_response: true,
							frame_class: "aops-modal-quick",
						});
						self.model.deleteAvatar({
							onError: function (msg) {},
							onFinish: function (msg) {
								location.reload();
							},
						});
					} else {
						Modal.closeAllModals();
					}
				},
				{
					title: Lang["edit-profile-delete-avatar"],
					close_on_button_click: false,
				}
			);
		},

		/**
		 * Rebuild this if the status is changed from the profile page.
		 **/
		onStatusChange: function (obj) {
			if (obj.set_from !== "edit_user_profile") {
				this.render();
			}
		},
	});

	/**
	 * Edit a user's avatar.
	 *
	 * model : ComModels.User
	 **/
	ComViews.EditAvatar = AoPS.View.extend({
		template_id: "#cmty-edit-avatar-tpl",

		className: "cmty-edit-avatar",

		initialize: function () {
			var self = this,
				$edit_avatar;

			this.$el.html(
				this.getTemplate(this.template_id, {
					lang_upload: Lang["edit-avatar-default-message"],
				})
			);

			$edit_avatar = this.$("#edit-avatar");
			$edit_avatar.dropzone({
				url: "/m/community/ajax.php",
				maxFiles: 1,
				sending: function (file, xhr, formData) {
					formData.append("a", "upload_avatar");
					formData.append("aops_session_id", AoPS.session.id);
					formData.append("user_id", self.model.get("user_id"));
				},
				thumbnailWidth: 30,
				thumbnailHeight: 30,
				resizeWidth: 100,
				resizeHeight: 100,
				accept: function (file, done) {
					if (/[^a-zA-Z0-9\.\ \_\-]/.test(file.name)) {
						done("err-invalid-character");
					} else {
						done();
					}
				},
				fallback: function () {
					AoPS.Ui.Modal.showAlert(Lang["err-dropzone-fallback"], {
						width: "450px",
					});
					setTimeout(function () {
						AoPS.Ui.Modal.closeTopModal();
					}, 100);
				},
				maxFilesize: AoPS.Community.Constants.max_avatar_file_size / 1000,
				success: function (file, msg) {
					if (msg.hasOwnProperty("error_code")) {
						var error_msg;
						switch (msg.error_code) {
							case "E_INVALID_SESSION_WRONG":
								error_msg = Lang["err-no-such-session"];
								break;

							case "E_TOO_MANY_FILES":
								error_msg = Lang["edit-avatar-too-many"];
								break;

							case "E_NO_FILE_SENT":
								error_msg = Lang["edit-avatar-no-file"];
								break;

							case "E_IMAGE_DIMENSIONS_TOO_LARGE":
								error_msg = Lang["edit-avatar-dimensions-too-big"];
								break;

							case "E_FILE_TOO_LARGE":
								error_msg = Lang["edit-avatar-file-too-big"];
								break;

							case "E_NO_PERMISSION":
								error_msg = Lang["edit-avatar-no-permission"];
								break;

							case "E_IMPROPER_AVATAR_FILE_TYPE":
								error_msg = Lang["edit-avatar-bad-file-type"];
								break;

							case "E_IMPROPER_AVATAR_FILE_TYPE_APNG":
								error_msg = Lang["edit-avatar-bad-file-type-apng"];
								break;

							default:
								error_msg = Lang["unexpected-error-code"] + msg.error_code;
								break;
						}
						ComViews.showErrorAtopAModal(error_msg);
						this.removeFile(file);
					} else {
						$(file.previewElement).addClass("dz-success");
						location.reload();
					}
				},
				error: function (file, error) {
					if (error === "err-invalid-character") {
						ComViews.showErrorAtopAModal(
							Lang["post-attachments-invalid-character"]
						);
					} else if (error.substr(0, 15) === "File is too big") {
						ComViews.showErrorAtopAModal(Lang["edit-avatar-file-too-big"]);
					} else if (
						error.substr(0, 35) === "You can't upload files of this type"
					) {
						ComViews.showErrorAtopAModal(Lang["edit-avatar-bad-file-type"]);
					}
					this.removeFile(file);
				},
				acceptedFiles: "image/*",
			});

			this.$el.showModal({
				title: Lang["edit-avatar-title"],
				width: "250px",
				frame_class: "aops-modal-standard cmty-upload-avatar-modal",
			});
		},
	});

	/**
	 * Helper used in Edit Settings a lot; I probably will
	 *  find use for it elsewhere.
	 **/
	ComViews.edit_community_yn_options = [
		{
			value: "1",
			label: Lang["Yes"],
		},
		{
			value: "0",
			label: Lang["No"],
		},
	];

	/**
	 * Edit a user's community settings.
	 *
	 * model : AoPS.Community.User
	 **/
	ComViews.EditCommunitySettings = AoPS.View.extend({
		className: "cmty-folder-top",

		template_id: "#cmty-edit-cmty-settings-tpl",

		sections: [
			{
				heading: Lang["edit-settings-general-heading"],
				settings: [
					{
						model_field: "hidden",
					},
					/*{
				model_field : 'enable_advanced_hotkeys',
				bold : true
			},*/ {
						model_field: "base_view",
						options: [
							{
								value: "main",
								label: Lang["edit-settings-main-base-view"],
							},
							{
								value: "portal",
								label: Lang["edit-settings-portal-base-view"],
							},
						],
					},
				],
			},
			{
				heading: Lang["edit-settings-friends-heading"],
				settings: [
					{
						model_field: "friends_show_profile",
					},
					{
						model_field: "friends_exclude",
						action: function (val, view, $data_row) {
							if (parseInt(val) === 0) {
								view.model.setUserSetting({
									value: val,
									field: "friends_exclude",
								});
								view.flashRow($data_row);
							} else {
								Modal.showConfirm(
									Lang["edit-settings-no-friends-confirm"],
									function (ok) {
										if (ok) {
											view.model.setUserSetting({
												value: val,
												field: "friends_exclude",
											});
											view.flashRow($data_row);
										} else {
											$data_row.find("select")[0].value = "0";
										}
									},
									{
										width: "450px",
										title: Lang["edit-settings-no-friends-confirm-title"],
									}
								);
							}
						},
					},
				],
			},
			{
				heading: Lang["edit-settings-posting-heading"],
				settings: [
					{
						model_field: "posting_subscribe_new_topic",
					},
					{
						model_field: "posting_subscribe_reply",
					},
					{
						model_field: "posting_fullscreen_reply",
					},
					{
						model_field: "warn_on_snipes",
						options: [
							{
								value: "none",
								label: Lang["None"],
							},
							{
								value: "flyout",
								label: Lang["Flyout"],
							},
							{
								value: "modal",
								label: Lang["Popup"],
							},
						],
					},
					{
						model_field: "forum_view",
						options: [
							{
								value: "full",
								label: Lang["Tall"],
							},
							{
								value: "condensed",
								label: Lang["Short"],
							},
						],
						refresh_page: true,
					},
					{
						model_field: "turn_off_autotagging",
					},
					{
						model_field: "hide_avatars",
					},
					{
						model_field: "hide_tags_on_topic",
					},
				],
			},
			{
				heading: Lang["edit-settings-pm-heading"],
				settings: [
					{
						model_field: "pm_email",
					},
					{
						model_field: "pm_archive_on_send",
					},
					{
						model_field: "pm_live_notify",
						options: [
							{
								value: "none",
								label: Lang["None"],
							},
							{
								value: "flyout",
								label: Lang["Flyout"],
							},
							{
								value: "modal",
								label: Lang["Popup"],
							},
						],
					},
					{
						model_field: "pm_exclude_self",
					},
					{
						type: "link_w_label",
						action: function (user) {
							Modal.showConfirm(
								Lang["edit-settings-archive-confirm"],
								function (ok) {
									if (ok) {
										user.archiveAllPrivates();
										AoPS.Ui.Flyout.display(
											Lang["edit-settings-privates-archived"]
										);
									}
								},
								{
									width: "450px",
								}
							);
						},
						link_text: Lang["edit-settings-archive-pm-btn"],
						link_label: Lang["edit-settings-archive-pm-label"],
					},
					{
						type: "link_w_label",
						action: function (user) {
							Modal.showConfirm(
								Lang["edit-settings-remove-confirm"],
								function (ok) {
									if (ok) {
										user.removeFromAllPrivates();
										AoPS.Ui.Flyout.display(
											Lang["edit-settings-privates-removed"]
										);
									}
								},
								{
									width: "450px",
								}
							);
						},
						link_text: Lang["edit-settings-remove-from-pm-btn"],
						link_label: Lang["edit-settings-remove-from-pm-label"],
					},
				],
			},
			{
				heading: Lang["edit-settings-feed-heading"],
				settings: [
					{
						model_field: "hide_feed",
					},
					{
						model_field: "show_tags_on_feed",
					},
					{
						model_field: "global_feed_type",
						options: [
							{
								value: "full",
								label: Lang["Full"],
							},
							{
								value: "custom",
								label: Lang["Custom"],
							},
						],
						refresh_page: true,
					},
				],
			},
		],

		initialize: function () {
			this.appendBookmarkSections();
			this.appendBlockedUsersSection();
			this.render();
			this.listenTo(this.model, "change:friends_show_profile", this.render);
			this.listenTo(this.model, "change:blocked_users", this.render);
		},

		/**
		 * Add the bookmark sections to the Edit Community Settings.
		 **/
		appendBookmarkSections: function () {
			var self = this;

			_.each(["topics", "forums", "tags"], function (bkmk) {
				var section = {};

				section["heading"] = Utils.formatString(
					Lang["edit-settings-bkmk-heading"],
					[bkmk]
				);
				section["settings"] = [];
				_.each(["all", "feed", "email"], function (clear_type) {
					var setting;

					setting = {
						type: "link_w_label",
						link_text: Lang["edit-settings-bkmk-link-" + clear_type],
						link_label: Utils.formatString(
							Lang["edit-settings-bkmk-" + clear_type + "-label"],
							[bkmk]
						),
						action: function (user) {
							Modal.showConfirm(
								Utils.formatString(
									Lang["edit-settings-bkmk-" + clear_type + "-confirm"],
									[bkmk]
								),
								function (ok) {
									if (ok) {
										ComViews.throwBlockingMessage(
											Lang["edit-settings-please-wait-bkmk"]
										);
										user.clearBookmarks({
											bookmark_section: bkmk,
											clear_type: clear_type,
											onFinish: function () {
												setTimeout(function () {
													location.reload();
												}, 1000);
											},
										});
									} else {
										Modal.closeAllModals();
									}
								},
								{
									width: "450px",
									close_on_button_click: false,
								}
							);
						},
					};

					section["settings"].push(setting);
				});

				self.sections.push(section);
			});
		},

		appendBlockedUsersSection: function () {
			var section = {
				heading: "Blocked users",
				settings: [
					{
						type: "link_w_label",
						link_text: "Add User",
						link_label:
							"Add a user to your list of blocked users. (Blocks private messages.)",
						action: ComViews.showBlockUserModal,
					},
					{type: "blocked_users_list"},
				],
			};

			if (this.model && this.model.fetchBlockedUsers) {
				this.model.fetchBlockedUsers();
			}

			this.sections.push(section);
		},

		render: function () {
			var self = this,
				i = 0,
				$card_row;

			this.$el.html(
				this.getTemplate(this.template_id, {
					lang_Page_Title: Lang["edit-settings-page-title"],
				})
			);
			_.each(this.sections, function (section) {
				var $section = $(
						self.getTemplate("#cmty-user-profile-card-tpl", {
							title: section.heading,
						})
					),
					$data = $section.find(".cmty-user-profile-data");

				if (i % 2 === 0) {
					$card_row = $('<div class="cmty-user-profile-row"></div>');
					self.$el.append($card_row);
				}
				$card_row.append($section);
				i++;
				_.each(section.settings, function (obj) {
					var selected, $data_row, action, settings;

					settings = _.extend(
						{
							type: "select",
							bold: false,
							refresh_page: false,
						},
						obj
					);
					action = obj.hasOwnProperty("action")
						? function (val) {
								obj.action(val, self, $data_row);
							}
						: function (val) {
								self.model.setUserSetting({
									value: val,
									field: settings.model_field,
									onFinish: function () {
										if (settings.refresh_page) {
											location.reload();
										}
									},
								});
								self.flashRow($data_row);
							};

					if (settings.type === "select") {
						selected = self.model.get(settings.model_field);
						$data_row = ComViews.buildSelectRow({
							options: settings.hasOwnProperty("options")
								? settings.options
								: ComViews.edit_community_yn_options,
							bold: settings.bold,
							selected:
								typeof selected === "boolean"
									? String(Number(selected))
									: selected,
							action: action,
							text: Lang["edit-settings-" + settings.model_field + "-label"],
						});
					} else if (settings.type === "link_w_label") {
						$data_row = ComViews.buildLinkLabelRow({
							bold: settings.bold,
							link_text: settings.link_text,
							link_label: settings.link_label,
							action: function () {
								settings.action(self.model);
							},
						});
					} else if (settings.type === "blocked_users_list") {
						$data_row = ComViews.buildBlockedUsersWidget(self.model);
					}
					$data.append($data_row);
				});
			});
		},

		events: {
			"click a.cmty-advanced-hotkeys": "onClickHotkeys",
		},

		onClickHotkeys: function (e) {
			if (!this.hasOwnProperty("hotkeys_modal")) {
				this.hotkeys_modal = this.getTemplate(
					"#cmty-advanced-hotkeys-modal-tpl",
					{}
				);
			}
			Modal.showMessage(this.hotkeys_modal, {
				title: Lang["edit-settings-hotkeys-modal-title"],
				width: "600px",
			});

			e.stopPropagation();
			e.preventDefault();
		},

		flashRow: function ($data_row) {
			$data_row
				.addClass("cmty-select-row-flash")
				.removeClass("cmty-select-row-flash", 1000);
		},
	});

	/**
	 * Builds a blocked-users widget, which is a list of the user's.
	 *
	 * @param {ComModels.User} userModel
	 * @returns {jQuery} $widget element
	 */
	ComViews.buildBlockedUsersWidget = function (userModel) {
		var blocked_users = userModel.get("blocked_users") || [];

		var $widget = $("<ul class='cmty-user-profile-blocked-users'></ul>").append(
			blocked_users.map(function (blockedUser) {
				var $username = $(
					"<span class='cmty-user-profile-blocked-user-username'></span>"
				).text(blockedUser.username);

				var $unblock = $(
					"<span class='aops-font cmty-user-profile-blocked-user-unblock'>J</span>"
				).click(function () {
					userModel.unblockUser({
						blocked_user_id: blockedUser.user_id,
						blocked_username: blockedUser.username,
					});

					$li.hide();
				});

				var $li = $("<li class='cmty-user-profile-blocked-user-row'></li>")
					.append($username)
					.append($unblock);

				return $li;
			})
		);
		return $widget;
	};

	/**
	 * Constructs the block user form.
	 *
	 * @returns {jQuery} $form element
	 */
	ComViews.buildBlockUserForm = function () {
		var $form = $("<div class='cmty-user-profile-block-user-form'></div>");

		var $input = $(
			"<input class='cmty-user-profile-block-user-input' type='text'></input>"
		);

		$form
			.append(
				$(
					"<p>Enter the user you would like to block. You will no longer see PMs from this user.</p>"
				)
			)
			.append(
				$(
					"<p>If you are in any group PMs with this user, you will lose access to those PMs.</p>"
				)
			)
			.append($("<span>Username: </span>"))
			.append($input);

		Utils.buildUsernameAutocomplete($input, {
			ajax_call: "fetch_username_matches",
			autocomplete_settings: {
				onSelect: function (event, user_item) {
					var user_id = user_item.item.user_id;
					$input.attr("data-user-id", user_id);
				},
			},
		});

		return $form;
	};

	/**
	 * Shows the block user modal.
	 *
	 * @param {ComModels.User} userModel
	 */
	ComViews.showBlockUserModal = function (userModel) {
		var $modal = Modal.showButtonsQuick(
			ComViews.buildBlockUserForm(),
			[
				{text: "Block", value: 1},
				{text: "Cancel", value: 0},
			],
			function (performBlock) {
				if (!performBlock) {
					return;
				}

				var user_id = $modal.$obj
					.find(".cmty-user-profile-block-user-input")
					.attr("data-user-id");

				var username = $modal.$obj
					.find(".cmty-user-profile-block-user-input")
					.val();

				if (user_id || username) {
					userModel.blockUser({
						blocked_user_id: user_id,
						blocked_username: username,
						onError: function (error) {
							var msg = "An error occurred while trying to block this user.";

							if (error.error_code === "E_CANNOT_BLOCK_SELF") {
								msg = "You cannot block yourself!";
							} else if (error.error_code === "E_CANNOT_BLOCK_STAFF") {
								msg = "You cannot block admins or staff.";
							} else if (error.erro_code === "E_TOO_MANY_BLOCKS") {
								msg = "You have reached the maximum number of blocked users.";
							}

							Modal.showAlertQuick(msg);
						},
					});
				}
			},
			{title: "Block User"}
		);
	};

	/**
	 * View for the FAQ.
	 * This is about as simple is things get. A loading icon appears and the help CMS
	 * is loaded. Once loaded, the loading icon is removed and events are set up
	 * to toggle headers on the help page.
	 */
	ComViews.FAQ = AoPS.View.extend({
		className: "cmty-faq-panel",

		initialize: function () {
			this.$loader = AoPS.Page.buildLoader();
			this.$el.append(this.$loader);
			this.render();
		},

		render: function () {
			var self = this;
			this.$el.cmtyLoadFromFile({
				filename:
					AoPS.bootstrap_data.datastore_path +
					"cms/community/lang_en/help.html",
				onFinish: function () {
					self.$loader.detach();
					self
						.$(".grey-panel .header")
						.add(".grey-panel .toggle")
						.on("click", function (e) {
							$(this).parent().toggleClass("closed");
						});
				},
			});
		},
	});

	/*** START Memberlist ***/

	ComViews.Memberlist = AoPS.View.extend({
		template_id: "#cmty-memberlist-master-tpl",

		className: "cmty-memberlist",

		initialize: function (options) {
			this.render();
			this.stub = options.stub;
			// Set up some way to pass term through options
			this.user_list = new AoPS.Community.Models.UserList({
				stub: this.stub,
			});
			this.all_users = {};

			this.$loader = AoPS.Page.buildLoader();
			this.$no_matches = $(
				'<div class="cmty-memberlist-none">' +
					Lang["memberlist-no-matches"] +
					"</div>"
			);

			this.startMemberlist();
			this.$input.val(this.stub);
			this.setArrows();
		},

		render: function () {
			var self = this;
			var full_list = AoPS.Community.MasterModel.fetchStaffPermission(
				"see-full-memberlist"
			);
			var can_temp_ban =
				AoPS.Community.MasterModel.fetchPermission("can_temp_ban");

			this.$el.html(
				this.getTemplate(this.template_id, {
					lang_page_title: Lang["memberlist-page-title"],
					lang_user_search: Lang["memberlist-user-search"],
					lang_Username: Lang["Username"],
					lang_placeholder: Lang["memberlist-user-search-placeholder"],
					lang_search_button: Lang["SEARCH"],
					has_email: full_list || can_temp_ban,
					has_IP: full_list,
					has_VPN_check: full_list,
					lang_Joined: Lang["memberlist-joined"],
					lang_Last_Visit: Lang["memberlist-last-visit"],
					lang_Email: Lang["Email"],
					lang_IP: Lang["IP"],
					lang_Posts: Lang["memberlist-posts"],
					lang_Thanks: Lang["memberlist-thanks"],
					tooltip_posts: Lang["memberlist-posts-tooltip"],
					tooltip_thanks: Lang["memberlist-thanks-tooltip"],
				})
			);

			this.$input = this.$("input");

			this.$table = this.$("table > tbody");

			this.$input.on("keydown", function (e) {
				var key_pressed = e.which || e.keyCode;

				if (key_pressed === 13) {
					self.buildFromInput();
				}
			});
		},

		events: {
			"click .cmty-user-search-row .btn": "buildFromInput",
			"click th.clickable": "onClickTableHead",
			"click span.cmty-ban-link": "onClickBan",
			"click span.cmty-troll-link": "onClickTroll",
			"click span.cmty-temp-ban-link": "onClickTempBan",
			"click .cmty-vpn-check": "onClickCheckVPN",
		},

		startMemberlist: function () {
			if (this.user_list.get("users").length === 0) {
				this.fetchMoreUsers();
			} else {
				this.addUsers(this.user_list);
			}
		},

		addUsers: function (users) {
			var self = this;
			var full_list = AoPS.Community.MasterModel.fetchStaffPermission(
				"see-full-memberlist"
			);
			var can_temp_ban =
				AoPS.Community.MasterModel.fetchPermission("can_temp_ban");

			_.each(users, function (user) {
				self.all_users[user.user_id] = user;
			});

			this.$table.append(
				this.getTemplate("#cmty-memberlist-rows-tpl", {
					users: users,
					has_email: full_list || can_temp_ban,
					has_IP: full_list,
					has_VPN_check: full_list,
				})
			);
		},

		onAddToPage: function () {
			var self = this;
			this.$input.focus();
			$(window).on("scroll", function () {
				if (
					document.documentElement.clientHeight + $(document).scrollTop() >=
					document.body.offsetHeight - 80
				) {
					self.fetchMoreUsers();
				}
			});
		},

		onRemoveFromPage: function () {
			$(window).off("scroll");
		},

		onClickTableHead: function (e) {
			var sort_on = e.currentTarget.getAttribute("sort-on");
			var sort_direction;

			if (sort_on !== this.user_list.get("sort_column")) {
				sort_direction = this.getDefaultDirection(sort_on);
			} else {
				sort_direction =
					this.user_list.get("sort_direction") === "ASC" ? "DESC" : "ASC";
			}

			this.rebuildList({
				sort_column: sort_on,
				sort_direction: sort_direction,
			});
		},

		getDefaultDirection: function (sort_on) {
			if (sort_on === "username" || sort_on === "joined_at") {
				return "ASC";
			} else {
				return "DESC";
			}
		},

		fetchMoreUsers: function () {
			var self = this;
			if (
				!this.user_list.get("all_fetched") &&
				!this.user_list.get("is_loading")
			) {
				this.$el.append(this.$loader);
				this.user_list.fetchMoreUsers({
					onFinish: function (data) {
						self.$loader.detach();
						if (data.hasOwnProperty("new_users") && data.new_users.length > 0) {
							self.addUsers(data.new_users);
						}
						if (self.user_list.get("users").length == 0) {
							self.$el.append(self.$no_matches);
						}
					},
				});
			}
		},

		buildFromInput: function () {
			var sort_column = this.user_list.get("sort_column");
			this.rebuildList({
				sort_column: sort_column,
				sort_direction: this.user_list.get("sort_direction"),
			});
		},

		rebuildList: function (obj) {
			obj.stub = this.$input.val();
			this.$no_matches.detach();
			if (
				obj.stub === this.user_list.get("stub") &&
				obj.sort_direction === this.user_list.get("sort_direction") &&
				obj.sort_column === this.user_list.get("sort_column")
			) {
				return;
			}

			this.$table.empty();
			this.user_list.destroy();

			this.user_list = new AoPS.Community.Models.UserList(obj);
			this.fetchMoreUsers();
			this.setArrows();
		},

		setArrows: function () {
			var sort_direction = this.user_list.get("sort_direction"),
				sort_column = this.user_list.get("sort_column");

			this.$table.parent().find("th .aops-font").remove();
			this.$table
				.parent()
				.find('[sort-on="' + sort_column + '"]')
				.append(
					'<span class="aops-font">' + (sort_direction === "DESC" ? " S" : " T")
				);
		},

		onClickBan: AoPS.Community.Utils.onClickBan,

		onClickTroll: AoPS.Community.Utils.onClickTroll,

		onClickTempBan: function (e) {
			var user_id = e.currentTarget.getAttribute("user_id");
			var found_user = this.all_users[user_id];

			if (found_user) {
				AoPS.Community.Utils.onClickTempBan(
					_.extend(
						{
							user_id: found_user.user_id,
							username: found_user.username,
							success: function (temp_ban) {
								$(e.target).text(
									temp_ban.can_access ? "RESTRICT" : "UNRESTRICT"
								);
								found_user.temp_ban = temp_ban;
							},
						},
						found_user.temp_ban
					)
				);
			}
		},

		onClickCheckVPN: function (e) {
			var ip = e.currentTarget.getAttribute("ip");
			AoPS.Community.MasterModel.checkVPN({
				ip: ip,
			});
			$(e.currentTarget).hide();
		},
	});

	/*** END Memberlist ***/

	/*** START Category Admin views ***/

	/**
	 * Many groups of category_types have the same admin page.
	 *  Here, we cast those groups to a single type for use in
	 *  lang options and in the CategoryAdminBlocks below
	 **/
	ComViews.getCategoryAdminCatType = function (category_type) {
		switch (category_type) {
			case "forum_class":
				category_type = "forum";
				break;
		}

		return category_type;
	};

	/***
	 * Get the blocks that we must include in a category admin.
	 *
	 */
	ComViews.fetchCategoryAdminBlocks = function (category_type) {
		var blocks = [];

		switch (category_type) {
			case "forum":
			case "forum_class":
				blocks = ["GeneralInfo", "Permissions"];
				break;

			case "blog":
				blocks = ["GeneralInfo", "Permissions", "BlogSettings", "BlogCss"];
				break;

			case "view_tags":
				blocks = ["GeneralInfo", "Permissions", "ContentsViewTags"];
				break;

			case "view_posts":
				blocks = ["GeneralInfo", "Permissions", "ContentsViewPosts"];
				break;

			case "view_topics":
				blocks = ["GeneralInfo", "Permissions", "ContentsViewTopics"];
				break;

			case "blogroll":
				blocks = ["GeneralInfo", "Permissions", "ContentsBlogroll"];
				break;

			case "folder":
				blocks = ["GeneralInfo", "Permissions", "ContentsFolder"];
				break;

			case "folder_forums":
				blocks = ["GeneralInfo", "Permissions", "ContentsFolderForums"];
				break;

			case "folder_collections":
				blocks = ["GeneralInfo", "Permissions", "ContentsFolderCollections"];
				break;

			case "my_forums":
			case "my_blogs":
			case "my_collections":
				blocks = ["GeneralInfo", "ContentsFolder"];
				break;

			case "bookmark_topics":
				blocks = ["GeneralInfo", "ContentsViewTopics"];
				break;

			case "bookmark_users":
				blocks = ["GeneralInfo", "ContentsBookmarkUsers"];
				break;

			case "bookmark_tags":
				blocks = ["GeneralInfo", "ContentsViewTags"];
				break;

			case "bookmark_forums":
				blocks = ["GeneralInfo", "ContentsFolderForums"];
				break;
		}

		blocks = _.map(blocks, function (block) {
			return "CategoryAdminBlock" + block;
		});

		return blocks;
	};

	/**
	 *
	 * model : AoPS.Community.Models.Category
	 *
	 */
	ComViews.CategoryAdmin = AoPS.View.extend({
		className: "cmty-category-admin",

		initialize: function (options) {
			if (this.model.get("category_type") === "") {
				// TODO : holding pattern
				/**
				Ask them what they are trying to build, redirect.

				Need a permission check here.
				**/
			}

			/**
			 *	From here on, we have a real category.
			 */
			this.is_building_new = this.model.get("category_id") === 0;
			this.is_creating = false;
			this.render();
		},

		render: function () {
			var block_view_constructors,
				self = this;

			this.constructTitle();
			block_view_constructors = ComViews.fetchCategoryAdminBlocks(
				ComViews.getCategoryAdminCatType(this.model.get("category_type"))
			);

			if (block_view_constructors.length === 0) {
				// TODO : sent a dumb category type in, probably do the same thing
				//  as with category_type empty, might just fold that here.
			}

			/**
			 * Views for the blocks from which we build the page.
			 *  Different category types have different components; we
			 *  first fetch the list of those components, and then we build them
			 *  all.
			 **/
			self.block_views = [];

			_.each(block_view_constructors, function (constructor) {
				var block_view = new ComViews[constructor]({
					model: self.model,
				});

				self.$el.append(block_view.$el);
				self.block_views.push(block_view);
			});
			if (this.is_building_new) {
				this.$el.append(
					'<div class="buttons"><button class="cmty-create-category btn btn-primary">' +
						Lang["cat-admin-create-button"] +
						"</button></div>"
				);
			}
		},

		events: {
			"click .cmty-create-category": "onClickCreate",
		},

		onClickCreate: function () {
			var i,
				max = this.block_views.length,
				self = this;

			if (this.is_creating) {
				return;
			}
			this.is_creating = true;

			for (i = 0; i < max; i++) {
				if (!this.block_views[i].validateNewCategorySettings()) {
					this.is_creating = false;
					return;
				}
			}

			AoPS.Ui.Modal.showConfirm(
				Lang[
					"cat-admin-create-" +
						(this.model.get("is_public") ? "public" : "private") +
						"-" +
						this.model.getAdminLangType() +
						"-warning"
				],
				function (ok) {
					if (ok) {
						self.createNewCategory();
					} else {
						self.is_creating = false;
						AoPS.Ui.Modal.closeAllModals();
					}
				},
				{
					width: "450px",
					confirm_button_cancel: "NO!",
					confirm_button_ok: "YES!",
					close_on_button_click: false,
				}
			);

			// Notes from when I thought I'd have to do
			// Ajax calls as part of validation:  We have to loop through the
			//  blocks and validate each, but each may have a related Ajax call.
			//  That will be tricky.  May need to trigger a 'validated' on
			//  each block_view's $el.  Yeah, that's the way to go.
		},

		createNewCategory: function () {
			var self = this;

			AoPS.Ui.Modal.replaceTopModal({
				type: "message",
				body: Lang["cat-admin-create-category-blocker"],
				frame_class: "aops-modal-quick",
				force_response: true,
				closeX: false,
			});
			this.is_creating = false;

			this.model.burnNewCategory({
				onFinish: function (response) {
					var target_url;

					if (self.checkIfOneMoreStep()) {
						target_url = "/community/category-admin/" + response.category_id;
					} else {
						target_url =
							"/community/c" +
							response.category_id +
							"_" +
							ComViews.convertToUrlFragment(self.model.get("category_name"));
					}
					//	AoPS.Ui.Modal.closeAllModals();
					/**
					 * We use window.location in part because if we made
					 *  a blog, then we have to start all over, as we need a different router,
					 *  and in part so users can't just hit "Back" and quickly make another
					 *  forum.  We could also use the route changing stuff commented out below
					 * 	for forums and collections.
					 **/
					window.location.replace(target_url);

					/*
					WE MAY BRING THESE LINES BACK FOR FORUMS AND COLLECTIONS

					self.model.destroy();

					Backbone.history.navigate('/c' + response.category_id + '_' +
						ComViews.convertToUrlFragment(self.model.get('category_name')), {trigger : true});
					*/
				},
				onError: function (data) {
					var msg;

					if (!_.isUndefined(Lang["cat-admin-error-" + data.error_code])) {
						msg = Lang["cat-admin-error-" + data.error_code];

						switch (data.error_code) {
							case "E_NOT_LOGGED_IN":
							case "E_NO_PERMISSION":
								msg =
									msg +
									Utils.displayCategoryType(self.model.get("category_type")) +
									".";
								break;

							case "E_NO_SUCH_CATEGORY_TYPE":
								msg = msg + self.model.get("category_type");
								break;
						}
					} else {
						msg = Lang["unexpected-error-code"] + data.error_code;
					}

					AoPS.Ui.Modal.showAlertQuick(msg, {
						width: "450px",
						onClose: function () {
							AoPS.Ui.Modal.closeAllModals();
						},
					});
				},
			});
		},

		checkIfOneMoreStep: function () {
			return (
				_.indexOf(
					["forum", "forum_class", "blog"],
					this.model.get("category_type")
				) === -1
			);
		},

		constructTitle: function () {},

		onClose: function () {
			_.each(this.block_views, function (block_view) {
				block_view.close();
			});
		},
	});

	/**
	 * Top bar for the category admin pages.
	 *
	 * model : AoPS.Community.Models.Category or child
	 **/
	ComViews.CategoryAdminTitleBar = AoPS.View.extend({
		initialize: function () {
			var is_building_new = this.model.get("category_id") === 0,
				type = Utils.displayCategoryType(this.model.get("category_type")),
				has_class = false,
				class_id = 0;

			if (this.model.has("class_id")) {
				has_class = true;
				class_id = this.model.get("class_id");
			}
			if (is_building_new) {
				this.$el.html(
					this.getTemplate("#cmty-build-new-cat-heading-tpl", {
						lang_Type: Utils.capitalizeFirstLetter(Lang[type]),
						lang_Create: Lang["Create"],
					})
				);
			} else {
				this.$el.html(
					this.getTemplate("#cmty-cat-info-page-heading-tpl", {
						lang_Type: Utils.capitalizeFirstLetter(Lang[type]),
						lang_TYPE: Lang[type].toUpperCase(),
						has_push_state_attr: this.model.get("category_type") !== "blog",
						lang_Info: Lang["Info"],
						category_id: this.model.get("category_id"),
						return_target: this.getUrlEnd(),
						name: this.model.get("category_name"),
						lang_BACK_TO: Lang["Back-to"].toUpperCase(),
						lang_button_class: Lang["cat-admin-back-to-class"],
						lang_button_cmty: Lang["cat-admin-back-to-cmty"],
						class_id: class_id,
						has_class: has_class,
					})
				);
			}
		},

		getUrlEnd: function () {
			switch (this.model.get("category_type")) {
				case "my_collections":
					return "my-collections";

				case "my_forums":
					return "my-forums";

				case "my_blogs":
					return "my-blogs";

				default:
					return "c" + this.model.get("category_id");
			}
		},
	});

	/**
	 * General information atop the category create/administrate page.
	 *
	 * model : AoPS.Community.Models.Category (or children)
	 **/
	ComViews.CategoryAdminBlockGeneralInfo = AoPS.View.extend({
		template_id: "#cmty-category-admin-general-info-tpl",

		className: "aops-panel cmty-cat-admin-gen-info",

		initialize: function () {
			var lang_field = this.model.getAdminLangType(),
				is_new = this.model.get("category_id") === 0,
				can_edit = this.model.getPermission("c_can_edit_core_data"),
				can_soft_delete =
					!is_new && this.model.getPermission("c_can_delete_category"),
				can_hard_delete =
					!is_new && this.model.getPermission("c_can_hard_delete_cat"),
				can_settle_reports =
					!is_new && this.model.getPermission("c_can_settle_report"),
				can_access_log =
					!is_new && this.model.get("master").fetchPermission("can_access_log"),
				has_admin_row =
					can_soft_delete ||
					can_hard_delete ||
					can_access_log ||
					can_settle_reports,
				self = this,
				can_edit_global_feed;

			var soft_delete_text = "";
			if (can_soft_delete && can_hard_delete) {
				soft_delete_text = Lang["cat-admin-soft-delete"];
			} else if (can_soft_delete) {
				soft_delete_text = Lang["cat-admin-delete"];
			}

			/** forum_class cannot be edited **/
			can_edit_global_feed =
				!is_new &&
				(this.model.get("category_type") === "forum" ||
					this.model.get("category_type") === "forum_class") &&
				AoPS.session.logged_in_and_initialized &&
				this.model.get("master").get("feed").get("global_feed_type") ===
					"custom";

			var category_description = "";
			if (this.model.get("short_description").length > 0) {
				category_description = this.model.get("short_description");
			} else if (!can_edit) {
				category_description = Lang["cat-admin-no-description"];
			}
			this.$el.html(
				this.getTemplate(this.template_id, {
					title: Lang["cat-admin-general-info"],
					description_heading: Lang["cat-admin-description-heading"],
					can_edit_core_data: can_edit,
					lang_view_log: Lang["cat-admin-view-log"],
					category_id: this.model.get("category_id"),
					lang_name_warning: Lang["cat-admin-cat-name-warning"],
					category_name: this.model.get("category_name"),
					category_description: category_description,
					has_admin_row: has_admin_row,
					can_settle_reports: can_settle_reports,
					lang_reported_posts: Lang["cat-admin-reported-posts"],
					can_soft_delete: can_soft_delete,
					lang_soft_delete: soft_delete_text,
					lang_hard_delete: Lang["cat-admin-hard-delete"],
					can_hard_delete: can_hard_delete,
					can_access_log: can_access_log,
					has_buttons: can_edit && !is_new,
					name_heading: Lang["cat-admin-" + lang_field + "-name"],
					name_placeholder:
						Lang["cat-admin-" + lang_field + "-name-placeholder"],
					description_placeholder:
						Lang["cat-admin-" + lang_field + "-desc-placeholder"],
					max_name_length: Constants.max_category_name_length,
					max_description_length: Constants.max_category_description_length,
					Save: Lang["Save"],
					Reset: Lang["Reset"],
					can_edit_global_feed: can_edit_global_feed,
					global_feed_heading: Lang["cat-admin-in-global-feed"],
					lang_Yes: Lang["Yes"],
					lang_No: Lang["No"],
					is_class_forum: this.model.get("category_type") === "forum_class",
					lang_automatically_included: Lang["cat-admin-global-automatic"],
					lang_see_faq: Lang["cat-admin-global-feed-help"],
					is_in_global_feed:
						can_edit_global_feed &&
						_.indexOf(
							this.model.get("master").get("feed").get("global_feed_fora"),
							this.model.get("category_id")
						) > -1,
				})
			);

			if (can_edit) {
				this.$category_name = this.$el.find('input[name="collection-name"]');
				this.$category_description = this.$el.find(
					'input[name="collection-description"]'
				);
				if (!is_new) {
					this.$footer = this.$el.find(".footer");
					this.$category_name
						.add(this.$category_description)
						.on("input", function () {
							self.activateSaveButton();
						});
				}
				this.cacheData();
			}
			if (
				!is_new &&
				this.model.get("is_forum") &&
				this.model.getPermission("c_can_edit_admin_items")
			) {
				this.$el.append(
					'<div class="cmty-admin-only-line">' +
						Lang["cat-admin-admin-item-warning"] +
						"</div>"
				);
				_.each(
					[
						"include_in_count",
						"include_in_thank_count",
						"include_in_nothank_count",
						"include_in_dynamic_collections",
					],
					function (setting) {
						self.buildEditableBitSetting(setting);
					}
				);
			}
		},

		/**
		 * We can only edit the colors of categories that have system colors --
		 *  I don't want anyone messing with the colors of the toplevel fora without
		 *  talking to me.
		 **/
		hasSystemColor: function () {
			var colors = _.pluck(Lang["cat-admin-category-colors"], "color");

			return _.indexOf(colors, this.model.get("main_color").toLowerCase()) > -1;
		},

		prepareColors: function () {
			var colors_obj = _.clone(Lang["cat-admin-category-colors"]),
				my_color = this.model.get("main_color").toLowerCase();

			_.each(colors_obj, function (obj) {
				obj.checked = my_color === obj.color;
			});

			return colors_obj;
		},

		/**
		 * Build the row for a setting and put the label in place
		 *
		 * @param string setting
		 */
		buildSettingGroup: function (setting) {
			return $(
				'<div class="form-group"><div><label>' +
					Lang["cat-admin-label-" + setting] +
					"</label></div>"
			);
		},

		/**
		 * Build a static setting to reveal
		 *
		 * @param string setting
		 */
		buildStaticSetting: function (setting) {
			var $setting_group = this.buildSettingGroup(setting),
				value = this.model.get(setting);

			if (typeof value === "boolean") {
				value = value ? Lang["Yes"] : Lang["No"];
			}

			$setting_group.append("<div>" + value + "</div>");
			this.$el.append($setting_group);
		},

		/**
		 * Build an editable yes/no setting.
		 *
		 * @param string setting
		 */
		buildEditableBitSetting: function (setting) {
			var self = this,
				$setting_group = this.buildSettingGroup(setting),
				$select = $(
					this.getTemplate("#yes-no-select-tpl", {
						value: this.model.get(setting),
						Yes: Lang["Yes"],
						No: Lang["No"],
					})
				);

			$select.on("change", function (e) {
				ComViews.EditCommunitySettings.prototype.flashRow(
					$select.parent().parent()
				);
				self.updateBitSetting(
					setting,
					e.target.options[e.target.selectedIndex].value
				);
			});
			$setting_group.append($("<div></div>").append($select));
			this.$el.append($setting_group);
		},

		/**
		 * Update a bit setting for this model.
		 *
		 * @param string setting to update
		 * @param string value of the setting
		 */
		updateBitSetting: function (setting, value) {
			this.model.setAdminItemSetting({
				setting: setting,
				value: parseInt(value),
				/*onError : function (msg) {
					if (typeof Lang['change-blog-err-' + msg.error_code]) {
						ComViews.showError(Lang['change-blog-err-' + msg.error_code]);
					}

				}*/
			});

			this.model.set(setting, parseInt(value) == 1);
		},

		events: {
			"click .cmty-cat-admin-gen-save": "onClickSave",
			"click .cmty-cat-admin-gen-reset": "onClickReset",
			"click .cmty-soft-delete-cat": "onClickSoftDelete",
			"click .cmty-hard-delete-cat": "onClickHardDelete",
			'change select[name="cmty-cat-admin-global-feed-setting"]':
				"onChangeGlobalFeedSetting",
		},

		onClickReset: function () {
			this.resetToCachedData();
			this.$footer.hide();
		},

		onChangeGlobalFeedSetting: function () {
			var new_setting;

			new_setting = this.$(
				'select[name="cmty-cat-admin-global-feed-setting"]'
			).val();

			this.model.updateGlobalFeedSetting({
				new_setting: new_setting,
				onFinish: function () {
					location.reload();
				},
				onError: function (msg) {
					var error_msg;

					if (Lang.hasOwnProperty("cat-admin-global-err-" + msg.error_code)) {
						error_msg = Lang["cat-admin-global-err-" + msg.error_code];
					} else {
						error_msg = Lang["err-unknown"];
					}

					AoPS.Ui.Modal.showAlert(error_msg, {
						width: "450px",
						onClose: function () {
							location.reload();
						},
					});
				},
			});
		},

		onClickSoftDelete: function () {
			this.onClickDelete("soft");
		},

		onClickHardDelete: function () {
			this.onClickDelete("hard");
		},

		onClickDelete: function (delete_type) {
			var self = this;
			Modal.showConfirm(
				Utils.formatString(
					Lang["cat-admin-" + delete_type + "-delete-confirm"],
					[this.model.get("category_name")]
				),
				function (ok) {
					if (ok) {
						ComViews.throwLoaderBlockingMessage(
							Lang["cat-admin-delete-blocker"]
						);
						setTimeout(function () {
							self.model.delete({
								delete_type: delete_type,
								onFinish: function (data) {
									window.location.href = "/community";
								},
								onError: function (msg) {
									var message;
									switch (msg.error_code) {
										case "E_PROTECTED":
											message = Lang["cat-admin-delete-protected"];
											break;

										case "E_CATEGORY_NOT_FOUND":
											message = Lang["cat-admin-delete-not-found"];
											break;

										case "E_NO_PERMISSION":
											message = Lang["cat-admin-delete-no-permission"];
											break;

										default:
											message = Lang["unexpected-error-code"] + msg.error_code;
											break;
									}
									ComViews.showError(message);
								},
							});
						}, 1000); // buy time to read blocker
					} else {
						Modal.closeAllModals();
					}
				},
				{
					width: "450px",
					close_on_button_click: false,
				}
			);
		},

		cacheData: function () {
			this.cached_name = this.$category_name.val();
			this.cached_description = this.$category_description.val();
		},

		resetToCachedData: function () {
			this.$category_name.val(this.cached_name);
			this.$category_description.val(this.cached_description);
		},

		activateSaveButton: function () {
			this.$footer.show();
		},

		onClickSave: function () {
			var self = this;
			if (this.validateNewCategorySettings()) {
				ComViews.throwLoaderBlockingMessage(Lang["saving-blocker"]);
				this.$footer.hide();
				this.model.saveCoreDataToDb({
					onFinish: function () {
						setTimeout(function () {
							AoPS.Ui.Modal.closeAllModals();
							self.cacheData();
							AoPS.Ui.Flyout.display(Lang["data-saved-reload"]);
						}, Constants.message_readability_delay_short);
					},
					onError: function (msg) {
						var error_msg;

						if (msg.error_code === "E_NO_PERMISSION") {
							error_msg = Lang["cat-admin-gen-info-error-E_NO_PERMISSION"];
						} else {
							error_msg = Lang["cat-admin-error-" + msg.error_code];
						}

						error_msg += "<br><br>" + Lang["cat-admin-error-nothing-saved"];

						AoPS.Ui.Modal.showAlert(error_msg, {
							width: "450px",
							onClose: function () {
								AoPS.Ui.Modal.closeAllModals();
								self.activateSaveButton();
							},
						});
					},
				});
			}
			// Hide button,
			// Throw blocker
			// Go to back end
			// Eh, skip the blocker phase.  Maybe a flyout?
		},

		/**
		 * On edit or create, these are the front-end checks we make before sending anything to the backend.
		 **/
		validateNewCategorySettings: function () {
			if (
				this.$category_name.val().length < Constants.min_category_name_length
			) {
				AoPS.Ui.Modal.showAlertQuick(
					Lang[
						"cat-admin-" +
							Utils.simplifyCategoryType(this.model.get("category_type")) +
							"-name-too-short"
					]
				);
				return false;
			}
			this.model.set("category_name", this.$category_name.val());
			this.model.set("short_description", this.$category_description.val());
			return true;
		},
	});

	/**
	 *
	 * model : AoPS.Community.Models.Category (or one of its children)
	 */
	ComViews.CategoryAdminBlockPermissions = AoPS.View.extend({
		template_id: "#cmty-category-admin-permissions-tpl",

		className: "aops-panel cmty-cat-admin-perm-panel",

		initialize: function () {
			this.is_new = this.model.get("category_id") === 0;
			if (this.is_new) {
				this.model.get("users").push({
					user_id: AoPS.session.user_id,
					username: AoPS.session.username,
					is_admin: AoPS.session.admin,
					role: "owner",
				});
			}
			if (this.isUserPermissionAvailable() || AoPS.session.admin) {
				this.user_box_views = [];
				this.render();
				this.listenTo(
					this.model,
					"change:is_public change:is_locked change:has_source",
					this.setHelpers
				);
				this.buildHelper();
			} else {
				this.$el.html(
					this.getTemplate(
						"#cmty-category-admin-permissions-private-coll-tpl",
						{
							title: Lang["cat-admin-permissions-title"],
							explanation: Lang["cat-admin-private-collection-perms"],
						}
					)
				);
			}
		},

		buildHelper: function () {
			var help_id = this.category_type_specific_settings.help_template_id;
			this.$help = $(this.getTemplate(help_id, {}));
		},

		render: function () {
			var can_lock = this.model.getPermission("c_can_lock_category"),
				cat_type;

			if (this.model.get("category_type") === "forum") {
				cat_type = "forum";
			} else if (this.model.get("category_type") === "blog") {
				cat_type = "blog";
			} else {
				cat_type = "collection";
			}
			this.category_type_specific_settings = this.fetchRenderData();

			this.$el.html(
				this.getTemplate(this.template_id, {
					is_new: this.is_new,
					header_text: Lang["cat-admin-permissions-header-" + cat_type],
					title: Lang["cat-admin-permissions-title"],
					lang_private: Lang["Private"],
					can_edit_public:
						this.is_new || this.model.getPermission("c_can_change_is_public"),
					lang_public: Lang["Public"],
					public_private_heading: Lang["cat-admin-permissions-public-heading"],
					is_locked_heading: Lang["cat-admin-permissions-is-locked"],
					can_lock: can_lock,
					lang_open: Lang["cat-admin-permissions-open"],
					lang_locked: Lang["cat-admin-permissions-locked"],
					is_public: this.model.get("is_public"),
					is_locked: this.model.get("is_locked"),
					has_source_toggle:
						!this.is_new &&
						this.model.get("category_type") == "forum" &&
						this.model.getPermission("c_can_edit_core_data"),
					has_source_heading: Lang["cat-admin-permissions-has-source"],
					inheritance_heading: Lang["cat-admin-permissions-inherit-head"],
					lang_No: Lang["No"],
					lang_Yes: Lang["Yes"],
					has_source: this.model.get("has_source"),
					can_set_inheritance:
						!this.is_new && this.model.getPermission("c_can_set_role_inherit"),
				})
			);

			this.$is_locked = this.$el.find(
				'select[name="cmty-category-admin-is-locked"]'
			);

			if (this.model.get("category_type") === "forum") {
				this.$has_source = this.$el.find(
					'select[name="cmty-category-admin-has-source"]'
				);
			}
			if (this.is_new) {
				this.$is_public = this.$el.find(
					'select[name="cmty-category-admin-is-public"]'
				);
			}
			this.addUserBoxes();

			this.setHelpers();

			if (this.model.getPermission("c_can_set_role_inherit")) {
				this.$role_inheritance = this.$(".cmty-category-admin-role-inherit");
				this.listenTo(
					this.model,
					"change:role_inheritance_parent",
					this.constructRoleInheritance
				);
				this.constructRoleInheritance();
			}
		},

		events: {
			'change select[name="cmty-category-admin-is-public"]': "onChangeIsPublic",
			'change select[name="cmty-category-admin-is-locked"]': "onChangeIsLocked",
			'change select[name="cmty-category-admin-has-source"]': "onChangeSource",
			"click .cmty-cat-admin-help": "onClickHelp",
		},

		onClickHelp: function () {
			this.$help.showModal({
				frame_class: "cmty-cat-admin-helper-modal aops-modal-standard",
				title: Lang["cat-admin-perms-help-title"],
				width: "600px",
				scrollable: true,
			});
		},

		onChangeIsPublic: function () {
			var self = this,
				warning_property;

			if (this.model.get("category_type") === "blog") {
				if (this.model.get("is_public")) {
					warning_property = "cat-admin-set-blog-private-warning";
				} else {
					warning_property = "cat-admin-set-blog-public-warning";
				}
			} else {
				warning_property = "cat-admin-is-public-confirm-warning";
			}
			if (!this.is_new) {
				Modal.showConfirm(
					Lang[warning_property],
					function (ok) {
						if (ok) {
							ComViews.throwBlockingMessage(
								Lang["cat-admin-is-public-blocker"]
							);
							self.model.toggleIsPublic({
								onFinish: function (msg) {
									location.reload();
								},
								onError: function (msg) {
									var error_msg;
									if (msg.error_code === "E_NO_PERMISSION") {
										error_msg =
											Lang["cat-admin-gen-info-error-E_NO_PERMISSION"];
									} else {
										error_msg = Lang["cat-admin-error-" + msg.error_code];
									}

									error_msg +=
										"<br><br>" + Lang["cat-admin-error-nothing-saved"];

									AoPS.Ui.Modal.showAlert(error_msg, {
										width: "450px",
										onClose: function () {
											AoPS.Ui.Modal.closeAllModals();
											self.resetIsPublic();
										},
									});
								},
							});
						} else {
							Modal.closeAllModals();
						}
					},
					{
						close_on_button_click: false,
						width: "550px",
						onClose: function () {
							self.resetIsPublic();
						},
					}
				);
			} else {
				this.model.set("is_public", parseInt(this.$is_public.val()) === 1);
				this.addUserBoxes();
			}
		},

		constructRoleInheritance: function () {
			if (
				this.model.has("role_inheritance_parent") &&
				!_.isNull(this.model.get("role_inheritance_parent"))
			) {
				this.renderInheritanceParent();
			} else {
				this.renderInheritanceInput();
			}
			this.$role_inheritance.append(
				'<div class="cmty-cat-admin-inherit-info"><span class="cmty-category-admin-helper">' +
					Utils.formatString(Lang["cat-admin-inheritance-info"], [
						Utils.simplifyCategoryType(this.model.getAdminLangType()),
					]) +
					"</span></div>"
			);
		},

		/** Properties to set to mix-in the construction of items for the role parent to be rendered */
		check_can_remove: true,
		can_remove_all: false,
		url_cmty_path: "",
		push_state_attribute: "data-cmty",
		url_router_base: "/community",
		constructItem: ComViews.Itembox.prototype.constructItem,

		renderInheritanceParent: function () {
			var $delete_parent = $('<span class="aops-font clickable">J</span>');
			var self = this;
			this.$role_inheritance.empty();
			this.$role_inheritance.append(
				this.constructItem(this.model.get("role_inheritance_parent"))
			);
			this.$role_inheritance.prepend($delete_parent);
			$delete_parent
				.on("click", function () {
					self.removeInheritanceParent();
				})
				.css({
					color: this.model.get("role_inheritance_parent").item_main_color,
				});
		},

		removeInheritanceParent: function () {
			this.model.set("role_inheritance_parent", null);
			if (this.model.get("category_id") > 0) {
				this.model.removeInheritanceParent();
			}
		},

		renderInheritanceInput: function () {
			var self = this;
			this.$role_inheritance.empty();
			this.$role_inheritance_input = $('<input type="text">');
			this.$role_inheritance.append(this.$role_inheritance_input);
			Utils.buildCategoryAutocomplete(this.$role_inheritance_input, {
				ajax_call: "fetch_inherits_from_autocomplete",
				additional_ajax_settings: {
					category_id: this.model.get("category_id"),
					category_type: this.model.get("category_type"),
				},
				autocomplete_settings: {
					onSelect: function (e, ui) {
						if (self.model.get("category_id") === 0) {
							self.model.set("role_inheritance_parent", {
								item_id: ui.item.category_id,
								item_text: ui.item.label,
								item_type: ui.item.category_type,
								item_forum_id: ui.item.item_forum_id,
								item_main_color: ui.item.main_color,
								item_secondary_color: ui.item.secondary_color,
								item_can_remove: false,
								item_subtitle: ui.item.short_description,
							});
						} else {
							ComViews.throwLoaderBlockingMessage(
								Lang["cat-admin-set-role-inherit"]
							);
							self.model.setRoleInheritanceParent({
								parent_id: ui.item.category_id,
								onFinish: function (msg) {
									window.location.href =
										"/community/category-admin/" +
										self.model.get("category_id");
								},
								onError: function (msg) {
									var message;
									switch (msg.error_code) {
										case "E_NO_PERMISSION":
											message = Lang["cat-admin-set-inherit-no-perm"];
											break;

										case "E_INVALID_PARENT_TYPE":
											message = Lang["cat-admin-set-inherit-invalid-parent"];
											break;

										case "E_CANT_INHERIT_FROM_SELF":
											message = Lang["cat-admin-no-inherit-from-self"];
											break;

										default:
											message = Lang["unexpected-error-code"] + msg.error_code;
											break;
									}
									AoPS.Community.Views.showError(message);
								},
							});
						}
						e.stopPropagation();
						e.preventDefault();
					},
				},
				show_no_results_msg: true,
			});
		},

		resetIsPublic: function () {
			this.$('select[name="cmty-category-admin-is-public"]').val(
				this.model.get("is_public") ? 1 : 0
			);
		},

		onChangeIsLocked: function () {
			this.model.setLockedStatus({
				is_locked: parseInt(this.$is_locked.val()) === 1, //,
				/*onFinish : function () {
					setTimeout(function () {
							AoPS.Ui.Modal.closeAllModals();
						},
						Constants.message_readability_delay_short
					);
				},
				onError : function () {

				}*/
			});
		},

		onChangeSource: function () {
			this.model.setHasSource({
				has_source: parseInt(this.$has_source.val()) === 1,
			});
		},

		/**
		 * Add the boxes where we edit the users.
		 **/
		addUserBoxes: function () {
			var self = this,
				is_public = this.model.get("is_public"),
				$user_boxes = this.$el.find(".cmty-category-admin-users");

			// We call this function when public/private changes,
			//  so we'll need to empty out what's there.
			$user_boxes.empty();

			this.closeUserBoxes();
			if (!is_public) {
				if (this.is_new && this.model.get("category_type") === "folder") {
					return;
				} else if (
					!this.is_new &&
					!AoPS.session.admin &&
					_.indexOf(
						["folder", "folder_forums", "folder_collections"],
						this.model.get("category_type")
					) > -1
				) {
					return;
				}
			}
			_.each(
				this.category_type_specific_settings.user_boxes,
				function (user_box) {
					var $user_box = $('<div class="form-group"></div>'),
						user_box_view = null;
					if (
						(is_public && user_box.show_if_category_public) ||
						(!is_public && user_box.show_if_category_private)
					) {
						$user_box.append(
							"<div><label>" + user_box.title + "</label></div>"
						);

						/**
						 * If user can edit, then we give them the box that can
						 *  be toggled; otherwise, they just get the static list.
						 **/
						if (self.model.getPermission("c_can_edit_" + user_box.role)) {
							user_box_view = new ComViews.ToggleableUserListCategoryAdmin({
								role: user_box.role,
								model: self.model,
							});
						} else {
							if (!user_box.show_only_if_can_edit) {
								user_box_view = new ComViews.StaticUserList({
									is_editable: false,
									no_users_message:
										user_box.role === "owner"
											? Lang["cat-admin-site-admins-are-admins"]
											: Lang["cat-admin-no-users-with-this-role"],
									user_list: _.filter(self.model.get("users"), function (user) {
										return user.role === user_box.role;
									}),
									// Here we allow logged-in users to remove themselves from admin, mod, contributor, etc.
									onMatchLoggedInUser: function ($user_cell, user) {
										var $delete_me;

										if (!self.model.get("can_remove_self")) {
											return;
										}

										$delete_me = $(
											' <span class="cmty-delete-item aops-font">J</span>'
										);
										$user_cell.find("span").append($delete_me);

										$delete_me.on("click", function (e) {
											Modal.showConfirm(
												Utils.formatString(
													Lang["cat-admin-permissions-remove-self"],
													[user_box.title, self.model.get("category_name")]
												),
												function (ok) {
													if (ok) {
														ComViews.throwBlockingMessage(Lang["please-wait"]);
														self.model.removeUser({
															user_id: user.user_id,
															onFinish: function () {
																setTimeout(function () {
																	location.reload();
																}, 500);
															},
															onError: function (msg) {
																ComViews.showError(
																	Lang["unexpected-error-code"] + msg.error_code
																);
															},
														});
													} else {
														Modal.closeAllModals();
													}
												},
												{
													width: "450px",
													close_on_button_click: false,
												}
											);

											e.stopPropagation();
											e.preventDefault();
										});
									},
								});
							}
						}
						if (!_.isNull(user_box_view)) {
							self.user_box_views.push(user_box_view);
							$user_box.append(user_box_view.$el);
							$user_boxes.append($user_box);
						}
					} else {
						self.model.removeUsersByRole(user_box.role);
					}
				}
			);

			// Parse visibility of everything.
			if (!this.isUserPermissionAvailable()) {
				this.$(".cmty-cat-admin-perm-is-locked").hide();
				this.$(".cmty-category-admin-users").hide();
				this.$(".cmty-cat-admin-perm-set-inheritance").hide();
			} else {
				this.$(".cmty-cat-admin-perm-is-locked").show();
				this.$(".cmty-category-admin-users").show();
				this.$(".cmty-cat-admin-perm-set-inheritance").show();
			}
		},

		isUserPermissionAvailable: function () {
			return (
				this.model.get("is_public") ||
				_.indexOf(
					Constants.categories_with_private_roles,
					this.model.get("category_type")
				) > -1
			);
		},

		/**
		 * Close all the user box views.
		 **/
		closeUserBoxes: function () {
			_.each(self.user_box_views, function (view) {
				view.close();
			});
		},

		fetchRenderData: function () {
			var base_user_box_settings = {
				show_if_category_public: true,
				show_if_category_private: true,
				show_only_if_can_edit: false,
			};
			switch (this.model.get("category_type")) {
				case "forum":
				case "forum_class":
					return {
						public_helper: Lang["cat-admin-permissions-forum-public-helper"],
						private_helper: Lang["cat-admin-permissions-forum-private-helper"],
						locked_helper: Lang["cat-admin-permissions-forum-locked-helper"],
						open_helper: Lang["cat-admin-permissions-forum-open-helper"],
						has_source_helper:
							Lang["cat-admin-permissions-forum-has-source-helper"],
						no_source_helper:
							Lang["cat-admin-permissions-forum-no-source-helper"],
						user_boxes: [
							_.defaults(
								{
									title: Lang["Administrators"],
									role: "owner",
									box_class: "cmty-cat-admin-administrators",
								},
								base_user_box_settings
							),
							_.defaults(
								{
									title: Lang["Moderators"],
									role: "mod",
									box_class: "cmty-cat-admin-moderators",
								},
								base_user_box_settings
							),
							_.defaults(
								{
									title: Lang["Users"],
									role: "registered_user",
									box_class: "cmty-cat-admin-users",
									show_if_category_public: false,
								},
								base_user_box_settings
							),
							_.defaults(
								{
									title: Lang["Banned"],
									role: "deny",
									box_class: "cmty-cat-admin-banned-users",
									show_if_category_private: false,
									show_only_if_can_edit: true,
								},
								base_user_box_settings
							),
						],
						help_template_id: "#cmty-cat-admin-perm-forum-help-tpl",
					};

				case "blog":
					return {
						public_helper: Lang["cat-admin-permissions-blog-public-helper"],
						private_helper: Lang["cat-admin-permissions-blog-private-helper"],
						locked_helper: Lang["cat-admin-permissions-blog-locked-helper"],
						open_helper: Lang["cat-admin-permissions-blog-open-helper"],
						help_template_id: "#cmty-cat-admin-perm-blog-help-tpl",
						user_boxes: [
							_.defaults(
								{
									title: Lang["Administrators"],
									role: "owner",
									box_class: "cmty-cat-admin-administrators",
								},
								base_user_box_settings
							),
							_.defaults(
								{
									title: Lang["Contributors"],
									role: "contributor",
									box_class: "cmty-cat-admin-contributors",
								},
								base_user_box_settings
							),
							_.defaults(
								{
									title: Lang["Readers"],
									role: "reader",
									box_class: "cmty-cat-admin-readers",
									show_if_category_public: false,
								},
								base_user_box_settings
							),
							_.defaults(
								{
									title: Lang["Banned"],
									role: "deny",
									box_class: "cmty-cat-admin-banned-users",
									show_if_category_private: false,
									show_only_if_can_edit: true,
								},
								base_user_box_settings
							),
						],
					};

				case "my_forums":
				case "my_collections":
					// START HERE.  NEED A WAY TO TURN OFF THE LOCKED THING,
					//  AND NEED TO MAKE A DIFFERENT HELP TEMPLATE FOR THESE.
					//
					//  ALSO, MAKE A MY_COLLECTIONS IN THE PHP WORLD
					//  I ALSO NEED TO PREVENT THE USERS FROM EVER CHANGING ON THE BACK END.  IN
					//
					// AHHHHHH -- I HAVE IT -- DON'T HAVE THE PERMISSIONS BOX FOR THESE!!!!!
					//
					// STILL NEED TO DO SOME BLOCKING ON THE BACK END.
					//
					return {
						public_helper:
							Lang["cat-admin-permissions-collection-public-helper"],
						private_helper:
							Lang["cat-admin-permissions-collection-private-helper"],
						locked_helper:
							Lang["cat-admin-permissions-collection-locked-helper"],
						open_helper: Lang["cat-admin-permissions-collection-open-helper"],
						help_template_id: "#cmty-cat-admin-perm-collection-help-tpl",
						user_boxes: [
							_.defaults(
								{
									title: Lang["Administrators"],
									role: "owner",
									box_class: "cmty-cat-admin-administrators",
								},
								base_user_box_settings
							),
						],
					};

				default:
					return {
						public_helper:
							Lang["cat-admin-permissions-collection-public-helper"],
						private_helper:
							Lang["cat-admin-permissions-collection-private-helper"],
						locked_helper:
							Lang["cat-admin-permissions-collection-locked-helper"],
						open_helper: Lang["cat-admin-permissions-collection-open-helper"],
						help_template_id: "#cmty-cat-admin-perm-collection-help-tpl",
						user_boxes: [
							_.defaults(
								{
									title: Lang["Administrators"],
									role: "owner",
									box_class: "cmty-cat-admin-administrators",
								},
								base_user_box_settings
							),
							_.defaults(
								{
									title: Lang["Moderators"],
									role: "mod",
									box_class: "cmty-cat-admin-moderators",
								},
								base_user_box_settings
							),
							_.defaults(
								{
									title: Lang["Users"],
									role: "registered_user",
									box_class: "cmty-cat-admin-users",
									show_if_category_public: false,
								},
								base_user_box_settings
							),
							_.defaults(
								{
									title: Lang["Banned"],
									role: "deny",
									box_class: "cmty-cat-admin-banned-users",
									show_if_category_private: false,
									show_only_if_can_edit: true,
								},
								base_user_box_settings
							),
						],
					};
			}
		},

		/**
		 * Put the correct language in the helper boxes.
		 **/
		setHelpers: function () {
			var public_helper = this.model.get("is_public")
					? this.category_type_specific_settings.public_helper
					: this.category_type_specific_settings.private_helper,
				is_locked_helper = this.model.get("is_locked")
					? this.category_type_specific_settings.locked_helper
					: this.category_type_specific_settings.open_helper,
				is_locked_icon = this.model.get("is_locked") ? "k" : "2";

			this.$el
				.find(".cmty-category-admin-is-public-helper")
				.html(public_helper);
			this.$el
				.find(".cmty-category-admin-is-locked-helper")
				.html(is_locked_helper);
			this.$el.find(".cmty-category-lock-status").html(is_locked_icon);
			this.$(".cmty-cat-admin-locked-label").html(
				this.model.get("is_locked")
					? Lang["cat-admin-permissions-locked"]
					: Lang["cat-admin-permissions-open"]
			);

			if (this.model.get("category_type") === "forum") {
				this.$(".cmty-category-admin-has-source-helper").html(
					this.model.get("has_source")
						? this.category_type_specific_settings.has_source_helper
						: this.category_type_specific_settings.no_source_helper
				);
			}
		},

		onClose: function () {
			this.closeUserBoxes();
		},

		validateNewCategorySettings: function () {
			return true;
		},
	});

	ComViews.CategoryAdminBlockContents = AoPS.View.extend({
		template_id: "#cmty-category-admin-contents-new-tpl",

		className: "aops-panel cmty-cat-admin-contents",

		can_additems_in_admin: true,

		initialize: function () {
			if (
				_.indexOf(
					[
						"bookmark_topics",
						"bookmark_forums",
						"bookmark_tags",
						"my_forums",
						"my_collections",
						"my_blogs",
						"view_posts",
						"view_topics",
						"view_tags",
					],
					this.model.get("category_type")
				) > -1
			) {
				this.has_help = true;
			} else {
				this.has_help = false;
			}

			if (this.has_help) {
				this.$help = $(
					this.getTemplate(
						"#cmty-cat-admin-contents-" +
							this.model.get("category_type") +
							"-help-tpl",
						{}
					)
				);
			}
			this.is_bookmark = this.model.get("is_bookmark_category");

			if (this.model.get("category_id") === 0) {
				this.renderConstructingCollection();
			} else {
				this.$loader = AoPS.Page.buildLoader();

				this.edit_window_created = false;
				this.render();
			}

			this.listenTo(this.model, "item_added", this.onClickCancel);
		},

		renderConstructingCollection: function () {
			this.$el.html(
				this.getTemplate("#cmty-category-admin-contents-info-tpl", {
					title: Lang["cat-admin-contents-title"],
					info: Lang["cat-admin-contents-building-info"],
				})
			);
		},

		render: function () {
			var can_add = this.model.canAddItem(),
				can_remove = this.model.canRemoveItem();
			this.$el.html(
				this.getTemplate(this.template_id, {
					can_edit_items: can_add || can_remove,
					title: Lang["cat-admin-contents-title"],
					has_help: this.has_help,
					lang_help: Lang["cat-admin-contents-help-tooltip"],
					title_editing: Lang["cat-admin-contents-title-editing"],
					lang_description: Lang["cat-admin-contents-desc-heading"],
					lang_contents_desc:
						Lang["cat-admin-contents-desc-" + this.model.get("category_type")],
					show_sort_type: can_add || can_remove,
					lang_current_state: Lang["cat-admin-contents-current-state"],
					lang_sort_heading: Lang["cat-admin-contents-sort-heading"],
					lang_sort_type: this.model.getSortDescription(
						this.model.get("item_sort_type")
					),
					lang_edit_contents: Lang["cat-admin-contents-edit-btn"],
				})
			);

			this.$contents = this.$(".cmty-cat-admin-contents-current-state");
			this.$edit_contents = this.$(".cmty-cat-admin-edit-window");

			this.cat_cell = new (ComViews.fetchCategoryCellConstructor(
				this.model.get("category_type")
			))({
				model: this.model,
			});
			this.$contents.append(this.cat_cell.$el);
		},

		events: {
			"click .cmty-admin-edit-contents-btn": "onClickEdit",
			"click .cmty-cat-admin-help": "onClickHelp",
			"click .cmty-cat-admin-edit-cancel": "onClickCancel",
			"click .cmty-cat-admin-edit-save": "onClickSave",
			"click .cmty-cat-admin-available-tab": "onClickAvailableTab",
			"click .cmty-cat-admin-edit-tab": "onClickEditTab",
		},

		onClickHelp: function () {
			this.$help.showModal({
				frame_class: "cmty-cat-admin-helper-modal aops-modal-standard",
				title: Lang["cat-admin-contents-help-title"],
				width: "600px",
				scrollable: true,
			});
		},

		onClickEdit: function () {
			if (!this.edit_window_created) {
				ComViews.throwBlockingMessage(
					Lang["cmty-cat-admin-edit-contents-fetch"]
				);

				this.constructEditContents();
			}
			this.$edit_contents.show();
			this.$el.addClass("cmty-editing-contents");
			this.setFocus();
		},

		setFocus: function () {
			var $target = this.$('input[type="text"]');

			if ($target.length > 0) {
				$target.first().focus();
			}
		},

		onClickCancel: function () {
			if (this.hasOwnProperty("$edit_contents")) {
				this.$edit_contents.empty();
				this.$edit_contents.hide();
			}
			this.$el.removeClass("cmty-editing-contents");
			this.model.unset("items_for_edit");
			this.edit_window_created = false;
		},

		onClickSave: function () {
			var can_change_sort_type = this.model.getPermission(
					"c_can_change_sort_type"
				),
				self = this,
				sort_type = this.getSortType();
			if (sort_type === "manual") {
				this.resortModelItemEdits();
			}

			ComViews.throwLoaderBlockingMessage(
				Lang["cat-admin-contents-save-blocker"]
			);
			this.model.saveItemEdits({
				change_sort_type:
					can_change_sort_type &&
					this.$sort_type.val() !== this.model.get("item_sort_type"),
				sort_type: sort_type,
				onError: function (data) {
					var msg;
					if (data.error_code === "E_CATEGORY_LOCKED") {
						AoPS.Ui.Modal.showAlert(Lang["cat-admin-contents-locked-error"]);
						self.model.set("is_locked", true);
						self.onClickCancel();
						return;
					} else {
						msg = Lang["cat-admin-contents-save-error"];
						if (
							typeof Lang[
								"cat-admin-contents-save-error-" + data.error_code
							] === "string"
						) {
							msg += Lang["cat-admin-contents-save-error-" + data.error_code];
						} else {
							msg += Utils.formatString(
								Lang["cat-admin-contents-unexpected-error"],
								[data.error_code]
							);
						}

						AoPS.Ui.Modal.showAlert(msg, {
							width: "450px",

							onButtonClick: function () {
								//location.reload();
							},
						});
					}
				},
				onFinish: function () {
					location.reload();
				},
			});
		},

		resortModelItemEdits: function () {
			var items = [];

			this.$edit_items
				.find(".cmty-admin-contents-edit-row")
				.each(function (row) {
					items.push($(this).data("row_obj").item);
				});
			this.model.set("items_for_edit", items);
		},

		constructEditContents: function () {
			var can_add_items = this.model.canAddItem(),
				self = this;

			this.$edit_contents.html(
				this.getTemplate("#cmty-category-admin-edit-contents-tpl", {
					can_add_items: can_add_items,
					lang_sort_heading: Lang["cat-admin-contents-sort-heading"],
					can_change_sort: this.model.getPermission("c_can_change_sort_type"),
					lang_save: Lang["Save"].toUpperCase(),
					lang_cancel: Lang["Cancel"].toUpperCase(),
					category_title: this.model.get("category_name"),
					category_desc: this.model.get("short_description"),
					is_my_category: this.model.get("is_my_category"),
					lang_current_items: Lang["cat-admin-contents-current-tab"],
					lang_available_items: Lang["cat-admin-contents-available-tab"],
				})
			);

			if (this.model.getPermission("c_can_change_sort_type")) {
				this.$sort_type = this.$edit_contents.find(
					'select[name="cmty-item-sort-type"]'
				);
				_.each(this.model.get("allowed_item_sort_types"), function (type) {
					var description = self.model.getSortDescription(type),
						option =
							'<option value="' +
							type +
							'" ' +
							(self.model.get("item_sort_type") === type ? "selected" : "") +
							">" +
							description +
							"</option>";
					self.$sort_type.append(option);
				});
				this.$sort_type.on("change", function () {
					self.onSortTypeChange();
				});
			}
			this.$edit_items_header = this.$edit_contents.find(
				".cmty-cat-admin-content-items-header"
			);
			this.$edit_items = this.$edit_contents.find(
				".cmty-cat-admin-contents-edit-list"
			);
			this.edit_window_created = true;
			if (this.model.get("is_my_category") && can_add_items) {
				this.$available_items = this.$edit_contents.find(
					".cmty-cat-admin-available-item-list"
				);
			}
			this.constructEditableItems();
			this.setSortableStatus();

			if (
				this.can_additems_in_admin &&
				can_add_items &&
				!this.model.get("is_my_category") &&
				!this.is_bookmark
			) {
				this.$items_input = this.$edit_contents.find(
					".cmty-cat-admin-add-item"
				);
				this.constructItemsInput();
			}
		},

		onSortTypeChange: function () {
			this.sortRows();
			this.setSortableStatus();
		},

		/**
		 * Set whether or not the rows in the contents cell are drag-and-drop
		 *  sortable.
		 **/
		setSortableStatus: function () {
			if (this.getSortType() === "manual") {
				this.$edit_items.sortable();
			} else {
				if (this.$edit_items.is(":ui-sortable")) {
					this.$edit_items.sortable("destroy");
				}
			}
		},

		/**
		 * Get the current sort type -- if we are able to edit the
		 *  sort type, then the sort type might be different than the
		 *  model's saved sort type.
		 **/
		getSortType: function () {
			return this.model.getPermission("c_can_change_sort_type")
				? this.$sort_type.val()
				: this.model.get("item_sort_type");
		},

		/**
		 * Sort the rows in the contents cell by the current sort type
		 **/
		sortRows: function () {
			var rows = this.$edit_items.find(".cmty-admin-contents-edit-row"),
				sort_type = this.getSortType(),
				self = this,
				sort_func = function (item) {
					return 0;
				};

			if (sort_type === "abc") {
				sort_func = function (item) {
					return $(item).data("row_obj").item.item_text.toLowerCase();
				};
			} else if (sort_type === "system") {
				sort_func = function (item) {
					return parseInt(-$(item).data("row_obj").item.item_score);
				};
			} else if (sort_type === "manual") {
				sort_func = function (item) {
					return parseInt(-$(item).data("row_obj").item.item_level);
				};
			}

			var new_rows = _.sortBy(rows, sort_func);

			_.each(new_rows, function (row) {
				self.$edit_items.append($(row));
			});
		},

		/**
		 * Sort the rows in the Available category alphabetically
		 **/
		sortAvailableRows: function () {
			var rows = this.$available_items.find(".cmty-admin-contents-edit-row"),
				self = this,
				sort_func = function (item) {
					return $(item).data("row_obj").item.item_text.toLowerCase();
				};

			var new_rows = _.sortBy(rows, sort_func);

			_.each(new_rows, function (row) {
				self.$available_items.append($(row));
			});
		},

		/**
		 * Construct the box with all the editable items in it
		 *
		 * Sometimes overwritten in children.
		 **/
		constructEditableItems: function () {
			var self = this;
			this.$edit_items.append(this.$loader);
			this.model.fetchItemsForEdit({
				onFinish: function () {
					self.$loader.detach();
					self.renderItems();

					$(window).scrollTop(self.$el.offset().top);
					setTimeout(function () {
						Modal.closeAllModals();
					}, 700);
				},
				onError: function () {},
			});
		},

		constructAvailableItems: function () {
			var self = this;
			_.each(this.model.get("available_items"), function (item) {
				var row;
				row = self.constructAvailableRow(item);

				self.$available_items.append(row.$row);
			});
		},

		onClickAvailableTab: function () {
			this.$edit_items.hide();
			this.$available_items.show();
			this.$edit_contents
				.find(".cmty-cat-admin-available-tab")
				.addClass("active-tab");
			this.$edit_contents
				.find(".cmty-cat-admin-edit-tab")
				.removeClass("active-tab");
		},

		onClickEditTab: function () {
			this.$edit_items.show();
			this.$available_items.hide();
			this.$edit_contents
				.find(".cmty-cat-admin-edit-tab")
				.addClass("active-tab");
			this.$edit_contents
				.find(".cmty-cat-admin-available-tab")
				.removeClass("active-tab");
		},

		renderItems: function () {
			var self = this;
			_.each(this.model.get("items_for_edit"), function (item) {
				var row;
				row = self.constructRow(item);

				self.$edit_items.append(row.$row);
			});

			if (this.model.get("is_my_category")) {
				this.constructAvailableItems();
			}
		},

		constructRow: function (item) {
			var $item = this.constructItem(item),
				row = {
					item: item,
					$item: $item,
				},
				$delete,
				$bookmark_email,
				$bookmark_feed,
				self = this;

			row.$row = $('<div class="cmty-admin-contents-edit-row"></div>');

			if (this.model.canRemoveItem()) {
				$delete = $(
					'<div title="' +
						Lang["cmty-admin-delete-item"] +
						'" class="cmty-delete-item aops-font">J</div>'
				);
				$delete.on("click", function (e) {
					self.deleteItem(item);
				});
				row.$row.append($delete);
			}

			if (this.model.get("is_bookmark_category")) {
				$bookmark_email = $(
					'<div class="cmty-edit-bookmark"><label title="' +
						Lang["cat-admin-contents-subscribe"] +
						'"><input type="checkbox" ' +
						(item.is_watched ? "checked" : "") +
						'><span class="aops-font">D</span></label></div>'
				);
				$bookmark_email.find("input").on("change", function (e) {
					item.edit_state = "edited";
					item.is_watched = this.checked ? 1 : 0;
				});

				$bookmark_feed = $(
					'<div class="cmty-edit-bookmark"><label title="' +
						Lang["cat-admin-contents-feed"] +
						'"><input type="checkbox" ' +
						(item.in_feed ? "checked" : "") +
						'><span class="aops-font">E</span></label></div>'
				);
				$bookmark_feed.find("input").on("change", function (e) {
					item.edit_state = "edited";
					item.in_feed = this.checked ? 1 : 0;
				});
				row.$row.append($bookmark_email);
				row.$row.append($bookmark_feed);
			}

			row.$row.data("row_obj", row);
			row.$row.append(row.$item);
			return row;
		},

		fetchRowByItem: function ($container, item) {
			var rows = $container.find(".cmty-admin-contents-edit-row"),
				i,
				row_item,
				num = rows.length;

			for (i = 0; i < num; i++) {
				row_item = $(rows[i]).data("row_obj").item;
				if (
					item.item_id === row_item.item_id &&
					item.item_forum_id === row_item.item_forum_id &&
					item.item_type === row_item.item_type
				) {
					return $(rows[i]).data("row_obj");
				}
			}
			return null;
		},

		/**
		 * There are notes above deleteEditItem in Community.Models
		 * about how the items work.  On the front end, we create rows for each of the
		 * items that existed at the very beginning.  If one of these rows get removed,
		 * we just fade it out, then bring it back if it gets re-added.
		 *
		 * If we add a new item from the back end or create it here, then it gets a new row.
		 *  If that row gets removed, then we delete it completely.
		 *
		 * My Forums, My Collections, My Blogs have "Available Items".  If an available
		 *  item is added to the collection, it is thereafter treated as if it always existed.
		 *
		 * We do this goofy row-holding in order to let users maintain ordering while removing
		 *  and adding.
		 *
		 * One exception is in collections of posts.  For these, we don't want to
		 *  drag 'deleted' items back on-screen.  The user may be deleting and re-adding
		 *  a given post in order to edit its label.  If we dragged deleted items back in when
		 *  they were re-added, a user couldn't change a post label without saving between
		 *  the delete and the add.
		 *
		 * @param object describing the item
		 * @return boolean true if all is clear to call closeAllModals; false if there
		 *		is some error thrown on-screen.
		 *
		 **/
		addItem: function (item) {
			var edit_item,
				already_holds_text,
				self = this,
				edit_item_row;

			if (!this.model.canAddEditItems()) {
				// In timeout wrapper because sometimes a closeAllModals is downstream from this,
				//  sigh.  What a kludge.
				setTimeout(function () {
					Modal.showAlert(
						Utils.formatString(Lang["cat-admin-contents-limit-exceeded"], [
							self.model.get("item_limit"),
						])
					);
				}, 10);
				return true;
			}

			if (
				item.item_id !== 0 &&
				!_.isUndefined((edit_item = this.model.fetchEditItem(item)))
			) {
				if (edit_item.edit_state === "deleted") {
					if (this.model.get("category_type") === "view_posts") {
						// For a view of posts, we don't want to dig stuff out that has just been deleted.
						//  The user may have deleted a post because the user wants to change the label.
						//  So, we let the old post die, and we add a new one.
						this.addNewItem(item);
					} else {
						edit_item.edit_state = "saved";
						edit_item_row = this.fetchRowByItem(this.$edit_items, item);
						if (!_.isNull(edit_item_row)) {
							edit_item_row.$row.show();
						} else {
							this.addNewItem(edit_item_row);
						}
					}
				} else {
					if (this.model.get("category_type") === "view_posts") {
						already_holds_text = Utils.formatString(
							Lang["cat-admin-view_posts-already-holds"],
							[item.item_id]
						);
					} else {
						already_holds_text = item.item_text;
					}

					AoPS.Ui.Modal.showAlertQuick(
						Utils.formatString(Lang["cat-admin-contents-already-holds"], [
							already_holds_text,
						]),
						{
							onClose: function () {
								Modal.closeAllModals();
							},
						}
					);
					return false;
				}
				if (this.model.get("is_my_category")) {
					this.removeFromAvailableItems(item);
				}
			} else {
				if (this.model.get("is_my_category")) {
					this.removeFromAvailableItems(item);
				}
				// For custom text rows being added, the item_id will always be
				//  0.  Just build these puppies.
				/*if (item.item_type === 'post' &&
				(item.post_type === 'custom_text' || item.post_type === 'custom_hidden_text')) {*/
				if (this.model.get("category_type") === "view_posts") {
					this.addNewItem(item);
				} else {
					edit_item_row = this.fetchRowByItem(this.$edit_items, item);

					item.edit_state = "added";

					// If this item was added once, then removed, then added again,
					//  it will be among the $edit_items rows.  Otherwise,
					//  it has never been added, so we have to construct a new item.
					if (!_.isNull(edit_item_row)) {
						this.model.addToEditItems(item);
						edit_item_row.$row.show();
					} else {
						this.addNewItem(item);
					}
				}
			}

			return true;
		},

		// Add item we know is completely new and does not have a row hidden
		//  already in the list
		addNewItem: function (item) {
			var edit_item_row = this.constructRow(item);
			this.model.addToEditItems(item);
			this.addNewRow(edit_item_row);
		},

		/**
		 * Add a row to the front end, re-sort.
		 */
		addNewRow: function (row) {
			this.$edit_items.append(row.$row);
			if (this.getSortType() !== "manual") {
				this.sortRows();
			}
			this.resortModelItemEdits();
		},

		deleteItem: function (item) {
			var item_row = this.fetchRowByItem(this.$edit_items, item);

			// Blocking double-click during fade out
			if (item.edit_state === "deleted") {
				return;
			}
			this.model.deleteEditItem(item);

			if (item.edit_state === "added") {
				if (!_.isNull(item_row)) {
					item_row.$row.remove();
				}
			} else {
				item_row.$row.fadeOut(200);
			}

			if (this.model.get("is_my_category")) {
				this.addToAvailableItems(item);
				// ADD TO AVAILABLE items and screel
			}
		},

		addToAvailableItems: function (item) {
			var available_row = this.fetchRowByItem(this.$available_items, item);

			this.model.addToAvailableItems(item);

			if (_.isNull(available_row)) {
				available_row = this.constructAvailableRow(item);
			}

			this.$available_items.append(available_row.$row);
			this.sortAvailableRows();
		},

		removeFromAvailableItems: function (item) {
			var row = this.fetchRowByItem(this.$available_items, item);

			if (!_.isNull(row)) {
				row.$row.remove();
			}
			this.model.removeAvailableItem(item);
		},

		constructItem: ComViews.Itembox.prototype.constructItem,

		constructItemsInput: function () {
			// over-written in children
		},

		url_router_base: "/community",

		push_state_attribute: "data-cmty",

		url_cmty_path: "",

		check_can_remove: false,

		validateNewCategorySettings: function () {
			/*if (this.model.get('items').length === 0) {
				AoPS.Ui.Modal.showAlertQuick(Lang['cat-admin-no-empty-collections']);
				return false;
			} */
			return true;
		},
	});

	ComViews.CategoryAdminBlockContentsViewTopics =
		ComViews.CategoryAdminBlockContents.extend({
			constructItem: function (item) {
				var $topic;

				$topic = $(
					'<div class="cmty-cat-admin-topic-item"><div class="cmty-cat-admin-topic-title"><a data-cmty href="/community/h' +
						item.item_id +
						'">' +
						item.item_text +
						'</a></div><span class="cmty-cat-admin-in"> ' +
						Lang["in"] +
						' </span><div class="cmty-cat-admin-topic-forum">' +
						item.item_category_name +
						"</div></div>"
				);
				$topic.css({
					color: item.item_main_color,
				});

				$topic.find("a").css({
					color: item.item_main_color,
				});

				return $topic;
			},

			constructItemsInput: function () {
				var self = this;
				this.$items_input.empty();
				this.$items_input.append(
					'<div class="cmty-admin-new-contents-add-head">' +
						Lang["cat-admin-add-heading-topic"] +
						'</div><input type="text" class="cmty-admin-new-contents-view_topics cmty-admin-new-contents-category"\
					placeholder="' +
						Lang["cat-admin-add-content-topic-placeholder"] +
						'"><button class="btn btn-primary">' +
						Lang["Submit"] +
						"</button>"
				);

				this.$items_input.find("input").on("keydown", function (e) {
					var key = e.which || e.keyCode;

					if (key == 13) {
						self.onSubmitTopic();
					}
				});

				this.$items_input.find("button").on("click", function (e) {
					self.onSubmitTopic();
				});
			},

			onSubmitTopic: function () {
				var input = this.$items_input.find("input").val(),
					pieces,
					self = this,
					topic_id = 0;

				if (/^[1-9]\d*$/.test(input)) {
					topic_id = parseInt(input);
				} else {
					pieces = input.split("/");
					input = pieces[pieces.length - 1];
					input = input.match(/(?:h\d+)/);
					if (!_.isNull(input)) {
						topic_id = parseInt(input[0].substring(1));
					}
				}

				if (topic_id === 0) {
					this.$items_input.find("input").val("");
					Modal.showAlert(Lang["cmty-admin-add-topic-error"], {
						width: "450px",
					});
				} else {
					// We'll check if already exists downstream
					this.$items_input.find("input").val("");
					ComViews.throwLoaderBlockingMessage(
						Lang["cmty-admin-add-topic-blocker"]
					);
					this.model.fetchTopicEditItem({
						topic_id: topic_id,
						onFinish: function (data) {
							if (self.addItem(data.topic_item)) {
								Modal.closeAllModals();
							}
						},
						onError: function (data) {
							var msg;

							switch (data.error_code) {
								case "E_TOPIC_PRIVATE":
									msg = Lang["cmty-admin-add-topic-err-private"];
									break;

								case "E_NOT_FORUM_TOPIC":
									msg = Lang["cmty-admin-add-topic-err-not-forum"];
									break;

								case "E_NO_SUCH_TOPIC":
									msg = Lang["cmty-admin-add-topic-err-no-topic"];
									break;

								case "E_NO_PERMISSION":
									msg = Lang["cmty-admin-add-topic-err-no-permission"];
									break;

								default:
									msg = Lang["unexpected-error-code"] + data.error_code;
									break;
							}

							ComViews.showError(msg);
						},
					});
				}
			},
		});

	ComViews.CategoryAdminBlockContentsViewPosts =
		ComViews.CategoryAdminBlockContents.extend({
			post_views: [], // Property needed for mixing in ItemboxPosts

			post_types: {
				forum_post: {
					has_label: true,
					has_post: true,
					has_hide: false,
					has_custom: false,
				},
				forum_hidden_post: {
					has_label: false,
					has_post: true,
					has_hide: true,
					has_custom: false,
				},
				custom_text: {
					has_label: true,
					has_post: false,
					has_hide: false,
					has_custom: true,
				},
				custom_hidden_text: {
					has_label: false,
					has_post: false,
					has_hide: true,
					has_custom: true,
				},
			},

			constructItem: function (item) {
				var $item = $('<div class="cmty-cat-admin-edit-post-view"></div>'),
					$post_item;
				$post_item = ComViews.ItemboxPosts.prototype.constructItem.apply(this, [
					item,
				]);

				$item.append($post_item);
				return $item;
			},

			constructItemsInput: function () {
				var $new_items_input,
					self = this;

				$new_items_input = $(
					this.getTemplate("#cmty-category-admin-add-post-tpl", {
						max_label_length: Constants.view_post_max_label_len,
						max_hide_label_length: Constants.view_post_max_hide_label_len,
					})
				);

				this.$items_input.empty();
				this.$items_input.removeClass("cmty-cat-admin-edit-row");
				this.$items_input.append($new_items_input);
				this.$items_input.find("select").on("change", function (e) {
					self.setupPostType(this.value);
				});

				this.setupPostType("forum_post");
				this.$items_input.find("button").on("click", function (e) {
					self.processItemInput();
				});
			},

			setFocus: function () {
				this.setupPostType("forum_post");
			},

			setupPostType: function (type) {
				var $target_div = this.$(".cmty-admin-new-" + type);
				this.$(".cmty-admin-new-post-option").hide();
				$target_div.show();
				$target_div.find("input").first().focus();
			},

			processItemInput: function () {
				var post_type = this.$('select[name="cmty-cat-admin-post-type"]').val(),
					$input_div = this.$(".cmty-admin-new-" + post_type),
					self = this,
					post_label = "",
					post_id = 0,
					post_input,
					pieces,
					hide_label = "",
					custom_text = "",
					error_code = "",
					post_type_data = this.post_types[post_type];

				// Collect data & Perform tests

				// label test : length
				if (post_type_data.has_label) {
					post_label = $input_div
						.find('input[name="cmty-admin-new-contents-post-label"]')
						.val();
					if (post_label.length > Constants.view_post_max_label_len) {
						error_code = "E_LABEL_TOO_LONG";
					}
				}

				// post_id test: Is it a real id?
				if (post_type_data.has_post) {
					post_input = $input_div
						.find('input[name="cmty-admin-new-contents-post"]')
						.val();

					if (/^[1-9]\d*$/.test(post_input)) {
						post_id = parseInt(post_input);
					} else {
						pieces = post_input.split("/");
						post_input = pieces[pieces.length - 1];
						post_input = post_input.match(/(?:p\d+)/);
						if (!_.isNull(post_input)) {
							post_id = parseInt(post_input[0].substring(1));
						}
						if (post_id === 0) {
							error_code = "E_INVALID_POST_ID";
						}
					}
				}

				// hide label test : length
				if (post_type_data.has_hide) {
					hide_label = $input_div
						.find('input[name="cmty-admin-new-contents-hidden-text"]')
						.val();

					if (hide_label.length > Constants.view_post_max_hide_label_len) {
						error_code = "E_HIDE_LABEL_TOO_LONG";
					}
				}

				if (post_type_data.has_custom) {
					custom_text = $input_div
						.find('textarea[name="cmty-admin-new-contents-custom-text"]')
						.val();

					if (custom_text.length === 0) {
						error_code = "E_NO_CUSTOM_TEXT_ENTERED";
					}
				}

				if (error_code !== "") {
					this.processError(error_code);
					return;
				}

				ComViews.throwLoaderBlockingMessage(
					Lang["cat-admin-post-construct-blocker"]
				);
				this.model.createViewPostItem({
					post_type: post_type,
					post_label: post_label,
					post_id: post_id,
					hide_label: hide_label,
					custom_text: custom_text,
					onFinish: function (data) {
						if (self.addItem(data.new_item)) {
							Modal.closeAllModals();
						}

						self.$('input[type="text"]').val("");
						self.$("textarea").val("");
					},
					onError: function (data) {
						self.processError(data.error_code);
					},
				});
			},

			processError: function (error_code) {
				var msg;

				if (
					typeof Lang["cmty-admin-new-post-error-" + error_code] === "string"
				) {
					msg = Lang["cmty-admin-new-post-error-" + error_code];
				} else {
					msg = Lang["unexpected-error-code"] + error_code;
				}
				ComViews.showError(msg);
			},
		});

	ComViews.CategoryAdminBlockContentsViewTags =
		ComViews.CategoryAdminBlockContents.extend({
			constructItem: function (item) {
				this.category_id = item.item_forum_id;
				var $tag = ComViews.Itembox.prototype.constructItem.apply(this, [item]),
					$tag_cell = $(
						'<div class="cmty-cat-admin-view_tags-tag"><span class="cmty-cat-admin-in">' +
							Lang["in"] +
							' </span><span class="cmty-cat-admin-view_tags-forum">' +
							item.item_category_name +
							"</span></div>"
					);

				$tag_cell.css({
					color: item.item_main_color,
				});
				$tag_cell.prepend($tag);

				this.category_id = this.model.get("category_id");
				return $tag_cell;
			},

			constructItemsInput: function () {
				var self = this,
					additional_settings = {};
				// TODO: make sure this line removes all stuff inside; I think it does.
				this.$items_input.empty();
				this.$items_input.append(
					'<div class="cmty-admin-new-contents-add-head">' +
						Lang["cat-admin-add-heading-" + this.model.get("category_type")] +
						'</div><input type="text" class="cmty-admin-new-contents-category"\
					placeholder="' +
						Lang["cat-admin-add-content-tag-forum-placeholder"] +
						'">'
				);

				if (this.model.get("is_public")) {
					additional_settings.is_public_setting = 1;
				}
				Utils.buildCategoryAutocomplete(this.$items_input.find("input"), {
					ajax_call: "fetch_forum_autocomplete",
					additional_ajax_settings: additional_settings,
					autocomplete_settings: {
						onSelect: function (e, ui) {
							self.buildTagInput({
								item_id: ui.item.category_id,
								item_text: ui.item.label,
								item_type: ui.item.category_type,
								item_forum_id: ui.item.item_forum_id,
								item_main_color: ui.item.main_color,
								item_secondary_color: ui.item.secondary_color,
								item_can_remove: ui.item.can_remove,
								item_subtitle: ui.item.short_description,
							});
							e.stopPropagation();
							e.preventDefault();
						},
					},
					show_no_results_msg: true,
				});
			},

			/**
			 * We have chosen a forum, let's build the input box for inputting tags.
			 *
			 * @param object (Itembox item that is a forum)
			 */
			buildTagInput: function (forum) {
				var $forum,
					self = this;

				// TODO : think about public/private issues
				this.$items_input.empty();
				this.$items_input.html(
					this.getTemplate("#cmty-cat-admin-add-content-tags-tpl", {
						lang_Forum: Lang["Forum"],
						lang_Tag: Lang["Tag"],
						tag_placeholder: Lang["cat-admin-contents-tag-placeholder"],
					})
				);
				this.current_forum = forum;
				/**
				 * If this forum has been loaded to the DOM, use that model.  Otherwise,
				 *  create a temp one, so we have access to the item management methods we
				 *  need.
				 **/
				this.category = this.model.get("master").fetchCategory(forum.item_id);
				if (_.isUndefined(this.category)) {
					this.category = this.model.get("master").constructTemporaryCategory({
						category_type: forum.item_type,
						category_id: forum.item_id,
						main_color: forum.item_main_color,
						secondary_color: forum.item_secondary_color,
						category_name: forum.item_text,
					});
				}

				$forum = AoPS.Community.Views.Itembox.prototype.constructItem.apply(
					{
						push_state_attribute: "data-cmty",
						check_can_remove: true,
						can_remove_all: true,
						url_router_base: "/community",
						url_cmty_path: "",
						onClickDelete: function () {
							self.onClickCloseForum();
						},
					},
					[forum]
				);

				// Template has div in which to add forum
				this.$items_input
					.find(".cmty-cat-admin-contents-add-tag-forum")
					.append($forum);

				this.$input_box = this.$items_input.find("input");

				AoPS.Community.Views.buildTagAutocomplete({
					$input_box: this.$input_box,
					show_no_results_msg: true,
					model: this.category,
					submitNewItem: function (item) {
						var text;
						//  Kludge for people adding /open to monitored collections
						//  Needed so that hitting return after typing /open autocompletes
						//  to the tag in the autocomplete drop down rather than causing the
						//  input "you didn't pick a real tag" rebuild.
						if (item.label.substr(0, 5) === "/open") {
							item.label = forum.item_text;
						}

						// At some point, I'll build a "force item select"

						if (item.item_id > 0) {
							var tag_item = {
								in_feed: 0,
								is_watched: 0,
								item_category_name: forum.item_text,
								item_forum_id: parseInt(item.item_forum_id),
								item_id: parseInt(item.item_id),
								item_level: 0,
								item_main_color: item.main_color,
								item_secondary_color: item.secondary_color,
								item_text: item.label,
								item_type: "tag",
							};
							self.addItem(tag_item);
							self.buildTagInput(forum);
						} else {
							text = self.$input_box.val();
							self.buildTagInput(forum);
							self.$input_box.val(text);
						}
					},
				});
				this.$input_box.focus();
				//			this.constructAutocomplete();
				// Make a tag autocomplete thing that I can export to.
				// Also, the focus tag box needs to not go to the database for the search thing.
				//  T In getAutocompleteSource in CategoryCell, need to make
				//  a function that has a switch based on category type.  If the
				//  category is a view_tags, just build the autocomplete out of items.
				//	Maybe that function still exists in models?
				// Nope - build fetchTagAutocomplete, and in there build it out of current
				//   items.  After built once, put listeners on items to update it.
				//   (And always check if it exists before building anew.)
				/*


			7) Create new view_tags
			8) Switch the focus tag box in forums to the new autocompleter
			*/
			},

			onClickCloseForum: function (e) {
				this.constructItemsInput();
				this.$items_input.find("input").focus();
			},
		});

	/**
	 * Portion of Category admin that shows the contents.
	 *
	 * Only for collections.
	 *
	 * model : AoPS.Community.Models.Category (or one of its children)
	 */
	ComViews.CategoryAdminBlockContentsFolder =
		ComViews.CategoryAdminBlockContents.extend({
			new_contents_autocomplete_ajax:
				"fetch_add_contents_categories_autocomplete",

			constructAvailableRow: function (item) {
				var $item = this.constructItem(item),
					row = {
						item: item,
						$item: $item,
					},
					$add,
					self = this;

				row.$row = $('<div class="cmty-admin-contents-edit-row"></div>');

				if (this.model.getPermission("c_can_add_item")) {
					$add = $('<div class="cmty-add-available-item aops-font">+</div>');
					$add.on("click", function (e) {
						self.addItem(item);
					});
					row.$row.append($add);
				}

				row.$row.data("row_obj", row);
				row.$row.append(row.$item);

				return row;
			},

			constructItemsInput: function () {
				var self = this,
					additional_settings = {};
				this.$items_input.append(
					'<div class="cmty-admin-new-contents-add-head">' +
						Lang["cat-admin-add-heading-" + this.model.get("category_type")] +
						'</div><input type="text" class="cmty-admin-new-contents-category"\
				placeholder="' +
						Lang[
							"cat-admin-add-content-" +
								this.model.get("category_type") +
								"-placeholder"
						] +
						'">'
				);
				this.$new_item_input = this.$items_input.find("input");
				if (this.model.get("is_public")) {
					additional_settings.is_public_setting = 1;
				}

				Utils.buildCategoryAutocomplete(this.$new_item_input, {
					ajax_call: this.new_contents_autocomplete_ajax,
					additional_ajax_settings: additional_settings,
					autocomplete_settings: {
						onSelect: function (e, ui) {
							self.parsePotentialNewContents({
								item_id: ui.item.category_id,
								item_text: ui.item.label,
								item_type: ui.item.category_type,
								item_forum_id: ui.item.item_forum_id,
								item_main_color: ui.item.main_color,
								item_secondary_color: ui.item.secondary_color,
								item_can_remove: ui.item.can_remove,
								item_level: 0,
								item_score: ui.item.last_post_time,
								item_subtitle: ui.item.short_description,
								item_is_public: ui.item.is_public,
								edit_state: "added",
								id: 0,
							});
							e.stopPropagation();
							e.preventDefault();
						},
					},
					show_no_results_msg: true,
				});
			},

			parsePotentialNewContents: function (item) {
				if (item.item_id === this.model.get("category_id")) {
					AoPS.Ui.Modal.showAlertQuick(
						Lang["cat-admin-contents-no-adding-to-self"]
					);
				} else {
					this.addItem(item);
				}
				this.$new_item_input.val("");
				this.$new_item_input.focus();
			},

			// Probably delete the rest of these functions after all cooked

			onAddItemError: function (msg, item) {
				if (msg.error_code === "E_CATEGORY_LOCKED") {
					AoPS.Ui.Modal.showAlert(Lang["cat-admin-contents-locked-error"]);
					this.model.set("is_locked", true);
					this.render();
				} else {
					AoPS.Ui.Flyout.display(
						Utils.formatString(Lang["cat-admin-contents-add-category-error"], [
							item.item_text,
							msg.error_code,
						])
					);
				}
				this.model.removeItem(item);
			},

			/**
			 * When we click delete, we nuke the tag right away on the
			 *  front end, and only speak up if something goes wrong.
			 *
			 * @param obj : item from Itembox (see ComViews.Itembox for details)
			 */
			onClickDeleteItem: function (item) {
				var self = this;
				this.model.removeItemDb({
					item: item,
					remove_from_client_immediately: true,
					onError: function (msg) {
						if (msg.error_code === "E_CATEGORY_LOCKED") {
							AoPS.Ui.Modal.showAlert(Lang["cat-admin-contents-locked-error"]);
							self.model.addItem(item);
							self.model.set("is_locked", true);
							self.render();
						} else {
							AoPS.Ui.Flyout.display(
								Utils.formatString(
									Lang["cat-admin-contents-remove-tag-error"],
									[item.item_text]
								)
							);
						}
						self.model.addItem(item);
					},
				});
			},

			addItemToExistingCategory: function (item) {
				var self = this;
				this.model.addItemDb({
					item: item,
					add_to_client_immediately: true,
					onError: function (msg) {
						self.onAddItemError(msg, item);
					},
				});
			},

			onClose: function () {
				if (this.itembox_view) {
					this.itembox_view.close();
				}
			},
		});

	ComViews.CategoryAdminBlockContentsBookmarkUsers =
		ComViews.CategoryAdminBlockContentsFolder.extend({
			can_additems_in_admin: false,
		});

	ComViews.CategoryAdminBlockContentsBlogroll =
		ComViews.CategoryAdminBlockContentsFolder.extend({
			new_contents_autocomplete_ajax: "fetch_blogs_autocomplete",
		});

	ComViews.CategoryAdminBlockContentsFolderForums =
		ComViews.CategoryAdminBlockContentsFolder.extend({
			new_contents_autocomplete_ajax: "fetch_forum_autocomplete",
		});

	ComViews.CategoryAdminBlockContentsFolderCollections =
		ComViews.CategoryAdminBlockContentsFolder.extend({
			new_contents_autocomplete_ajax:
				"fetch_folder_collections_contents_autocomplete",
		});

	/**
	 * Portion of Category admin that shows the contents.
	 *
	 * Only for collections.
	 *
	 * model : AoPS.Community.Models.Category (or one of its children)
	 */
	ComViews.CategoryAdminBlockContentsFolderOld = AoPS.View.extend({
		template_id: "#cmty-category-admin-contents-tpl",

		className: "aops-panel cmty-cat-admin-contents",

		new_contents_autocomplete_ajax:
			"fetch_add_contents_categories_autocomplete",

		initialize: function () {
			this.$help = $(
				this.getTemplate(
					"#cmty-cat-admin-contents-" +
						ComViews.getCategoryAdminCatType(this.model.get("category_type")) +
						"-help-tpl",
					{}
				)
			);
			this.render();
		},

		events: {
			"click .cmty-cat-admin-help": "onClickHelp",
		},

		onClickHelp: function () {
			this.$help.showModal({
				frame_class: "cmty-cat-admin-helper-modal aops-modal-standard",
				title: Lang["cat-admin-contents-help-title"],
				width: "600px",
				scrollable: true,
			});
		},

		render: function () {
			var can_add = this.model.canAddItem(),
				can_remove = this.model.canRemoveItem(),
				self = this;

			this.$el.html(
				this.getTemplate(this.template_id, {
					can_add_item: can_add,
					title: Lang["cat-admin-contents-title"],
					lang_add: Lang["cat-admin-contents-add-item"],
					lang_contents: Lang["cat-admin-contents-items-header"],
				})
			);

			// Change class here and in location if we stay happy with them as the same
			this.$contents = this.$el.find(".cmty-admin-location-containers");

			// TODO : Do we append all the can_remove here?
			this.itembox_view = new ComViews.Itembox({
				model: this.model,
				check_can_remove: can_remove,
				can_remove_all: true,
				onDeleteItem: function (item) {
					self.onClickDeleteItem(item);
				},
			});

			this.$contents.append(this.itembox_view.$el);

			if (can_add) {
				this.$content_add = this.$el.find(".cmty-cat-admin-content-add");
				this.constructContentsInput();
			}
		},

		/**
		 * When we click delete, we nuke the tag right away on the
		 *  front end, and only speak up if something goes wrong.
		 *
		 * @param obj : item from Itembox (see ComViews.Itembox for details)
		 */
		onClickDeleteItem: function (item) {
			var self = this;
			this.model.removeItemDb({
				item: item,
				remove_from_client_immediately: true,
				onError: function (msg) {
					if (msg.error_code === "E_CATEGORY_LOCKED") {
						AoPS.Ui.Modal.showAlert(Lang["cat-admin-contents-locked-error"]);
						self.model.addItem(item);
						self.model.set("is_locked", true);
						self.render();
					} else {
						AoPS.Ui.Flyout.display(
							Utils.formatString(Lang["cat-admin-contents-remove-tag-error"], [
								item.item_text,
							])
						);
					}
					self.model.addItem(item);
				},
			});
		},

		constructContentsInput: function () {
			var self = this,
				additional_settings = {};
			this.$content_add.append(
				'<input class="cmty-admin-new-contents-category"\
				placeholder="' +
					Lang[
						"cat-admin-add-content-" +
							this.model.get("category_type") +
							"-placeholder"
					] +
					'">'
			);
			this.$new_item_input = this.$content_add.find("input");

			if (this.model.get("is_public")) {
				additional_settings.is_public_setting = 1;
			}

			Utils.buildCategoryAutocomplete(this.$new_item_input, {
				ajax_call: this.new_contents_autocomplete_ajax,
				additional_ajax_settings: additional_settings,
				autocomplete_settings: {
					onSelect: function (e, ui) {
						self.parsePotentialNewContents({
							item_id: ui.item.category_id,
							item_text: ui.item.label,
							item_type: ui.item.category_type,
							item_forum_id: ui.item.item_forum_id,
							item_main_color: ui.item.main_color,
							item_secondary_color: ui.item.secondary_color,
							item_can_remove: ui.item.can_remove,
							item_subtitle: ui.item.short_description,
						});
						e.stopPropagation();
						e.preventDefault();
					},
				},
				show_no_results_msg: true,
			});
		},

		parsePotentialNewContents: function (item) {
			if (item.item_id === this.model.get("category_id")) {
				AoPS.Ui.Modal.showAlertQuick(
					Lang["cat-admin-contents-no-adding-to-self"]
				);
			} else if (_.isUndefined(this.model.fetchItem(item))) {
				if (this.model.get("category_id") > 0) {
					this.addItemToExistingCategory(item);
				} else {
					this.model.addItem(item);
				}
			} else {
				AoPS.Ui.Modal.showAlertQuick(
					Utils.formatString(Lang["cat-admin-contents-already-holds"], [
						item.item_text,
					])
				);
			}

			this.$new_item_input.val("");
			this.$new_item_input.focus();
		},

		onAddItemError: function (msg, item) {
			if (msg.error_code === "E_CATEGORY_LOCKED") {
				AoPS.Ui.Modal.showAlert(Lang["cat-admin-contents-locked-error"]);
				this.model.removeItem(item);
				this.model.set("is_locked", true);
				this.render();
			} else {
				AoPS.Ui.Flyout.display(
					Utils.formatString(Lang["cat-admin-contents-add-category-error"], [
						item.item_text,
						msg.error_code,
					])
				);
			}
			this.model.removeItem(item);
		},

		addItemToExistingCategory: function (item) {
			var self = this;
			this.model.addItemDb({
				item: item,
				add_to_client_immediately: true,
				onError: function (msg) {
					self.onAddItemError(msg, item);
				},
			});
		},

		onClose: function () {
			this.itembox_view.close();
		},

		validateNewCategorySettings: function () {
			if (this.model.get("items").length === 0) {
				AoPS.Ui.Modal.showAlertQuick(Lang["cat-admin-no-empty-collections"]);
				return false;
			}
			return true;
		},
	});

	/**
	 * Contents block for bookmarked forums.  Almost the same as the one for folders.  Operates the
	 *  same way, except needs a different Ajax call and different finish when we finally add the
	 *  item.
	 *
	 * Model : AoPS.Community.Modals.CategoryBookmarkForums
	 *
	 * CURRENTLY DEPRECATED; LEAVING HERE IN CASE WE DECIDE TO ALLOW ADDING BOOKMARKS FROM HERE
	 */
	ComViews.CategoryAdminBlockContentsBookmarkForums =
		ComViews.CategoryAdminBlockContentsFolder.extend({
			new_contents_autocomplete_ajax: "fetch_forum_autocomplete",

			addItemToExistingCategory: function (item) {
				var self = this;

				ComViews.fireBookmarkModal(
					"forum",
					_.bind(function (setting) {
						var new_item = _.defaults(
							{
								state: setting,
							},
							item
						);

						this.model.get("master").addBookmarkForumViaAdmin({
							item: new_item,
							onError: function (msg) {
								self.onAddItemError(msg, item);
							},
						});
					}, this)
				);
			},
		});

	/**
	 * Portion of Category admin that shows the contents.
	 *
	 * Only for collections.
	 *
	 * model : AoPS.Community.Models.CategoryMyForums
	 */
	ComViews.CategoryAdminBlockContentsMyForums =
		ComViews.CategoryAdminBlockContentsFolder.extend({
			new_contents_autocomplete_ajax:
				"fetch_add_contents_my_forums_autocomplete",
		});

	/**
	 * Portion of Category admin that shows the contents.
	 *
	 * Only for collections.
	 *
	 * model : AoPS.Community.Models.CategoryMyCollections
	 */
	ComViews.CategoryAdminBlockContentsMyCollections =
		ComViews.CategoryAdminBlockContentsFolder.extend({
			new_contents_autocomplete_ajax:
				"fetch_add_contents_my_collections_autocomplete",
		});

	/**
	 *
	 * model : AoPS.Community.Models.Category (or child).
	 */
	ComViews.CategoryAdminBlockContentsViewTagsOld =
		ComViews.CategoryAdminBlockContentsFolder.extend({
			onClickCloseForum: function (e) {
				this.constructContentsInput();
				this.$content_add.find("input").focus();
			},

			constructContentsInput: function () {
				var self = this;
				// TODO: make sure this line removes all stuff inside; I think it does.
				this.$content_add.empty();
				this.$content_add.append(
					'<input class="cmty-admin-new-contents-category"\
					placeholder="' +
						Lang["cat-admin-add-content-tag-forum-placeholder"] +
						'">'
				);

				Utils.buildCategoryAutocomplete(this.$content_add.find("input"), {
					ajax_call: "fetch_forum_autocomplete",
					autocomplete_settings: {
						onSelect: function (e, ui) {
							self.buildTagInput({
								item_id: ui.item.category_id,
								item_text: ui.item.label,
								item_type: ui.item.category_type,
								item_forum_id: ui.item.item_forum_id,
								item_main_color: ui.item.main_color,
								item_secondary_color: ui.item.secondary_color,
								item_can_remove: ui.item.can_remove,
								item_subtitle: ui.item.short_description,
							});
							e.stopPropagation();
							e.preventDefault();
						},
					},
					show_no_results_msg: true,
				});
			},

			/**
			 * We have chosen a forum, let's build the input box for inputting tags.
			 *
			 * @param object (Itembox item that is a forum)
			 */
			buildTagInput: function (forum) {
				var $forum,
					self = this;

				// TODO : think about public/private issues
				this.$content_add.empty();
				this.$content_add.html(
					this.getTemplate("#cmty-cat-admin-add-content-tags-tpl", {
						lang_Forum: Lang["Forum"],
						lang_Tag: Lang["Tag"],
						tag_placeholder: Lang["cat-admin-contents-tag-placeholder"],
					})
				);
				this.current_forum = forum;
				/**
				 * If this forum has been loaded to the DOM, use that model.  Otherwise,
				 *  create a temp one, so we have access to the item management methods we
				 *  need.
				 **/
				this.category = this.model.get("master").fetchCategory(forum.item_id);
				if (_.isUndefined(this.category)) {
					this.category = this.model.get("master").constructTemporaryCategory({
						category_type: forum.item_type,
						category_id: forum.item_id,
						main_color: forum.item_main_color,
						secondary_color: forum.item_secondary_color,
						category_name: forum.item_text,
					});
				}

				$forum = AoPS.Community.Views.Itembox.prototype.constructItem.apply(
					{
						push_state_attribute: "data-cmty",
						check_can_remove: true,
						can_remove_all: true,
						onClickDelete: function () {
							self.onClickCloseForum();
						},
					},
					[forum]
				);

				// Template has div in which to add forum
				this.$content_add
					.find(".cmty-cat-admin-contents-add-tag-forum")
					.append($forum);

				this.$input_box = this.$content_add.find("input");

				AoPS.Community.Views.buildTagAutocomplete({
					$input_box: this.$input_box,
					show_no_results_msg: true,
					model: this.category,
					submitNewItem: function (item) {
						self.addItem(item);
					},
				});
				this.$input_box.focus();
				//			this.constructAutocomplete();
				// Make a tag autocomplete thing that I can export to.
				// Also, the focus tag box needs to not go to the database for the search thing.
				//  In getAutocompleteSource in CategoryCell, need to make
				//  a function that has a switch based on category type.  If the
				//  category is a view_tags, just build the autocomplete out of items.
				//	Maybe that function still exists in models?
				// Nope - build fetchTagAutocomplete, and in there build it out of current
				//   items.  After built once, put listeners on items to update it.
				//   (And always check if it exists before building anew.)
				/*


			7) Create new view_tags
			8) Switch the focus tag box in forums to the new autocompleter
			*/
			},

			/**
			 * What to do when we submit an entry to the tag box.
			 *  We head down the route for that tag.
			 *
			 * @param object : the new item (the ui.item from autocomplete)
			 *
			 */
			addItem: function (added_item) {
				var self = this,
					item = {
						item_id: parseInt(added_item.item_id),
						item_type: "tag",
						item_forum_id: parseInt(added_item.item_forum_id),
						item_text: added_item.value,
						item_main_color: added_item.main_color,
						item_secondary_color: added_item.secondary_color,
					};

				if (!_.isUndefined(this.model.fetchItem(item))) {
					AoPS.Ui.Flyout.display(
						Utils.formatString(Lang["cat-admin-contents-added-tag-already"], [
							item.item_text,
							self.current_forum.item_text,
						])
					);
				} else {
					if (this.model.get("category_id") > 0) {
						this.addItemToExistingCategory(item);
					} else {
						this.model.addItem(item);
					}
				}
				this.buildTagInput(this.current_forum);
			},

			/**
			 * Add this item to an existing category.
			 *
			 * @param object : the new item (the ui.item from autocomplete)
			 **/
			addItemToExistingCategory: function (item) {
				var self = this;
				this.model.addItemDb({
					item: item,
					add_to_client_immediately: true,
					onError: function (msg) {
						if (msg.error_code === "E_CATEGORY_LOCKED") {
							AoPS.Ui.Modal.showAlert(Lang["cat-admin-contents-locked-error"]);
							self.model.removeItem(item);
							self.model.set("is_locked", true);
							self.render();
						} else {
							AoPS.Ui.Flyout.display(
								Utils.formatString(Lang["cat-admin-contents-add-tag-error"], [
									item.item_text,
									self.current_forum.item_text,
								])
							);
						}
						self.model.removeItem(item);
					},
				});
			},
		});

	/**
	 * Portion of Category admin that shows the contents.
	 *
	 * Only for collections.
	 *
	 * model : AoPS.Community.Models.CategoryBookmarkTags
	 *
	 * CURRENTLY DEPRECATED; LEAVING HERE IN CASE WE DECIDE TO ALLOW ADDING BOOKMARKS FROM HERE
	 */
	ComViews.CategoryAdminBlockContentsBookmarkTags =
		ComViews.CategoryAdminBlockContentsViewTags.extend({
			// JUST need to add the modal to add to feed or email.  Or drop those options right into the form
			// Maybe wait for Jason's words, but this is already nearly done :)

			addItemToExistingCategory: function (item) {
				var self = this;
				ComViews.fireBookmarkModal(
					"tag",
					_.bind(function (setting) {
						this.model.get("master").addTagBookmark({
							item: _.defaults(setting, item),
							onError: function (msg) {
								self.onAddItemError(msg, item);
							},
						});
					}, this)
				);
			},
		});

	/**
	 *
	 * model : AoPS.Community.Models.Category (or one of its children)
	 */
	ComViews.CategoryAdminBlockLocation = AoPS.View.extend({
		template_id: "#cmty-category-admin-location-tpl",

		className: "aops-panel cmty-cat-admin-location",

		initialize: function () {
			this.display_type = Utils.displayCategoryType(
				this.model.get("category_type")
			);
			this.render();
			this.$help = $(
				this.getTemplate("#cmty-cat-admin-location-help-tpl", {
					type: this.display_type,
					lang_contained_in: Lang["cat-admin-location-contained-in"],
				})
			);
		},

		events: {
			"click .cmty-cat-admin-help": "onClickHelp",
		},

		buildHelper: function () {
			var help_id = this.category_type_specific_settings.help_template_id;
			this.$help = $(this.getTemplate(help_id, {}));
		},

		render: function () {
			var self = this;
			/**

			IF WE BRING THIS BACK, NOTE THAT THE METHOD
			getDefaultContainers
			IN Models.Master is responsible for setting the default containers.
			It is called from the router when the category is first built
			for the CategoryAdmin page.


			**/

			this.$el.html(
				this.getTemplate(this.template_id, {
					can_add_to_folders: AoPS.session.logged_in_and_initialized,
					placeholder: Lang["cat-admin-add-to-location-placeholder"],
					title: Lang["cat-admin-location-title"],
					lang_add_to: Lang["cat-admin-location-add-to"],
					lang_contained_in: Lang["cat-admin-location-contained-in"],
				})
			);

			this.$contained_in = this.$el.find(".cmty-admin-location-containers");

			if (AoPS.session.logged_in_and_initialized) {
				this.$input_box = this.$el.find("input");
				Utils.buildCategoryAutocomplete(this.$input_box, {
					ajax_call: "fetch_containers_autocomplete",
					additional_ajax_settings: {
						item_type: this.model.get("category_type"),
					},
					autocomplete_settings: {
						onSelect: function (e, ui) {
							self.parsePotentialNewContainer({
								item_id: ui.item.category_id,
								item_text: ui.item.label,
								item_type: "folder",
								item_forum_id: 0,
								item_main_color: ui.item.main_color,
								item_secondary_color: ui.item.secondary_color,
								item_can_remove: ui.item.can_remove,
								item_subtitle: ui.item.short_description,
							});
							e.stopPropagation();
							e.preventDefault();
						},
					},
					show_no_results_msg: true,
				});
			}

			this.itembox_view = new ComViews.Itembox({
				model: this.model.get("container_model"),
				check_can_remove: true,
				can_remove_all: false,
				onDeleteItem: function (item) {
					self.onClickDeleteContainer(item);
				},
			});
			this.$contained_in.append(this.itembox_view.$el);
		},

		/**
		 * Given a new container from the autocomplete, check if we
		 *  already have it, and then add it if we don't already have it.
		 *
		 * @param obj (item that can be added to Itembox; see ComViews.Itembox for details.)
		 **/
		parsePotentialNewContainer: function (container) {
			var self = this;

			if (container.item_id === this.model.get("category_id")) {
				AoPS.Ui.Modal.showAlertQuick(
					Lang["cat-admin-contents-no-adding-to-self"]
				);
			} else {
				this.model.get("container_model").addItem({
					item: container,
					onError: function (obj) {
						if (obj.error_code === "E_ALREADY_ADDED") {
							AoPS.Ui.Modal.showAlert(
								Utils.formatString(Lang["cat-admin-location-exists"], [
									self.display_type,
									container.item_text,
								])
							);
						}
					},
				});
			}

			this.$input_box.val("");
			this.$input_box.focus();
		},

		/**
		 * Here's what happens when the user clicks an "X" on a container.
		 *
		 * @param obj (item that can be added to Itembox; see ComViews.Itembox for details.)
		 **/
		onClickDeleteContainer: function (container_item) {
			var self = this;

			if (this.model.get("category_id") > 0) {
				AoPS.Ui.Modal.showConfirm(
					Lang["cat-admin-delete-container-1"] +
						" <b>" +
						container_item.item_text +
						"</b>?",
					function (ok) {
						if (ok) {
							self.model.get("container_model").removeItem(container_item);
						}
						AoPS.Ui.Modal.closeAllModals();
					},
					{
						width: "450px",
					}
				);
			} else {
				self.model.get("container_model").removeItem(container_item);
			}
		},

		onClickHelp: function () {
			this.$help.showModal({
				frame_class: "cmty-cat-admin-helper-modal aops-modal-standard",
				title: Lang["cat-admin-location-help-title"],
				width: "600px",
				scrollable: true,
			});
		},

		validateNewCategorySettings: function () {
			return true;
		},

		onClose: function () {
			this.itembox_view.close();
		},
	});
	/**
	 * Extra settings for a blog.
	 *
	 * model : AoPS.Community.Models.CategoryBlog
	 *
	 * TODO : Custom block details, CSS
	 **/
	ComViews.CategoryAdminBlockBlogSettings = AoPS.View.extend({
		template_id: "#cmty-category-admin-blog-extras-tpl",

		className: "aops-panel",

		initialize: function () {
			var bit_settings = [
					"show_profile_info",
					"show_stats",
					"show_shoutbox",
					"show_contributors",
					"show_tags",
				], //, 'show_custom_block'], Maybe someday we'll bring this back -- need to add in models, too
				input_settings = [
					"blog_post_comment_text",
					"blog_comments_text",
					"blog_one_comment_text",
					"blog_no_comments_text",
				],
				self = this,
				can_edit = this.model.getPermission("c_can_edit_core_data");

			if (can_edit) {
				bit_settings.push("is_primary_blog");
				this.model.set(
					"is_primary_blog",
					this.model.get("category_id") ===
						this.model.get("master").get("current_user").get("primary_blog_id")
				);
			}

			this.$el.html(
				this.getTemplate(this.template_id, {
					title: Lang["cat-admin-blog-settings-title"],
				})
			);

			_.each(input_settings, function (setting) {
				if (can_edit) {
					self.buildEditableInputSetting(setting);
				} else {
					self.buildStaticSetting(setting);
				}
			});

			this.intervals = {};

			_.each(bit_settings, function (setting) {
				if (can_edit) {
					self.buildEditableBitSetting(setting);
				} else {
					self.buildStaticSetting(setting);
				}
			});

			this.$help = $(
				this.getTemplate("#cmty-cat-admin-blog-settings-help-tpl", {})
			);
		},

		events: {
			"click .cmty-cat-admin-help": "onClickHelp",
		},

		onClickHelp: function () {
			this.$help.showModal({
				frame_class: "cmty-cat-admin-helper-modal aops-modal-standard",
				title: Lang["cat-admin-blog-settings-help-title"],
				width: "600px",
				scrollable: true,
			});
		},

		/**
		 * Build the row for a setting and put the label in place
		 *
		 * @param string setting
		 */
		buildSettingGroup: function (setting) {
			return $(
				'<div class="form-group"><div><label>' +
					Lang["cat-admin-blog-label-" + setting] +
					"</label></div>"
			);
		},

		/**
		 * Build a static setting to reveal
		 *
		 * @param string setting
		 */
		buildStaticSetting:
			ComViews.CategoryAdminBlockGeneralInfo.prototype.buildStaticSetting,

		/**
		 * Build an editable yes/no setting.
		 *
		 * @param string setting
		 */
		buildEditableBitSetting:
			ComViews.CategoryAdminBlockGeneralInfo.prototype.buildEditableBitSetting,

		/**
		 * Update a bit setting for this model.
		 *
		 * @param string setting to update
		 * @param string value of the setting
		 */
		updateBitSetting: function (setting, value) {
			this.model.setBitBlogSetting({
				setting: setting,
				value: parseInt(value) == 1,
				onError: function (msg) {
					if (typeof Lang["change-blog-err-" + msg.error_code]) {
						ComViews.showError(Lang["change-blog-err-" + msg.error_code]);
					}
				},
			});
		},

		/**
		 * Build an input box for an editable setting.
		 *
		 * @param string setting
		 */
		buildEditableInputSetting: function (setting) {
			var self = this,
				$setting_group = this.buildSettingGroup(setting),
				$input = $(
					'<input class="form-control" type="text" maxlength="' +
						Constants.max_blog_comments_text_length +
						'" value="' +
						this.model.get(setting) +
						'">'
				);

			$input.on("input", function (e) {
				self.prepareSaveInput($input, setting);
			});

			$setting_group.append($("<div></div>").append($input));
			this.$el.append($setting_group);
		},

		/**
		 * Prepare to save an input field.  We have a slight delay between
		 *  changes and saves, in case the user keeps typing in the input field.
		 *
		 * @param jQuery input object
		 * @param string model setting
		 **/
		prepareSaveInput: function ($input, setting) {
			var self = this,
				value = $input.val();

			if (this.intervals.hasOwnProperty(setting)) {
				clearTimeout(this.intervals[setting]);
			}
			this.intervals[setting] = setTimeout(function () {
				self.saveInput(setting, value);
			}, Constants.cat_admin_save_input_delay);
		},

		/**
		 * Save an input field's value.
		 *
		 * @param string model setting
		 * @param string value to save
		 **/
		saveInput: function (setting, value) {
			this.model.setStringBlogSetting({
				setting: setting,
				value: value,
				onFinish: function (msg) {
					AoPS.Ui.Flyout.close();
					AoPS.Ui.Flyout.display(
						Lang["cat-admin-blog-label-" + setting] + " " + Lang["saved"] + "."
					);
				},
				onError: function (msg) {
					if (typeof Lang["change-blog-err-" + msg.error_code]) {
						ComViews.showError(Lang["change-blog-err-" + msg.error_code]);
					}
				},
			});
		},

		validateNewCategorySettings: function () {
			return true;
		},
	});

	ComViews.CategoryAdminBlockBlogCss = AoPS.View.extend({
		template_id: "#cmty-cat-admin-blog-css-tpl",

		className: "aops-panel",

		editor: null,

		initialize: function () {
			var self = this;
			var blog_exists = this.model.get("category_id") > 0,
				can_edit =
					blog_exists && this.model.getPermission("c_can_edit_core_data"),
				blog_message;

			if (!blog_exists) {
				blog_message = Lang["cat-admin-blog-css-new-info"];
			} else {
				if (can_edit) {
					blog_message = Lang["cat-admin-blog-css-existing-info"];
				} else if (this.model.has("css") && this.model.get("css").length > 0) {
					blog_message = Lang["cat-admin-blog-css-no-perm"];
				} else {
					blog_message = "";
				}
			}
			this.$el.html(
				this.getTemplate(this.template_id, {
					title: Lang["cat-admin-blog-css-title"],
					blog_exists: blog_exists,
					blog_message: blog_message,
					Save: Lang["Save"],
					Reset: Lang["Reset"],
					Delete: Lang["Delete"],
					content: this.model.has("css")
						? this.model.get("css")
						: Lang["cat-admin-blog-css-default-css"],
					can_edit: can_edit,
					placeholder: can_edit
						? Lang["cat-admin-blog-css-enter"]
						: Lang["cat-admin-blog-css-none"],
				})
			);
			this.$css = this.$("textarea");

			if (can_edit) {
				// this.$css.on("keyup", function () {
				// 	self.onKeyPress();
				// });
				this.$save = this.$(".cmty-cat-admin-blog-css-save");
				this.$reset = this.$(".cmty-cat-admin-blog-css-reset");
				this.$delete = this.$(".cmty-cat-admin-blog-css-delete");
				this.resetButtonVisibility();
			}

			// Experimental: Use CodeMirror to display/edit CSS.
			setTimeout(() => {
				this.editor = CodeMirror.fromTextArea(this.$css[0], {
					mode: "css",
					lineWrapping: true,
					lineNumbers: true,
					dragDrop: false,
				});
				this.editor.setSize("100%", "500px");
				if (can_edit) {
					this.editor.on("change", () => self.onKeyPress());
				}

				// Select the CodeMirror wrapper element
				var cmWrapper = this.editor.getWrapperElement();

				// Intercept the mouse wheel event
				cmWrapper.addEventListener(
					"wheel",
					(e) => {
						// Stop the event from bubbling up to the main page
						e.stopPropagation();
						e.preventDefault();

						// deltaX/deltaY units depend on deltaMode (pixels, lines, or pages)
						var deltaX = e.deltaX;
						var deltaY = e.deltaY;
						if (e.deltaMode === 1) {
							var lineHeight = this.editor.defaultTextHeight();
							deltaX *= lineHeight;
							deltaY *= lineHeight;
						} else if (e.deltaMode === 2) {
							var scroller = this.editor.getScrollerElement();
							deltaX *= scroller.clientWidth;
							deltaY *= scroller.clientHeight;
						}

						var scrollInfo = this.editor.getScrollInfo();
						this.editor.scrollTo(
							scrollInfo.left + deltaX,
							scrollInfo.top + deltaY
						);
					},
					{passive: false}
				);
			}, 1);

			this.$help = $(this.getTemplate("#cmty-cat-admin-blog-css-help-tpl", {}));
		},

		validateNewCategorySettings: function () {
			return true;
		},

		events: {
			"click .cmty-cat-admin-blog-css-save": "onClickSave",
			"click .cmty-cat-admin-blog-css-reset": "onClickReset",
			"click .cmty-cat-admin-blog-css-delete": "onClickDelete",
			"click .cmty-cat-admin-help": "onClickHelp",
		},

		onClickHelp: function () {
			this.$help.showModal({
				frame_class: "cmty-cat-admin-helper-modal aops-modal-standard",
				title: Lang["cat-admin-blog-css-help-title"],
				width: "600px",
				scrollable: true,
			});
		},
		onKeyPress: function () {
			this.$save.show();
			this.$reset.show();
		},

		resetButtonVisibility: function () {
			this.$reset.hide();
			this.$save.hide();
			this.$delete.toggle(
				this.model.has("css") && this.model.get("css").length > 0
			);
		},

		onClickReset: function () {
			var old_css = this.model.has("css") ? this.model.get("css") : "";
			this.$css.val(old_css);
			this.editor.setValue(old_css);
			this.resetButtonVisibility();
		},

		onClickSave: function () {
			var self = this,
				new_css = self.$css.val();

			Modal.showConfirm(
				Lang["cat-admin-blog-css-save-sure"],
				function (ok) {
					if (ok) {
						ComViews.throwBlockingMessage(
							Lang["cat-admin-blog-css-save-block"]
						);
						self.model.setNewCss({
							new_css: self.editor.getValue(),
							onFinish: function () {
								self.model.set("css", new_css);
								self.resetButtonVisibility();
								setTimeout(function () {
									Modal.closeAllModals();
								}, 500);
							},
							onError: function (msg) {
								self.throwEditError(msg);
							},
						});
					} else {
						Modal.closeAllModals();
					}
				},
				{
					close_on_button_click: false,
					width: "450px",
				}
			);
		},

		/**
		 * Parse errors that come back from an Ajax call.
		 *
		 * @param object -- return from an ajax call that has an error
		 **/
		throwEditError: function (msg) {
			var err_message;

			if (msg.error_code === "E_NO_PERMISSION") {
				err_message = Lang["cat-admin-blog-css-no-perm-err"];
			} else {
				err_message = Lang["unexpected-error-code"] + msg.error_code;
			}
			AoPS.Community.Views.showError(err_message);
		},

		onClickDelete: function () {
			var self = this;
			Modal.showConfirm(
				Lang["cat-admin-blog-css-delete-sure"],
				function (ok) {
					if (ok) {
						ComViews.throwBlockingMessage(
							Lang["cat-admin-blog-css-delete-block"]
						);
						self.model.deleteCss({
							onFinish: function () {
								self.$css.val("");
								self.model.unset("css");
								self.resetButtonVisibility();
								setTimeout(function () {
									Modal.closeAllModals();
								}, 500);
							},
							onError: function (msg) {
								self.throwEditError(msg);
							},
						});
					} else {
						Modal.closeAllModals();
					}
				},
				{
					close_on_button_click: false,
					width: "450px",
				}
			);
		},
	});

	/*** END Category Admin views ***/

	return ComViews;
})(AoPS.Community.Views || {});

/* eslint-enable eqeqeq */
